import * as d from "react";
import q, { createContext as _e, useState as Ge, useEffect as pt, useContext as pe, useLayoutEffect as ai, forwardRef as Lo, createElement as io, useRef as Xn, useId as Fb, useCallback as ii, useMemo as dn, useInsertionEffect as $b, Fragment as bd, Component as Bb } from "react";
import { jsx as p, Fragment as ge, jsxs as O } from "react/jsx-runtime";
import * as fr from "react-dom";
import Ub from "react-dom";
import { startOfMonth as ke, endOfMonth as li, startOfDay as va, addMonths as nt, differenceInCalendarMonths as nr, isSameMonth as ci, isBefore as wd, isSameDay as Te, addDays as Ne, subDays as Ts, differenceInCalendarDays as lt, getWeeksInMonth as Wb, addWeeks as ga, getUnixTime as Hb, isAfter as ya, addYears as Gb, max as jb, min as Kb, isSameYear as ba, setMonth as Rs, setYear as ec, startOfYear as zb, endOfISOWeek as xd, endOfWeek as Sd, startOfISOWeek as ui, startOfWeek as di, getISOWeek as Yb, getWeek as Xb, format as be, isDate as Cd, endOfDay as qb, parse as Zb, isValid as Ad, parseISO as Jb, isToday as Qb, isTomorrow as e0, isYesterday as t0 } from "date-fns";
import { enUS as n0 } from "date-fns/locale";
import { useTranslation as Vo } from "react-i18next";
import { getDateFnsLocale as Ed, useMediaQuery as r0, dateUtils as Ps, DateFormats as Fn, parseLocalDate as o0 } from "@guardian/shared-utils";
import { useDropzone as s0 } from "react-dropzone";
function Nd(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = Nd(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Td() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = Nd(e)) && (r && (r += " "), r += t);
  return r;
}
const fi = "-", a0 = (e) => {
  const t = l0(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      const i = a.split(fi);
      return i[0] === "" && i.length !== 1 && i.shift(), Rd(i, t) || i0(a);
    },
    getConflictingClassGroupIds: (a, i) => {
      const l = n[a] || [];
      return i && r[a] ? [...l, ...r[a]] : l;
    }
  };
}, Rd = (e, t) => {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Rd(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const s = e.join(fi);
  return (a = t.validators.find(({
    validator: i
  }) => i(s))) == null ? void 0 : a.classGroupId;
}, tc = /^\[(.+)\]$/, i0 = (e) => {
  if (tc.test(e)) {
    const t = tc.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, l0 = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return u0(Object.entries(e.classGroups), n).forEach(([s, a]) => {
    wa(a, r, s, t);
  }), r;
}, wa = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const s = o === "" ? t : nc(t, o);
      s.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (c0(o)) {
        wa(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([s, a]) => {
      wa(a, nc(t, s), n, r);
    });
  });
}, nc = (e, t) => {
  let n = e;
  return t.split(fi).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, c0 = (e) => e.isThemeGetter, u0 = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((s) => typeof s == "string" ? t + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(([a, i]) => [t + a, i])) : s);
  return [n, o];
}) : e, d0 = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (s, a) => {
    n.set(s, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let a = n.get(s);
      if (a !== void 0)
        return a;
      if ((a = r.get(s)) !== void 0)
        return o(s, a), a;
    },
    set(s, a) {
      n.has(s) ? n.set(s, a) : o(s, a);
    }
  };
}, Pd = "!", f0 = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], s = t.length, a = (i) => {
    const l = [];
    let c = 0, u = 0, f;
    for (let y = 0; y < i.length; y++) {
      let b = i[y];
      if (c === 0) {
        if (b === o && (r || i.slice(y, y + s) === t)) {
          l.push(i.slice(u, y)), u = y + s;
          continue;
        }
        if (b === "/") {
          f = y;
          continue;
        }
      }
      b === "[" ? c++ : b === "]" && c--;
    }
    const h = l.length === 0 ? i : i.substring(u), m = h.startsWith(Pd), g = m ? h.substring(1) : h, v = f && f > u ? f - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: m,
      baseClassName: g,
      maybePostfixModifierPosition: v
    };
  };
  return n ? (i) => n({
    className: i,
    parseClassName: a
  }) : a;
}, p0 = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, h0 = (e) => ({
  cache: d0(e.cacheSize),
  parseClassName: f0(e),
  ...a0(e)
}), m0 = /\s+/, v0 = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, s = [], a = e.trim().split(m0);
  let i = "";
  for (let l = a.length - 1; l >= 0; l -= 1) {
    const c = a[l], {
      modifiers: u,
      hasImportantModifier: f,
      baseClassName: h,
      maybePostfixModifierPosition: m
    } = n(c);
    let g = !!m, v = r(g ? h.substring(0, m) : h);
    if (!v) {
      if (!g) {
        i = c + (i.length > 0 ? " " + i : i);
        continue;
      }
      if (v = r(h), !v) {
        i = c + (i.length > 0 ? " " + i : i);
        continue;
      }
      g = !1;
    }
    const y = p0(u).join(":"), b = f ? y + Pd : y, w = b + v;
    if (s.includes(w))
      continue;
    s.push(w);
    const x = o(v, g);
    for (let S = 0; S < x.length; ++S) {
      const C = x[S];
      s.push(b + C);
    }
    i = c + (i.length > 0 ? " " + i : i);
  }
  return i;
};
function g0() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = _d(t)) && (r && (r += " "), r += n);
  return r;
}
const _d = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = _d(e[r])) && (n && (n += " "), n += t);
  return n;
};
function y0(e, ...t) {
  let n, r, o, s = a;
  function a(l) {
    const c = t.reduce((u, f) => f(u), e());
    return n = h0(c), r = n.cache.get, o = n.cache.set, s = i, i(l);
  }
  function i(l) {
    const c = r(l);
    if (c)
      return c;
    const u = v0(l, n);
    return o(l, u), u;
  }
  return function() {
    return s(g0.apply(null, arguments));
  };
}
const le = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Md = /^\[(?:([a-z-]+):)?(.+)\]$/i, b0 = /^\d+\/\d+$/, w0 = /* @__PURE__ */ new Set(["px", "full", "screen"]), x0 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, S0 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, C0 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, A0 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, E0 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, at = (e) => an(e) || w0.has(e) || b0.test(e), vt = (e) => bn(e, "length", D0), an = (e) => !!e && !Number.isNaN(Number(e)), _s = (e) => bn(e, "number", an), $n = (e) => !!e && Number.isInteger(Number(e)), N0 = (e) => e.endsWith("%") && an(e.slice(0, -1)), te = (e) => Md.test(e), gt = (e) => x0.test(e), T0 = /* @__PURE__ */ new Set(["length", "size", "percentage"]), R0 = (e) => bn(e, T0, Id), P0 = (e) => bn(e, "position", Id), _0 = /* @__PURE__ */ new Set(["image", "url"]), M0 = (e) => bn(e, _0, O0), I0 = (e) => bn(e, "", k0), Bn = () => !0, bn = (e, t, n) => {
  const r = Md.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, D0 = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  S0.test(e) && !C0.test(e)
), Id = () => !1, k0 = (e) => A0.test(e), O0 = (e) => E0.test(e), L0 = () => {
  const e = le("colors"), t = le("spacing"), n = le("blur"), r = le("brightness"), o = le("borderColor"), s = le("borderRadius"), a = le("borderSpacing"), i = le("borderWidth"), l = le("contrast"), c = le("grayscale"), u = le("hueRotate"), f = le("invert"), h = le("gap"), m = le("gradientColorStops"), g = le("gradientColorStopPositions"), v = le("inset"), y = le("margin"), b = le("opacity"), w = le("padding"), x = le("saturate"), S = le("scale"), C = le("sepia"), E = le("skew"), A = le("space"), T = le("translate"), I = () => ["auto", "contain", "none"], L = () => ["auto", "hidden", "clip", "visible", "scroll"], B = () => ["auto", te, t], V = () => [te, t], z = () => ["", at, vt], D = () => ["auto", an, te], G = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], U = () => ["solid", "dashed", "dotted", "double", "none"], P = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], R = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], k = () => ["", "0", te], Z = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ne = () => [an, te];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Bn],
      spacing: [at, vt],
      blur: ["none", "", gt, te],
      brightness: ne(),
      borderColor: [e],
      borderRadius: ["none", "", "full", gt, te],
      borderSpacing: V(),
      borderWidth: z(),
      contrast: ne(),
      grayscale: k(),
      hueRotate: ne(),
      invert: k(),
      gap: V(),
      gradientColorStops: [e],
      gradientColorStopPositions: [N0, vt],
      inset: B(),
      margin: B(),
      opacity: ne(),
      padding: V(),
      saturate: ne(),
      scale: ne(),
      sepia: k(),
      skew: ne(),
      space: V(),
      translate: V()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", te]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [gt]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": Z()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": Z()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...G(), te]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: L()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": L()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": L()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: I()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": I()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": I()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", $n, te]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: B()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", te]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: k()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: k()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", $n, te]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Bn]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", $n, te]
        }, te]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": D()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": D()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Bn]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [$n, te]
        }, te]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": D()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": D()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", te]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", te]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [h]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [h]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [h]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...R()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...R(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...R(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [w]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [w]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [w]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [w]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [w]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [w]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [w]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [w]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [w]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [A]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [A]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", te, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [te, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [te, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [gt]
        }, gt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [te, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [te, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [te, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [te, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", gt, vt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", _s]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Bn]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", te]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", an, _s]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", at, te]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", te]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", te]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...U(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", at, vt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", at, te]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: V()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", te]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", te]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...G(), P0]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", R0]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, M0]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [s]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [s]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [s]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [s]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [s]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [s]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [s]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [s]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [s]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [s]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [s]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [s]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [s]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [s]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [s]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [i]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [i]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [i]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [i]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [i]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [i]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [i]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [i]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [i]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...U(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [i]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [i]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: U()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...U()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [at, te]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [at, vt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: z()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [at, vt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", gt, I0]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Bn]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...P(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": P()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", gt, te]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [C]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [C]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", te]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ne()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", te]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ne()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", te]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [S]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [S]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [S]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [$n, te]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [T]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [T]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [E]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [E]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", te]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", te]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": V()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": V()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": V()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": V()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": V()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": V()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": V()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": V()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": V()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": V()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": V()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": V()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": V()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": V()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": V()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": V()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": V()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": V()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", te]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [at, vt, _s]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, V0 = /* @__PURE__ */ y0(L0);
function N(...e) {
  return V0(Td(e));
}
const F0 = 5, $0 = 3e3, B0 = 3e3;
let Dd = F0, kd = $0, qr = B0;
function YO(e) {
  e.limit !== void 0 && (Dd = e.limit), e.removeDelay !== void 0 && (kd = e.removeDelay), e.duration !== void 0 && (qr = e.duration);
}
let Ms = 0;
function U0() {
  return Ms = (Ms + 1) % Number.MAX_SAFE_INTEGER, Ms.toString();
}
const Is = /* @__PURE__ */ new Map(), rc = (e) => {
  if (Is.has(e))
    return;
  const t = setTimeout(() => {
    Is.delete(e), qn({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, kd);
  Is.set(e, t);
}, W0 = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, Dd)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map(
          (n) => n.id === t.toast.id ? { ...n, ...t.toast } : n
        )
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return n ? rc(n) : e.toasts.forEach((r) => {
        rc(r.id);
      }), {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, Zr = [];
let Jr = { toasts: [] };
function qn(e) {
  Jr = W0(Jr, e), Zr.forEach((t) => {
    t(Jr);
  });
}
function H0({ ...e }) {
  const t = U0(), n = (o) => qn({
    type: "UPDATE_TOAST",
    toast: { ...o, id: t }
  }), r = () => qn({ type: "DISMISS_TOAST", toastId: t });
  return qn({
    type: "ADD_TOAST",
    toast: {
      ...e,
      id: t,
      open: !0,
      onOpenChange: (o) => {
        o || r();
      }
    }
  }), qr > 0 && qr < 1 / 0 && setTimeout(r, qr), {
    id: t,
    dismiss: r,
    update: n
  };
}
function G0() {
  const [e, t] = d.useState(Jr);
  return d.useEffect(() => (Zr.push(t), () => {
    const n = Zr.indexOf(t);
    n > -1 && Zr.splice(n, 1);
  }), [e]), {
    ...e,
    toast: H0,
    dismiss: (n) => qn({ type: "DISMISS_TOAST", toastId: n })
  };
}
const j0 = {
  theme: "system",
  setTheme: () => null
}, Od = _e(j0), K0 = (e, t = "system") => {
  let n = null;
  try {
    n = localStorage.getItem(e);
  } catch {
  }
  return n || t;
};
function XO({
  children: e,
  defaultTheme: t = "system",
  storageKey: n = "guardian-theme",
  ...r
}) {
  const [o, s] = Ge(!1), [a, i] = Ge(
    () => K0(n, t)
  ), l = (u) => {
    const f = window.document.documentElement;
    f.classList.remove("light", "dark");
    let h = u;
    u === "system" && (h = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), f.classList.add(h);
  }, c = (u) => {
    i(u);
    try {
      localStorage.setItem(n, u);
    } catch {
    }
    l(u);
  };
  return pt(() => {
    if (!o) {
      s(!0);
      return;
    }
    const u = window.matchMedia("(prefers-color-scheme: dark)"), f = () => {
      a === "system" && l("system");
    };
    return u.addEventListener("change", f), l(a), () => u.removeEventListener("change", f);
  }, [a, o]), o ? /* @__PURE__ */ p(
    Od.Provider,
    {
      ...r,
      value: {
        theme: a,
        setTheme: c
      },
      children: e
    }
  ) : null;
}
const z0 = () => {
  const e = pe(Od);
  if (e === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
};
function oc(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Le(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const s = oc(o, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const s = r[o];
          typeof s == "function" ? s() : oc(e[o], null);
        }
      };
  };
}
function K(...e) {
  return d.useCallback(Le(...e), e);
}
// @__NO_SIDE_EFFECTS__
function xt(e) {
  const t = /* @__PURE__ */ Y0(e), n = d.forwardRef((r, o) => {
    const { children: s, ...a } = r, i = d.Children.toArray(s), l = i.find(X0);
    if (l) {
      const c = l.props.children, u = i.map((f) => f === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...a, ref: o, children: d.isValidElement(c) ? d.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ p(t, { ...a, ref: o, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
var Ld = /* @__PURE__ */ xt("Slot");
// @__NO_SIDE_EFFECTS__
function Y0(e) {
  const t = d.forwardRef((n, r) => {
    const { children: o, ...s } = n;
    if (d.isValidElement(o)) {
      const a = Z0(o), i = q0(s, o.props);
      return o.type !== d.Fragment && (i.ref = r ? Le(r, a) : a), d.cloneElement(o, i);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Vd = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Fd(e) {
  const t = ({ children: n }) => /* @__PURE__ */ p(ge, { children: n });
  return t.displayName = `${e}.Slottable`, t.__radixId = Vd, t;
}
function X0(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Vd;
}
function q0(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...i) => {
      const l = s(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Z0(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
const sc = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ac = Td, wn = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return ac(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: s } = t, a = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], f = s == null ? void 0 : s[c];
    if (u === null) return null;
    const h = sc(u) || sc(f);
    return o[c][h];
  }), i = n && Object.entries(n).reduce((c, u) => {
    let [f, h] = u;
    return h === void 0 || (c[f] = h), c;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: f, className: h, ...m } = u;
    return Object.entries(m).every((g) => {
      let [v, y] = g;
      return Array.isArray(y) ? y.includes({
        ...s,
        ...i
      }[v]) : {
        ...s,
        ...i
      }[v] === y;
    }) ? [
      ...c,
      f,
      h
    ] : c;
  }, []);
  return ac(e, a, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Bt = wn(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-neutral-900 text-neutral-50 hover:bg-neutral-900/90 dark:bg-neutral-50 dark:text-neutral-900 dark:hover:bg-neutral-50/90",
        destructive: "bg-red-500 text-neutral-50 hover:bg-red-500/90 dark:bg-red-900 dark:text-neutral-50 dark:hover:bg-red-900/90",
        outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        "outline-primary": "border border-primary bg-background text-primary hover:bg-primary hover:text-white",
        "outline-destructive": "border border-destructive bg-background text-destructive hover:bg-destructive hover:text-white",
        secondary: "bg-neutral-100 text-neutral-900 hover:bg-neutral-100/80 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-800/80",
        ghost: "text-foreground hover:bg-accent hover:text-accent-foreground",
        "ghost-primary": "text-primary hover:bg-primary hover:text-white",
        link: "text-foreground underline-offset-4 hover:underline",
        primary: "bg-primary text-white hover:bg-primary/90 dark:bg-primary dark:text-white dark:hover:bg-primary/90"
      },
      size: {
        default: "h-11 px-4 py-2",
        sm: "h-10 rounded-md px-3",
        lg: "h-12 rounded-md px-8",
        icon: "h-11 w-11"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Ut = d.forwardRef(
  ({ className: e, variant: t, size: n, asChild: r = !1, ...o }, s) => /* @__PURE__ */ p(
    r ? Ld : "button",
    {
      className: N(Bt({ variant: t, size: n, className: e })),
      ref: s,
      ...o
    }
  )
);
Ut.displayName = "Button";
function M(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function J0(e, t) {
  const n = d.createContext(t), r = (s) => {
    const { children: a, ...i } = s, l = d.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ p(n.Provider, { value: l, children: a });
  };
  r.displayName = e + "Provider";
  function o(s) {
    const a = d.useContext(n);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function we(e, t = []) {
  let n = [];
  function r(s, a) {
    const i = d.createContext(a), l = n.length;
    n = [...n, a];
    const c = (f) => {
      var b;
      const { scope: h, children: m, ...g } = f, v = ((b = h == null ? void 0 : h[e]) == null ? void 0 : b[l]) || i, y = d.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ p(v.Provider, { value: y, children: m });
    };
    c.displayName = s + "Provider";
    function u(f, h) {
      var v;
      const m = ((v = h == null ? void 0 : h[e]) == null ? void 0 : v[l]) || i, g = d.useContext(m);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return [c, u];
  }
  const o = () => {
    const s = n.map((a) => d.createContext(a));
    return function(i) {
      const l = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return o.scopeName = e, [r, Q0(o, ...t)];
}
function Q0(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(s) {
      const a = r.reduce((i, { useScope: l, scopeName: c }) => {
        const f = l(s)[`__scope${c}`];
        return { ...i, ...f };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var me = globalThis != null && globalThis.document ? d.useLayoutEffect : () => {
}, ew = d[" useInsertionEffect ".trim().toString()] || me;
function Pe({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, s, a] = tw({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, l = i ? e : o;
  {
    const u = d.useRef(e !== void 0);
    d.useEffect(() => {
      const f = u.current;
      f !== i && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = i;
    }, [i, r]);
  }
  const c = d.useCallback(
    (u) => {
      var f;
      if (i) {
        const h = nw(u) ? u(e) : u;
        h !== e && ((f = a.current) == null || f.call(a, h));
      } else
        s(u);
    },
    [i, e, s, a]
  );
  return [l, c];
}
function tw({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = d.useState(e), o = d.useRef(n), s = d.useRef(t);
  return ew(() => {
    s.current = t;
  }, [t]), d.useEffect(() => {
    var a;
    o.current !== n && ((a = s.current) == null || a.call(s, n), o.current = n);
  }, [n, o]), [n, r, s];
}
function nw(e) {
  return typeof e == "function";
}
var rw = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], $ = rw.reduce((e, t) => {
  const n = /* @__PURE__ */ xt(`Primitive.${t}`), r = d.forwardRef((o, s) => {
    const { asChild: a, ...i } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(l, { ...i, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function pi(e, t) {
  e && fr.flushSync(() => e.dispatchEvent(t));
}
function Fo(e) {
  const t = e + "CollectionProvider", [n, r] = we(t), [o, s] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (v) => {
    const { scope: y, children: b } = v, w = q.useRef(null), x = q.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p(o, { scope: y, itemMap: x, collectionRef: w, children: b });
  };
  a.displayName = t;
  const i = e + "CollectionSlot", l = /* @__PURE__ */ xt(i), c = q.forwardRef(
    (v, y) => {
      const { scope: b, children: w } = v, x = s(i, b), S = K(y, x.collectionRef);
      return /* @__PURE__ */ p(l, { ref: S, children: w });
    }
  );
  c.displayName = i;
  const u = e + "CollectionItemSlot", f = "data-radix-collection-item", h = /* @__PURE__ */ xt(u), m = q.forwardRef(
    (v, y) => {
      const { scope: b, children: w, ...x } = v, S = q.useRef(null), C = K(y, S), E = s(u, b);
      return q.useEffect(() => (E.itemMap.set(S, { ref: S, ...x }), () => void E.itemMap.delete(S))), /* @__PURE__ */ p(h, { [f]: "", ref: C, children: w });
    }
  );
  m.displayName = u;
  function g(v) {
    const y = s(e + "CollectionConsumer", v);
    return q.useCallback(() => {
      const w = y.collectionRef.current;
      if (!w) return [];
      const x = Array.from(w.querySelectorAll(`[${f}]`));
      return Array.from(y.itemMap.values()).sort(
        (E, A) => x.indexOf(E.ref.current) - x.indexOf(A.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: m },
    g,
    r
  ];
}
var ow = d.createContext(void 0);
function xn(e) {
  const t = d.useContext(ow);
  return e || t || "ltr";
}
function de(e) {
  const t = d.useRef(e);
  return d.useEffect(() => {
    t.current = e;
  }), d.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function sw(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = de(e);
  d.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var aw = "DismissableLayer", xa = "dismissableLayer.update", iw = "dismissableLayer.pointerDownOutside", lw = "dismissableLayer.focusOutside", ic, $d = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Rt = d.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: s,
      onInteractOutside: a,
      onDismiss: i,
      ...l
    } = e, c = d.useContext($d), [u, f] = d.useState(null), h = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = d.useState({}), g = K(t, (A) => f(A)), v = Array.from(c.layers), [y] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), b = v.indexOf(y), w = u ? v.indexOf(u) : -1, x = c.layersWithOutsidePointerEventsDisabled.size > 0, S = w >= b, C = uw((A) => {
      const T = A.target, I = [...c.branches].some((L) => L.contains(T));
      !S || I || (o == null || o(A), a == null || a(A), A.defaultPrevented || i == null || i());
    }, h), E = dw((A) => {
      const T = A.target;
      [...c.branches].some((L) => L.contains(T)) || (s == null || s(A), a == null || a(A), A.defaultPrevented || i == null || i());
    }, h);
    return sw((A) => {
      w === c.layers.size - 1 && (r == null || r(A), !A.defaultPrevented && i && (A.preventDefault(), i()));
    }, h), d.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (ic = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), lc(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = ic);
        };
    }, [u, h, n, c]), d.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), lc());
    }, [u, c]), d.useEffect(() => {
      const A = () => m({});
      return document.addEventListener(xa, A), () => document.removeEventListener(xa, A);
    }, []), /* @__PURE__ */ p(
      $.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: x ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: M(e.onFocusCapture, E.onFocusCapture),
        onBlurCapture: M(e.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: M(
          e.onPointerDownCapture,
          C.onPointerDownCapture
        )
      }
    );
  }
);
Rt.displayName = aw;
var cw = "DismissableLayerBranch", Bd = d.forwardRef((e, t) => {
  const n = d.useContext($d), r = d.useRef(null), o = K(t, r);
  return d.useEffect(() => {
    const s = r.current;
    if (s)
      return n.branches.add(s), () => {
        n.branches.delete(s);
      };
  }, [n.branches]), /* @__PURE__ */ p($.div, { ...e, ref: o });
});
Bd.displayName = cw;
function uw(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = de(e), r = d.useRef(!1), o = d.useRef(() => {
  });
  return d.useEffect(() => {
    const s = (i) => {
      if (i.target && !r.current) {
        let l = function() {
          Ud(
            iw,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = l, t.addEventListener("click", o.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function dw(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = de(e), r = d.useRef(!1);
  return d.useEffect(() => {
    const o = (s) => {
      s.target && !r.current && Ud(lw, n, { originalEvent: s }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function lc() {
  const e = new CustomEvent(xa);
  document.dispatchEvent(e);
}
function Ud(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? pi(o, s) : o.dispatchEvent(s);
}
var fw = Rt, pw = Bd, Ds = 0;
function $o() {
  d.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? cc()), document.body.insertAdjacentElement("beforeend", e[1] ?? cc()), Ds++, () => {
      Ds === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ds--;
    };
  }, []);
}
function cc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ks = "focusScope.autoFocusOnMount", Os = "focusScope.autoFocusOnUnmount", uc = { bubbles: !1, cancelable: !0 }, hw = "FocusScope", pr = d.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s,
    ...a
  } = e, [i, l] = d.useState(null), c = de(o), u = de(s), f = d.useRef(null), h = K(t, (v) => l(v)), m = d.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  d.useEffect(() => {
    if (r) {
      let v = function(x) {
        if (m.paused || !i) return;
        const S = x.target;
        i.contains(S) ? f.current = S : yt(f.current, { select: !0 });
      }, y = function(x) {
        if (m.paused || !i) return;
        const S = x.relatedTarget;
        S !== null && (i.contains(S) || yt(f.current, { select: !0 }));
      }, b = function(x) {
        if (document.activeElement === document.body)
          for (const C of x)
            C.removedNodes.length > 0 && yt(i);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", y);
      const w = new MutationObserver(b);
      return i && w.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", y), w.disconnect();
      };
    }
  }, [r, i, m.paused]), d.useEffect(() => {
    if (i) {
      fc.add(m);
      const v = document.activeElement;
      if (!i.contains(v)) {
        const b = new CustomEvent(ks, uc);
        i.addEventListener(ks, c), i.dispatchEvent(b), b.defaultPrevented || (mw(ww(Wd(i)), { select: !0 }), document.activeElement === v && yt(i));
      }
      return () => {
        i.removeEventListener(ks, c), setTimeout(() => {
          const b = new CustomEvent(Os, uc);
          i.addEventListener(Os, u), i.dispatchEvent(b), b.defaultPrevented || yt(v ?? document.body, { select: !0 }), i.removeEventListener(Os, u), fc.remove(m);
        }, 0);
      };
    }
  }, [i, c, u, m]);
  const g = d.useCallback(
    (v) => {
      if (!n && !r || m.paused) return;
      const y = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
      if (y && b) {
        const w = v.currentTarget, [x, S] = vw(w);
        x && S ? !v.shiftKey && b === S ? (v.preventDefault(), n && yt(x, { select: !0 })) : v.shiftKey && b === x && (v.preventDefault(), n && yt(S, { select: !0 })) : b === w && v.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ p($.div, { tabIndex: -1, ...a, ref: h, onKeyDown: g });
});
pr.displayName = hw;
function mw(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (yt(r, { select: t }), document.activeElement !== n) return;
}
function vw(e) {
  const t = Wd(e), n = dc(t, e), r = dc(t.reverse(), e);
  return [n, r];
}
function Wd(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function dc(e, t) {
  for (const n of e)
    if (!gw(n, { upTo: t })) return n;
}
function gw(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function yw(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function yt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && yw(e) && t && e.select();
  }
}
var fc = bw();
function bw() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = pc(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = pc(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function pc(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function ww(e) {
  return e.filter((t) => t.tagName !== "A");
}
var xw = d[" useId ".trim().toString()] || (() => {
}), Sw = 0;
function ve(e) {
  const [t, n] = d.useState(xw());
  return me(() => {
    n((r) => r ?? String(Sw++));
  }, [e]), t ? `radix-${t}` : "";
}
const Cw = ["top", "right", "bottom", "left"], St = Math.min, De = Math.max, lo = Math.round, Lr = Math.floor, Je = (e) => ({
  x: e,
  y: e
}), Aw = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Sa(e, t, n) {
  return De(e, St(t, n));
}
function ut(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function dt(e) {
  return e.split("-")[0];
}
function Sn(e) {
  return e.split("-")[1];
}
function hi(e) {
  return e === "x" ? "y" : "x";
}
function mi(e) {
  return e === "y" ? "height" : "width";
}
function Ze(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function vi(e) {
  return hi(Ze(e));
}
function Ew(e, t, n) {
  n === void 0 && (n = !1);
  const r = Sn(e), o = vi(e), s = mi(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[s] > t.floating[s] && (a = co(a)), [a, co(a)];
}
function Nw(e) {
  const t = co(e);
  return [Ca(e), t, Ca(t)];
}
function Ca(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const hc = ["left", "right"], mc = ["right", "left"], Tw = ["top", "bottom"], Rw = ["bottom", "top"];
function Pw(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? mc : hc : t ? hc : mc;
    case "left":
    case "right":
      return t ? Tw : Rw;
    default:
      return [];
  }
}
function _w(e, t, n, r) {
  const o = Sn(e);
  let s = Pw(dt(e), n === "start", r);
  return o && (s = s.map((a) => a + "-" + o), t && (s = s.concat(s.map(Ca)))), s;
}
function co(e) {
  const t = dt(e);
  return Aw[t] + e.slice(t.length);
}
function Mw(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Hd(e) {
  return typeof e != "number" ? Mw(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function uo(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function vc(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const s = Ze(t), a = vi(t), i = mi(a), l = dt(t), c = s === "y", u = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, h = r[i] / 2 - o[i] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (Sn(t)) {
    case "start":
      m[a] -= h * (n && c ? -1 : 1);
      break;
    case "end":
      m[a] += h * (n && c ? -1 : 1);
      break;
  }
  return m;
}
async function Iw(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: s,
    rects: a,
    elements: i,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: m = 0
  } = ut(t, e), g = Hd(m), y = i[h ? f === "floating" ? "reference" : "floating" : f], b = uo(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(y))) == null || n ? y : y.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(i.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), w = f === "floating" ? {
    x: r,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(i.floating)), S = await (s.isElement == null ? void 0 : s.isElement(x)) ? await (s.getScale == null ? void 0 : s.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = uo(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: w,
    offsetParent: x,
    strategy: l
  }) : w);
  return {
    top: (b.top - C.top + g.top) / S.y,
    bottom: (C.bottom - b.bottom + g.bottom) / S.y,
    left: (b.left - C.left + g.left) / S.x,
    right: (C.right - b.right + g.right) / S.x
  };
}
const Dw = 50, kw = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: s = [],
    platform: a
  } = n, i = a.detectOverflow ? a : {
    ...a,
    detectOverflow: Iw
  }, l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let c = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: f
  } = vc(c, r, l), h = r, m = 0;
  const g = {};
  for (let v = 0; v < s.length; v++) {
    const y = s[v];
    if (!y)
      continue;
    const {
      name: b,
      fn: w
    } = y, {
      x,
      y: S,
      data: C,
      reset: E
    } = await w({
      x: u,
      y: f,
      initialPlacement: r,
      placement: h,
      strategy: o,
      middlewareData: g,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = x ?? u, f = S ?? f, g[b] = {
      ...g[b],
      ...C
    }, E && m < Dw && (m++, typeof E == "object" && (E.placement && (h = E.placement), E.rects && (c = E.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: u,
      y: f
    } = vc(c, h, l)), v = -1);
  }
  return {
    x: u,
    y: f,
    placement: h,
    strategy: o,
    middlewareData: g
  };
}, Ow = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: s,
      platform: a,
      elements: i,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = ut(e, t) || {};
    if (c == null)
      return {};
    const f = Hd(u), h = {
      x: n,
      y: r
    }, m = vi(o), g = mi(m), v = await a.getDimensions(c), y = m === "y", b = y ? "top" : "left", w = y ? "bottom" : "right", x = y ? "clientHeight" : "clientWidth", S = s.reference[g] + s.reference[m] - h[m] - s.floating[g], C = h[m] - s.reference[m], E = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let A = E ? E[x] : 0;
    (!A || !await (a.isElement == null ? void 0 : a.isElement(E))) && (A = i.floating[x] || s.floating[g]);
    const T = S / 2 - C / 2, I = A / 2 - v[g] / 2 - 1, L = St(f[b], I), B = St(f[w], I), V = L, z = A - v[g] - B, D = A / 2 - v[g] / 2 + T, G = Sa(V, D, z), U = !l.arrow && Sn(o) != null && D !== G && s.reference[g] / 2 - (D < V ? L : B) - v[g] / 2 < 0, P = U ? D < V ? D - V : D - z : 0;
    return {
      [m]: h[m] + P,
      data: {
        [m]: G,
        centerOffset: D - G - P,
        ...U && {
          alignmentOffset: P
        }
      },
      reset: U
    };
  }
}), Lw = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: s,
        rects: a,
        initialPlacement: i,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...y
      } = ut(e, t);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const b = dt(o), w = Ze(i), x = dt(i) === i, S = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), C = h || (x || !v ? [co(i)] : Nw(i)), E = g !== "none";
      !h && E && C.push(..._w(i, v, g, S));
      const A = [i, ...C], T = await l.detectOverflow(t, y), I = [];
      let L = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (u && I.push(T[b]), f) {
        const D = Ew(o, a, S);
        I.push(T[D[0]], T[D[1]]);
      }
      if (L = [...L, {
        placement: o,
        overflows: I
      }], !I.every((D) => D <= 0)) {
        var B, V;
        const D = (((B = s.flip) == null ? void 0 : B.index) || 0) + 1, G = A[D];
        if (G && (!(f === "alignment" ? w !== Ze(G) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        L.every((R) => Ze(R.placement) === w ? R.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: L
            },
            reset: {
              placement: G
            }
          };
        let U = (V = L.filter((P) => P.overflows[0] <= 0).sort((P, R) => P.overflows[1] - R.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!U)
          switch (m) {
            case "bestFit": {
              var z;
              const P = (z = L.filter((R) => {
                if (E) {
                  const k = Ze(R.placement);
                  return k === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  k === "y";
                }
                return !0;
              }).map((R) => [R.placement, R.overflows.filter((k) => k > 0).reduce((k, Z) => k + Z, 0)]).sort((R, k) => R[1] - k[1])[0]) == null ? void 0 : z[0];
              P && (U = P);
              break;
            }
            case "initialPlacement":
              U = i;
              break;
          }
        if (o !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
function gc(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function yc(e) {
  return Cw.some((t) => e[t] >= 0);
}
const Vw = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: r
      } = t, {
        strategy: o = "referenceHidden",
        ...s
      } = ut(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await r.detectOverflow(t, {
            ...s,
            elementContext: "reference"
          }), i = gc(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: yc(i)
            }
          };
        }
        case "escaped": {
          const a = await r.detectOverflow(t, {
            ...s,
            altBoundary: !0
          }), i = gc(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: yc(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Gd = /* @__PURE__ */ new Set(["left", "top"]);
async function Fw(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, s = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = dt(n), i = Sn(n), l = Ze(n) === "y", c = Gd.has(a) ? -1 : 1, u = s && l ? -1 : 1, f = ut(t, e);
  let {
    mainAxis: h,
    crossAxis: m,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return i && typeof g == "number" && (m = i === "end" ? g * -1 : g), l ? {
    x: m * u,
    y: h * c
  } : {
    x: h * c,
    y: m * u
  };
}
const $w = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: s,
        placement: a,
        middlewareData: i
      } = t, l = await Fw(t, e);
      return a === ((n = i.offset) == null ? void 0 : n.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, Bw = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        platform: s
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: l = {
          fn: (b) => {
            let {
              x: w,
              y: x
            } = b;
            return {
              x: w,
              y: x
            };
          }
        },
        ...c
      } = ut(e, t), u = {
        x: n,
        y: r
      }, f = await s.detectOverflow(t, c), h = Ze(dt(o)), m = hi(h);
      let g = u[m], v = u[h];
      if (a) {
        const b = m === "y" ? "top" : "left", w = m === "y" ? "bottom" : "right", x = g + f[b], S = g - f[w];
        g = Sa(x, g, S);
      }
      if (i) {
        const b = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", x = v + f[b], S = v - f[w];
        v = Sa(x, v, S);
      }
      const y = l.fn({
        ...t,
        [m]: g,
        [h]: v
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - r,
          enabled: {
            [m]: a,
            [h]: i
          }
        }
      };
    }
  };
}, Uw = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: s,
        middlewareData: a
      } = t, {
        offset: i = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = ut(e, t), u = {
        x: n,
        y: r
      }, f = Ze(o), h = hi(f);
      let m = u[h], g = u[f];
      const v = ut(i, t), y = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (l) {
        const x = h === "y" ? "height" : "width", S = s.reference[h] - s.floating[x] + y.mainAxis, C = s.reference[h] + s.reference[x] - y.mainAxis;
        m < S ? m = S : m > C && (m = C);
      }
      if (c) {
        var b, w;
        const x = h === "y" ? "width" : "height", S = Gd.has(dt(o)), C = s.reference[f] - s.floating[x] + (S && ((b = a.offset) == null ? void 0 : b[f]) || 0) + (S ? 0 : y.crossAxis), E = s.reference[f] + s.reference[x] + (S ? 0 : ((w = a.offset) == null ? void 0 : w[f]) || 0) - (S ? y.crossAxis : 0);
        g < C ? g = C : g > E && (g = E);
      }
      return {
        [h]: m,
        [f]: g
      };
    }
  };
}, Ww = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: s,
        platform: a,
        elements: i
      } = t, {
        apply: l = () => {
        },
        ...c
      } = ut(e, t), u = await a.detectOverflow(t, c), f = dt(o), h = Sn(o), m = Ze(o) === "y", {
        width: g,
        height: v
      } = s.floating;
      let y, b;
      f === "top" || f === "bottom" ? (y = f, b = h === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (b = f, y = h === "end" ? "top" : "bottom");
      const w = v - u.top - u.bottom, x = g - u.left - u.right, S = St(v - u[y], w), C = St(g - u[b], x), E = !t.middlewareData.shift;
      let A = S, T = C;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (T = x), (r = t.middlewareData.shift) != null && r.enabled.y && (A = w), E && !h) {
        const L = De(u.left, 0), B = De(u.right, 0), V = De(u.top, 0), z = De(u.bottom, 0);
        m ? T = g - 2 * (L !== 0 || B !== 0 ? L + B : De(u.left, u.right)) : A = v - 2 * (V !== 0 || z !== 0 ? V + z : De(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: T,
        availableHeight: A
      });
      const I = await a.getDimensions(i.floating);
      return g !== I.width || v !== I.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Bo() {
  return typeof window < "u";
}
function Cn(e) {
  return jd(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Oe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function rt(e) {
  var t;
  return (t = (jd(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function jd(e) {
  return Bo() ? e instanceof Node || e instanceof Oe(e).Node : !1;
}
function je(e) {
  return Bo() ? e instanceof Element || e instanceof Oe(e).Element : !1;
}
function ht(e) {
  return Bo() ? e instanceof HTMLElement || e instanceof Oe(e).HTMLElement : !1;
}
function bc(e) {
  return !Bo() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Oe(e).ShadowRoot;
}
function hr(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Ke(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && o !== "inline" && o !== "contents";
}
function Hw(e) {
  return /^(table|td|th)$/.test(Cn(e));
}
function Uo(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Gw = /transform|translate|scale|rotate|perspective|filter/, jw = /paint|layout|strict|content/, kt = (e) => !!e && e !== "none";
let Ls;
function gi(e) {
  const t = je(e) ? Ke(e) : e;
  return kt(t.transform) || kt(t.translate) || kt(t.scale) || kt(t.rotate) || kt(t.perspective) || !yi() && (kt(t.backdropFilter) || kt(t.filter)) || Gw.test(t.willChange || "") || jw.test(t.contain || "");
}
function Kw(e) {
  let t = Ct(e);
  for (; ht(t) && !fn(t); ) {
    if (gi(t))
      return t;
    if (Uo(t))
      return null;
    t = Ct(t);
  }
  return null;
}
function yi() {
  return Ls == null && (Ls = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Ls;
}
function fn(e) {
  return /^(html|body|#document)$/.test(Cn(e));
}
function Ke(e) {
  return Oe(e).getComputedStyle(e);
}
function Wo(e) {
  return je(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ct(e) {
  if (Cn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    bc(e) && e.host || // Fallback.
    rt(e)
  );
  return bc(t) ? t.host : t;
}
function Kd(e) {
  const t = Ct(e);
  return fn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ht(t) && hr(t) ? t : Kd(t);
}
function rr(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Kd(e), s = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = Oe(o);
  if (s) {
    const i = Aa(a);
    return t.concat(a, a.visualViewport || [], hr(o) ? o : [], i && n ? rr(i) : []);
  } else
    return t.concat(o, rr(o, [], n));
}
function Aa(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function zd(e) {
  const t = Ke(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = ht(e), s = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, i = lo(n) !== s || lo(r) !== a;
  return i && (n = s, r = a), {
    width: n,
    height: r,
    $: i
  };
}
function bi(e) {
  return je(e) ? e : e.contextElement;
}
function ln(e) {
  const t = bi(e);
  if (!ht(t))
    return Je(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: s
  } = zd(t);
  let a = (s ? lo(n.width) : n.width) / r, i = (s ? lo(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const zw = /* @__PURE__ */ Je(0);
function Yd(e) {
  const t = Oe(e);
  return !yi() || !t.visualViewport ? zw : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Yw(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Oe(e) ? !1 : t;
}
function Wt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), s = bi(e);
  let a = Je(1);
  t && (r ? je(r) && (a = ln(r)) : a = ln(e));
  const i = Yw(s, n, r) ? Yd(s) : Je(0);
  let l = (o.left + i.x) / a.x, c = (o.top + i.y) / a.y, u = o.width / a.x, f = o.height / a.y;
  if (s) {
    const h = Oe(s), m = r && je(r) ? Oe(r) : r;
    let g = h, v = Aa(g);
    for (; v && r && m !== g; ) {
      const y = ln(v), b = v.getBoundingClientRect(), w = Ke(v), x = b.left + (v.clientLeft + parseFloat(w.paddingLeft)) * y.x, S = b.top + (v.clientTop + parseFloat(w.paddingTop)) * y.y;
      l *= y.x, c *= y.y, u *= y.x, f *= y.y, l += x, c += S, g = Oe(v), v = Aa(g);
    }
  }
  return uo({
    width: u,
    height: f,
    x: l,
    y: c
  });
}
function Ho(e, t) {
  const n = Wo(e).scrollLeft;
  return t ? t.left + n : Wt(rt(e)).left + n;
}
function Xd(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Ho(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Xw(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const s = o === "fixed", a = rt(r), i = t ? Uo(t.floating) : !1;
  if (r === a || i && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Je(1);
  const u = Je(0), f = ht(r);
  if ((f || !f && !s) && ((Cn(r) !== "body" || hr(a)) && (l = Wo(r)), f)) {
    const m = Wt(r);
    c = ln(r), u.x = m.x + r.clientLeft, u.y = m.y + r.clientTop;
  }
  const h = a && !f && !s ? Xd(a, l) : Je(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - l.scrollLeft * c.x + u.x + h.x,
    y: n.y * c.y - l.scrollTop * c.y + u.y + h.y
  };
}
function qw(e) {
  return Array.from(e.getClientRects());
}
function Zw(e) {
  const t = rt(e), n = Wo(e), r = e.ownerDocument.body, o = De(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), s = De(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + Ho(e);
  const i = -n.scrollTop;
  return Ke(r).direction === "rtl" && (a += De(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: s,
    x: a,
    y: i
  };
}
const wc = 25;
function Jw(e, t) {
  const n = Oe(e), r = rt(e), o = n.visualViewport;
  let s = r.clientWidth, a = r.clientHeight, i = 0, l = 0;
  if (o) {
    s = o.width, a = o.height;
    const u = yi();
    (!u || u && t === "fixed") && (i = o.offsetLeft, l = o.offsetTop);
  }
  const c = Ho(r);
  if (c <= 0) {
    const u = r.ownerDocument, f = u.body, h = getComputedStyle(f), m = u.compatMode === "CSS1Compat" && parseFloat(h.marginLeft) + parseFloat(h.marginRight) || 0, g = Math.abs(r.clientWidth - f.clientWidth - m);
    g <= wc && (s -= g);
  } else c <= wc && (s += c);
  return {
    width: s,
    height: a,
    x: i,
    y: l
  };
}
function Qw(e, t) {
  const n = Wt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, s = ht(e) ? ln(e) : Je(1), a = e.clientWidth * s.x, i = e.clientHeight * s.y, l = o * s.x, c = r * s.y;
  return {
    width: a,
    height: i,
    x: l,
    y: c
  };
}
function xc(e, t, n) {
  let r;
  if (t === "viewport")
    r = Jw(e, n);
  else if (t === "document")
    r = Zw(rt(e));
  else if (je(t))
    r = Qw(t, n);
  else {
    const o = Yd(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return uo(r);
}
function qd(e, t) {
  const n = Ct(e);
  return n === t || !je(n) || fn(n) ? !1 : Ke(n).position === "fixed" || qd(n, t);
}
function ex(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = rr(e, [], !1).filter((i) => je(i) && Cn(i) !== "body"), o = null;
  const s = Ke(e).position === "fixed";
  let a = s ? Ct(e) : e;
  for (; je(a) && !fn(a); ) {
    const i = Ke(a), l = gi(a);
    !l && i.position === "fixed" && (o = null), (s ? !l && !o : !l && i.position === "static" && !!o && (o.position === "absolute" || o.position === "fixed") || hr(a) && !l && qd(e, a)) ? r = r.filter((u) => u !== a) : o = i, a = Ct(a);
  }
  return t.set(e, r), r;
}
function tx(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? Uo(t) ? [] : ex(t, this._c) : [].concat(n), r], i = xc(t, a[0], o);
  let l = i.top, c = i.right, u = i.bottom, f = i.left;
  for (let h = 1; h < a.length; h++) {
    const m = xc(t, a[h], o);
    l = De(m.top, l), c = St(m.right, c), u = St(m.bottom, u), f = De(m.left, f);
  }
  return {
    width: c - f,
    height: u - l,
    x: f,
    y: l
  };
}
function nx(e) {
  const {
    width: t,
    height: n
  } = zd(e);
  return {
    width: t,
    height: n
  };
}
function rx(e, t, n) {
  const r = ht(t), o = rt(t), s = n === "fixed", a = Wt(e, !0, s, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Je(0);
  function c() {
    l.x = Ho(o);
  }
  if (r || !r && !s)
    if ((Cn(t) !== "body" || hr(o)) && (i = Wo(t)), r) {
      const m = Wt(t, !0, s, t);
      l.x = m.x + t.clientLeft, l.y = m.y + t.clientTop;
    } else o && c();
  s && !r && o && c();
  const u = o && !r && !s ? Xd(o, i) : Je(0), f = a.left + i.scrollLeft - l.x - u.x, h = a.top + i.scrollTop - l.y - u.y;
  return {
    x: f,
    y: h,
    width: a.width,
    height: a.height
  };
}
function Vs(e) {
  return Ke(e).position === "static";
}
function Sc(e, t) {
  if (!ht(e) || Ke(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return rt(e) === n && (n = n.ownerDocument.body), n;
}
function Zd(e, t) {
  const n = Oe(e);
  if (Uo(e))
    return n;
  if (!ht(e)) {
    let o = Ct(e);
    for (; o && !fn(o); ) {
      if (je(o) && !Vs(o))
        return o;
      o = Ct(o);
    }
    return n;
  }
  let r = Sc(e, t);
  for (; r && Hw(r) && Vs(r); )
    r = Sc(r, t);
  return r && fn(r) && Vs(r) && !gi(r) ? n : r || Kw(e) || n;
}
const ox = async function(e) {
  const t = this.getOffsetParent || Zd, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: rx(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function sx(e) {
  return Ke(e).direction === "rtl";
}
const ax = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Xw,
  getDocumentElement: rt,
  getClippingRect: tx,
  getOffsetParent: Zd,
  getElementRects: ox,
  getClientRects: qw,
  getDimensions: nx,
  getScale: ln,
  isElement: je,
  isRTL: sx
};
function Jd(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function ix(e, t) {
  let n = null, r;
  const o = rt(e);
  function s() {
    var i;
    clearTimeout(r), (i = n) == null || i.disconnect(), n = null;
  }
  function a(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), s();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: f,
      width: h,
      height: m
    } = c;
    if (i || t(), !h || !m)
      return;
    const g = Lr(f), v = Lr(o.clientWidth - (u + h)), y = Lr(o.clientHeight - (f + m)), b = Lr(u), x = {
      rootMargin: -g + "px " + -v + "px " + -y + "px " + -b + "px",
      threshold: De(0, St(1, l)) || 1
    };
    let S = !0;
    function C(E) {
      const A = E[0].intersectionRatio;
      if (A !== l) {
        if (!S)
          return a();
        A ? a(!1, A) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      A === 1 && !Jd(c, e.getBoundingClientRect()) && a(), S = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, x);
    }
    n.observe(e);
  }
  return a(!0), s;
}
function lx(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: s = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = bi(e), u = o || s ? [...c ? rr(c) : [], ...t ? rr(t) : []] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), s && b.addEventListener("resize", n);
  });
  const f = c && i ? ix(c, n) : null;
  let h = -1, m = null;
  a && (m = new ResizeObserver((b) => {
    let [w] = b;
    w && w.target === c && m && t && (m.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var x;
      (x = m) == null || x.observe(t);
    })), n();
  }), c && !l && m.observe(c), t && m.observe(t));
  let g, v = l ? Wt(e) : null;
  l && y();
  function y() {
    const b = Wt(e);
    v && !Jd(v, b) && n(), v = b, g = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    u.forEach((w) => {
      o && w.removeEventListener("scroll", n), s && w.removeEventListener("resize", n);
    }), f == null || f(), (b = m) == null || b.disconnect(), m = null, l && cancelAnimationFrame(g);
  };
}
const cx = $w, ux = Bw, dx = Lw, fx = Ww, px = Vw, Cc = Ow, hx = Uw, mx = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: ax,
    ...n
  }, s = {
    ...o.platform,
    _c: r
  };
  return kw(e, t, {
    ...o,
    platform: s
  });
};
var vx = typeof document < "u", gx = function() {
}, Qr = vx ? ai : gx;
function fo(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!fo(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const s = o[r];
      if (!(s === "_owner" && e.$$typeof) && !fo(e[s], t[s]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Qd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ac(e, t) {
  const n = Qd(e);
  return Math.round(t * n) / n;
}
function Fs(e) {
  const t = d.useRef(e);
  return Qr(() => {
    t.current = e;
  }), t;
}
function yx(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: s,
      floating: a
    } = {},
    transform: i = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, f] = d.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, m] = d.useState(r);
  fo(h, r) || m(r);
  const [g, v] = d.useState(null), [y, b] = d.useState(null), w = d.useCallback((R) => {
    R !== E.current && (E.current = R, v(R));
  }, []), x = d.useCallback((R) => {
    R !== A.current && (A.current = R, b(R));
  }, []), S = s || g, C = a || y, E = d.useRef(null), A = d.useRef(null), T = d.useRef(u), I = l != null, L = Fs(l), B = Fs(o), V = Fs(c), z = d.useCallback(() => {
    if (!E.current || !A.current)
      return;
    const R = {
      placement: t,
      strategy: n,
      middleware: h
    };
    B.current && (R.platform = B.current), mx(E.current, A.current, R).then((k) => {
      const Z = {
        ...k,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: V.current !== !1
      };
      D.current && !fo(T.current, Z) && (T.current = Z, fr.flushSync(() => {
        f(Z);
      }));
    });
  }, [h, t, n, B, V]);
  Qr(() => {
    c === !1 && T.current.isPositioned && (T.current.isPositioned = !1, f((R) => ({
      ...R,
      isPositioned: !1
    })));
  }, [c]);
  const D = d.useRef(!1);
  Qr(() => (D.current = !0, () => {
    D.current = !1;
  }), []), Qr(() => {
    if (S && (E.current = S), C && (A.current = C), S && C) {
      if (L.current)
        return L.current(S, C, z);
      z();
    }
  }, [S, C, z, L, I]);
  const G = d.useMemo(() => ({
    reference: E,
    floating: A,
    setReference: w,
    setFloating: x
  }), [w, x]), U = d.useMemo(() => ({
    reference: S,
    floating: C
  }), [S, C]), P = d.useMemo(() => {
    const R = {
      position: n,
      left: 0,
      top: 0
    };
    if (!U.floating)
      return R;
    const k = Ac(U.floating, u.x), Z = Ac(U.floating, u.y);
    return i ? {
      ...R,
      transform: "translate(" + k + "px, " + Z + "px)",
      ...Qd(U.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: k,
      top: Z
    };
  }, [n, i, U.floating, u.x, u.y]);
  return d.useMemo(() => ({
    ...u,
    update: z,
    refs: G,
    elements: U,
    floatingStyles: P
  }), [u, z, G, U, P]);
}
const bx = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Cc({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Cc({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, wx = (e, t) => {
  const n = cx(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, xx = (e, t) => {
  const n = ux(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Sx = (e, t) => ({
  fn: hx(e).fn,
  options: [e, t]
}), Cx = (e, t) => {
  const n = dx(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Ax = (e, t) => {
  const n = fx(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Ex = (e, t) => {
  const n = px(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, Nx = (e, t) => {
  const n = bx(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var Tx = "Arrow", ef = d.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...s } = e;
  return /* @__PURE__ */ p(
    $.svg,
    {
      ...s,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ p("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
ef.displayName = Tx;
var Rx = ef;
function Go(e) {
  const [t, n] = d.useState(void 0);
  return me(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const s = o[0];
        let a, i;
        if ("borderBoxSize" in s) {
          const l = s.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          a = c.inlineSize, i = c.blockSize;
        } else
          a = e.offsetWidth, i = e.offsetHeight;
        n({ width: a, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var wi = "Popper", [tf, ot] = we(wi), [Px, nf] = tf(wi), rf = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = d.useState(null);
  return /* @__PURE__ */ p(Px, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
rf.displayName = wi;
var of = "PopperAnchor", sf = d.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, s = nf(of, n), a = d.useRef(null), i = K(t, a), l = d.useRef(null);
    return d.useEffect(() => {
      const c = l.current;
      l.current = (r == null ? void 0 : r.current) || a.current, c !== l.current && s.onAnchorChange(l.current);
    }), r ? null : /* @__PURE__ */ p($.div, { ...o, ref: i });
  }
);
sf.displayName = of;
var xi = "PopperContent", [_x, Mx] = tf(xi), af = d.forwardRef(
  (e, t) => {
    var F, J, Q, re, oe, se;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: s = "center",
      alignOffset: a = 0,
      arrowPadding: i = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: g,
      ...v
    } = e, y = nf(xi, n), [b, w] = d.useState(null), x = K(t, (Ie) => w(Ie)), [S, C] = d.useState(null), E = Go(S), A = (E == null ? void 0 : E.width) ?? 0, T = (E == null ? void 0 : E.height) ?? 0, I = r + (s !== "center" ? "-" + s : ""), L = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, B = Array.isArray(c) ? c : [c], V = B.length > 0, z = {
      padding: L,
      boundary: B.filter(Dx),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: V
    }, { refs: D, floatingStyles: G, placement: U, isPositioned: P, middlewareData: R } = yx({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: I,
      whileElementsMounted: (...Ie) => lx(...Ie, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        wx({ mainAxis: o + T, alignmentAxis: a }),
        l && xx({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Sx() : void 0,
          ...z
        }),
        l && Cx({ ...z }),
        Ax({
          ...z,
          apply: ({ elements: Ie, rects: Xe, availableWidth: On, availableHeight: Ln }) => {
            const { width: Vn, height: Vb } = Xe.reference, Or = Ie.floating.style;
            Or.setProperty("--radix-popper-available-width", `${On}px`), Or.setProperty("--radix-popper-available-height", `${Ln}px`), Or.setProperty("--radix-popper-anchor-width", `${Vn}px`), Or.setProperty("--radix-popper-anchor-height", `${Vb}px`);
          }
        }),
        S && Nx({ element: S, padding: i }),
        kx({ arrowWidth: A, arrowHeight: T }),
        h && Ex({ strategy: "referenceHidden", ...z })
      ]
    }), [k, Z] = uf(U), ne = de(g);
    me(() => {
      P && (ne == null || ne());
    }, [P, ne]);
    const _ = (F = R.arrow) == null ? void 0 : F.x, H = (J = R.arrow) == null ? void 0 : J.y, Y = ((Q = R.arrow) == null ? void 0 : Q.centerOffset) !== 0, [W, ee] = d.useState();
    return me(() => {
      b && ee(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ p(
      "div",
      {
        ref: D.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: P ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: W,
          "--radix-popper-transform-origin": [
            (re = R.transformOrigin) == null ? void 0 : re.x,
            (oe = R.transformOrigin) == null ? void 0 : oe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((se = R.hide) == null ? void 0 : se.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ p(
          _x,
          {
            scope: n,
            placedSide: k,
            onArrowChange: C,
            arrowX: _,
            arrowY: H,
            shouldHideArrow: Y,
            children: /* @__PURE__ */ p(
              $.div,
              {
                "data-side": k,
                "data-align": Z,
                ...v,
                ref: x,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: P ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
af.displayName = xi;
var lf = "PopperArrow", Ix = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, cf = d.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, s = Mx(lf, r), a = Ix[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ p(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ p(
          Rx,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
cf.displayName = lf;
function Dx(e) {
  return e !== null;
}
var kx = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, b, w;
    const { placement: n, rects: r, middlewareData: o } = t, a = ((y = o.arrow) == null ? void 0 : y.centerOffset) !== 0, i = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [c, u] = uf(n), f = { start: "0%", center: "50%", end: "100%" }[u], h = (((b = o.arrow) == null ? void 0 : b.x) ?? 0) + i / 2, m = (((w = o.arrow) == null ? void 0 : w.y) ?? 0) + l / 2;
    let g = "", v = "";
    return c === "bottom" ? (g = a ? f : `${h}px`, v = `${-l}px`) : c === "top" ? (g = a ? f : `${h}px`, v = `${r.floating.height + l}px`) : c === "right" ? (g = `${-l}px`, v = a ? f : `${m}px`) : c === "left" && (g = `${r.floating.width + l}px`, v = a ? f : `${m}px`), { data: { x: g, y: v } };
  }
});
function uf(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var An = rf, En = sf, mr = af, vr = cf, Ox = "Portal", Nn = d.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [o, s] = d.useState(!1);
  me(() => s(!0), []);
  const a = n || o && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return a ? Ub.createPortal(/* @__PURE__ */ p($.div, { ...r, ref: t }), a) : null;
});
Nn.displayName = Ox;
function Lx(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var ye = (e) => {
  const { present: t, children: n } = e, r = Vx(t), o = typeof n == "function" ? n({ present: r.isPresent }) : d.Children.only(n), s = K(r.ref, Fx(o));
  return typeof n == "function" || r.isPresent ? d.cloneElement(o, { ref: s }) : null;
};
ye.displayName = "Presence";
function Vx(e) {
  const [t, n] = d.useState(), r = d.useRef(null), o = d.useRef(e), s = d.useRef("none"), a = e ? "mounted" : "unmounted", [i, l] = Lx(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return d.useEffect(() => {
    const c = Vr(r.current);
    s.current = i === "mounted" ? c : "none";
  }, [i]), me(() => {
    const c = r.current, u = o.current;
    if (u !== e) {
      const h = s.current, m = Vr(c);
      e ? l("MOUNT") : m === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && h !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), me(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, f = (m) => {
        const v = Vr(r.current).includes(CSS.escape(m.animationName));
        if (m.target === t && v && (l("ANIMATION_END"), !o.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, h = (m) => {
        m.target === t && (s.current = Vr(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: d.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, n(c);
    }, [])
  };
}
function Vr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Fx(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var $s = "rovingFocusGroup.onEntryFocus", $x = { bubbles: !1, cancelable: !0 }, gr = "RovingFocusGroup", [Ea, df, Bx] = Fo(gr), [Ux, Tn] = we(
  gr,
  [Bx]
), [Wx, Hx] = Ux(gr), ff = d.forwardRef(
  (e, t) => /* @__PURE__ */ p(Ea.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Ea.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Gx, { ...e, ref: t }) }) })
);
ff.displayName = gr;
var Gx = d.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: s,
    currentTabStopId: a,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...f
  } = e, h = d.useRef(null), m = K(t, h), g = xn(s), [v, y] = Pe({
    prop: a,
    defaultProp: i ?? null,
    onChange: l,
    caller: gr
  }), [b, w] = d.useState(!1), x = de(c), S = df(n), C = d.useRef(!1), [E, A] = d.useState(0);
  return d.useEffect(() => {
    const T = h.current;
    if (T)
      return T.addEventListener($s, x), () => T.removeEventListener($s, x);
  }, [x]), /* @__PURE__ */ p(
    Wx,
    {
      scope: n,
      orientation: r,
      dir: g,
      loop: o,
      currentTabStopId: v,
      onItemFocus: d.useCallback(
        (T) => y(T),
        [y]
      ),
      onItemShiftTab: d.useCallback(() => w(!0), []),
      onFocusableItemAdd: d.useCallback(
        () => A((T) => T + 1),
        []
      ),
      onFocusableItemRemove: d.useCallback(
        () => A((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ p(
        $.div,
        {
          tabIndex: b || E === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: M(e.onMouseDown, () => {
            C.current = !0;
          }),
          onFocus: M(e.onFocus, (T) => {
            const I = !C.current;
            if (T.target === T.currentTarget && I && !b) {
              const L = new CustomEvent($s, $x);
              if (T.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const B = S().filter((U) => U.focusable), V = B.find((U) => U.active), z = B.find((U) => U.id === v), G = [V, z, ...B].filter(
                  Boolean
                ).map((U) => U.ref.current);
                mf(G, u);
              }
            }
            C.current = !1;
          }),
          onBlur: M(e.onBlur, () => w(!1))
        }
      )
    }
  );
}), pf = "RovingFocusGroupItem", hf = d.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: s,
      children: a,
      ...i
    } = e, l = ve(), c = s || l, u = Hx(pf, n), f = u.currentTabStopId === c, h = df(n), { onFocusableItemAdd: m, onFocusableItemRemove: g, currentTabStopId: v } = u;
    return d.useEffect(() => {
      if (r)
        return m(), () => g();
    }, [r, m, g]), /* @__PURE__ */ p(
      Ea.ItemSlot,
      {
        scope: n,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ p(
          $.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: t,
            onMouseDown: M(e.onMouseDown, (y) => {
              r ? u.onItemFocus(c) : y.preventDefault();
            }),
            onFocus: M(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: M(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const b = zx(y, u.orientation, u.dir);
              if (b !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let x = h().filter((S) => S.focusable).map((S) => S.ref.current);
                if (b === "last") x.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && x.reverse();
                  const S = x.indexOf(y.currentTarget);
                  x = u.loop ? Yx(x, S + 1) : x.slice(S + 1);
                }
                setTimeout(() => mf(x));
              }
            }),
            children: typeof a == "function" ? a({ isCurrentTabStop: f, hasTabStop: v != null }) : a
          }
        )
      }
    );
  }
);
hf.displayName = pf;
var jx = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Kx(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function zx(e, t, n) {
  const r = Kx(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return jx[r];
}
function mf(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Yx(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Si = ff, Ci = hf, Xx = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, qt = /* @__PURE__ */ new WeakMap(), Fr = /* @__PURE__ */ new WeakMap(), $r = {}, Bs = 0, vf = function(e) {
  return e && (e.host || vf(e.parentNode));
}, qx = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = vf(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Zx = function(e, t, n, r) {
  var o = qx(t, Array.isArray(e) ? e : [e]);
  $r[n] || ($r[n] = /* @__PURE__ */ new WeakMap());
  var s = $r[n], a = [], i = /* @__PURE__ */ new Set(), l = new Set(o), c = function(f) {
    !f || i.has(f) || (i.add(f), c(f.parentNode));
  };
  o.forEach(c);
  var u = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(h) {
      if (i.has(h))
        u(h);
      else
        try {
          var m = h.getAttribute(r), g = m !== null && m !== "false", v = (qt.get(h) || 0) + 1, y = (s.get(h) || 0) + 1;
          qt.set(h, v), s.set(h, y), a.push(h), v === 1 && g && Fr.set(h, !0), y === 1 && h.setAttribute(n, "true"), g || h.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", h, b);
        }
    });
  };
  return u(t), i.clear(), Bs++, function() {
    a.forEach(function(f) {
      var h = qt.get(f) - 1, m = s.get(f) - 1;
      qt.set(f, h), s.set(f, m), h || (Fr.has(f) || f.removeAttribute(r), Fr.delete(f)), m || f.removeAttribute(n);
    }), Bs--, Bs || (qt = /* @__PURE__ */ new WeakMap(), qt = /* @__PURE__ */ new WeakMap(), Fr = /* @__PURE__ */ new WeakMap(), $r = {});
  };
}, jo = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = Xx(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), Zx(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, qe = function() {
  return qe = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, qe.apply(this, arguments);
};
function gf(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Jx(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, s; r < o; r++)
    (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var eo = "right-scroll-bar-position", to = "width-before-scroll-bar", Qx = "with-scroll-bars-hidden", eS = "--removed-body-scroll-bar-size";
function Us(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function tS(e, t) {
  var n = Ge(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var nS = typeof window < "u" ? d.useLayoutEffect : d.useEffect, Ec = /* @__PURE__ */ new WeakMap();
function rS(e, t) {
  var n = tS(null, function(r) {
    return e.forEach(function(o) {
      return Us(o, r);
    });
  });
  return nS(function() {
    var r = Ec.get(n);
    if (r) {
      var o = new Set(r), s = new Set(e), a = n.current;
      o.forEach(function(i) {
        s.has(i) || Us(i, null);
      }), s.forEach(function(i) {
        o.has(i) || Us(i, a);
      });
    }
    Ec.set(n, e);
  }, [e]), n;
}
function oS(e) {
  return e;
}
function sS(e, t) {
  t === void 0 && (t = oS);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var a = t(s, r);
      return n.push(a), function() {
        n = n.filter(function(i) {
          return i !== a;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(s);
      }
      n = {
        push: function(i) {
          return s(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var a = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(s), a = n;
      }
      var l = function() {
        var u = a;
        a = [], u.forEach(s);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          a.push(u), c();
        },
        filter: function(u) {
          return a = a.filter(u), n;
        }
      };
    }
  };
  return o;
}
function aS(e) {
  e === void 0 && (e = {});
  var t = sS(null);
  return t.options = qe({ async: !0, ssr: !1 }, e), t;
}
var yf = function(e) {
  var t = e.sideCar, n = gf(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return d.createElement(r, qe({}, n));
};
yf.isSideCarExport = !0;
function iS(e, t) {
  return e.useMedium(t), yf;
}
var bf = aS(), Ws = function() {
}, Ko = d.forwardRef(function(e, t) {
  var n = d.useRef(null), r = d.useState({
    onScrollCapture: Ws,
    onWheelCapture: Ws,
    onTouchMoveCapture: Ws
  }), o = r[0], s = r[1], a = e.forwardProps, i = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, f = e.shards, h = e.sideCar, m = e.noRelative, g = e.noIsolation, v = e.inert, y = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, x = e.gapMode, S = gf(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = h, E = rS([n, t]), A = qe(qe({}, S), o);
  return d.createElement(
    d.Fragment,
    null,
    u && d.createElement(C, { sideCar: bf, removeScrollBar: c, shards: f, noRelative: m, noIsolation: g, inert: v, setCallbacks: s, allowPinchZoom: !!y, lockRef: n, gapMode: x }),
    a ? d.cloneElement(d.Children.only(i), qe(qe({}, A), { ref: E })) : d.createElement(w, qe({}, A, { className: l, ref: E }), i)
  );
});
Ko.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ko.classNames = {
  fullWidth: to,
  zeroRight: eo
};
var lS = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function cS() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = lS();
  return t && e.setAttribute("nonce", t), e;
}
function uS(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function dS(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var fS = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = cS()) && (uS(t, n), dS(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, pS = function() {
  var e = fS();
  return function(t, n) {
    d.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, wf = function() {
  var e = pS(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, hS = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Hs = function(e) {
  return parseInt(e || "", 10) || 0;
}, mS = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Hs(n), Hs(r), Hs(o)];
}, vS = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return hS;
  var t = mS(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, gS = wf(), cn = "data-scroll-locked", yS = function(e, t, n, r) {
  var o = e.left, s = e.top, a = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Qx, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(cn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(eo, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(to, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(eo, " .").concat(eo, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(to, " .").concat(to, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(cn, `] {
    `).concat(eS, ": ").concat(i, `px;
  }
`);
}, Nc = function() {
  var e = parseInt(document.body.getAttribute(cn) || "0", 10);
  return isFinite(e) ? e : 0;
}, bS = function() {
  d.useEffect(function() {
    return document.body.setAttribute(cn, (Nc() + 1).toString()), function() {
      var e = Nc() - 1;
      e <= 0 ? document.body.removeAttribute(cn) : document.body.setAttribute(cn, e.toString());
    };
  }, []);
}, wS = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  bS();
  var s = d.useMemo(function() {
    return vS(o);
  }, [o]);
  return d.createElement(gS, { styles: yS(s, !t, o, n ? "" : "!important") });
}, Na = !1;
if (typeof window < "u")
  try {
    var Br = Object.defineProperty({}, "passive", {
      get: function() {
        return Na = !0, !0;
      }
    });
    window.addEventListener("test", Br, Br), window.removeEventListener("test", Br, Br);
  } catch {
    Na = !1;
  }
var Zt = Na ? { passive: !1 } : !1, xS = function(e) {
  return e.tagName === "TEXTAREA";
}, xf = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !xS(e) && n[t] === "visible")
  );
}, SS = function(e) {
  return xf(e, "overflowY");
}, CS = function(e) {
  return xf(e, "overflowX");
}, Tc = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Sf(e, r);
    if (o) {
      var s = Cf(e, r), a = s[1], i = s[2];
      if (a > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, AS = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, ES = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Sf = function(e, t) {
  return e === "v" ? SS(t) : CS(t);
}, Cf = function(e, t) {
  return e === "v" ? AS(t) : ES(t);
}, NS = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, TS = function(e, t, n, r, o) {
  var s = NS(e, window.getComputedStyle(t).direction), a = s * r, i = n.target, l = t.contains(i), c = !1, u = a > 0, f = 0, h = 0;
  do {
    if (!i)
      break;
    var m = Cf(e, i), g = m[0], v = m[1], y = m[2], b = v - y - s * g;
    (g || b) && Sf(e, i) && (f += b, h += g);
    var w = i.parentNode;
    i = w && w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? w.host : w;
  } while (
    // portaled content
    !l && i !== document.body || // self content
    l && (t.contains(i) || t === i)
  );
  return (u && Math.abs(f) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, Ur = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Rc = function(e) {
  return [e.deltaX, e.deltaY];
}, Pc = function(e) {
  return e && "current" in e ? e.current : e;
}, RS = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, PS = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, _S = 0, Jt = [];
function MS(e) {
  var t = d.useRef([]), n = d.useRef([0, 0]), r = d.useRef(), o = d.useState(_S++)[0], s = d.useState(wf)[0], a = d.useRef(e);
  d.useEffect(function() {
    a.current = e;
  }, [e]), d.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = Jx([e.lockRef.current], (e.shards || []).map(Pc), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = d.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !a.current.allowPinchZoom;
    var b = Ur(v), w = n.current, x = "deltaX" in v ? v.deltaX : w[0] - b[0], S = "deltaY" in v ? v.deltaY : w[1] - b[1], C, E = v.target, A = Math.abs(x) > Math.abs(S) ? "h" : "v";
    if ("touches" in v && A === "h" && E.type === "range")
      return !1;
    var T = window.getSelection(), I = T && T.anchorNode, L = I ? I === E || I.contains(E) : !1;
    if (L)
      return !1;
    var B = Tc(A, E);
    if (!B)
      return !0;
    if (B ? C = A : (C = A === "v" ? "h" : "v", B = Tc(A, E)), !B)
      return !1;
    if (!r.current && "changedTouches" in v && (x || S) && (r.current = C), !C)
      return !0;
    var V = r.current || C;
    return TS(V, y, v, V === "h" ? x : S);
  }, []), l = d.useCallback(function(v) {
    var y = v;
    if (!(!Jt.length || Jt[Jt.length - 1] !== s)) {
      var b = "deltaY" in y ? Rc(y) : Ur(y), w = t.current.filter(function(C) {
        return C.name === y.type && (C.target === y.target || y.target === C.shadowParent) && RS(C.delta, b);
      })[0];
      if (w && w.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!w) {
        var x = (a.current.shards || []).map(Pc).filter(Boolean).filter(function(C) {
          return C.contains(y.target);
        }), S = x.length > 0 ? i(y, x[0]) : !a.current.noIsolation;
        S && y.cancelable && y.preventDefault();
      }
    }
  }, []), c = d.useCallback(function(v, y, b, w) {
    var x = { name: v, delta: y, target: b, should: w, shadowParent: IS(b) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== x;
      });
    }, 1);
  }, []), u = d.useCallback(function(v) {
    n.current = Ur(v), r.current = void 0;
  }, []), f = d.useCallback(function(v) {
    c(v.type, Rc(v), v.target, i(v, e.lockRef.current));
  }, []), h = d.useCallback(function(v) {
    c(v.type, Ur(v), v.target, i(v, e.lockRef.current));
  }, []);
  d.useEffect(function() {
    return Jt.push(s), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Zt), document.addEventListener("touchmove", l, Zt), document.addEventListener("touchstart", u, Zt), function() {
      Jt = Jt.filter(function(v) {
        return v !== s;
      }), document.removeEventListener("wheel", l, Zt), document.removeEventListener("touchmove", l, Zt), document.removeEventListener("touchstart", u, Zt);
    };
  }, []);
  var m = e.removeScrollBar, g = e.inert;
  return d.createElement(
    d.Fragment,
    null,
    g ? d.createElement(s, { styles: PS(o) }) : null,
    m ? d.createElement(wS, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function IS(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const DS = iS(bf, MS);
var yr = d.forwardRef(function(e, t) {
  return d.createElement(Ko, qe({}, e, { ref: t, sideCar: DS }));
});
yr.classNames = Ko.classNames;
var Ta = ["Enter", " "], kS = ["ArrowDown", "PageUp", "Home"], Af = ["ArrowUp", "PageDown", "End"], OS = [...kS, ...Af], LS = {
  ltr: [...Ta, "ArrowRight"],
  rtl: [...Ta, "ArrowLeft"]
}, VS = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, br = "Menu", [or, FS, $S] = Fo(br), [Yt, Ef] = we(br, [
  $S,
  ot,
  Tn
]), wr = ot(), Nf = Tn(), [Tf, Pt] = Yt(br), [BS, xr] = Yt(br), Rf = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: s, modal: a = !0 } = e, i = wr(t), [l, c] = d.useState(null), u = d.useRef(!1), f = de(s), h = xn(o);
  return d.useEffect(() => {
    const m = () => {
      u.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => u.current = !1;
    return document.addEventListener("keydown", m, { capture: !0 }), () => {
      document.removeEventListener("keydown", m, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ p(An, { ...i, children: /* @__PURE__ */ p(
    Tf,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ p(
        BS,
        {
          scope: t,
          onClose: d.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: u,
          dir: h,
          modal: a,
          children: r
        }
      )
    }
  ) });
};
Rf.displayName = br;
var US = "MenuAnchor", Ai = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = wr(n);
    return /* @__PURE__ */ p(En, { ...o, ...r, ref: t });
  }
);
Ai.displayName = US;
var Ei = "MenuPortal", [WS, Pf] = Yt(Ei, {
  forceMount: void 0
}), _f = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, s = Pt(Ei, t);
  return /* @__PURE__ */ p(WS, { scope: t, forceMount: n, children: /* @__PURE__ */ p(ye, { present: n || s.open, children: /* @__PURE__ */ p(Nn, { asChild: !0, container: o, children: r }) }) });
};
_f.displayName = Ei;
var Be = "MenuContent", [HS, Ni] = Yt(Be), Mf = d.forwardRef(
  (e, t) => {
    const n = Pf(Be, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, s = Pt(Be, e.__scopeMenu), a = xr(Be, e.__scopeMenu);
    return /* @__PURE__ */ p(or.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(ye, { present: r || s.open, children: /* @__PURE__ */ p(or.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ p(GS, { ...o, ref: t }) : /* @__PURE__ */ p(jS, { ...o, ref: t }) }) }) });
  }
), GS = d.forwardRef(
  (e, t) => {
    const n = Pt(Be, e.__scopeMenu), r = d.useRef(null), o = K(t, r);
    return d.useEffect(() => {
      const s = r.current;
      if (s) return jo(s);
    }, []), /* @__PURE__ */ p(
      Ti,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: M(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), jS = d.forwardRef((e, t) => {
  const n = Pt(Be, e.__scopeMenu);
  return /* @__PURE__ */ p(
    Ti,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), KS = /* @__PURE__ */ xt("MenuContent.ScrollLock"), Ti = d.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: s,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: f,
      onInteractOutside: h,
      onDismiss: m,
      disableOutsideScroll: g,
      ...v
    } = e, y = Pt(Be, n), b = xr(Be, n), w = wr(n), x = Nf(n), S = FS(n), [C, E] = d.useState(null), A = d.useRef(null), T = K(t, A, y.onContentChange), I = d.useRef(0), L = d.useRef(""), B = d.useRef(0), V = d.useRef(null), z = d.useRef("right"), D = d.useRef(0), G = g ? yr : d.Fragment, U = g ? { as: KS, allowPinchZoom: !0 } : void 0, P = (k) => {
      var F, J;
      const Z = L.current + k, ne = S().filter((Q) => !Q.disabled), _ = document.activeElement, H = (F = ne.find((Q) => Q.ref.current === _)) == null ? void 0 : F.textValue, Y = ne.map((Q) => Q.textValue), W = oC(Y, Z, H), ee = (J = ne.find((Q) => Q.textValue === W)) == null ? void 0 : J.ref.current;
      (function Q(re) {
        L.current = re, window.clearTimeout(I.current), re !== "" && (I.current = window.setTimeout(() => Q(""), 1e3));
      })(Z), ee && setTimeout(() => ee.focus());
    };
    d.useEffect(() => () => window.clearTimeout(I.current), []), $o();
    const R = d.useCallback((k) => {
      var ne, _;
      return z.current === ((ne = V.current) == null ? void 0 : ne.side) && aC(k, (_ = V.current) == null ? void 0 : _.area);
    }, []);
    return /* @__PURE__ */ p(
      HS,
      {
        scope: n,
        searchRef: L,
        onItemEnter: d.useCallback(
          (k) => {
            R(k) && k.preventDefault();
          },
          [R]
        ),
        onItemLeave: d.useCallback(
          (k) => {
            var Z;
            R(k) || ((Z = A.current) == null || Z.focus(), E(null));
          },
          [R]
        ),
        onTriggerLeave: d.useCallback(
          (k) => {
            R(k) && k.preventDefault();
          },
          [R]
        ),
        pointerGraceTimerRef: B,
        onPointerGraceIntentChange: d.useCallback((k) => {
          V.current = k;
        }, []),
        children: /* @__PURE__ */ p(G, { ...U, children: /* @__PURE__ */ p(
          pr,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: M(s, (k) => {
              var Z;
              k.preventDefault(), (Z = A.current) == null || Z.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ p(
              Rt,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: f,
                onInteractOutside: h,
                onDismiss: m,
                children: /* @__PURE__ */ p(
                  Si,
                  {
                    asChild: !0,
                    ...x,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: C,
                    onCurrentTabStopIdChange: E,
                    onEntryFocus: M(l, (k) => {
                      b.isUsingKeyboardRef.current || k.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ p(
                      mr,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Yf(y.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...w,
                        ...v,
                        ref: T,
                        style: { outline: "none", ...v.style },
                        onKeyDown: M(v.onKeyDown, (k) => {
                          const ne = k.target.closest("[data-radix-menu-content]") === k.currentTarget, _ = k.ctrlKey || k.altKey || k.metaKey, H = k.key.length === 1;
                          ne && (k.key === "Tab" && k.preventDefault(), !_ && H && P(k.key));
                          const Y = A.current;
                          if (k.target !== Y || !OS.includes(k.key)) return;
                          k.preventDefault();
                          const ee = S().filter((F) => !F.disabled).map((F) => F.ref.current);
                          Af.includes(k.key) && ee.reverse(), nC(ee);
                        }),
                        onBlur: M(e.onBlur, (k) => {
                          k.currentTarget.contains(k.target) || (window.clearTimeout(I.current), L.current = "");
                        }),
                        onPointerMove: M(
                          e.onPointerMove,
                          sr((k) => {
                            const Z = k.target, ne = D.current !== k.clientX;
                            if (k.currentTarget.contains(Z) && ne) {
                              const _ = k.clientX > D.current ? "right" : "left";
                              z.current = _, D.current = k.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Mf.displayName = Be;
var zS = "MenuGroup", Ri = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p($.div, { role: "group", ...r, ref: t });
  }
);
Ri.displayName = zS;
var YS = "MenuLabel", If = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p($.div, { ...r, ref: t });
  }
);
If.displayName = YS;
var po = "MenuItem", _c = "menu.itemSelect", zo = d.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, s = d.useRef(null), a = xr(po, e.__scopeMenu), i = Ni(po, e.__scopeMenu), l = K(t, s), c = d.useRef(!1), u = () => {
      const f = s.current;
      if (!n && f) {
        const h = new CustomEvent(_c, { bubbles: !0, cancelable: !0 });
        f.addEventListener(_c, (m) => r == null ? void 0 : r(m), { once: !0 }), pi(f, h), h.defaultPrevented ? c.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ p(
      Df,
      {
        ...o,
        ref: l,
        disabled: n,
        onClick: M(e.onClick, u),
        onPointerDown: (f) => {
          var h;
          (h = e.onPointerDown) == null || h.call(e, f), c.current = !0;
        },
        onPointerUp: M(e.onPointerUp, (f) => {
          var h;
          c.current || (h = f.currentTarget) == null || h.click();
        }),
        onKeyDown: M(e.onKeyDown, (f) => {
          const h = i.searchRef.current !== "";
          n || h && f.key === " " || Ta.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
zo.displayName = po;
var Df = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...s } = e, a = Ni(po, n), i = Nf(n), l = d.useRef(null), c = K(t, l), [u, f] = d.useState(!1), [h, m] = d.useState("");
    return d.useEffect(() => {
      const g = l.current;
      g && m((g.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ p(
      or.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? h,
        children: /* @__PURE__ */ p(Ci, { asChild: !0, ...i, focusable: !r, children: /* @__PURE__ */ p(
          $.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...s,
            ref: c,
            onPointerMove: M(
              e.onPointerMove,
              sr((g) => {
                r ? a.onItemLeave(g) : (a.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: M(
              e.onPointerLeave,
              sr((g) => a.onItemLeave(g))
            ),
            onFocus: M(e.onFocus, () => f(!0)),
            onBlur: M(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), XS = "MenuCheckboxItem", kf = d.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ p($f, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ p(
      zo,
      {
        role: "menuitemcheckbox",
        "aria-checked": ho(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": Mi(n),
        onSelect: M(
          o.onSelect,
          () => r == null ? void 0 : r(ho(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
kf.displayName = XS;
var Of = "MenuRadioGroup", [qS, ZS] = Yt(
  Of,
  { value: void 0, onValueChange: () => {
  } }
), Lf = d.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, s = de(r);
    return /* @__PURE__ */ p(qS, { scope: e.__scopeMenu, value: n, onValueChange: s, children: /* @__PURE__ */ p(Ri, { ...o, ref: t }) });
  }
);
Lf.displayName = Of;
var Vf = "MenuRadioItem", Ff = d.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = ZS(Vf, e.__scopeMenu), s = n === o.value;
    return /* @__PURE__ */ p($f, { scope: e.__scopeMenu, checked: s, children: /* @__PURE__ */ p(
      zo,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...r,
        ref: t,
        "data-state": Mi(s),
        onSelect: M(
          r.onSelect,
          () => {
            var a;
            return (a = o.onValueChange) == null ? void 0 : a.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ff.displayName = Vf;
var Pi = "MenuItemIndicator", [$f, JS] = Yt(
  Pi,
  { checked: !1 }
), Bf = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, s = JS(Pi, n);
    return /* @__PURE__ */ p(
      ye,
      {
        present: r || ho(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ p(
          $.span,
          {
            ...o,
            ref: t,
            "data-state": Mi(s.checked)
          }
        )
      }
    );
  }
);
Bf.displayName = Pi;
var QS = "MenuSeparator", Uf = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(
      $.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Uf.displayName = QS;
var eC = "MenuArrow", Wf = d.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = wr(n);
    return /* @__PURE__ */ p(vr, { ...o, ...r, ref: t });
  }
);
Wf.displayName = eC;
var _i = "MenuSub", [tC, Hf] = Yt(_i), Gf = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, s = Pt(_i, t), a = wr(t), [i, l] = d.useState(null), [c, u] = d.useState(null), f = de(o);
  return d.useEffect(() => (s.open === !1 && f(!1), () => f(!1)), [s.open, f]), /* @__PURE__ */ p(An, { ...a, children: /* @__PURE__ */ p(
    Tf,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: c,
      onContentChange: u,
      children: /* @__PURE__ */ p(
        tC,
        {
          scope: t,
          contentId: ve(),
          triggerId: ve(),
          trigger: i,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
Gf.displayName = _i;
var Hn = "MenuSubTrigger", jf = d.forwardRef(
  (e, t) => {
    const n = Pt(Hn, e.__scopeMenu), r = xr(Hn, e.__scopeMenu), o = Hf(Hn, e.__scopeMenu), s = Ni(Hn, e.__scopeMenu), a = d.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: l } = s, c = { __scopeMenu: e.__scopeMenu }, u = d.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return d.useEffect(() => u, [u]), d.useEffect(() => {
      const f = i.current;
      return () => {
        window.clearTimeout(f), l(null);
      };
    }, [i, l]), /* @__PURE__ */ p(Ai, { asChild: !0, ...c, children: /* @__PURE__ */ p(
      Df,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": Yf(n.open),
        ...e,
        ref: Le(t, o.onTriggerChange),
        onClick: (f) => {
          var h;
          (h = e.onClick) == null || h.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: M(
          e.onPointerMove,
          sr((f) => {
            s.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !a.current && (s.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: M(
          e.onPointerLeave,
          sr((f) => {
            var m, g;
            u();
            const h = (m = n.content) == null ? void 0 : m.getBoundingClientRect();
            if (h) {
              const v = (g = n.content) == null ? void 0 : g.dataset.side, y = v === "right", b = y ? -5 : 5, w = h[y ? "left" : "right"], x = h[y ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + b, y: f.clientY },
                  { x: w, y: h.top },
                  { x, y: h.top },
                  { x, y: h.bottom },
                  { x: w, y: h.bottom }
                ],
                side: v
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(f), f.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: M(e.onKeyDown, (f) => {
          var m;
          const h = s.searchRef.current !== "";
          e.disabled || h && f.key === " " || LS[r.dir].includes(f.key) && (n.onOpenChange(!0), (m = n.content) == null || m.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
jf.displayName = Hn;
var Kf = "MenuSubContent", zf = d.forwardRef(
  (e, t) => {
    const n = Pf(Be, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, s = Pt(Be, e.__scopeMenu), a = xr(Be, e.__scopeMenu), i = Hf(Kf, e.__scopeMenu), l = d.useRef(null), c = K(t, l);
    return /* @__PURE__ */ p(or.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(ye, { present: r || s.open, children: /* @__PURE__ */ p(or.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(
      Ti,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ref: c,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var f;
          a.isUsingKeyboardRef.current && ((f = l.current) == null || f.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: M(e.onFocusOutside, (u) => {
          u.target !== i.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: M(e.onEscapeKeyDown, (u) => {
          a.onClose(), u.preventDefault();
        }),
        onKeyDown: M(e.onKeyDown, (u) => {
          var m;
          const f = u.currentTarget.contains(u.target), h = VS[a.dir].includes(u.key);
          f && h && (s.onOpenChange(!1), (m = i.trigger) == null || m.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
zf.displayName = Kf;
function Yf(e) {
  return e ? "open" : "closed";
}
function ho(e) {
  return e === "indeterminate";
}
function Mi(e) {
  return ho(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function nC(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function rC(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function oC(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, s = n ? e.indexOf(n) : -1;
  let a = rC(e, Math.max(s, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function sC(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let s = 0, a = t.length - 1; s < t.length; a = s++) {
    const i = t[s], l = t[a], c = i.x, u = i.y, f = l.x, h = l.y;
    u > r != h > r && n < (f - c) * (r - u) / (h - u) + c && (o = !o);
  }
  return o;
}
function aC(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return sC(n, t);
}
function sr(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var iC = Rf, lC = Ai, cC = _f, uC = Mf, dC = Ri, fC = If, pC = zo, hC = kf, mC = Lf, vC = Ff, gC = Bf, yC = Uf, bC = Wf, wC = Gf, xC = jf, SC = zf, Yo = "DropdownMenu", [CC] = we(
  Yo,
  [Ef]
), Ae = Ef(), [AC, Xf] = CC(Yo), qf = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: s,
    onOpenChange: a,
    modal: i = !0
  } = e, l = Ae(t), c = d.useRef(null), [u, f] = Pe({
    prop: o,
    defaultProp: s ?? !1,
    onChange: a,
    caller: Yo
  });
  return /* @__PURE__ */ p(
    AC,
    {
      scope: t,
      triggerId: ve(),
      triggerRef: c,
      contentId: ve(),
      open: u,
      onOpenChange: f,
      onOpenToggle: d.useCallback(() => f((h) => !h), [f]),
      modal: i,
      children: /* @__PURE__ */ p(iC, { ...l, open: u, onOpenChange: f, dir: r, modal: i, children: n })
    }
  );
};
qf.displayName = Yo;
var Zf = "DropdownMenuTrigger", Jf = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, s = Xf(Zf, n), a = Ae(n);
    return /* @__PURE__ */ p(lC, { asChild: !0, ...a, children: /* @__PURE__ */ p(
      $.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Le(t, s.triggerRef),
        onPointerDown: M(e.onPointerDown, (i) => {
          !r && i.button === 0 && i.ctrlKey === !1 && (s.onOpenToggle(), s.open || i.preventDefault());
        }),
        onKeyDown: M(e.onKeyDown, (i) => {
          r || (["Enter", " "].includes(i.key) && s.onOpenToggle(), i.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
Jf.displayName = Zf;
var EC = "DropdownMenuPortal", Qf = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Ae(t);
  return /* @__PURE__ */ p(cC, { ...r, ...n });
};
Qf.displayName = EC;
var ep = "DropdownMenuContent", tp = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Xf(ep, n), s = Ae(n), a = d.useRef(!1);
    return /* @__PURE__ */ p(
      uC,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...s,
        ...r,
        ref: t,
        onCloseAutoFocus: M(e.onCloseAutoFocus, (i) => {
          var l;
          a.current || (l = o.triggerRef.current) == null || l.focus(), a.current = !1, i.preventDefault();
        }),
        onInteractOutside: M(e.onInteractOutside, (i) => {
          const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!o.modal || u) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
tp.displayName = ep;
var NC = "DropdownMenuGroup", np = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
    return /* @__PURE__ */ p(dC, { ...o, ...r, ref: t });
  }
);
np.displayName = NC;
var TC = "DropdownMenuLabel", rp = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
    return /* @__PURE__ */ p(fC, { ...o, ...r, ref: t });
  }
);
rp.displayName = TC;
var RC = "DropdownMenuItem", op = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
    return /* @__PURE__ */ p(pC, { ...o, ...r, ref: t });
  }
);
op.displayName = RC;
var PC = "DropdownMenuCheckboxItem", sp = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
  return /* @__PURE__ */ p(hC, { ...o, ...r, ref: t });
});
sp.displayName = PC;
var _C = "DropdownMenuRadioGroup", ap = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
  return /* @__PURE__ */ p(mC, { ...o, ...r, ref: t });
});
ap.displayName = _C;
var MC = "DropdownMenuRadioItem", ip = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
  return /* @__PURE__ */ p(vC, { ...o, ...r, ref: t });
});
ip.displayName = MC;
var IC = "DropdownMenuItemIndicator", lp = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
  return /* @__PURE__ */ p(gC, { ...o, ...r, ref: t });
});
lp.displayName = IC;
var DC = "DropdownMenuSeparator", cp = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
  return /* @__PURE__ */ p(yC, { ...o, ...r, ref: t });
});
cp.displayName = DC;
var kC = "DropdownMenuArrow", OC = d.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
    return /* @__PURE__ */ p(bC, { ...o, ...r, ref: t });
  }
);
OC.displayName = kC;
var LC = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: s } = e, a = Ae(t), [i, l] = Pe({
    prop: r,
    defaultProp: s ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ p(wC, { ...a, open: i, onOpenChange: l, children: n });
}, VC = "DropdownMenuSubTrigger", up = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
  return /* @__PURE__ */ p(xC, { ...o, ...r, ref: t });
});
up.displayName = VC;
var FC = "DropdownMenuSubContent", dp = d.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Ae(n);
  return /* @__PURE__ */ p(
    SC,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
dp.displayName = FC;
var $C = qf, BC = Jf, fp = Qf, pp = tp, UC = np, hp = rp, mp = op, vp = sp, WC = ap, gp = ip, yp = lp, bp = cp, HC = LC, wp = up, xp = dp;
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GC = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Sp = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var jC = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const KC = Lo(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: s,
    iconNode: a,
    ...i
  }, l) => io(
    "svg",
    {
      ref: l,
      ...jC,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Sp("lucide", o),
      ...i
    },
    [
      ...a.map(([c, u]) => io(c, u)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ae = (e, t) => {
  const n = Lo(
    ({ className: r, ...o }, s) => io(KC, {
      ref: s,
      iconNode: t,
      className: Sp(`lucide-${GC(e)}`, r),
      ...o
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mo = ae("Calendar", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sr = ae("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cp = ae("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ap = ae("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ii = ae("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zC = ae("ChevronUp", [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YC = ae("ChevronsUpDown", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XC = ae("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qC = ae("CircleCheckBig", [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZC = ae("CircleX", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ep = ae("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vo = ae("Clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JC = ae("Ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QC = ae("Hourglass", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eA = ae("Image", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mc = ae("LoaderCircle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tA = ae("LogOut", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nA = ae("Monitor", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Np = ae("Moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rA = ae("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oA = ae("Send", [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sA = ae("ShieldCheck", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tp = ae("Sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aA = ae("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iA = ae("Upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xo = ae("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), lA = $C, cA = BC, qO = UC, ZO = fp, JO = HC, QO = WC, uA = d.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ O(
  wp,
  {
    ref: o,
    className: N(
      "flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ p(Ii, { className: "ml-auto" })
    ]
  }
));
uA.displayName = wp.displayName;
const dA = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  xp,
  {
    ref: n,
    className: N(
      "z-[100] min-w-[8rem] overflow-hidden rounded-md border border-border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t,
    translate: "no"
  }
));
dA.displayName = xp.displayName;
const Rp = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ p(fp, { children: /* @__PURE__ */ p(
  pp,
  {
    ref: r,
    sideOffset: t,
    className: N(
      "z-[100] min-w-[8rem] overflow-hidden rounded-md border border-border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n,
    translate: "no"
  }
) }));
Rp.displayName = pp.displayName;
const Pp = d.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ p(
  mp,
  {
    ref: o,
    className: N(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...r,
    children: n
  }
));
Pp.displayName = mp.displayName;
const fA = d.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ O(
  vp,
  {
    ref: o,
    className: N(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ p("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p(yp, { children: /* @__PURE__ */ p(Sr, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
fA.displayName = vp.displayName;
const pA = d.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ O(
  gp,
  {
    ref: r,
    className: N(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ p("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p(yp, { children: /* @__PURE__ */ p(Ep, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
pA.displayName = gp.displayName;
const hA = d.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ p(
  hp,
  {
    ref: r,
    className: N(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
hA.displayName = hp.displayName;
const mA = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  bp,
  {
    ref: n,
    className: N("-mx-1 my-1 h-px bg-border", e),
    ...t
  }
));
mA.displayName = bp.displayName;
const vA = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "span",
  {
    className: N("ml-auto text-xs tracking-widest opacity-60", e),
    ...t
  }
);
vA.displayName = "DropdownMenuShortcut";
const gA = {
  toggle: "Toggle theme",
  light: "Light",
  dark: "Dark",
  system: "System"
}, Ic = [
  { value: "light", icon: Tp },
  { value: "dark", icon: Np },
  { value: "system", icon: nA }
];
function eL({
  labels: e,
  showSystemOption: t = !0
} = {}) {
  const { theme: n, setTheme: r } = z0(), [o, s] = d.useState(!1), a = { ...gA, ...e };
  if (d.useEffect(() => {
    s(!0);
  }, []), !o) return null;
  const i = t ? Ic : Ic.filter((l) => l.value !== "system");
  return /* @__PURE__ */ O(lA, { children: [
    /* @__PURE__ */ p(cA, { asChild: !0, children: /* @__PURE__ */ O(
      Ut,
      {
        variant: "ghost",
        size: "sm",
        className: "h-9 w-9 px-0 relative overflow-hidden hover:bg-muted",
        children: [
          /* @__PURE__ */ p(Tp, { className: "h-4 w-4 rotate-0 scale-100 transition-transform duration-500 dark:-rotate-90 dark:scale-0" }),
          /* @__PURE__ */ p(Np, { className: "absolute h-4 w-4 rotate-90 scale-0 transition-transform duration-500 dark:rotate-0 dark:scale-100" }),
          /* @__PURE__ */ p("span", { className: "sr-only", children: a.toggle })
        ]
      }
    ) }),
    /* @__PURE__ */ p(Rp, { align: "end", className: "w-40 bg-background", children: i.map(({ value: l, icon: c }) => /* @__PURE__ */ O(
      Pp,
      {
        className: "flex items-center gap-2 cursor-pointer hover:bg-muted",
        onClick: () => r(l),
        children: [
          /* @__PURE__ */ p(c, { className: "h-4 w-4" }),
          /* @__PURE__ */ p("span", { className: "font-poppins-medium text-sm", children: a[l] }),
          n === l && /* @__PURE__ */ p(Sr, { className: "h-4 w-4 ml-auto" })
        ]
      },
      l
    )) })
  ] });
}
const yA = wn(
  "relative w-full rounded-lg border border-border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-red-500/50 text-red-500 dark:border-red-500 [&>svg]:text-red-500 dark:border-red-900/50 dark:text-red-900 dark:dark:border-red-900 dark:[&>svg]:text-red-900",
        warning: "border-amber-500/50 bg-amber-50 text-amber-800 [&>svg]:text-amber-600 dark:border-amber-500/30 dark:bg-amber-950/50 dark:text-amber-200 dark:[&>svg]:text-amber-400"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), _p = d.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ p(
  "div",
  {
    ref: r,
    role: "alert",
    className: N(yA({ variant: t }), e),
    ...n
  }
));
_p.displayName = "Alert";
const bA = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "h5",
  {
    ref: n,
    className: N("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
bA.displayName = "AlertTitle";
const Mp = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: N("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
Mp.displayName = "AlertDescription";
var qo = "Dialog", [Ip, Dp] = we(qo), [wA, Ye] = Ip(qo), kp = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    modal: a = !0
  } = e, i = d.useRef(null), l = d.useRef(null), [c, u] = Pe({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: qo
  });
  return /* @__PURE__ */ p(
    wA,
    {
      scope: t,
      triggerRef: i,
      contentRef: l,
      contentId: ve(),
      titleId: ve(),
      descriptionId: ve(),
      open: c,
      onOpenChange: u,
      onOpenToggle: d.useCallback(() => u((f) => !f), [u]),
      modal: a,
      children: n
    }
  );
};
kp.displayName = qo;
var Op = "DialogTrigger", Lp = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(Op, n), s = K(t, o.triggerRef);
    return /* @__PURE__ */ p(
      $.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Oi(o.open),
        ...r,
        ref: s,
        onClick: M(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Lp.displayName = Op;
var Di = "DialogPortal", [xA, Vp] = Ip(Di, {
  forceMount: void 0
}), Fp = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, s = Ye(Di, t);
  return /* @__PURE__ */ p(xA, { scope: t, forceMount: n, children: d.Children.map(r, (a) => /* @__PURE__ */ p(ye, { present: n || s.open, children: /* @__PURE__ */ p(Nn, { asChild: !0, container: o, children: a }) })) });
};
Fp.displayName = Di;
var go = "DialogOverlay", $p = d.forwardRef(
  (e, t) => {
    const n = Vp(go, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, s = Ye(go, e.__scopeDialog);
    return s.modal ? /* @__PURE__ */ p(ye, { present: r || s.open, children: /* @__PURE__ */ p(CA, { ...o, ref: t }) }) : null;
  }
);
$p.displayName = go;
var SA = /* @__PURE__ */ xt("DialogOverlay.RemoveScroll"), CA = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(go, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p(yr, { as: SA, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ p(
        $.div,
        {
          "data-state": Oi(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Ht = "DialogContent", Bp = d.forwardRef(
  (e, t) => {
    const n = Vp(Ht, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, s = Ye(Ht, e.__scopeDialog);
    return /* @__PURE__ */ p(ye, { present: r || s.open, children: s.modal ? /* @__PURE__ */ p(AA, { ...o, ref: t }) : /* @__PURE__ */ p(EA, { ...o, ref: t }) });
  }
);
Bp.displayName = Ht;
var AA = d.forwardRef(
  (e, t) => {
    const n = Ye(Ht, e.__scopeDialog), r = d.useRef(null), o = K(t, n.contentRef, r);
    return d.useEffect(() => {
      const s = r.current;
      if (s) return jo(s);
    }, []), /* @__PURE__ */ p(
      Up,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: M(e.onCloseAutoFocus, (s) => {
          var a;
          s.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: M(e.onPointerDownOutside, (s) => {
          const a = s.detail.originalEvent, i = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || i) && s.preventDefault();
        }),
        onFocusOutside: M(
          e.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), EA = d.forwardRef(
  (e, t) => {
    const n = Ye(Ht, e.__scopeDialog), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ p(
      Up,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var a, i;
          (a = e.onCloseAutoFocus) == null || a.call(e, s), s.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), s.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (s) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = s.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && o.current && s.preventDefault();
        }
      }
    );
  }
), Up = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: s, ...a } = e, i = Ye(Ht, n), l = d.useRef(null), c = K(t, l);
    return $o(), /* @__PURE__ */ O(ge, { children: [
      /* @__PURE__ */ p(
        pr,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ p(
            Rt,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": Oi(i.open),
              ...a,
              ref: c,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ O(ge, { children: [
        /* @__PURE__ */ p(TA, { titleId: i.titleId }),
        /* @__PURE__ */ p(PA, { contentRef: l, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), ki = "DialogTitle", Wp = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(ki, n);
    return /* @__PURE__ */ p($.h2, { id: o.titleId, ...r, ref: t });
  }
);
Wp.displayName = ki;
var Hp = "DialogDescription", Gp = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(Hp, n);
    return /* @__PURE__ */ p($.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Gp.displayName = Hp;
var jp = "DialogClose", Kp = d.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ye(jp, n);
    return /* @__PURE__ */ p(
      $.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: M(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Kp.displayName = jp;
function Oi(e) {
  return e ? "open" : "closed";
}
var zp = "DialogTitleWarning", [NA, Yp] = J0(zp, {
  contentName: Ht,
  titleName: ki,
  docsSlug: "dialog"
}), TA = ({ titleId: e }) => {
  const t = Yp(zp), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return d.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, RA = "DialogDescriptionWarning", PA = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Yp(RA).contentName}}.`;
  return d.useEffect(() => {
    var s;
    const o = (s = e.current) == null ? void 0 : s.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Zo = kp, Li = Lp, Jo = Fp, Rn = $p, Pn = Bp, Cr = Wp, Ar = Gp, _n = Kp, Xp = "AlertDialog", [_A] = we(Xp, [
  Dp
]), mt = Dp(), qp = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = mt(t);
  return /* @__PURE__ */ p(Zo, { ...r, ...n, modal: !0 });
};
qp.displayName = Xp;
var MA = "AlertDialogTrigger", Zp = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = mt(n);
    return /* @__PURE__ */ p(Li, { ...o, ...r, ref: t });
  }
);
Zp.displayName = MA;
var IA = "AlertDialogPortal", Jp = (e) => {
  const { __scopeAlertDialog: t, ...n } = e, r = mt(t);
  return /* @__PURE__ */ p(Jo, { ...r, ...n });
};
Jp.displayName = IA;
var DA = "AlertDialogOverlay", Qp = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = mt(n);
    return /* @__PURE__ */ p(Rn, { ...o, ...r, ref: t });
  }
);
Qp.displayName = DA;
var un = "AlertDialogContent", [kA, OA] = _A(un), LA = /* @__PURE__ */ Fd("AlertDialogContent"), eh = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, children: r, ...o } = e, s = mt(n), a = d.useRef(null), i = K(t, a), l = d.useRef(null);
    return /* @__PURE__ */ p(
      NA,
      {
        contentName: un,
        titleName: th,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ p(kA, { scope: n, cancelRef: l, children: /* @__PURE__ */ O(
          Pn,
          {
            role: "alertdialog",
            ...s,
            ...o,
            ref: i,
            onOpenAutoFocus: M(o.onOpenAutoFocus, (c) => {
              var u;
              c.preventDefault(), (u = l.current) == null || u.focus({ preventScroll: !0 });
            }),
            onPointerDownOutside: (c) => c.preventDefault(),
            onInteractOutside: (c) => c.preventDefault(),
            children: [
              /* @__PURE__ */ p(LA, { children: r }),
              /* @__PURE__ */ p(FA, { contentRef: a })
            ]
          }
        ) })
      }
    );
  }
);
eh.displayName = un;
var th = "AlertDialogTitle", nh = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = mt(n);
    return /* @__PURE__ */ p(Cr, { ...o, ...r, ref: t });
  }
);
nh.displayName = th;
var rh = "AlertDialogDescription", oh = d.forwardRef((e, t) => {
  const { __scopeAlertDialog: n, ...r } = e, o = mt(n);
  return /* @__PURE__ */ p(Ar, { ...o, ...r, ref: t });
});
oh.displayName = rh;
var VA = "AlertDialogAction", sh = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, o = mt(n);
    return /* @__PURE__ */ p(_n, { ...o, ...r, ref: t });
  }
);
sh.displayName = VA;
var ah = "AlertDialogCancel", ih = d.forwardRef(
  (e, t) => {
    const { __scopeAlertDialog: n, ...r } = e, { cancelRef: o } = OA(ah, n), s = mt(n), a = K(t, o);
    return /* @__PURE__ */ p(_n, { ...s, ...r, ref: a });
  }
);
ih.displayName = ah;
var FA = ({ contentRef: e }) => {
  const t = `\`${un}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${un}\` by passing a \`${rh}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${un}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  return d.useEffect(() => {
    var r;
    document.getElementById(
      (r = e.current) == null ? void 0 : r.getAttribute("aria-describedby")
    ) || console.warn(t);
  }, [t, e]), null;
}, $A = qp, BA = Zp, UA = Jp, lh = Qp, ch = eh, uh = sh, dh = ih, fh = nh, ph = oh;
const tL = $A, nL = BA, WA = UA, hh = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  lh,
  {
    className: N(
      "fixed inset-0 z-[100] bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
hh.displayName = lh.displayName;
const HA = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ O(WA, { children: [
  /* @__PURE__ */ p(hh, {}),
  /* @__PURE__ */ p(
    ch,
    {
      ref: n,
      className: N(
        "fixed left-[50%] top-[50%] z-[100] grid w-[calc(100%-2rem)] max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-border bg-background p-4 sm:p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] rounded-lg max-h-[calc(100dvh-2rem)] my-4 overflow-y-auto",
        e
      ),
      ...t,
      translate: "no"
    }
  )
] }));
HA.displayName = ch.displayName;
const GA = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "div",
  {
    className: N(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
GA.displayName = "AlertDialogHeader";
const jA = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "div",
  {
    className: N(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
jA.displayName = "AlertDialogFooter";
const KA = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  fh,
  {
    ref: n,
    className: N("text-lg font-semibold", e),
    ...t
  }
));
KA.displayName = fh.displayName;
const zA = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  ph,
  {
    ref: n,
    className: N("text-sm text-muted-foreground", e),
    ...t
  }
));
zA.displayName = ph.displayName;
const YA = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  uh,
  {
    ref: n,
    className: N(Bt(), e),
    ...t
  }
));
YA.displayName = uh.displayName;
const XA = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  dh,
  {
    ref: n,
    className: N(
      Bt({ variant: "outline" }),
      "mt-2 sm:mt-0",
      e
    ),
    ...t
  }
));
XA.displayName = dh.displayName;
function qA(e, t = []) {
  let n = [];
  function r(s, a) {
    const i = d.createContext(a);
    i.displayName = s + "Context";
    const l = n.length;
    n = [...n, a];
    const c = (f) => {
      var b;
      const { scope: h, children: m, ...g } = f, v = ((b = h == null ? void 0 : h[e]) == null ? void 0 : b[l]) || i, y = d.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ p(v.Provider, { value: y, children: m });
    };
    c.displayName = s + "Provider";
    function u(f, h) {
      var v;
      const m = ((v = h == null ? void 0 : h[e]) == null ? void 0 : v[l]) || i, g = d.useContext(m);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return [c, u];
  }
  const o = () => {
    const s = n.map((a) => d.createContext(a));
    return function(i) {
      const l = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return o.scopeName = e, [r, ZA(o, ...t)];
}
function ZA(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(s) {
      const a = r.reduce((i, { useScope: l, scopeName: c }) => {
        const f = l(s)[`__scope${c}`];
        return { ...i, ...f };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var JA = Symbol.for("react.lazy"), yo = d[" use ".trim().toString()];
function QA(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function mh(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === JA && "_payload" in e && QA(e._payload);
}
// @__NO_SIDE_EFFECTS__
function eE(e) {
  const t = /* @__PURE__ */ tE(e), n = d.forwardRef((r, o) => {
    let { children: s, ...a } = r;
    mh(s) && typeof yo == "function" && (s = yo(s._payload));
    const i = d.Children.toArray(s), l = i.find(rE);
    if (l) {
      const c = l.props.children, u = i.map((f) => f === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...a, ref: o, children: d.isValidElement(c) ? d.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ p(t, { ...a, ref: o, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function tE(e) {
  const t = d.forwardRef((n, r) => {
    let { children: o, ...s } = n;
    if (mh(o) && typeof yo == "function" && (o = yo(o._payload)), d.isValidElement(o)) {
      const a = sE(o), i = oE(s, o.props);
      return o.type !== d.Fragment && (i.ref = r ? Le(r, a) : a), d.cloneElement(o, i);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var nE = Symbol("radix.slottable");
function rE(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === nE;
}
function oE(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...i) => {
      const l = s(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function sE(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var aE = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Vi = aE.reduce((e, t) => {
  const n = /* @__PURE__ */ eE(`Primitive.${t}`), r = d.forwardRef((o, s) => {
    const { asChild: a, ...i } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(l, { ...i, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Wr = { exports: {} }, Gs = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dc;
function iE() {
  if (Dc) return Gs;
  Dc = 1;
  var e = q;
  function t(f, h) {
    return f === h && (f !== 0 || 1 / f === 1 / h) || f !== f && h !== h;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, o = e.useEffect, s = e.useLayoutEffect, a = e.useDebugValue;
  function i(f, h) {
    var m = h(), g = r({ inst: { value: m, getSnapshot: h } }), v = g[0].inst, y = g[1];
    return s(
      function() {
        v.value = m, v.getSnapshot = h, l(v) && y({ inst: v });
      },
      [f, m, h]
    ), o(
      function() {
        return l(v) && y({ inst: v }), f(function() {
          l(v) && y({ inst: v });
        });
      },
      [f]
    ), a(m), m;
  }
  function l(f) {
    var h = f.getSnapshot;
    f = f.value;
    try {
      var m = h();
      return !n(f, m);
    } catch {
      return !0;
    }
  }
  function c(f, h) {
    return h();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : i;
  return Gs.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Gs;
}
var js = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kc;
function lE() {
  return kc || (kc = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(m, g) {
      return m === g && (m !== 0 || 1 / m === 1 / g) || m !== m && g !== g;
    }
    function t(m, g) {
      u || o.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var v = g();
      if (!f) {
        var y = g();
        s(v, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      y = a({
        inst: { value: v, getSnapshot: g }
      });
      var b = y[0].inst, w = y[1];
      return l(
        function() {
          b.value = v, b.getSnapshot = g, n(b) && w({ inst: b });
        },
        [m, v, g]
      ), i(
        function() {
          return n(b) && w({ inst: b }), m(function() {
            n(b) && w({ inst: b });
          });
        },
        [m]
      ), c(v), v;
    }
    function n(m) {
      var g = m.getSnapshot;
      m = m.value;
      try {
        var v = g();
        return !s(m, v);
      } catch {
        return !0;
      }
    }
    function r(m, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = q, s = typeof Object.is == "function" ? Object.is : e, a = o.useState, i = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, u = !1, f = !1, h = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    js.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : h, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), js;
}
var Oc;
function cE() {
  return Oc || (Oc = 1, process.env.NODE_ENV === "production" ? Wr.exports = iE() : Wr.exports = lE()), Wr.exports;
}
var uE = cE();
function dE() {
  return uE.useSyncExternalStore(
    fE,
    () => !0,
    () => !1
  );
}
function fE() {
  return () => {
  };
}
var Fi = "Avatar", [pE] = qA(Fi), [hE, vh] = pE(Fi), gh = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [o, s] = d.useState("idle");
    return /* @__PURE__ */ p(
      hE,
      {
        scope: n,
        imageLoadingStatus: o,
        onImageLoadingStatusChange: s,
        children: /* @__PURE__ */ p(Vi.span, { ...r, ref: t })
      }
    );
  }
);
gh.displayName = Fi;
var yh = "AvatarImage", bh = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: o = () => {
    }, ...s } = e, a = vh(yh, n), i = mE(r, s), l = de((c) => {
      o(c), a.onImageLoadingStatusChange(c);
    });
    return me(() => {
      i !== "idle" && l(i);
    }, [i, l]), i === "loaded" ? /* @__PURE__ */ p(Vi.img, { ...s, ref: t, src: r }) : null;
  }
);
bh.displayName = yh;
var wh = "AvatarFallback", xh = d.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...o } = e, s = vh(wh, n), [a, i] = d.useState(r === void 0);
    return d.useEffect(() => {
      if (r !== void 0) {
        const l = window.setTimeout(() => i(!0), r);
        return () => window.clearTimeout(l);
      }
    }, [r]), a && s.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ p(Vi.span, { ...o, ref: t }) : null;
  }
);
xh.displayName = wh;
function Lc(e, t) {
  return e ? t ? (e.src !== t && (e.src = t), e.complete && e.naturalWidth > 0 ? "loaded" : "loading") : "error" : "idle";
}
function mE(e, { referrerPolicy: t, crossOrigin: n }) {
  const r = dE(), o = d.useRef(null), s = r ? (o.current || (o.current = new window.Image()), o.current) : null, [a, i] = d.useState(
    () => Lc(s, e)
  );
  return me(() => {
    i(Lc(s, e));
  }, [s, e]), me(() => {
    const l = (f) => () => {
      i(f);
    };
    if (!s) return;
    const c = l("loaded"), u = l("error");
    return s.addEventListener("load", c), s.addEventListener("error", u), t && (s.referrerPolicy = t), typeof n == "string" && (s.crossOrigin = n), () => {
      s.removeEventListener("load", c), s.removeEventListener("error", u);
    };
  }, [s, n, t]), a;
}
var Sh = gh, Ch = bh, Ah = xh;
const vE = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Sh,
  {
    ref: n,
    className: N(
      "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
      e
    ),
    ...t
  }
));
vE.displayName = Sh.displayName;
const gE = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ch,
  {
    ref: n,
    className: N("aspect-square h-full w-full", e),
    ...t
  }
));
gE.displayName = Ch.displayName;
const yE = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ah,
  {
    ref: n,
    className: N(
      "flex h-full w-full items-center justify-center rounded-full bg-neutral-100 dark:bg-neutral-800",
      e
    ),
    ...t
  }
));
yE.displayName = Ah.displayName;
const bE = wn(
  "inline-flex items-center rounded-full border border-neutral-200 px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 dark:border-neutral-600 dark:focus:ring-neutral-300",
  {
    variants: {
      variant: {
        default: "border-transparent bg-neutral-900 text-neutral-50 hover:bg-neutral-900/80 dark:bg-neutral-50 dark:text-neutral-900 dark:hover:bg-neutral-50/80",
        secondary: "border-transparent bg-neutral-100 text-neutral-900 hover:bg-neutral-100/80 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-800/80",
        destructive: "border-transparent bg-red-500 text-neutral-50 hover:bg-red-500/80 dark:bg-red-900 dark:text-neutral-50 dark:hover:bg-red-900/80",
        outline: "bg-background text-foreground",
        premium: "border-transparent bg-yellow-500 text-neutral-50 hover:bg-yellow-500/80 dark:bg-yellow-500 dark:text-neutral-50 dark:hover:bg-yellow-500/80",
        // Integrations catalog status variants (Epic 36 Story 36.2). Color is paired with
        // an icon + text label by IntegrationStatusBadge — never color-alone (WCAG, AC6).
        available: "border-transparent bg-blue-500 text-neutral-50 hover:bg-blue-500/80 dark:bg-blue-600 dark:text-neutral-50",
        connected: "border-transparent bg-green-600 text-neutral-50 hover:bg-green-600/80 dark:bg-green-700 dark:text-neutral-50",
        error: "border-transparent bg-red-500 text-neutral-50 hover:bg-red-500/80 dark:bg-red-900 dark:text-neutral-50",
        availableOnBusiness: "border-transparent bg-yellow-500 text-neutral-50 hover:bg-yellow-500/80 dark:bg-yellow-500 dark:text-neutral-50",
        managed: "border-transparent bg-slate-200 text-slate-700 hover:bg-slate-200/80 dark:bg-slate-700 dark:text-slate-200",
        comingSoon: "border-transparent bg-zinc-400 text-neutral-50 hover:bg-zinc-400/80 dark:bg-zinc-600 dark:text-neutral-50"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function rL({ className: e, variant: t, ...n }) {
  return /* @__PURE__ */ p("div", { className: N(bE({ variant: t }), e), ...n });
}
const Eh = _e({});
function wE(e) {
  const t = Xn(null);
  return t.current === null && (t.current = e()), t.current;
}
const $i = _e(null), Nh = _e({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function xE(e = !0) {
  const t = pe($i);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: o } = t, s = Fb();
  pt(() => {
    e && o(s);
  }, [e]);
  const a = ii(() => e && r && r(s), [s, r, e]);
  return !n && r ? [!1, a] : [!0];
}
const Bi = typeof window < "u", SE = Bi ? ai : pt, Re = /* @__NO_SIDE_EFFECTS__ */ (e) => e;
let Mn = Re, At = Re;
process.env.NODE_ENV !== "production" && (Mn = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, At = (e, t) => {
  if (!e)
    throw new Error(t);
});
// @__NO_SIDE_EFFECTS__
function Ui(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const pn = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Qe = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, ct = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, CE = {
  useManualTiming: !1
};
function AE(e) {
  let t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = !1, o = !1;
  const s = /* @__PURE__ */ new WeakSet();
  let a = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function i(c) {
    s.has(c) && (l.schedule(c), e()), c(a);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, u = !1, f = !1) => {
      const m = f && r ? t : n;
      return u && s.add(c), m.has(c) || m.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), s.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (a = c, r) {
        o = !0;
        return;
      }
      r = !0, [t, n] = [n, t], t.forEach(i), t.clear(), r = !1, o && (o = !1, l.process(c));
    }
  };
  return l;
}
const Hr = [
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
], EE = 40;
function Th(e, t) {
  let n = !1, r = !0;
  const o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = () => n = !0, a = Hr.reduce((b, w) => (b[w] = AE(s), b), {}), { read: i, resolveKeyframes: l, update: c, preRender: u, render: f, postRender: h } = a, m = () => {
    const b = performance.now();
    n = !1, o.delta = r ? 1e3 / 60 : Math.max(Math.min(b - o.timestamp, EE), 1), o.timestamp = b, o.isProcessing = !0, i.process(o), l.process(o), c.process(o), u.process(o), f.process(o), h.process(o), o.isProcessing = !1, n && t && (r = !1, e(m));
  }, g = () => {
    n = !0, r = !0, o.isProcessing || e(m);
  };
  return { schedule: Hr.reduce((b, w) => {
    const x = a[w];
    return b[w] = (S, C = !1, E = !1) => (n || g(), x.schedule(S, C, E)), b;
  }, {}), cancel: (b) => {
    for (let w = 0; w < Hr.length; w++)
      a[Hr[w]].cancel(b);
  }, state: o, steps: a };
}
const { schedule: ce, cancel: Et, state: xe, steps: Ks } = Th(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Re, !0), Rh = _e({ strict: !1 }), Vc = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, hn = {};
for (const e in Vc)
  hn[e] = {
    isEnabled: (t) => Vc[e].some((n) => !!t[n])
  };
function NE(e) {
  for (const t in e)
    hn[t] = {
      ...hn[t],
      ...e[t]
    };
}
const TE = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function bo(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || TE.has(e);
}
let Ph = (e) => !bo(e);
function RE(e) {
  e && (Ph = (t) => t.startsWith("on") ? !bo(t) : e(t));
}
try {
  RE(require("@emotion/is-prop-valid").default);
} catch {
}
function PE(e, t, n) {
  const r = {};
  for (const o in e)
    o === "values" && typeof e.values == "object" || (Ph(o) || n === !0 && bo(o) || !t && !bo(o) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && o.startsWith("onDrag")) && (r[o] = e[o]);
  return r;
}
const Fc = /* @__PURE__ */ new Set();
function Qo(e, t, n) {
  e || Fc.has(t) || (console.warn(t), Fc.add(t));
}
function _E(e) {
  if (typeof Proxy > "u")
    return e;
  const t = /* @__PURE__ */ new Map(), n = (...r) => (process.env.NODE_ENV !== "production" && Qo(!1, "motion() is deprecated. Use motion.create() instead."), e(...r));
  return new Proxy(n, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (r, o) => o === "create" ? e : (t.has(o) || t.set(o, e(o)), t.get(o))
  });
}
const es = _e({});
function ar(e) {
  return typeof e == "string" || Array.isArray(e);
}
function ts(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
const Wi = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Hi = ["initial", ...Wi];
function ns(e) {
  return ts(e.animate) || Hi.some((t) => ar(e[t]));
}
function _h(e) {
  return !!(ns(e) || e.variants);
}
function ME(e, t) {
  if (ns(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || ar(n) ? n : void 0,
      animate: ar(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function IE(e) {
  const { initial: t, animate: n } = ME(e, pe(es));
  return dn(() => ({ initial: t, animate: n }), [$c(t), $c(n)]);
}
function $c(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const DE = Symbol.for("motionComponentSymbol");
function tn(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function kE(e, t, n) {
  return ii(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : tn(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
const Gi = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), OE = "framerAppearId", Mh = "data-" + Gi(OE), { schedule: ji } = Th(queueMicrotask, !1), Ih = _e({});
function LE(e, t, n, r, o) {
  var s, a;
  const { visualElement: i } = pe(es), l = pe(Rh), c = pe($i), u = pe(Nh).reducedMotion, f = Xn(null);
  r = r || l.renderer, !f.current && r && (f.current = r(e, {
    visualState: t,
    parent: i,
    props: n,
    presenceContext: c,
    blockInitialAnimation: c ? c.initial === !1 : !1,
    reducedMotionConfig: u
  }));
  const h = f.current, m = pe(Ih);
  h && !h.projection && o && (h.type === "html" || h.type === "svg") && VE(f.current, n, o, m);
  const g = Xn(!1);
  $b(() => {
    h && g.current && h.update(n, c);
  });
  const v = n[Mh], y = Xn(!!v && !(!((s = window.MotionHandoffIsComplete) === null || s === void 0) && s.call(window, v)) && ((a = window.MotionHasOptimisedAnimation) === null || a === void 0 ? void 0 : a.call(window, v)));
  return SE(() => {
    h && (g.current = !0, window.MotionIsMounted = !0, h.updateFeatures(), ji.render(h.render), y.current && h.animationState && h.animationState.animateChanges());
  }), pt(() => {
    h && (!y.current && h.animationState && h.animationState.animateChanges(), y.current && (queueMicrotask(() => {
      var b;
      (b = window.MotionHandoffMarkAsComplete) === null || b === void 0 || b.call(window, v);
    }), y.current = !1));
  }), h;
}
function VE(e, t, n, r) {
  const { layoutId: o, layout: s, drag: a, dragConstraints: i, layoutScroll: l, layoutRoot: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : Dh(e.parent)), e.projection.setOptions({
    layoutId: o,
    layout: s,
    alwaysMeasureLayout: !!a || i && tn(i),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof s == "string" ? s : "both",
    initialPromotionConfig: r,
    layoutScroll: l,
    layoutRoot: c
  });
}
function Dh(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : Dh(e.parent);
}
function FE({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: o }) {
  var s, a;
  e && NE(e);
  function i(c, u) {
    let f;
    const h = {
      ...pe(Nh),
      ...c,
      layoutId: $E(c)
    }, { isStatic: m } = h, g = IE(c), v = r(c, m);
    if (!m && Bi) {
      BE(h, e);
      const y = UE(h);
      f = y.MeasureLayout, g.visualElement = LE(o, v, h, t, y.ProjectionNode);
    }
    return O(es.Provider, { value: g, children: [f && g.visualElement ? p(f, { visualElement: g.visualElement, ...h }) : null, n(o, c, kE(v, g.visualElement, u), v, m, g.visualElement)] });
  }
  i.displayName = `motion.${typeof o == "string" ? o : `create(${(a = (s = o.displayName) !== null && s !== void 0 ? s : o.name) !== null && a !== void 0 ? a : ""})`}`;
  const l = Lo(i);
  return l[DE] = o, l;
}
function $E({ layoutId: e }) {
  const t = pe(Eh).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function BE(e, t) {
  const n = pe(Rh).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? Mn(!1, r) : At(!1, r);
  }
}
function UE(e) {
  const { drag: t, layout: n } = hn;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const WE = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Ki(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(WE.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function Bc(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function zi(e, t, n, r) {
  if (typeof t == "function") {
    const [o, s] = Bc(r);
    t = t(n !== void 0 ? n : e.custom, o, s);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [o, s] = Bc(r);
    t = t(n !== void 0 ? n : e.custom, o, s);
  }
  return t;
}
const Ra = (e) => Array.isArray(e), HE = (e) => !!(e && typeof e == "object" && e.mix && e.toValue), GE = (e) => Ra(e) ? e[e.length - 1] || 0 : e, Ce = (e) => !!(e && e.getVelocity);
function no(e) {
  const t = Ce(e) ? e.get() : e;
  return HE(t) ? t.toValue() : t;
}
function jE({ scrapeMotionValuesFromProps: e, createRenderState: t, onUpdate: n }, r, o, s) {
  const a = {
    latestValues: KE(r, o, s, e),
    renderState: t()
  };
  return n && (a.onMount = (i) => n({ props: r, current: i, ...a }), a.onUpdate = (i) => n(i)), a;
}
const kh = (e) => (t, n) => {
  const r = pe(es), o = pe($i), s = () => jE(e, t, r, o);
  return n ? s() : wE(s);
};
function KE(e, t, n, r) {
  const o = {}, s = r(e, {});
  for (const h in s)
    o[h] = no(s[h]);
  let { initial: a, animate: i } = e;
  const l = ns(e), c = _h(e);
  t && c && !l && e.inherit !== !1 && (a === void 0 && (a = t.initial), i === void 0 && (i = t.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || a === !1;
  const f = u ? i : a;
  if (f && typeof f != "boolean" && !ts(f)) {
    const h = Array.isArray(f) ? f : [f];
    for (let m = 0; m < h.length; m++) {
      const g = zi(e, h[m]);
      if (g) {
        const { transitionEnd: v, transition: y, ...b } = g;
        for (const w in b) {
          let x = b[w];
          if (Array.isArray(x)) {
            const S = u ? x.length - 1 : 0;
            x = x[S];
          }
          x !== null && (o[w] = x);
        }
        for (const w in v)
          o[w] = v[w];
      }
    }
  }
  return o;
}
const In = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Xt = new Set(In), Oh = (e) => (t) => typeof t == "string" && t.startsWith(e), Lh = /* @__PURE__ */ Oh("--"), zE = /* @__PURE__ */ Oh("var(--"), Yi = (e) => zE(e) ? YE.test(e.split("/*")[0].trim()) : !1, YE = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Vh = (e, t) => t && typeof e == "number" ? t.transform(e) : e, ft = (e, t, n) => n > t ? t : n < e ? e : n, Dn = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, ir = {
  ...Dn,
  transform: (e) => ft(0, 1, e)
}, Gr = {
  ...Dn,
  default: 1
}, Er = (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), bt = /* @__PURE__ */ Er("deg"), et = /* @__PURE__ */ Er("%"), j = /* @__PURE__ */ Er("px"), XE = /* @__PURE__ */ Er("vh"), qE = /* @__PURE__ */ Er("vw"), Uc = {
  ...et,
  parse: (e) => et.parse(e) / 100,
  transform: (e) => et.transform(e * 100)
}, ZE = {
  // Border props
  borderWidth: j,
  borderTopWidth: j,
  borderRightWidth: j,
  borderBottomWidth: j,
  borderLeftWidth: j,
  borderRadius: j,
  radius: j,
  borderTopLeftRadius: j,
  borderTopRightRadius: j,
  borderBottomRightRadius: j,
  borderBottomLeftRadius: j,
  // Positioning props
  width: j,
  maxWidth: j,
  height: j,
  maxHeight: j,
  top: j,
  right: j,
  bottom: j,
  left: j,
  // Spacing props
  padding: j,
  paddingTop: j,
  paddingRight: j,
  paddingBottom: j,
  paddingLeft: j,
  margin: j,
  marginTop: j,
  marginRight: j,
  marginBottom: j,
  marginLeft: j,
  // Misc
  backgroundPositionX: j,
  backgroundPositionY: j
}, JE = {
  rotate: bt,
  rotateX: bt,
  rotateY: bt,
  rotateZ: bt,
  scale: Gr,
  scaleX: Gr,
  scaleY: Gr,
  scaleZ: Gr,
  skew: bt,
  skewX: bt,
  skewY: bt,
  distance: j,
  translateX: j,
  translateY: j,
  translateZ: j,
  x: j,
  y: j,
  z: j,
  perspective: j,
  transformPerspective: j,
  opacity: ir,
  originX: Uc,
  originY: Uc,
  originZ: j
}, Wc = {
  ...Dn,
  transform: Math.round
}, Xi = {
  ...ZE,
  ...JE,
  zIndex: Wc,
  size: j,
  // SVG
  fillOpacity: ir,
  strokeOpacity: ir,
  numOctaves: Wc
}, QE = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, eN = In.length;
function tN(e, t, n) {
  let r = "", o = !0;
  for (let s = 0; s < eN; s++) {
    const a = In[s], i = e[a];
    if (i === void 0)
      continue;
    let l = !0;
    if (typeof i == "number" ? l = i === (a.startsWith("scale") ? 1 : 0) : l = parseFloat(i) === 0, !l || n) {
      const c = Vh(i, Xi[a]);
      if (!l) {
        o = !1;
        const u = QE[a] || a;
        r += `${u}(${c}) `;
      }
      n && (t[a] = c);
    }
  }
  return r = r.trim(), n ? r = n(t, o ? "" : r) : o && (r = "none"), r;
}
function qi(e, t, n) {
  const { style: r, vars: o, transformOrigin: s } = e;
  let a = !1, i = !1;
  for (const l in t) {
    const c = t[l];
    if (Xt.has(l)) {
      a = !0;
      continue;
    } else if (Lh(l)) {
      o[l] = c;
      continue;
    } else {
      const u = Vh(c, Xi[l]);
      l.startsWith("origin") ? (i = !0, s[l] = u) : r[l] = u;
    }
  }
  if (t.transform || (a || n ? r.transform = tN(t, e.transform, n) : r.transform && (r.transform = "none")), i) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = s;
    r.transformOrigin = `${l} ${c} ${u}`;
  }
}
const nN = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, rN = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function oN(e, t, n = 1, r = 0, o = !0) {
  e.pathLength = 1;
  const s = o ? nN : rN;
  e[s.offset] = j.transform(-r);
  const a = j.transform(t), i = j.transform(n);
  e[s.array] = `${a} ${i}`;
}
function Hc(e, t, n) {
  return typeof e == "string" ? e : j.transform(t + n * e);
}
function sN(e, t, n) {
  const r = Hc(t, e.x, e.width), o = Hc(n, e.y, e.height);
  return `${r} ${o}`;
}
function Zi(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  originX: o,
  originY: s,
  pathLength: a,
  pathSpacing: i = 1,
  pathOffset: l = 0,
  // This is object creation, which we try to avoid per-frame.
  ...c
}, u, f) {
  if (qi(e, c, f), u) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: h, style: m, dimensions: g } = e;
  h.transform && (g && (m.transform = h.transform), delete h.transform), g && (o !== void 0 || s !== void 0 || m.transform) && (m.transformOrigin = sN(g, o !== void 0 ? o : 0.5, s !== void 0 ? s : 0.5)), t !== void 0 && (h.x = t), n !== void 0 && (h.y = n), r !== void 0 && (h.scale = r), a !== void 0 && oN(h, a, i, l, !1);
}
const Ji = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), Fh = () => ({
  ...Ji(),
  attrs: {}
}), Qi = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function $h(e, { style: t, vars: n }, r, o) {
  Object.assign(e.style, t, o && o.getProjectionStyles(r));
  for (const s in n)
    e.style.setProperty(s, n[s]);
}
const Bh = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Uh(e, t, n, r) {
  $h(e, t, void 0, r);
  for (const o in t.attrs)
    e.setAttribute(Bh.has(o) ? o : Gi(o), t.attrs[o]);
}
const wo = {};
function aN(e) {
  Object.assign(wo, e);
}
function Wh(e, { layout: t, layoutId: n }) {
  return Xt.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!wo[e] || e === "opacity");
}
function el(e, t, n) {
  var r;
  const { style: o } = e, s = {};
  for (const a in o)
    (Ce(o[a]) || t.style && Ce(t.style[a]) || Wh(a, e) || ((r = n == null ? void 0 : n.getValue(a)) === null || r === void 0 ? void 0 : r.liveStyle) !== void 0) && (s[a] = o[a]);
  return s;
}
function Hh(e, t, n) {
  const r = el(e, t, n);
  for (const o in e)
    if (Ce(e[o]) || Ce(t[o])) {
      const s = In.indexOf(o) !== -1 ? "attr" + o.charAt(0).toUpperCase() + o.substring(1) : o;
      r[s] = e[o];
    }
  return r;
}
function iN(e, t) {
  try {
    t.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
  } catch {
    t.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
const Gc = ["x", "y", "width", "height", "cx", "cy", "r"], lN = {
  useVisualState: kh({
    scrapeMotionValuesFromProps: Hh,
    createRenderState: Fh,
    onUpdate: ({ props: e, prevProps: t, current: n, renderState: r, latestValues: o }) => {
      if (!n)
        return;
      let s = !!e.drag;
      if (!s) {
        for (const i in o)
          if (Xt.has(i)) {
            s = !0;
            break;
          }
      }
      if (!s)
        return;
      let a = !t;
      if (t)
        for (let i = 0; i < Gc.length; i++) {
          const l = Gc[i];
          e[l] !== t[l] && (a = !0);
        }
      a && ce.read(() => {
        iN(n, r), ce.render(() => {
          Zi(r, o, Qi(n.tagName), e.transformTemplate), Uh(n, r);
        });
      });
    }
  })
}, cN = {
  useVisualState: kh({
    scrapeMotionValuesFromProps: el,
    createRenderState: Ji
  })
};
function Gh(e, t, n) {
  for (const r in t)
    !Ce(t[r]) && !Wh(r, n) && (e[r] = t[r]);
}
function uN({ transformTemplate: e }, t) {
  return dn(() => {
    const n = Ji();
    return qi(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function dN(e, t) {
  const n = e.style || {}, r = {};
  return Gh(r, n, e), Object.assign(r, uN(e, t)), r;
}
function fN(e, t) {
  const n = {}, r = dN(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
function pN(e, t, n, r) {
  const o = dn(() => {
    const s = Fh();
    return Zi(s, t, Qi(r), e.transformTemplate), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [t]);
  if (e.style) {
    const s = {};
    Gh(s, e.style, e), o.style = { ...s, ...o.style };
  }
  return o;
}
function hN(e = !1) {
  return (n, r, o, { latestValues: s }, a) => {
    const l = (Ki(n) ? pN : fN)(r, s, a, n), c = PE(r, typeof n == "string", e), u = n !== bd ? { ...c, ...l, ref: o } : {}, { children: f } = r, h = dn(() => Ce(f) ? f.get() : f, [f]);
    return io(n, {
      ...u,
      children: h
    });
  };
}
function mN(e, t) {
  return function(r, { forwardMotionProps: o } = { forwardMotionProps: !1 }) {
    const a = {
      ...Ki(r) ? lN : cN,
      preloadedFeatures: e,
      useRender: hN(o),
      createVisualElement: t,
      Component: r
    };
    return FE(a);
  };
}
function jh(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
function rs(e, t, n) {
  const r = e.getProps();
  return zi(r, t, n !== void 0 ? n : r.custom, e);
}
const vN = /* @__PURE__ */ Ui(() => window.ScrollTimeline !== void 0);
class gN {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((t) => "finished" in t ? t.finished : t));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t, n) {
    const r = this.animations.map((o) => {
      if (vN() && o.attachTimeline)
        return o.attachTimeline(t);
      if (typeof n == "function")
        return n(o);
    });
    return () => {
      r.forEach((o, s) => {
        o && o(), this.animations[s].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  flatten() {
    this.runAll("flatten");
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class yN extends gN {
  then(t, n) {
    return Promise.all(this.animations).then(t).catch(n);
  }
}
function tl(e, t) {
  return e ? e[t] || e.default || e : void 0;
}
const Pa = 2e4;
function Kh(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Pa; )
    t += n, r = e.next(t);
  return t >= Pa ? 1 / 0 : t;
}
function nl(e) {
  return typeof e == "function";
}
function jc(e, t) {
  e.timeline = t, e.onfinish = null;
}
const rl = (e) => Array.isArray(e) && typeof e[0] == "number", bN = {
  linearEasing: void 0
};
function wN(e, t) {
  const n = /* @__PURE__ */ Ui(e);
  return () => {
    var r;
    return (r = bN[t]) !== null && r !== void 0 ? r : n();
  };
}
const xo = /* @__PURE__ */ wN(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), zh = (e, t, n = 10) => {
  let r = "";
  const o = Math.max(Math.round(t / n), 2);
  for (let s = 0; s < o; s++)
    r += e(/* @__PURE__ */ pn(0, o - 1, s)) + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
};
function Yh(e) {
  return !!(typeof e == "function" && xo() || !e || typeof e == "string" && (e in _a || xo()) || rl(e) || Array.isArray(e) && e.every(Yh));
}
const Gn = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, _a = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Gn([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Gn([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Gn([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Gn([0.33, 1.53, 0.69, 0.99])
};
function Xh(e, t) {
  if (e)
    return typeof e == "function" && xo() ? zh(e, t) : rl(e) ? Gn(e) : Array.isArray(e) ? e.map((n) => Xh(n, t) || _a.easeOut) : _a[e];
}
const We = {
  x: !1,
  y: !1
};
function qh() {
  return We.x || We.y;
}
function xN(e, t, n) {
  var r;
  if (e instanceof Element)
    return [e];
  if (typeof e == "string") {
    let o = document;
    const s = (r = void 0) !== null && r !== void 0 ? r : o.querySelectorAll(e);
    return s ? Array.from(s) : [];
  }
  return Array.from(e);
}
function Zh(e, t) {
  const n = xN(e), r = new AbortController(), o = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, o, () => r.abort()];
}
function Kc(e) {
  return (t) => {
    t.pointerType === "touch" || qh() || e(t);
  };
}
function SN(e, t, n = {}) {
  const [r, o, s] = Zh(e, n), a = Kc((i) => {
    const { target: l } = i, c = t(i);
    if (typeof c != "function" || !l)
      return;
    const u = Kc((f) => {
      c(f), l.removeEventListener("pointerleave", u);
    });
    l.addEventListener("pointerleave", u, o);
  });
  return r.forEach((i) => {
    i.addEventListener("pointerenter", a, o);
  }), s;
}
const Jh = (e, t) => t ? e === t ? !0 : Jh(e, t.parentElement) : !1, ol = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, CN = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function AN(e) {
  return CN.has(e.tagName) || e.tabIndex !== -1;
}
const jn = /* @__PURE__ */ new WeakSet();
function zc(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function zs(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const EN = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = zc(() => {
    if (jn.has(n))
      return;
    zs(n, "down");
    const o = zc(() => {
      zs(n, "up");
    }), s = () => zs(n, "cancel");
    n.addEventListener("keyup", o, t), n.addEventListener("blur", s, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function Yc(e) {
  return ol(e) && !qh();
}
function NN(e, t, n = {}) {
  const [r, o, s] = Zh(e, n), a = (i) => {
    const l = i.currentTarget;
    if (!Yc(i) || jn.has(l))
      return;
    jn.add(l);
    const c = t(i), u = (m, g) => {
      window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", h), !(!Yc(m) || !jn.has(l)) && (jn.delete(l), typeof c == "function" && c(m, { success: g }));
    }, f = (m) => {
      u(m, n.useGlobalTarget || Jh(l, m.target));
    }, h = (m) => {
      u(m, !1);
    };
    window.addEventListener("pointerup", f, o), window.addEventListener("pointercancel", h, o);
  };
  return r.forEach((i) => {
    !AN(i) && i.getAttribute("tabindex") === null && (i.tabIndex = 0), (n.useGlobalTarget ? window : i).addEventListener("pointerdown", a, o), i.addEventListener("focus", (c) => EN(c, o), o);
  }), s;
}
function TN(e) {
  return e === "x" || e === "y" ? We[e] ? null : (We[e] = !0, () => {
    We[e] = !1;
  }) : We.x || We.y ? null : (We.x = We.y = !0, () => {
    We.x = We.y = !1;
  });
}
const Qh = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...In
]);
let ro;
function RN() {
  ro = void 0;
}
const tt = {
  now: () => (ro === void 0 && tt.set(xe.isProcessing || CE.useManualTiming ? xe.timestamp : performance.now()), ro),
  set: (e) => {
    ro = e, queueMicrotask(RN);
  }
};
function sl(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function al(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class il {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return sl(this.subscriptions, t), () => al(this.subscriptions, t);
  }
  notify(t, n, r) {
    const o = this.subscriptions.length;
    if (o)
      if (o === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let s = 0; s < o; s++) {
          const a = this.subscriptions[s];
          a && a(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function em(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Xc = 30, PN = (e) => !isNaN(parseFloat(e));
class _N {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  constructor(t, n = {}) {
    this.version = "11.18.2", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, o = !0) => {
      const s = tt.now();
      this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && this.events.change && this.events.change.notify(this.current), o && this.events.renderRequest && this.events.renderRequest.notify(this.current);
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = tt.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = PN(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Qo(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new il());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), ce.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = tt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Xc)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Xc);
    return em(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function lr(e, t) {
  return new _N(e, t);
}
function MN(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, lr(n));
}
function IN(e, t) {
  const n = rs(e, t);
  let { transitionEnd: r = {}, transition: o = {}, ...s } = n || {};
  s = { ...s, ...r };
  for (const a in s) {
    const i = GE(s[a]);
    MN(e, a, i);
  }
}
function DN(e) {
  return !!(Ce(e) && e.add);
}
function Ma(e, t) {
  const n = e.getValue("willChange");
  if (DN(n))
    return n.add(t);
}
function tm(e) {
  return e.props[Mh];
}
const nm = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, kN = 1e-7, ON = 12;
function LN(e, t, n, r, o) {
  let s, a, i = 0;
  do
    a = t + (n - t) / 2, s = nm(a, r, o) - e, s > 0 ? n = a : t = a;
  while (Math.abs(s) > kN && ++i < ON);
  return a;
}
function Nr(e, t, n, r) {
  if (e === t && n === r)
    return Re;
  const o = (s) => LN(s, 0, 1, e, n);
  return (s) => s === 0 || s === 1 ? s : nm(o(s), t, r);
}
const rm = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, om = (e) => (t) => 1 - e(1 - t), sm = /* @__PURE__ */ Nr(0.33, 1.53, 0.69, 0.99), ll = /* @__PURE__ */ om(sm), am = /* @__PURE__ */ rm(ll), im = (e) => (e *= 2) < 1 ? 0.5 * ll(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), cl = (e) => 1 - Math.sin(Math.acos(e)), lm = om(cl), cm = rm(cl), um = (e) => /^0[^.\s]+$/u.test(e);
function VN(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || um(e) : !0;
}
const Zn = (e) => Math.round(e * 1e5) / 1e5, ul = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function FN(e) {
  return e == null;
}
const $N = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, dl = (e, t) => (n) => !!(typeof n == "string" && $N.test(n) && n.startsWith(e) || t && !FN(n) && Object.prototype.hasOwnProperty.call(n, t)), dm = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [o, s, a, i] = r.match(ul);
  return {
    [e]: parseFloat(o),
    [t]: parseFloat(s),
    [n]: parseFloat(a),
    alpha: i !== void 0 ? parseFloat(i) : 1
  };
}, BN = (e) => ft(0, 255, e), Ys = {
  ...Dn,
  transform: (e) => Math.round(BN(e))
}, Ft = {
  test: /* @__PURE__ */ dl("rgb", "red"),
  parse: /* @__PURE__ */ dm("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Ys.transform(e) + ", " + Ys.transform(t) + ", " + Ys.transform(n) + ", " + Zn(ir.transform(r)) + ")"
};
function UN(e) {
  let t = "", n = "", r = "", o = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), o = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), o = e.substring(4, 5), t += t, n += n, r += r, o += o), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const Ia = {
  test: /* @__PURE__ */ dl("#"),
  parse: UN,
  transform: Ft.transform
}, nn = {
  test: /* @__PURE__ */ dl("hsl", "hue"),
  parse: /* @__PURE__ */ dm("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + et.transform(Zn(t)) + ", " + et.transform(Zn(n)) + ", " + Zn(ir.transform(r)) + ")"
}, Se = {
  test: (e) => Ft.test(e) || Ia.test(e) || nn.test(e),
  parse: (e) => Ft.test(e) ? Ft.parse(e) : nn.test(e) ? nn.parse(e) : Ia.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Ft.transform(e) : nn.transform(e)
}, WN = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function HN(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(ul)) === null || t === void 0 ? void 0 : t.length) || 0) + (((n = e.match(WN)) === null || n === void 0 ? void 0 : n.length) || 0) > 0;
}
const fm = "number", pm = "color", GN = "var", jN = "var(", qc = "${}", KN = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function cr(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, o = [];
  let s = 0;
  const i = t.replace(KN, (l) => (Se.test(l) ? (r.color.push(s), o.push(pm), n.push(Se.parse(l))) : l.startsWith(jN) ? (r.var.push(s), o.push(GN), n.push(l)) : (r.number.push(s), o.push(fm), n.push(parseFloat(l))), ++s, qc)).split(qc);
  return { values: n, split: i, indexes: r, types: o };
}
function hm(e) {
  return cr(e).values;
}
function mm(e) {
  const { split: t, types: n } = cr(e), r = t.length;
  return (o) => {
    let s = "";
    for (let a = 0; a < r; a++)
      if (s += t[a], o[a] !== void 0) {
        const i = n[a];
        i === fm ? s += Zn(o[a]) : i === pm ? s += Se.transform(o[a]) : s += o[a];
      }
    return s;
  };
}
const zN = (e) => typeof e == "number" ? 0 : e;
function YN(e) {
  const t = hm(e);
  return mm(e)(t.map(zN));
}
const Nt = {
  test: HN,
  parse: hm,
  createTransformer: mm,
  getAnimatableNone: YN
}, XN = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function qN(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(ul) || [];
  if (!r)
    return e;
  const o = n.replace(r, "");
  let s = XN.has(t) ? 1 : 0;
  return r !== n && (s *= 100), t + "(" + s + o + ")";
}
const ZN = /\b([a-z-]*)\(.*?\)/gu, Da = {
  ...Nt,
  getAnimatableNone: (e) => {
    const t = e.match(ZN);
    return t ? t.map(qN).join(" ") : e;
  }
}, JN = {
  ...Xi,
  // Color props
  color: Se,
  backgroundColor: Se,
  outlineColor: Se,
  fill: Se,
  stroke: Se,
  // Border props
  borderColor: Se,
  borderTopColor: Se,
  borderRightColor: Se,
  borderBottomColor: Se,
  borderLeftColor: Se,
  filter: Da,
  WebkitFilter: Da
}, fl = (e) => JN[e];
function vm(e, t) {
  let n = fl(e);
  return n !== Da && (n = Nt), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const QN = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function eT(e, t, n) {
  let r = 0, o;
  for (; r < e.length && !o; ) {
    const s = e[r];
    typeof s == "string" && !QN.has(s) && cr(s).values.length && (o = e[r]), r++;
  }
  if (o && n)
    for (const s of t)
      e[s] = vm(n, o);
}
const Zc = (e) => e === Dn || e === j, Jc = (e, t) => parseFloat(e.split(", ")[t]), Qc = (e, t) => (n, { transform: r }) => {
  if (r === "none" || !r)
    return 0;
  const o = r.match(/^matrix3d\((.+)\)$/u);
  if (o)
    return Jc(o[1], t);
  {
    const s = r.match(/^matrix\((.+)\)$/u);
    return s ? Jc(s[1], e) : 0;
  }
}, tT = /* @__PURE__ */ new Set(["x", "y", "z"]), nT = In.filter((e) => !tT.has(e));
function rT(e) {
  const t = [];
  return nT.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const mn = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: Qc(4, 13),
  y: Qc(5, 14)
};
mn.translateX = mn.x;
mn.translateY = mn.y;
const $t = /* @__PURE__ */ new Set();
let ka = !1, Oa = !1;
function gm() {
  if (Oa) {
    const e = Array.from($t).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const o = rT(r);
      o.length && (n.set(r, o), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const o = n.get(r);
      o && o.forEach(([s, a]) => {
        var i;
        (i = r.getValue(s)) === null || i === void 0 || i.set(a);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Oa = !1, ka = !1, $t.forEach((e) => e.complete()), $t.clear();
}
function ym() {
  $t.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (Oa = !0);
  });
}
function oT() {
  ym(), gm();
}
class pl {
  constructor(t, n, r, o, s, a = !1) {
    this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = o, this.element = s, this.isAsync = a;
  }
  scheduleResolve() {
    this.isScheduled = !0, this.isAsync ? ($t.add(this), ka || (ka = !0, ce.read(ym), ce.resolveKeyframes(gm))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: o } = this;
    for (let s = 0; s < t.length; s++)
      if (t[s] === null)
        if (s === 0) {
          const a = o == null ? void 0 : o.get(), i = t[t.length - 1];
          if (a !== void 0)
            t[0] = a;
          else if (r && n) {
            const l = r.readValue(n, i);
            l != null && (t[0] = l);
          }
          t[0] === void 0 && (t[0] = i), o && a === void 0 && o.set(t[0]);
        } else
          t[s] = t[s - 1];
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete() {
    this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), $t.delete(this);
  }
  cancel() {
    this.isComplete || (this.isScheduled = !1, $t.delete(this));
  }
  resume() {
    this.isComplete || this.scheduleResolve();
  }
}
const bm = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), sT = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function aT(e) {
  const t = sT.exec(e);
  if (!t)
    return [,];
  const [, n, r, o] = t;
  return [`--${n ?? r}`, o];
}
const iT = 4;
function wm(e, t, n = 1) {
  At(n <= iT, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, o] = aT(e);
  if (!r)
    return;
  const s = window.getComputedStyle(t).getPropertyValue(r);
  if (s) {
    const a = s.trim();
    return bm(a) ? parseFloat(a) : a;
  }
  return Yi(o) ? wm(o, t, n + 1) : o;
}
const xm = (e) => (t) => t.test(e), lT = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Sm = [Dn, j, et, bt, qE, XE, lT], eu = (e) => Sm.find(xm(e));
class Cm extends pl {
  constructor(t, n, r, o, s) {
    super(t, n, r, o, s, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let c = t[l];
      if (typeof c == "string" && (c = c.trim(), Yi(c))) {
        const u = wm(c, n.current);
        u !== void 0 && (t[l] = u), l === t.length - 1 && (this.finalKeyframe = c);
      }
    }
    if (this.resolveNoneKeyframes(), !Qh.has(r) || t.length !== 2)
      return;
    const [o, s] = t, a = eu(o), i = eu(s);
    if (a !== i)
      if (Zc(a) && Zc(i))
        for (let l = 0; l < t.length; l++) {
          const c = t[l];
          typeof c == "string" && (t[l] = parseFloat(c));
        }
      else
        this.needsMeasurement = !0;
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let o = 0; o < t.length; o++)
      VN(t[o]) && r.push(o);
    r.length && eT(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = mn[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const o = n[n.length - 1];
    o !== void 0 && t.getValue(r, o).jump(o, !1);
  }
  measureEndState() {
    var t;
    const { element: n, name: r, unresolvedKeyframes: o } = this;
    if (!n || !n.current)
      return;
    const s = n.getValue(r);
    s && s.jump(this.measuredOrigin, !1);
    const a = o.length - 1, i = o[a];
    o[a] = mn[r](n.measureViewportBox(), window.getComputedStyle(n.current)), i !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = i), !((t = this.removedTransforms) === null || t === void 0) && t.length && this.removedTransforms.forEach(([l, c]) => {
      n.getValue(l).set(c);
    }), this.resolveNoneKeyframes();
  }
}
const tu = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(Nt.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function cT(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function uT(e, t, n, r) {
  const o = e[0];
  if (o === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const s = e[e.length - 1], a = tu(o, t), i = tu(s, t);
  return Mn(a === i, `You are trying to animate ${t} from "${o}" to "${s}". ${o} is not an animatable value - to enable this animation set ${o} to a value animatable to ${s} via the \`style\` property.`), !a || !i ? !1 : cT(e) || (n === "spring" || nl(n)) && r;
}
const dT = (e) => e !== null;
function os(e, { repeat: t, repeatType: n = "loop" }, r) {
  const o = e.filter(dT), s = t && n !== "loop" && t % 2 === 1 ? 0 : o.length - 1;
  return !s || r === void 0 ? o[s] : r;
}
const fT = 40;
class Am {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: o = 0, repeatDelay: s = 0, repeatType: a = "loop", ...i }) {
    this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = tt.now(), this.options = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: o,
      repeatDelay: s,
      repeatType: a,
      ...i
    }, this.updateFinishedPromise();
  }
  /**
   * This method uses the createdAt and resolvedAt to calculate the
   * animation startTime. *Ideally*, we would use the createdAt time as t=0
   * as the following frame would then be the first frame of the animation in
   * progress, which would feel snappier.
   *
   * However, if there's a delay (main thread work) between the creation of
   * the animation and the first commited frame, we prefer to use resolvedAt
   * to avoid a sudden jump into the animation.
   */
  calcStartTime() {
    return this.resolvedAt ? this.resolvedAt - this.createdAt > fT ? this.resolvedAt : this.createdAt : this.createdAt;
  }
  /**
   * A getter for resolved data. If keyframes are not yet resolved, accessing
   * this.resolved will synchronously flush all pending keyframe resolvers.
   * This is a deoptimisation, but at its worst still batches read/writes.
   */
  get resolved() {
    return !this._resolved && !this.hasAttemptedResolve && oT(), this._resolved;
  }
  /**
   * A method to be called when the keyframes resolver completes. This method
   * will check if its possible to run the animation and, if not, skip it.
   * Otherwise, it will call initPlayback on the implementing class.
   */
  onKeyframesResolved(t, n) {
    this.resolvedAt = tt.now(), this.hasAttemptedResolve = !0;
    const { name: r, type: o, velocity: s, delay: a, onComplete: i, onUpdate: l, isGenerator: c } = this.options;
    if (!c && !uT(t, r, o, s))
      if (a)
        this.options.duration = 0;
      else {
        l && l(os(t, this.options, n)), i && i(), this.resolveFinishedPromise();
        return;
      }
    const u = this.initPlayback(t, n);
    u !== !1 && (this._resolved = {
      keyframes: t,
      finalKeyframe: n,
      ...u
    }, this.onPostResolved());
  }
  onPostResolved() {
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.currentFinishedPromise.then(t, n);
  }
  flatten() {
    this.options.type = "keyframes", this.options.ease = "linear";
  }
  updateFinishedPromise() {
    this.currentFinishedPromise = new Promise((t) => {
      this.resolveFinishedPromise = t;
    });
  }
}
const fe = (e, t, n) => e + (t - e) * n;
function Xs(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function pT({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let o = 0, s = 0, a = 0;
  if (!t)
    o = s = a = n;
  else {
    const i = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - i;
    o = Xs(l, i, e + 1 / 3), s = Xs(l, i, e), a = Xs(l, i, e - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(s * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
function So(e, t) {
  return (n) => n > 0 ? t : e;
}
const qs = (e, t, n) => {
  const r = e * e, o = n * (t * t - r) + r;
  return o < 0 ? 0 : Math.sqrt(o);
}, hT = [Ia, Ft, nn], mT = (e) => hT.find((t) => t.test(e));
function nu(e) {
  const t = mT(e);
  if (Mn(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === nn && (n = pT(n)), n;
}
const ru = (e, t) => {
  const n = nu(e), r = nu(t);
  if (!n || !r)
    return So(e, t);
  const o = { ...n };
  return (s) => (o.red = qs(n.red, r.red, s), o.green = qs(n.green, r.green, s), o.blue = qs(n.blue, r.blue, s), o.alpha = fe(n.alpha, r.alpha, s), Ft.transform(o));
}, vT = (e, t) => (n) => t(e(n)), Tr = (...e) => e.reduce(vT), La = /* @__PURE__ */ new Set(["none", "hidden"]);
function gT(e, t) {
  return La.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function yT(e, t) {
  return (n) => fe(e, t, n);
}
function hl(e) {
  return typeof e == "number" ? yT : typeof e == "string" ? Yi(e) ? So : Se.test(e) ? ru : xT : Array.isArray(e) ? Em : typeof e == "object" ? Se.test(e) ? ru : bT : So;
}
function Em(e, t) {
  const n = [...e], r = n.length, o = e.map((s, a) => hl(s)(s, t[a]));
  return (s) => {
    for (let a = 0; a < r; a++)
      n[a] = o[a](s);
    return n;
  };
}
function bT(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const o in n)
    e[o] !== void 0 && t[o] !== void 0 && (r[o] = hl(e[o])(e[o], t[o]));
  return (o) => {
    for (const s in r)
      n[s] = r[s](o);
    return n;
  };
}
function wT(e, t) {
  var n;
  const r = [], o = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < t.values.length; s++) {
    const a = t.types[s], i = e.indexes[a][o[a]], l = (n = e.values[i]) !== null && n !== void 0 ? n : 0;
    r[s] = l, o[a]++;
  }
  return r;
}
const xT = (e, t) => {
  const n = Nt.createTransformer(t), r = cr(e), o = cr(t);
  return r.indexes.var.length === o.indexes.var.length && r.indexes.color.length === o.indexes.color.length && r.indexes.number.length >= o.indexes.number.length ? La.has(e) && !o.values.length || La.has(t) && !r.values.length ? gT(e, t) : Tr(Em(wT(r, o), o.values), n) : (Mn(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), So(e, t));
};
function Nm(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? fe(e, t, n) : hl(e)(e, t);
}
const ST = 5;
function Tm(e, t, n) {
  const r = Math.max(t - ST, 0);
  return em(n - e(r), t - r);
}
const ue = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, Zs = 1e-3;
function CT({ duration: e = ue.duration, bounce: t = ue.bounce, velocity: n = ue.velocity, mass: r = ue.mass }) {
  let o, s;
  Mn(e <= /* @__PURE__ */ Qe(ue.maxDuration), "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = ft(ue.minDamping, ue.maxDamping, a), e = ft(ue.minDuration, ue.maxDuration, /* @__PURE__ */ ct(e)), a < 1 ? (o = (c) => {
    const u = c * a, f = u * e, h = u - n, m = Va(c, a), g = Math.exp(-f);
    return Zs - h / m * g;
  }, s = (c) => {
    const f = c * a * e, h = f * n + n, m = Math.pow(a, 2) * Math.pow(c, 2) * e, g = Math.exp(-f), v = Va(Math.pow(c, 2), a);
    return (-o(c) + Zs > 0 ? -1 : 1) * ((h - m) * g) / v;
  }) : (o = (c) => {
    const u = Math.exp(-c * e), f = (c - n) * e + 1;
    return -Zs + u * f;
  }, s = (c) => {
    const u = Math.exp(-c * e), f = (n - c) * (e * e);
    return u * f;
  });
  const i = 5 / e, l = ET(o, s, i);
  if (e = /* @__PURE__ */ Qe(e), isNaN(l))
    return {
      stiffness: ue.stiffness,
      damping: ue.damping,
      duration: e
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: a * 2 * Math.sqrt(r * c),
      duration: e
    };
  }
}
const AT = 12;
function ET(e, t, n) {
  let r = n;
  for (let o = 1; o < AT; o++)
    r = r - e(r) / t(r);
  return r;
}
function Va(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const NT = ["duration", "bounce"], TT = ["stiffness", "damping", "mass"];
function ou(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function RT(e) {
  let t = {
    velocity: ue.velocity,
    stiffness: ue.stiffness,
    damping: ue.damping,
    mass: ue.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!ou(e, TT) && ou(e, NT))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), o = r * r, s = 2 * ft(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(o);
      t = {
        ...t,
        mass: ue.mass,
        stiffness: o,
        damping: s
      };
    } else {
      const n = CT(e);
      t = {
        ...t,
        ...n,
        mass: ue.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Rm(e = ue.visualDuration, t = ue.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: o } = n;
  const s = n.keyframes[0], a = n.keyframes[n.keyframes.length - 1], i = { done: !1, value: s }, { stiffness: l, damping: c, mass: u, duration: f, velocity: h, isResolvedFromDuration: m } = RT({
    ...n,
    velocity: -/* @__PURE__ */ ct(n.velocity || 0)
  }), g = h || 0, v = c / (2 * Math.sqrt(l * u)), y = a - s, b = /* @__PURE__ */ ct(Math.sqrt(l / u)), w = Math.abs(y) < 5;
  r || (r = w ? ue.restSpeed.granular : ue.restSpeed.default), o || (o = w ? ue.restDelta.granular : ue.restDelta.default);
  let x;
  if (v < 1) {
    const C = Va(b, v);
    x = (E) => {
      const A = Math.exp(-v * b * E);
      return a - A * ((g + v * b * y) / C * Math.sin(C * E) + y * Math.cos(C * E));
    };
  } else if (v === 1)
    x = (C) => a - Math.exp(-b * C) * (y + (g + b * y) * C);
  else {
    const C = b * Math.sqrt(v * v - 1);
    x = (E) => {
      const A = Math.exp(-v * b * E), T = Math.min(C * E, 300);
      return a - A * ((g + v * b * y) * Math.sinh(T) + C * y * Math.cosh(T)) / C;
    };
  }
  const S = {
    calculatedDuration: m && f || null,
    next: (C) => {
      const E = x(C);
      if (m)
        i.done = C >= f;
      else {
        let A = 0;
        v < 1 && (A = C === 0 ? /* @__PURE__ */ Qe(g) : Tm(x, C, E));
        const T = Math.abs(A) <= r, I = Math.abs(a - E) <= o;
        i.done = T && I;
      }
      return i.value = i.done ? a : E, i;
    },
    toString: () => {
      const C = Math.min(Kh(S), Pa), E = zh((A) => S.next(C * A).value, C, 30);
      return C + "ms " + E;
    }
  };
  return S;
}
function su({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: o = 10, bounceStiffness: s = 500, modifyTarget: a, min: i, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const f = e[0], h = {
    done: !1,
    value: f
  }, m = (T) => i !== void 0 && T < i || l !== void 0 && T > l, g = (T) => i === void 0 ? l : l === void 0 || Math.abs(i - T) < Math.abs(l - T) ? i : l;
  let v = n * t;
  const y = f + v, b = a === void 0 ? y : a(y);
  b !== y && (v = b - f);
  const w = (T) => -v * Math.exp(-T / r), x = (T) => b + w(T), S = (T) => {
    const I = w(T), L = x(T);
    h.done = Math.abs(I) <= c, h.value = h.done ? b : L;
  };
  let C, E;
  const A = (T) => {
    m(h.value) && (C = T, E = Rm({
      keyframes: [h.value, g(h.value)],
      velocity: Tm(x, T, h.value),
      // TODO: This should be passing * 1000
      damping: o,
      stiffness: s,
      restDelta: c,
      restSpeed: u
    }));
  };
  return A(0), {
    calculatedDuration: null,
    next: (T) => {
      let I = !1;
      return !E && C === void 0 && (I = !0, S(T), A(T)), C !== void 0 && T >= C ? E.next(T - C) : (!I && S(T), h);
    }
  };
}
const PT = /* @__PURE__ */ Nr(0.42, 0, 1, 1), _T = /* @__PURE__ */ Nr(0, 0, 0.58, 1), Pm = /* @__PURE__ */ Nr(0.42, 0, 0.58, 1), MT = (e) => Array.isArray(e) && typeof e[0] != "number", au = {
  linear: Re,
  easeIn: PT,
  easeInOut: Pm,
  easeOut: _T,
  circIn: cl,
  circInOut: cm,
  circOut: lm,
  backIn: ll,
  backInOut: am,
  backOut: sm,
  anticipate: im
}, iu = (e) => {
  if (rl(e)) {
    At(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, o] = e;
    return Nr(t, n, r, o);
  } else if (typeof e == "string")
    return At(au[e] !== void 0, `Invalid easing type '${e}'`), au[e];
  return e;
};
function IT(e, t, n) {
  const r = [], o = n || Nm, s = e.length - 1;
  for (let a = 0; a < s; a++) {
    let i = o(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] || Re : t;
      i = Tr(l, i);
    }
    r.push(i);
  }
  return r;
}
function DT(e, t, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const s = e.length;
  if (At(s === t.length, "Both input and output ranges must be the same length"), s === 1)
    return () => t[0];
  if (s === 2 && t[0] === t[1])
    return () => t[1];
  const a = e[0] === e[1];
  e[0] > e[s - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const i = IT(t, r, o), l = i.length, c = (u) => {
    if (a && u < e[0])
      return t[0];
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(u < e[f + 1]); f++)
        ;
    const h = /* @__PURE__ */ pn(e[f], e[f + 1], u);
    return i[f](h);
  };
  return n ? (u) => c(ft(e[0], e[s - 1], u)) : c;
}
function kT(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const o = /* @__PURE__ */ pn(0, t, r);
    e.push(fe(n, 1, o));
  }
}
function OT(e) {
  const t = [0];
  return kT(t, e.length - 1), t;
}
function LT(e, t) {
  return e.map((n) => n * t);
}
function VT(e, t) {
  return e.map(() => t || Pm).splice(0, e.length - 1);
}
function Co({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const o = MT(r) ? r.map(iu) : iu(r), s = {
    done: !1,
    value: t[0]
  }, a = LT(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : OT(t),
    e
  ), i = DT(a, t, {
    ease: Array.isArray(o) ? o : VT(t, o)
  });
  return {
    calculatedDuration: e,
    next: (l) => (s.value = i(l), s.done = l >= e, s)
  };
}
const FT = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: () => ce.update(t, !0),
    stop: () => Et(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => xe.isProcessing ? xe.timestamp : tt.now()
  };
}, $T = {
  decay: su,
  inertia: su,
  tween: Co,
  keyframes: Co,
  spring: Rm
}, BT = (e) => e / 100;
class ml extends Am {
  constructor(t) {
    super(t), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
      if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
        return;
      this.teardown();
      const { onStop: l } = this.options;
      l && l();
    };
    const { name: n, motionValue: r, element: o, keyframes: s } = this.options, a = (o == null ? void 0 : o.KeyframeResolver) || pl, i = (l, c) => this.onKeyframesResolved(l, c);
    this.resolver = new a(s, i, n, r, o), this.resolver.scheduleResolve();
  }
  flatten() {
    super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
  }
  initPlayback(t) {
    const { type: n = "keyframes", repeat: r = 0, repeatDelay: o = 0, repeatType: s, velocity: a = 0 } = this.options, i = nl(n) ? n : $T[n] || Co;
    let l, c;
    i !== Co && typeof t[0] != "number" && (process.env.NODE_ENV !== "production" && At(t.length === 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${t}`), l = Tr(BT, Nm(t[0], t[1])), t = [0, 100]);
    const u = i({ ...this.options, keyframes: t });
    s === "mirror" && (c = i({
      ...this.options,
      keyframes: [...t].reverse(),
      velocity: -a
    })), u.calculatedDuration === null && (u.calculatedDuration = Kh(u));
    const { calculatedDuration: f } = u, h = f + o, m = h * (r + 1) - o;
    return {
      generator: u,
      mirroredGenerator: c,
      mapPercentToKeyframes: l,
      calculatedDuration: f,
      resolvedDuration: h,
      totalDuration: m
    };
  }
  onPostResolved() {
    const { autoplay: t = !0 } = this.options;
    this.play(), this.pendingPlayState === "paused" || !t ? this.pause() : this.state = this.pendingPlayState;
  }
  tick(t, n = !1) {
    const { resolved: r } = this;
    if (!r) {
      const { keyframes: T } = this.options;
      return { done: !0, value: T[T.length - 1] };
    }
    const { finalKeyframe: o, generator: s, mirroredGenerator: a, mapPercentToKeyframes: i, keyframes: l, calculatedDuration: c, totalDuration: u, resolvedDuration: f } = r;
    if (this.startTime === null)
      return s.next(0);
    const { delay: h, repeat: m, repeatType: g, repeatDelay: v, onUpdate: y } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - u / this.speed, this.startTime)), n ? this.currentTime = t : this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = Math.round(t - this.startTime) * this.speed;
    const b = this.currentTime - h * (this.speed >= 0 ? 1 : -1), w = this.speed >= 0 ? b < 0 : b > u;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = u);
    let x = this.currentTime, S = s;
    if (m) {
      const T = Math.min(this.currentTime, u) / f;
      let I = Math.floor(T), L = T % 1;
      !L && T >= 1 && (L = 1), L === 1 && I--, I = Math.min(I, m + 1), !!(I % 2) && (g === "reverse" ? (L = 1 - L, v && (L -= v / f)) : g === "mirror" && (S = a)), x = ft(0, 1, L) * f;
    }
    const C = w ? { done: !1, value: l[0] } : S.next(x);
    i && (C.value = i(C.value));
    let { done: E } = C;
    !w && c !== null && (E = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
    const A = this.holdTime === null && (this.state === "finished" || this.state === "running" && E);
    return A && o !== void 0 && (C.value = os(l, this.options, o)), y && y(C.value), A && this.finish(), C;
  }
  get duration() {
    const { resolved: t } = this;
    return t ? /* @__PURE__ */ ct(t.calculatedDuration) : 0;
  }
  get time() {
    return /* @__PURE__ */ ct(this.currentTime);
  }
  set time(t) {
    t = /* @__PURE__ */ Qe(t), this.currentTime = t, this.holdTime !== null || this.speed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.speed);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ ct(this.currentTime));
  }
  play() {
    if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
      this.pendingPlayState = "running";
      return;
    }
    if (this.isStopped)
      return;
    const { driver: t = FT, onPlay: n, startTime: r } = this.options;
    this.driver || (this.driver = t((s) => this.tick(s))), n && n();
    const o = this.driver.now();
    this.holdTime !== null ? this.startTime = o - this.holdTime : this.startTime ? this.state === "finished" && (this.startTime = o) : this.startTime = r ?? this.calcStartTime(), this.state === "finished" && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    var t;
    if (!this._resolved) {
      this.pendingPlayState = "paused";
      return;
    }
    this.state = "paused", this.holdTime = (t = this.currentTime) !== null && t !== void 0 ? t : 0;
  }
  complete() {
    this.state !== "running" && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.teardown(), this.state = "finished";
    const { onComplete: t } = this.options;
    t && t();
  }
  cancel() {
    this.cancelTime !== null && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel();
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
}
const UT = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Can be accelerated but currently disabled until https://issues.chromium.org/issues/41491098 is resolved
  // or until we implement support for linear() easing.
  // "background-color"
]);
function WT(e, t, n, { delay: r = 0, duration: o = 300, repeat: s = 0, repeatType: a = "loop", ease: i = "easeInOut", times: l } = {}) {
  const c = { [t]: n };
  l && (c.offset = l);
  const u = Xh(i, o);
  return Array.isArray(u) && (c.easing = u), e.animate(c, {
    delay: r,
    duration: o,
    easing: Array.isArray(u) ? "linear" : u,
    fill: "both",
    iterations: s + 1,
    direction: a === "reverse" ? "alternate" : "normal"
  });
}
const HT = /* @__PURE__ */ Ui(() => Object.hasOwnProperty.call(Element.prototype, "animate")), Ao = 10, GT = 2e4;
function jT(e) {
  return nl(e.type) || e.type === "spring" || !Yh(e.ease);
}
function KT(e, t) {
  const n = new ml({
    ...t,
    keyframes: e,
    repeat: 0,
    delay: 0,
    isGenerator: !0
  });
  let r = { done: !1, value: e[0] };
  const o = [];
  let s = 0;
  for (; !r.done && s < GT; )
    r = n.sample(s), o.push(r.value), s += Ao;
  return {
    times: void 0,
    keyframes: o,
    duration: s - Ao,
    ease: "linear"
  };
}
const _m = {
  anticipate: im,
  backInOut: am,
  circInOut: cm
};
function zT(e) {
  return e in _m;
}
class lu extends Am {
  constructor(t) {
    super(t);
    const { name: n, motionValue: r, element: o, keyframes: s } = this.options;
    this.resolver = new Cm(s, (a, i) => this.onKeyframesResolved(a, i), n, r, o), this.resolver.scheduleResolve();
  }
  initPlayback(t, n) {
    let { duration: r = 300, times: o, ease: s, type: a, motionValue: i, name: l, startTime: c } = this.options;
    if (!i.owner || !i.owner.current)
      return !1;
    if (typeof s == "string" && xo() && zT(s) && (s = _m[s]), jT(this.options)) {
      const { onComplete: f, onUpdate: h, motionValue: m, element: g, ...v } = this.options, y = KT(t, v);
      t = y.keyframes, t.length === 1 && (t[1] = t[0]), r = y.duration, o = y.times, s = y.ease, a = "keyframes";
    }
    const u = WT(i.owner.current, l, t, { ...this.options, duration: r, times: o, ease: s });
    return u.startTime = c ?? this.calcStartTime(), this.pendingTimeline ? (jc(u, this.pendingTimeline), this.pendingTimeline = void 0) : u.onfinish = () => {
      const { onComplete: f } = this.options;
      i.set(os(t, this.options, n)), f && f(), this.cancel(), this.resolveFinishedPromise();
    }, {
      animation: u,
      duration: r,
      times: o,
      type: a,
      ease: s,
      keyframes: t
    };
  }
  get duration() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { duration: n } = t;
    return /* @__PURE__ */ ct(n);
  }
  get time() {
    const { resolved: t } = this;
    if (!t)
      return 0;
    const { animation: n } = t;
    return /* @__PURE__ */ ct(n.currentTime || 0);
  }
  set time(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.currentTime = /* @__PURE__ */ Qe(t);
  }
  get speed() {
    const { resolved: t } = this;
    if (!t)
      return 1;
    const { animation: n } = t;
    return n.playbackRate;
  }
  set speed(t) {
    const { resolved: n } = this;
    if (!n)
      return;
    const { animation: r } = n;
    r.playbackRate = t;
  }
  get state() {
    const { resolved: t } = this;
    if (!t)
      return "idle";
    const { animation: n } = t;
    return n.playState;
  }
  get startTime() {
    const { resolved: t } = this;
    if (!t)
      return null;
    const { animation: n } = t;
    return n.startTime;
  }
  /**
   * Replace the default DocumentTimeline with another AnimationTimeline.
   * Currently used for scroll animations.
   */
  attachTimeline(t) {
    if (!this._resolved)
      this.pendingTimeline = t;
    else {
      const { resolved: n } = this;
      if (!n)
        return Re;
      const { animation: r } = n;
      jc(r, t);
    }
    return Re;
  }
  play() {
    if (this.isStopped)
      return;
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.playState === "finished" && this.updateFinishedPromise(), n.play();
  }
  pause() {
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n } = t;
    n.pause();
  }
  stop() {
    if (this.resolver.cancel(), this.isStopped = !0, this.state === "idle")
      return;
    this.resolveFinishedPromise(), this.updateFinishedPromise();
    const { resolved: t } = this;
    if (!t)
      return;
    const { animation: n, keyframes: r, duration: o, type: s, ease: a, times: i } = t;
    if (n.playState === "idle" || n.playState === "finished")
      return;
    if (this.time) {
      const { motionValue: c, onUpdate: u, onComplete: f, element: h, ...m } = this.options, g = new ml({
        ...m,
        keyframes: r,
        duration: o,
        type: s,
        ease: a,
        times: i,
        isGenerator: !0
      }), v = /* @__PURE__ */ Qe(this.time);
      c.setWithVelocity(g.sample(v - Ao).value, g.sample(v).value, Ao);
    }
    const { onStop: l } = this.options;
    l && l(), this.cancel();
  }
  complete() {
    const { resolved: t } = this;
    t && t.animation.finish();
  }
  cancel() {
    const { resolved: t } = this;
    t && t.animation.cancel();
  }
  static supports(t) {
    const { motionValue: n, name: r, repeatDelay: o, repeatType: s, damping: a, type: i } = t;
    if (!n || !n.owner || !(n.owner.current instanceof HTMLElement))
      return !1;
    const { onUpdate: l, transformTemplate: c } = n.owner.getProps();
    return HT() && r && UT.has(r) && /**
     * If we're outputting values to onUpdate then we can't use WAAPI as there's
     * no way to read the value from WAAPI every frame.
     */
    !l && !c && !o && s !== "mirror" && a !== 0 && i !== "inertia";
  }
}
const YT = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, XT = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), qT = {
  type: "keyframes",
  duration: 0.8
}, ZT = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, JT = (e, { keyframes: t }) => t.length > 2 ? qT : Xt.has(e) ? e.startsWith("scale") ? XT(t[1]) : YT : ZT;
function QT({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: o, repeat: s, repeatType: a, repeatDelay: i, from: l, elapsed: c, ...u }) {
  return !!Object.keys(u).length;
}
const vl = (e, t, n, r = {}, o, s) => (a) => {
  const i = tl(r, e) || {}, l = i.delay || r.delay || 0;
  let { elapsed: c = 0 } = r;
  c = c - /* @__PURE__ */ Qe(l);
  let u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...i,
    delay: -c,
    onUpdate: (h) => {
      t.set(h), i.onUpdate && i.onUpdate(h);
    },
    onComplete: () => {
      a(), i.onComplete && i.onComplete();
    },
    name: e,
    motionValue: t,
    element: s ? void 0 : o
  };
  QT(i) || (u = {
    ...u,
    ...JT(e, u)
  }), u.duration && (u.duration = /* @__PURE__ */ Qe(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Qe(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let f = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (u.duration = 0, u.delay === 0 && (f = !0)), f && !s && t.get() !== void 0) {
    const h = os(u.keyframes, i);
    if (h !== void 0)
      return ce.update(() => {
        u.onUpdate(h), u.onComplete();
      }), new yN([]);
  }
  return !s && lu.supports(u) ? new lu(u) : new ml(u);
};
function eR({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function Mm(e, t, { delay: n = 0, transitionOverride: r, type: o } = {}) {
  var s;
  let { transition: a = e.getDefaultTransition(), transitionEnd: i, ...l } = t;
  r && (a = r);
  const c = [], u = o && e.animationState && e.animationState.getState()[o];
  for (const f in l) {
    const h = e.getValue(f, (s = e.latestValues[f]) !== null && s !== void 0 ? s : null), m = l[f];
    if (m === void 0 || u && eR(u, f))
      continue;
    const g = {
      delay: n,
      ...tl(a || {}, f)
    };
    let v = !1;
    if (window.MotionHandoffAnimation) {
      const b = tm(e);
      if (b) {
        const w = window.MotionHandoffAnimation(b, f, ce);
        w !== null && (g.startTime = w, v = !0);
      }
    }
    Ma(e, f), h.start(vl(f, h, m, e.shouldReduceMotion && Qh.has(f) ? { type: !1 } : g, e, v));
    const y = h.animation;
    y && c.push(y);
  }
  return i && Promise.all(c).then(() => {
    ce.update(() => {
      i && IN(e, i);
    });
  }), c;
}
function Fa(e, t, n = {}) {
  var r;
  const o = rs(e, t, n.type === "exit" ? (r = e.presenceContext) === null || r === void 0 ? void 0 : r.custom : void 0);
  let { transition: s = e.getDefaultTransition() || {} } = o || {};
  n.transitionOverride && (s = n.transitionOverride);
  const a = o ? () => Promise.all(Mm(e, o, n)) : () => Promise.resolve(), i = e.variantChildren && e.variantChildren.size ? (c = 0) => {
    const { delayChildren: u = 0, staggerChildren: f, staggerDirection: h } = s;
    return tR(e, t, u + c, f, h, n);
  } : () => Promise.resolve(), { when: l } = s;
  if (l) {
    const [c, u] = l === "beforeChildren" ? [a, i] : [i, a];
    return c().then(() => u());
  } else
    return Promise.all([a(), i(n.delay)]);
}
function tR(e, t, n = 0, r = 0, o = 1, s) {
  const a = [], i = (e.variantChildren.size - 1) * r, l = o === 1 ? (c = 0) => c * r : (c = 0) => i - c * r;
  return Array.from(e.variantChildren).sort(nR).forEach((c, u) => {
    c.notify("AnimationStart", t), a.push(Fa(c, t, {
      ...s,
      delay: n + l(u)
    }).then(() => c.notify("AnimationComplete", t)));
  }), Promise.all(a);
}
function nR(e, t) {
  return e.sortNodePosition(t);
}
function rR(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const o = t.map((s) => Fa(e, s, n));
    r = Promise.all(o);
  } else if (typeof t == "string")
    r = Fa(e, t, n);
  else {
    const o = typeof t == "function" ? rs(e, t, n.custom) : t;
    r = Promise.all(Mm(e, o, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
const oR = Hi.length;
function Im(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Im(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < oR; n++) {
    const r = Hi[n], o = e.props[r];
    (ar(o) || o === !1) && (t[r] = o);
  }
  return t;
}
const sR = [...Wi].reverse(), aR = Wi.length;
function iR(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => rR(e, n, r)));
}
function lR(e) {
  let t = iR(e), n = cu(), r = !0;
  const o = (l) => (c, u) => {
    var f;
    const h = rs(e, u, l === "exit" ? (f = e.presenceContext) === null || f === void 0 ? void 0 : f.custom : void 0);
    if (h) {
      const { transition: m, transitionEnd: g, ...v } = h;
      c = { ...c, ...v, ...g };
    }
    return c;
  };
  function s(l) {
    t = l(e);
  }
  function a(l) {
    const { props: c } = e, u = Im(e.parent) || {}, f = [], h = /* @__PURE__ */ new Set();
    let m = {}, g = 1 / 0;
    for (let y = 0; y < aR; y++) {
      const b = sR[y], w = n[b], x = c[b] !== void 0 ? c[b] : u[b], S = ar(x), C = b === l ? w.isActive : null;
      C === !1 && (g = y);
      let E = x === u[b] && x !== c[b] && S;
      if (E && r && e.manuallyAnimateOnMount && (E = !1), w.protectedKeys = { ...m }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && C === null || // If we didn't and don't have any defined prop for this animation type
      !x && !w.prevProp || // Or if the prop doesn't define an animation
      ts(x) || typeof x == "boolean")
        continue;
      const A = cR(w.prevProp, x);
      let T = A || // If we're making this variant active, we want to always make it active
      b === l && w.isActive && !E && S || // If we removed a higher-priority variant (i is in reverse order)
      y > g && S, I = !1;
      const L = Array.isArray(x) ? x : [x];
      let B = L.reduce(o(b), {});
      C === !1 && (B = {});
      const { prevResolvedValues: V = {} } = w, z = {
        ...V,
        ...B
      }, D = (P) => {
        T = !0, h.has(P) && (I = !0, h.delete(P)), w.needsAnimating[P] = !0;
        const R = e.getValue(P);
        R && (R.liveStyle = !1);
      };
      for (const P in z) {
        const R = B[P], k = V[P];
        if (m.hasOwnProperty(P))
          continue;
        let Z = !1;
        Ra(R) && Ra(k) ? Z = !jh(R, k) : Z = R !== k, Z ? R != null ? D(P) : h.add(P) : R !== void 0 && h.has(P) ? D(P) : w.protectedKeys[P] = !0;
      }
      w.prevProp = x, w.prevResolvedValues = B, w.isActive && (m = { ...m, ...B }), r && e.blockInitialAnimation && (T = !1), T && (!(E && A) || I) && f.push(...L.map((P) => ({
        animation: P,
        options: { type: b }
      })));
    }
    if (h.size) {
      const y = {};
      h.forEach((b) => {
        const w = e.getBaseTarget(b), x = e.getValue(b);
        x && (x.liveStyle = !0), y[b] = w ?? null;
      }), f.push({ animation: y });
    }
    let v = !!f.length;
    return r && (c.initial === !1 || c.initial === c.animate) && !e.manuallyAnimateOnMount && (v = !1), r = !1, v ? t(f) : Promise.resolve();
  }
  function i(l, c) {
    var u;
    if (n[l].isActive === c)
      return Promise.resolve();
    (u = e.variantChildren) === null || u === void 0 || u.forEach((h) => {
      var m;
      return (m = h.animationState) === null || m === void 0 ? void 0 : m.setActive(l, c);
    }), n[l].isActive = c;
    const f = a(l);
    for (const h in n)
      n[h].protectedKeys = {};
    return f;
  }
  return {
    animateChanges: a,
    setActive: i,
    setAnimateFunction: s,
    getState: () => n,
    reset: () => {
      n = cu(), r = !0;
    }
  };
}
function cR(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !jh(t, e) : !1;
}
function Ot(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function cu() {
  return {
    animate: Ot(!0),
    whileInView: Ot(),
    whileHover: Ot(),
    whileTap: Ot(),
    whileDrag: Ot(),
    whileFocus: Ot(),
    exit: Ot()
  };
}
class _t {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class uR extends _t {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = lR(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    ts(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) === null || t === void 0 || t.call(this);
  }
}
let dR = 0;
class fR extends _t {
  constructor() {
    super(...arguments), this.id = dR++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const o = this.node.animationState.setActive("exit", !t);
    n && !t && o.then(() => n(this.id));
  }
  mount() {
    const { register: t } = this.node.presenceContext || {};
    t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const pR = {
  animation: {
    Feature: uR
  },
  exit: {
    Feature: fR
  }
};
function ur(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function Rr(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const hR = (e) => (t) => ol(t) && e(t, Rr(t));
function Jn(e, t, n, r) {
  return ur(e, t, hR(n), r);
}
const uu = (e, t) => Math.abs(e - t);
function mR(e, t) {
  const n = uu(e.x, t.x), r = uu(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class Dm {
  constructor(t, n, { transformPagePoint: r, contextWindow: o, dragSnapToOrigin: s = !1 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const f = Qs(this.lastMoveEventInfo, this.history), h = this.startEvent !== null, m = mR(f.offset, { x: 0, y: 0 }) >= 3;
      if (!h && !m)
        return;
      const { point: g } = f, { timestamp: v } = xe;
      this.history.push({ ...g, timestamp: v });
      const { onStart: y, onMove: b } = this.handlers;
      h || (y && y(this.lastMoveEvent, f), this.startEvent = this.lastMoveEvent), b && b(this.lastMoveEvent, f);
    }, this.handlePointerMove = (f, h) => {
      this.lastMoveEvent = f, this.lastMoveEventInfo = Js(h, this.transformPagePoint), ce.update(this.updatePoint, !0);
    }, this.handlePointerUp = (f, h) => {
      this.end();
      const { onEnd: m, onSessionEnd: g, resumeAnimation: v } = this.handlers;
      if (this.dragSnapToOrigin && v && v(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const y = Qs(f.type === "pointercancel" ? this.lastMoveEventInfo : Js(h, this.transformPagePoint), this.history);
      this.startEvent && m && m(f, y), g && g(f, y);
    }, !ol(t))
      return;
    this.dragSnapToOrigin = s, this.handlers = n, this.transformPagePoint = r, this.contextWindow = o || window;
    const a = Rr(t), i = Js(a, this.transformPagePoint), { point: l } = i, { timestamp: c } = xe;
    this.history = [{ ...l, timestamp: c }];
    const { onSessionStart: u } = n;
    u && u(t, Qs(i, this.history)), this.removeListeners = Tr(Jn(this.contextWindow, "pointermove", this.handlePointerMove), Jn(this.contextWindow, "pointerup", this.handlePointerUp), Jn(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), Et(this.updatePoint);
  }
}
function Js(e, t) {
  return t ? { point: t(e.point) } : e;
}
function du(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Qs({ point: e }, t) {
  return {
    point: e,
    delta: du(e, km(t)),
    offset: du(e, vR(t)),
    velocity: gR(t, 0.1)
  };
}
function vR(e) {
  return e[0];
}
function km(e) {
  return e[e.length - 1];
}
function gR(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const o = km(e);
  for (; n >= 0 && (r = e[n], !(o.timestamp - r.timestamp > /* @__PURE__ */ Qe(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const s = /* @__PURE__ */ ct(o.timestamp - r.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const a = {
    x: (o.x - r.x) / s,
    y: (o.y - r.y) / s
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
const Om = 1e-4, yR = 1 - Om, bR = 1 + Om, Lm = 0.01, wR = 0 - Lm, xR = 0 + Lm;
function Ve(e) {
  return e.max - e.min;
}
function SR(e, t, n) {
  return Math.abs(e - t) <= n;
}
function fu(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = fe(t.min, t.max, e.origin), e.scale = Ve(n) / Ve(t), e.translate = fe(n.min, n.max, e.origin) - e.originPoint, (e.scale >= yR && e.scale <= bR || isNaN(e.scale)) && (e.scale = 1), (e.translate >= wR && e.translate <= xR || isNaN(e.translate)) && (e.translate = 0);
}
function Qn(e, t, n, r) {
  fu(e.x, t.x, n.x, r ? r.originX : void 0), fu(e.y, t.y, n.y, r ? r.originY : void 0);
}
function pu(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Ve(t);
}
function CR(e, t, n) {
  pu(e.x, t.x, n.x), pu(e.y, t.y, n.y);
}
function hu(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Ve(t);
}
function er(e, t, n) {
  hu(e.x, t.x, n.x), hu(e.y, t.y, n.y);
}
function AR(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? fe(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? fe(n, e, r.max) : Math.min(e, n)), e;
}
function mu(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function ER(e, { top: t, left: n, bottom: r, right: o }) {
  return {
    x: mu(e.x, n, o),
    y: mu(e.y, t, r)
  };
}
function vu(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function NR(e, t) {
  return {
    x: vu(e.x, t.x),
    y: vu(e.y, t.y)
  };
}
function TR(e, t) {
  let n = 0.5;
  const r = Ve(e), o = Ve(t);
  return o > r ? n = /* @__PURE__ */ pn(t.min, t.max - r, e.min) : r > o && (n = /* @__PURE__ */ pn(e.min, e.max - o, t.min)), ft(0, 1, n);
}
function RR(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const $a = 0.35;
function PR(e = $a) {
  return e === !1 ? e = 0 : e === !0 && (e = $a), {
    x: gu(e, "left", "right"),
    y: gu(e, "top", "bottom")
  };
}
function gu(e, t, n) {
  return {
    min: yu(e, t),
    max: yu(e, n)
  };
}
function yu(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const bu = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), rn = () => ({
  x: bu(),
  y: bu()
}), wu = () => ({ min: 0, max: 0 }), he = () => ({
  x: wu(),
  y: wu()
});
function $e(e) {
  return [e("x"), e("y")];
}
function Vm({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function _R({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function MR(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function ea(e) {
  return e === void 0 || e === 1;
}
function Ba({ scale: e, scaleX: t, scaleY: n }) {
  return !ea(e) || !ea(t) || !ea(n);
}
function Lt(e) {
  return Ba(e) || Fm(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function Fm(e) {
  return xu(e.x) || xu(e.y);
}
function xu(e) {
  return e && e !== "0%";
}
function Eo(e, t, n) {
  const r = e - n, o = t * r;
  return n + o;
}
function Su(e, t, n, r, o) {
  return o !== void 0 && (e = Eo(e, o, r)), Eo(e, n, r) + t;
}
function Ua(e, t = 0, n = 1, r, o) {
  e.min = Su(e.min, t, n, r, o), e.max = Su(e.max, t, n, r, o);
}
function $m(e, { x: t, y: n }) {
  Ua(e.x, t.translate, t.scale, t.originPoint), Ua(e.y, n.translate, n.scale, n.originPoint);
}
const Cu = 0.999999999999, Au = 1.0000000000001;
function IR(e, t, n, r = !1) {
  const o = n.length;
  if (!o)
    return;
  t.x = t.y = 1;
  let s, a;
  for (let i = 0; i < o; i++) {
    s = n[i], a = s.projectionDelta;
    const { visualElement: l } = s.options;
    l && l.props.style && l.props.style.display === "contents" || (r && s.options.layoutScroll && s.scroll && s !== s.root && sn(e, {
      x: -s.scroll.offset.x,
      y: -s.scroll.offset.y
    }), a && (t.x *= a.x.scale, t.y *= a.y.scale, $m(e, a)), r && Lt(s.latestValues) && sn(e, s.latestValues));
  }
  t.x < Au && t.x > Cu && (t.x = 1), t.y < Au && t.y > Cu && (t.y = 1);
}
function on(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function Eu(e, t, n, r, o = 0.5) {
  const s = fe(e.min, e.max, o);
  Ua(e, t, n, s, r);
}
function sn(e, t) {
  Eu(e.x, t.x, t.scaleX, t.scale, t.originX), Eu(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function Bm(e, t) {
  return Vm(MR(e.getBoundingClientRect(), t));
}
function DR(e, t, n) {
  const r = Bm(e, n), { scroll: o } = t;
  return o && (on(r.x, o.offset.x), on(r.y, o.offset.y)), r;
}
const Um = ({ current: e }) => e ? e.ownerDocument.defaultView : null, kR = /* @__PURE__ */ new WeakMap();
class OR {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = he(), this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1 } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const o = (u) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(Rr(u).point);
    }, s = (u, f) => {
      const { drag: h, dragPropagation: m, onDragStart: g } = this.getProps();
      if (h && !m && (this.openDragLock && this.openDragLock(), this.openDragLock = TN(h), !this.openDragLock))
        return;
      this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), $e((y) => {
        let b = this.getAxisMotionValue(y).get() || 0;
        if (et.test(b)) {
          const { projection: w } = this.visualElement;
          if (w && w.layout) {
            const x = w.layout.layoutBox[y];
            x && (b = Ve(x) * (parseFloat(b) / 100));
          }
        }
        this.originPoint[y] = b;
      }), g && ce.postRender(() => g(u, f)), Ma(this.visualElement, "transform");
      const { animationState: v } = this.visualElement;
      v && v.setActive("whileDrag", !0);
    }, a = (u, f) => {
      const { dragPropagation: h, dragDirectionLock: m, onDirectionLock: g, onDrag: v } = this.getProps();
      if (!h && !this.openDragLock)
        return;
      const { offset: y } = f;
      if (m && this.currentDirection === null) {
        this.currentDirection = LR(y), this.currentDirection !== null && g && g(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, y), this.updateAxis("y", f.point, y), this.visualElement.render(), v && v(u, f);
    }, i = (u, f) => this.stop(u, f), l = () => $e((u) => {
      var f;
      return this.getAnimationState(u) === "paused" && ((f = this.getAxisMotionValue(u).animation) === null || f === void 0 ? void 0 : f.play());
    }), { dragSnapToOrigin: c } = this.getProps();
    this.panSession = new Dm(t, {
      onSessionStart: o,
      onStart: s,
      onMove: a,
      onSessionEnd: i,
      resumeAnimation: l
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: c,
      contextWindow: Um(this.visualElement)
    });
  }
  stop(t, n) {
    const r = this.isDragging;
    if (this.cancel(), !r)
      return;
    const { velocity: o } = n;
    this.startAnimation(o);
    const { onDragEnd: s } = this.getProps();
    s && ce.postRender(() => s(t, n));
  }
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: o } = this.getProps();
    if (!r || !jr(t, o, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(t);
    let a = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (a = AR(a, this.constraints[t], this.elastic[t])), s.set(a);
  }
  resolveConstraints() {
    var t;
    const { dragConstraints: n, dragElastic: r } = this.getProps(), o = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (t = this.visualElement.projection) === null || t === void 0 ? void 0 : t.layout, s = this.constraints;
    n && tn(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && o ? this.constraints = ER(o.layoutBox, n) : this.constraints = !1, this.elastic = PR(r), s !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && $e((a) => {
      this.constraints !== !1 && this.getAxisMotionValue(a) && (this.constraints[a] = RR(o.layoutBox[a], this.constraints[a]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !tn(t))
      return !1;
    const r = t.current;
    At(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
    const { projection: o } = this.visualElement;
    if (!o || !o.layout)
      return !1;
    const s = DR(r, o.root, this.visualElement.getTransformPagePoint());
    let a = NR(o.layout.layoutBox, s);
    if (n) {
      const i = n(_R(a));
      this.hasMutatedConstraints = !!i, i && (a = Vm(i));
    }
    return a;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: o, dragTransition: s, dragSnapToOrigin: a, onDragTransitionEnd: i } = this.getProps(), l = this.constraints || {}, c = $e((u) => {
      if (!jr(u, n, this.currentDirection))
        return;
      let f = l && l[u] || {};
      a && (f = { min: 0, max: 0 });
      const h = o ? 200 : 1e6, m = o ? 40 : 1e7, g = {
        type: "inertia",
        velocity: r ? t[u] : 0,
        bounceStiffness: h,
        bounceDamping: m,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...f
      };
      return this.startAxisValueAnimation(u, g);
    });
    return Promise.all(c).then(i);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return Ma(this.visualElement, t), r.start(vl(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    $e((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    $e((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) === null || n === void 0 ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), o = r[n];
    return o || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    $e((n) => {
      const { drag: r } = this.getProps();
      if (!jr(n, r, this.currentDirection))
        return;
      const { projection: o } = this.visualElement, s = this.getAxisMotionValue(n);
      if (o && o.layout) {
        const { min: a, max: i } = o.layout.layoutBox[n];
        s.set(t[n] - fe(a, i, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!tn(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const o = { x: 0, y: 0 };
    $e((a) => {
      const i = this.getAxisMotionValue(a);
      if (i && this.constraints !== !1) {
        const l = i.get();
        o[a] = TR({ min: l, max: l }, this.constraints[a]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), $e((a) => {
      if (!jr(a, t, null))
        return;
      const i = this.getAxisMotionValue(a), { min: l, max: c } = this.constraints[a];
      i.set(fe(l, c, o[a]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    kR.set(this.visualElement, this);
    const t = this.visualElement.current, n = Jn(t, "pointerdown", (l) => {
      const { drag: c, dragListener: u = !0 } = this.getProps();
      c && u && this.start(l);
    }), r = () => {
      const { dragConstraints: l } = this.getProps();
      tn(l) && l.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: o } = this.visualElement, s = o.addEventListener("measure", r);
    o && !o.layout && (o.root && o.root.updateScroll(), o.updateLayout()), ce.read(r);
    const a = ur(window, "resize", () => this.scalePositionWithinConstraints()), i = o.addEventListener("didUpdate", (({ delta: l, hasLayoutChanged: c }) => {
      this.isDragging && c && ($e((u) => {
        const f = this.getAxisMotionValue(u);
        f && (this.originPoint[u] += l[u].translate, f.set(f.get() + l[u].translate));
      }), this.visualElement.render());
    }));
    return () => {
      a(), n(), s(), i && i();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: o = !1, dragConstraints: s = !1, dragElastic: a = $a, dragMomentum: i = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: o,
      dragConstraints: s,
      dragElastic: a,
      dragMomentum: i
    };
  }
}
function jr(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function LR(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class VR extends _t {
  constructor(t) {
    super(t), this.removeGroupControls = Re, this.removeListeners = Re, this.controls = new OR(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Re;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const Nu = (e) => (t, n) => {
  e && ce.postRender(() => e(t, n));
};
class FR extends _t {
  constructor() {
    super(...arguments), this.removePointerDownListener = Re;
  }
  onPointerDown(t) {
    this.session = new Dm(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Um(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: o } = this.node.getProps();
    return {
      onSessionStart: Nu(t),
      onStart: Nu(n),
      onMove: r,
      onEnd: (s, a) => {
        delete this.session, o && ce.postRender(() => o(s, a));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Jn(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const oo = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function Tu(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Un = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (j.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = Tu(e, t.target.x), r = Tu(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, $R = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, o = Nt.parse(e);
    if (o.length > 5)
      return r;
    const s = Nt.createTransformer(e), a = typeof o[0] != "number" ? 1 : 0, i = n.x.scale * t.x, l = n.y.scale * t.y;
    o[0 + a] /= i, o[1 + a] /= l;
    const c = fe(i, l, 0.5);
    return typeof o[2 + a] == "number" && (o[2 + a] /= c), typeof o[3 + a] == "number" && (o[3 + a] /= c), s(o);
  }
};
class BR extends Bb {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: o } = this.props, { projection: s } = t;
    aN(UR), s && (n.group && n.group.add(s), r && r.register && o && r.register(s), s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      onExitComplete: () => this.safeToRemove()
    })), oo.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: o, isPresent: s } = this.props, a = r.projection;
    return a && (a.isPresent = s, o || t.layoutDependency !== n || n === void 0 ? a.willUpdate() : this.safeToRemove(), t.isPresent !== s && (s ? a.promote() : a.relegate() || ce.postRender(() => {
      const i = a.getStack();
      (!i || !i.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), ji.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: o } = t;
    o && (o.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(o), r && r.deregister && r.deregister(o));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function Wm(e) {
  const [t, n] = xE(), r = pe(Eh);
  return p(BR, { ...e, layoutGroup: r, switchLayoutGroup: pe(Ih), isPresent: t, safeToRemove: n });
}
const UR = {
  borderRadius: {
    ...Un,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Un,
  borderTopRightRadius: Un,
  borderBottomLeftRadius: Un,
  borderBottomRightRadius: Un,
  boxShadow: $R
};
function WR(e, t, n) {
  const r = Ce(e) ? e : lr(e);
  return r.start(vl("", r, t, n)), r.animation;
}
function HR(e) {
  return e instanceof SVGElement && e.tagName !== "svg";
}
const GR = (e, t) => e.depth - t.depth;
class jR {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    sl(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    al(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort(GR), this.isDirty = !1, this.children.forEach(t);
  }
}
function KR(e, t) {
  const n = tt.now(), r = ({ timestamp: o }) => {
    const s = o - n;
    s >= t && (Et(r), e(s - t));
  };
  return ce.read(r, !0), () => Et(r);
}
const Hm = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], zR = Hm.length, Ru = (e) => typeof e == "string" ? parseFloat(e) : e, Pu = (e) => typeof e == "number" || j.test(e);
function YR(e, t, n, r, o, s) {
  o ? (e.opacity = fe(
    0,
    // TODO Reinstate this if only child
    n.opacity !== void 0 ? n.opacity : 1,
    XR(r)
  ), e.opacityExit = fe(t.opacity !== void 0 ? t.opacity : 1, 0, qR(r))) : s && (e.opacity = fe(t.opacity !== void 0 ? t.opacity : 1, n.opacity !== void 0 ? n.opacity : 1, r));
  for (let a = 0; a < zR; a++) {
    const i = `border${Hm[a]}Radius`;
    let l = _u(t, i), c = _u(n, i);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || Pu(l) === Pu(c) ? (e[i] = Math.max(fe(Ru(l), Ru(c), r), 0), (et.test(c) || et.test(l)) && (e[i] += "%")) : e[i] = c;
  }
  (t.rotate || n.rotate) && (e.rotate = fe(t.rotate || 0, n.rotate || 0, r));
}
function _u(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const XR = /* @__PURE__ */ Gm(0, 0.5, lm), qR = /* @__PURE__ */ Gm(0.5, 0.95, Re);
function Gm(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ pn(e, t, r));
}
function Mu(e, t) {
  e.min = t.min, e.max = t.max;
}
function Fe(e, t) {
  Mu(e.x, t.x), Mu(e.y, t.y);
}
function Iu(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function Du(e, t, n, r, o) {
  return e -= t, e = Eo(e, 1 / n, r), o !== void 0 && (e = Eo(e, 1 / o, r)), e;
}
function ZR(e, t = 0, n = 1, r = 0.5, o, s = e, a = e) {
  if (et.test(t) && (t = parseFloat(t), t = fe(a.min, a.max, t / 100) - a.min), typeof t != "number")
    return;
  let i = fe(s.min, s.max, r);
  e === s && (i -= t), e.min = Du(e.min, t, n, i, o), e.max = Du(e.max, t, n, i, o);
}
function ku(e, t, [n, r, o], s, a) {
  ZR(e, t[n], t[r], t[o], t.scale, s, a);
}
const JR = ["x", "scaleX", "originX"], QR = ["y", "scaleY", "originY"];
function Ou(e, t, n, r) {
  ku(e.x, t, JR, n ? n.x : void 0, r ? r.x : void 0), ku(e.y, t, QR, n ? n.y : void 0, r ? r.y : void 0);
}
function Lu(e) {
  return e.translate === 0 && e.scale === 1;
}
function jm(e) {
  return Lu(e.x) && Lu(e.y);
}
function Vu(e, t) {
  return e.min === t.min && e.max === t.max;
}
function eP(e, t) {
  return Vu(e.x, t.x) && Vu(e.y, t.y);
}
function Fu(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Km(e, t) {
  return Fu(e.x, t.x) && Fu(e.y, t.y);
}
function $u(e) {
  return Ve(e.x) / Ve(e.y);
}
function Bu(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class tP {
  constructor() {
    this.members = [];
  }
  add(t) {
    sl(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (al(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((o) => t === o);
    if (n === 0)
      return !1;
    let r;
    for (let o = n; o >= 0; o--) {
      const s = this.members[o];
      if (s.isPresent !== !1) {
        r = s;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: o } = t.options;
      o === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function nP(e, t, n) {
  let r = "";
  const o = e.x.translate / t.x, s = e.y.translate / t.y, a = (n == null ? void 0 : n.z) || 0;
  if ((o || s || a) && (r = `translate3d(${o}px, ${s}px, ${a}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: c, rotate: u, rotateX: f, rotateY: h, skewX: m, skewY: g } = n;
    c && (r = `perspective(${c}px) ${r}`), u && (r += `rotate(${u}deg) `), f && (r += `rotateX(${f}deg) `), h && (r += `rotateY(${h}deg) `), m && (r += `skewX(${m}deg) `), g && (r += `skewY(${g}deg) `);
  }
  const i = e.x.scale * t.x, l = e.y.scale * t.y;
  return (i !== 1 || l !== 1) && (r += `scale(${i}, ${l})`), r || "none";
}
const Vt = {
  type: "projectionFrame",
  totalNodes: 0,
  resolvedTargetDeltas: 0,
  recalculatedProjection: 0
}, Kn = typeof window < "u" && window.MotionDebug !== void 0, ta = ["", "X", "Y", "Z"], rP = { visibility: "hidden" }, Uu = 1e3;
let oP = 0;
function na(e, t, n, r) {
  const { latestValues: o } = t;
  o[e] && (n[e] = o[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function zm(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = tm(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: o, layoutId: s } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", ce, !(o || s));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && zm(r);
}
function Ym({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: o }) {
  return class {
    constructor(a = {}, i = t == null ? void 0 : t()) {
      this.id = oP++, this.animationId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, Kn && (Vt.totalNodes = Vt.resolvedTargetDeltas = Vt.recalculatedProjection = 0), this.nodes.forEach(iP), this.nodes.forEach(fP), this.nodes.forEach(pP), this.nodes.forEach(lP), Kn && window.MotionDebug.record(Vt);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = a, this.root = i ? i.root || i : this, this.path = i ? [...i.path, i] : [], this.parent = i, this.depth = i ? i.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new jR());
    }
    addEventListener(a, i) {
      return this.eventHandlers.has(a) || this.eventHandlers.set(a, new il()), this.eventHandlers.get(a).add(i);
    }
    notifyListeners(a, ...i) {
      const l = this.eventHandlers.get(a);
      l && l.notify(...i);
    }
    hasListeners(a) {
      return this.eventHandlers.has(a);
    }
    /**
     * Lifecycles
     */
    mount(a, i = this.root.hasTreeAnimated) {
      if (this.instance)
        return;
      this.isSVG = HR(a), this.instance = a;
      const { layoutId: l, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(a), this.root.nodes.add(this), this.parent && this.parent.children.add(this), i && (c || l) && (this.isLayoutDirty = !0), e) {
        let f;
        const h = () => this.root.updateBlockedByResize = !1;
        e(a, () => {
          this.root.updateBlockedByResize = !0, f && f(), f = KR(h, 250), oo.hasAnimatedSinceResize && (oo.hasAnimatedSinceResize = !1, this.nodes.forEach(Hu));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && u && (l || c) && this.addEventListener("didUpdate", ({ delta: f, hasLayoutChanged: h, hasRelativeTargetChanged: m, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const v = this.options.transition || u.getDefaultTransition() || yP, { onLayoutAnimationStart: y, onLayoutAnimationComplete: b } = u.getProps(), w = !this.targetLayout || !Km(this.targetLayout, g) || m, x = !h && m;
        if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || x || h && (w || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(f, x);
          const S = {
            ...tl(v, "layout"),
            onPlay: y,
            onComplete: b
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (S.delay = 0, S.type = !1), this.startAnimation(S);
        } else
          h || Hu(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const a = this.getStack();
      a && a.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, Et(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(hP), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: a } = this.options;
      return a && a.getProps().transformTemplate;
    }
    willUpdate(a = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && zm(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const f = this.path[u];
        f.shouldResetTransform = !0, f.updateScroll("snapshot"), f.options.layoutRoot && f.willUpdate(!1);
      }
      const { layoutId: i, layout: l } = this.options;
      if (i === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), a && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(Wu);
        return;
      }
      this.isUpdating || this.nodes.forEach(uP), this.isUpdating = !1, this.nodes.forEach(dP), this.nodes.forEach(sP), this.nodes.forEach(aP), this.clearAllSnapshots();
      const i = tt.now();
      xe.delta = ft(0, 1e3 / 60, i - xe.timestamp), xe.timestamp = i, xe.isProcessing = !0, Ks.update.process(xe), Ks.preRender.process(xe), Ks.render.process(xe), xe.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, ji.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(cP), this.sharedNodes.forEach(mP);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, ce.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      ce.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure());
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const a = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = he(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: i } = this.options;
      i && i.notify("LayoutMeasure", this.layout.layoutBox, a ? a.layoutBox : void 0);
    }
    updateScroll(a = "measure") {
      let i = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === a && (i = !1), i) {
        const l = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: a,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!o)
        return;
      const a = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, i = this.projectionDelta && !jm(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      a && (i || Lt(this.latestValues) || u) && (o(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(a = !0) {
      const i = this.measurePageBox();
      let l = this.removeElementScroll(i);
      return a && (l = this.removeTransform(l)), bP(l), {
        animationId: this.root.animationId,
        measuredBox: i,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var a;
      const { visualElement: i } = this.options;
      if (!i)
        return he();
      const l = i.measureViewportBox();
      if (!(((a = this.scroll) === null || a === void 0 ? void 0 : a.wasRoot) || this.path.some(wP))) {
        const { scroll: u } = this.root;
        u && (on(l.x, u.offset.x), on(l.y, u.offset.y));
      }
      return l;
    }
    removeElementScroll(a) {
      var i;
      const l = he();
      if (Fe(l, a), !((i = this.scroll) === null || i === void 0) && i.wasRoot)
        return l;
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c], { scroll: f, options: h } = u;
        u !== this.root && f && h.layoutScroll && (f.wasRoot && Fe(l, a), on(l.x, f.offset.x), on(l.y, f.offset.y));
      }
      return l;
    }
    applyTransform(a, i = !1) {
      const l = he();
      Fe(l, a);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        !i && u.options.layoutScroll && u.scroll && u !== u.root && sn(l, {
          x: -u.scroll.offset.x,
          y: -u.scroll.offset.y
        }), Lt(u.latestValues) && sn(l, u.latestValues);
      }
      return Lt(this.latestValues) && sn(l, this.latestValues), l;
    }
    removeTransform(a) {
      const i = he();
      Fe(i, a);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!c.instance || !Lt(c.latestValues))
          continue;
        Ba(c.latestValues) && c.updateSnapshot();
        const u = he(), f = c.measurePageBox();
        Fe(u, f), Ou(i, c.latestValues, c.snapshot ? c.snapshot.layoutBox : void 0, u);
      }
      return Lt(this.latestValues) && Ou(i, this.latestValues), i;
    }
    setTargetDelta(a) {
      this.targetDelta = a, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(a) {
      this.options = {
        ...this.options,
        ...a,
        crossfade: a.crossfade !== void 0 ? a.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== xe.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(a = !1) {
      var i;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(a || c && this.isSharedProjectionDirty || this.isProjectionDirty || !((i = this.parent) === null || i === void 0) && i.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: f, layoutId: h } = this.options;
      if (!(!this.layout || !(f || h))) {
        if (this.resolvedRelativeTargetAt = xe.timestamp, !this.targetDelta && !this.relativeTarget) {
          const m = this.getClosestProjectingParent();
          m && m.layout && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = he(), this.relativeTargetOrigin = he(), er(this.relativeTargetOrigin, this.layout.layoutBox, m.layout.layoutBox), Fe(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta)) {
          if (this.target || (this.target = he(), this.targetWithTransforms = he()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), CR(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : Fe(this.target, this.layout.layoutBox), $m(this.target, this.targetDelta)) : Fe(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
            this.attemptToResolveRelativeTarget = !1;
            const m = this.getClosestProjectingParent();
            m && !!m.resumingFrom == !!this.resumingFrom && !m.options.layoutScroll && m.target && this.animationProgress !== 1 ? (this.relativeParent = m, this.forceRelativeParentToResolveTarget(), this.relativeTarget = he(), this.relativeTargetOrigin = he(), er(this.relativeTargetOrigin, this.target, m.target), Fe(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
          }
          Kn && Vt.resolvedTargetDeltas++;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Ba(this.parent.latestValues) || Fm(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var a;
      const i = this.getLead(), l = !!this.resumingFrom || this !== i;
      let c = !0;
      if ((this.isProjectionDirty || !((a = this.parent) === null || a === void 0) && a.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === xe.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: f } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || f))
        return;
      Fe(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, m = this.treeScale.y;
      IR(this.layoutCorrected, this.treeScale, this.path, l), i.layout && !i.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (i.target = i.layout.layoutBox, i.targetWithTransforms = he());
      const { target: g } = i;
      if (!g) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Iu(this.prevProjectionDelta.x, this.projectionDelta.x), Iu(this.prevProjectionDelta.y, this.projectionDelta.y)), Qn(this.projectionDelta, this.layoutCorrected, g, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== m || !Bu(this.projectionDelta.x, this.prevProjectionDelta.x) || !Bu(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g)), Kn && Vt.recalculatedProjection++;
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(a = !0) {
      var i;
      if ((i = this.options.visualElement) === null || i === void 0 || i.scheduleRender(), a) {
        const l = this.getStack();
        l && l.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = rn(), this.projectionDelta = rn(), this.projectionDeltaWithTransform = rn();
    }
    setAnimationOrigin(a, i = !1) {
      const l = this.snapshot, c = l ? l.latestValues : {}, u = { ...this.latestValues }, f = rn();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !i;
      const h = he(), m = l ? l.source : void 0, g = this.layout ? this.layout.source : void 0, v = m !== g, y = this.getStack(), b = !y || y.members.length <= 1, w = !!(v && !b && this.options.crossfade === !0 && !this.path.some(gP));
      this.animationProgress = 0;
      let x;
      this.mixTargetDelta = (S) => {
        const C = S / 1e3;
        Gu(f.x, a.x, C), Gu(f.y, a.y, C), this.setTargetDelta(f), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (er(h, this.layout.layoutBox, this.relativeParent.layout.layoutBox), vP(this.relativeTarget, this.relativeTargetOrigin, h, C), x && eP(this.relativeTarget, x) && (this.isProjectionDirty = !1), x || (x = he()), Fe(x, this.relativeTarget)), v && (this.animationValues = u, YR(u, c, this.latestValues, C, w, b)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = C;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(a) {
      this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (Et(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ce.update(() => {
        oo.hasAnimatedSinceResize = !0, this.currentAnimation = WR(0, Uu, {
          ...a,
          onUpdate: (i) => {
            this.mixTargetDelta(i), a.onUpdate && a.onUpdate(i);
          },
          onComplete: () => {
            a.onComplete && a.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const a = this.getStack();
      a && a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(Uu), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const a = this.getLead();
      let { targetWithTransforms: i, target: l, layout: c, latestValues: u } = a;
      if (!(!i || !l || !c)) {
        if (this !== a && this.layout && c && Xm(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || he();
          const f = Ve(this.layout.layoutBox.x);
          l.x.min = a.target.x.min, l.x.max = l.x.min + f;
          const h = Ve(this.layout.layoutBox.y);
          l.y.min = a.target.y.min, l.y.max = l.y.min + h;
        }
        Fe(i, l), sn(i, u), Qn(this.projectionDeltaWithTransform, this.layoutCorrected, i, u);
      }
    }
    registerSharedNode(a, i) {
      this.sharedNodes.has(a) || this.sharedNodes.set(a, new tP()), this.sharedNodes.get(a).add(i);
      const c = i.options.initialPromotionConfig;
      i.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(i) : void 0
      });
    }
    isLead() {
      const a = this.getStack();
      return a ? a.lead === this : !0;
    }
    getLead() {
      var a;
      const { layoutId: i } = this.options;
      return i ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
    }
    getPrevLead() {
      var a;
      const { layoutId: i } = this.options;
      return i ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
    }
    getStack() {
      const { layoutId: a } = this.options;
      if (a)
        return this.root.sharedNodes.get(a);
    }
    promote({ needsReset: a, transition: i, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), a && (this.projectionDelta = void 0, this.needsReset = !0), i && this.setOptions({ transition: i });
    }
    relegate() {
      const a = this.getStack();
      return a ? a.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: a } = this.options;
      if (!a)
        return;
      let i = !1;
      const { latestValues: l } = a;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (i = !0), !i)
        return;
      const c = {};
      l.z && na("z", a, c, this.animationValues);
      for (let u = 0; u < ta.length; u++)
        na(`rotate${ta[u]}`, a, c, this.animationValues), na(`skew${ta[u]}`, a, c, this.animationValues);
      a.render();
      for (const u in c)
        a.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      a.scheduleRender();
    }
    getProjectionStyles(a) {
      var i, l;
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible)
        return rP;
      const c = {
        visibility: ""
      }, u = this.getTransformTemplate();
      if (this.needsReset)
        return this.needsReset = !1, c.opacity = "", c.pointerEvents = no(a == null ? void 0 : a.pointerEvents) || "", c.transform = u ? u(this.latestValues, "") : "none", c;
      const f = this.getLead();
      if (!this.projectionDelta || !this.layout || !f.target) {
        const v = {};
        return this.options.layoutId && (v.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, v.pointerEvents = no(a == null ? void 0 : a.pointerEvents) || ""), this.hasProjected && !Lt(this.latestValues) && (v.transform = u ? u({}, "") : "none", this.hasProjected = !1), v;
      }
      const h = f.animationValues || f.latestValues;
      this.applyTransformsToTarget(), c.transform = nP(this.projectionDeltaWithTransform, this.treeScale, h), u && (c.transform = u(h, c.transform));
      const { x: m, y: g } = this.projectionDelta;
      c.transformOrigin = `${m.origin * 100}% ${g.origin * 100}% 0`, f.animationValues ? c.opacity = f === this ? (l = (i = h.opacity) !== null && i !== void 0 ? i : this.latestValues.opacity) !== null && l !== void 0 ? l : 1 : this.preserveOpacity ? this.latestValues.opacity : h.opacityExit : c.opacity = f === this ? h.opacity !== void 0 ? h.opacity : "" : h.opacityExit !== void 0 ? h.opacityExit : 0;
      for (const v in wo) {
        if (h[v] === void 0)
          continue;
        const { correct: y, applyTo: b } = wo[v], w = c.transform === "none" ? h[v] : y(h[v], f);
        if (b) {
          const x = b.length;
          for (let S = 0; S < x; S++)
            c[b[S]] = w;
        } else
          c[v] = w;
      }
      return this.options.layoutId && (c.pointerEvents = f === this ? no(a == null ? void 0 : a.pointerEvents) || "" : "none"), c;
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((a) => {
        var i;
        return (i = a.currentAnimation) === null || i === void 0 ? void 0 : i.stop();
      }), this.root.nodes.forEach(Wu), this.root.sharedNodes.clear();
    }
  };
}
function sP(e) {
  e.updateLayout();
}
function aP(e) {
  var t;
  const n = ((t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: o } = e.layout, { animationType: s } = e.options, a = n.source !== e.layout.source;
    s === "size" ? $e((f) => {
      const h = a ? n.measuredBox[f] : n.layoutBox[f], m = Ve(h);
      h.min = r[f].min, h.max = h.min + m;
    }) : Xm(s, n.layoutBox, r) && $e((f) => {
      const h = a ? n.measuredBox[f] : n.layoutBox[f], m = Ve(r[f]);
      h.max = h.min + m, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[f].max = e.relativeTarget[f].min + m);
    });
    const i = rn();
    Qn(i, r, n.layoutBox);
    const l = rn();
    a ? Qn(l, e.applyTransform(o, !0), n.measuredBox) : Qn(l, r, n.layoutBox);
    const c = !jm(i);
    let u = !1;
    if (!e.resumeFrom) {
      const f = e.getClosestProjectingParent();
      if (f && !f.resumeFrom) {
        const { snapshot: h, layout: m } = f;
        if (h && m) {
          const g = he();
          er(g, n.layoutBox, h.layoutBox);
          const v = he();
          er(v, r, m.layoutBox), Km(g, v) || (u = !0), f.options.layoutRoot && (e.relativeTarget = v, e.relativeTargetOrigin = g, e.relativeParent = f);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: n,
      delta: l,
      layoutDelta: i,
      hasLayoutChanged: c,
      hasRelativeTargetChanged: u
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function iP(e) {
  Kn && Vt.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function lP(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function cP(e) {
  e.clearSnapshot();
}
function Wu(e) {
  e.clearMeasurements();
}
function uP(e) {
  e.isLayoutDirty = !1;
}
function dP(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function Hu(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function fP(e) {
  e.resolveTargetDelta();
}
function pP(e) {
  e.calcProjection();
}
function hP(e) {
  e.resetSkewAndRotation();
}
function mP(e) {
  e.removeLeadSnapshot();
}
function Gu(e, t, n) {
  e.translate = fe(t.translate, 0, n), e.scale = fe(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function ju(e, t, n, r) {
  e.min = fe(t.min, n.min, r), e.max = fe(t.max, n.max, r);
}
function vP(e, t, n, r) {
  ju(e.x, t.x, n.x, r), ju(e.y, t.y, n.y, r);
}
function gP(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const yP = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, Ku = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), zu = Ku("applewebkit/") && !Ku("chrome/") ? Math.round : Re;
function Yu(e) {
  e.min = zu(e.min), e.max = zu(e.max);
}
function bP(e) {
  Yu(e.x), Yu(e.y);
}
function Xm(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !SR($u(t), $u(n), 0.2);
}
function wP(e) {
  var t;
  return e !== e.root && ((t = e.scroll) === null || t === void 0 ? void 0 : t.wasRoot);
}
const xP = Ym({
  attachResizeListener: (e, t) => ur(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), ra = {
  current: void 0
}, qm = Ym({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!ra.current) {
      const e = new xP({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), ra.current = e;
    }
    return ra.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), SP = {
  pan: {
    Feature: FR
  },
  drag: {
    Feature: VR,
    ProjectionNode: qm,
    MeasureLayout: Wm
  }
};
function Xu(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const o = "onHover" + n, s = r[o];
  s && ce.postRender(() => s(t, Rr(t)));
}
class CP extends _t {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = SN(t, (n) => (Xu(this.node, n, "Start"), (r) => Xu(this.node, r, "End"))));
  }
  unmount() {
  }
}
class AP extends _t {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Tr(ur(this.node.current, "focus", () => this.onFocus()), ur(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function qu(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const o = "onTap" + (n === "End" ? "" : n), s = r[o];
  s && ce.postRender(() => s(t, Rr(t)));
}
class EP extends _t {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = NN(t, (n) => (qu(this.node, n, "Start"), (r, { success: o }) => qu(this.node, r, o ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Wa = /* @__PURE__ */ new WeakMap(), oa = /* @__PURE__ */ new WeakMap(), NP = (e) => {
  const t = Wa.get(e.target);
  t && t(e);
}, TP = (e) => {
  e.forEach(NP);
};
function RP({ root: e, ...t }) {
  const n = e || document;
  oa.has(n) || oa.set(n, {});
  const r = oa.get(n), o = JSON.stringify(t);
  return r[o] || (r[o] = new IntersectionObserver(TP, { root: e, ...t })), r[o];
}
function PP(e, t, n) {
  const r = RP(t);
  return Wa.set(e, n), r.observe(e), () => {
    Wa.delete(e), r.unobserve(e);
  };
}
const _P = {
  some: 0,
  all: 1
};
class MP extends _t {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: o = "some", once: s } = t, a = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof o == "number" ? o : _P[o]
    }, i = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, s && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: f } = this.node.getProps(), h = c ? u : f;
      h && h(l);
    };
    return PP(this.node.current, a, i);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(IP(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function IP({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const DP = {
  inView: {
    Feature: MP
  },
  tap: {
    Feature: EP
  },
  focus: {
    Feature: AP
  },
  hover: {
    Feature: CP
  }
}, kP = {
  layout: {
    ProjectionNode: qm,
    MeasureLayout: Wm
  }
}, Ha = { current: null }, Zm = { current: !1 };
function OP() {
  if (Zm.current = !0, !!Bi)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Ha.current = e.matches;
      e.addListener(t), t();
    } else
      Ha.current = !1;
}
const LP = [...Sm, Se, Nt], VP = (e) => LP.find(xm(e)), Zu = /* @__PURE__ */ new WeakMap();
function FP(e, t, n) {
  for (const r in t) {
    const o = t[r], s = n[r];
    if (Ce(o))
      e.addValue(r, o), process.env.NODE_ENV === "development" && Qo(o.version === "11.18.2", `Attempting to mix Motion versions ${o.version} with 11.18.2 may not work as expected.`);
    else if (Ce(s))
      e.addValue(r, lr(o, { owner: e }));
    else if (s !== o)
      if (e.hasValue(r)) {
        const a = e.getValue(r);
        a.liveStyle === !0 ? a.jump(o) : a.hasAnimated || a.set(o);
      } else {
        const a = e.getStaticValue(r);
        e.addValue(r, lr(a !== void 0 ? a : o, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Ju = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class $P {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: o, blockInitialAnimation: s, visualState: a }, i = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = pl, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const m = tt.now();
      this.renderScheduledAt < m && (this.renderScheduledAt = m, ce.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: c, onUpdate: u } = a;
    this.onUpdate = u, this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = c, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = o, this.options = i, this.blockInitialAnimation = !!s, this.isControllingVariants = ns(n), this.isVariantNode = _h(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: f, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const m in h) {
      const g = h[m];
      l[m] !== void 0 && Ce(g) && g.set(l[m], !1);
    }
  }
  mount(t) {
    this.current = t, Zu.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), Zm.current || OP(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Ha.current, process.env.NODE_ENV !== "production" && Qo(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    Zu.delete(this.current), this.projection && this.projection.unmount(), Et(this.notifyUpdate), Et(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = Xt.has(t), o = n.on("change", (i) => {
      this.latestValues[t] = i, this.props.onUpdate && ce.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), s = n.on("renderRequest", this.scheduleRender);
    let a;
    window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      o(), s(), a && a(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in hn) {
      const n = hn[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: o } = n;
      if (!this.features[t] && o && r(this.props) && (this.features[t] = new o(this)), this.features[t]) {
        const s = this.features[t];
        s.isMounted ? s.update() : (s.mount(), s.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : he();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Ju.length; r++) {
      const o = Ju[r];
      this.propEventSubscriptions[o] && (this.propEventSubscriptions[o](), delete this.propEventSubscriptions[o]);
      const s = "on" + o, a = t[s];
      a && (this.propEventSubscriptions[o] = this.on(o, a));
    }
    this.prevMotionValues = FP(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue(), this.onUpdate && this.onUpdate(this);
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = lr(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    var r;
    let o = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : (r = this.getBaseTargetFromProps(this.props, t)) !== null && r !== void 0 ? r : this.readValueFromInstance(this.current, t, this.options);
    return o != null && (typeof o == "string" && (bm(o) || um(o)) ? o = parseFloat(o) : !VP(o) && Nt.test(n) && (o = vm(t, n)), this.setBaseTarget(t, Ce(o) ? o.get() : o)), Ce(o) ? o.get() : o;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var n;
    const { initial: r } = this.props;
    let o;
    if (typeof r == "string" || typeof r == "object") {
      const a = zi(this.props, r, (n = this.presenceContext) === null || n === void 0 ? void 0 : n.custom);
      a && (o = a[t]);
    }
    if (r && o !== void 0)
      return o;
    const s = this.getBaseTargetFromProps(this.props, t);
    return s !== void 0 && !Ce(s) ? s : this.initialValues[t] !== void 0 && o === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new il()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
class Jm extends $P {
  constructor() {
    super(...arguments), this.KeyframeResolver = Cm;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Ce(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function BP(e) {
  return window.getComputedStyle(e);
}
class UP extends Jm {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = $h;
  }
  readValueFromInstance(t, n) {
    if (Xt.has(n)) {
      const r = fl(n);
      return r && r.default || 0;
    } else {
      const r = BP(t), o = (Lh(n) ? r.getPropertyValue(n) : r[n]) || 0;
      return typeof o == "string" ? o.trim() : o;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Bm(t, n);
  }
  build(t, n, r) {
    qi(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return el(t, n, r);
  }
}
class WP extends Jm {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = he;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Xt.has(n)) {
      const r = fl(n);
      return r && r.default || 0;
    }
    return n = Bh.has(n) ? n : Gi(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Hh(t, n, r);
  }
  build(t, n, r) {
    Zi(t, n, this.isSVGTag, r.transformTemplate);
  }
  renderInstance(t, n, r, o) {
    Uh(t, n, r, o);
  }
  mount(t) {
    this.isSVGTag = Qi(t.tagName), super.mount(t);
  }
}
const HP = (e, t) => Ki(e) ? new WP(t) : new UP(t, {
  allowProjection: e !== bd
}), GP = /* @__PURE__ */ mN({
  ...pR,
  ...DP,
  ...SP,
  ...kP
}, HP), Kr = /* @__PURE__ */ _E(GP);
function sL({
  className: e,
  variant: t = "grid",
  animate: n = !0,
  opacity: r = 0.03
}) {
  const o = {
    grid: /* @__PURE__ */ p("div", { className: "absolute inset-0", children: /* @__PURE__ */ p(
      "div",
      {
        className: N(
          "absolute inset-0 bg-[linear-gradient(45deg,var(--background)_25%,transparent_25%,transparent_75%,var(--background)_75%,var(--background)),linear-gradient(45deg,var(--background)_25%,transparent_25%,transparent_75%,var(--background)_75%,var(--background))]",
          "bg-[length:60px_60px] bg-[position:0_0,30px_30px]"
        ),
        style: { opacity: r }
      }
    ) }),
    dots: /* @__PURE__ */ p("div", { className: "absolute inset-0", children: /* @__PURE__ */ p(
      "div",
      {
        className: "absolute inset-0 bg-[radial-gradient(var(--background)_1px,transparent_1px)] bg-[length:20px_20px]",
        style: { opacity: r }
      }
    ) }),
    waves: /* @__PURE__ */ p(
      Kr.div,
      {
        className: "absolute inset-0",
        initial: n ? { opacity: 0, scale: 0.95 } : !1,
        animate: n ? { opacity: 1, scale: 1 } : !1,
        transition: { duration: 1.5 },
        children: /* @__PURE__ */ p(
          "svg",
          {
            className: "absolute h-full w-full",
            viewBox: "0 0 1440 320",
            preserveAspectRatio: "none",
            style: { opacity: r },
            children: /* @__PURE__ */ p(
              "path",
              {
                className: "text-primary dark:text-primary/50",
                fillOpacity: "0.05",
                d: "M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
              }
            )
          }
        )
      }
    ),
    curved: /* @__PURE__ */ O(
      Kr.div,
      {
        className: "absolute inset-0",
        initial: n ? { opacity: 0 } : !1,
        animate: n ? { opacity: 1 } : !1,
        transition: { duration: 1.5 },
        children: [
          /* @__PURE__ */ p(
            "div",
            {
              className: "absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent dark:from-primary/10",
              style: { opacity: r * 2 }
            }
          ),
          /* @__PURE__ */ p(
            "svg",
            {
              className: "absolute bottom-0 w-full transform translate-y-1/2",
              viewBox: "0 0 1440 320",
              preserveAspectRatio: "none",
              style: { opacity: r },
              children: /* @__PURE__ */ p(
                "path",
                {
                  className: "text-primary dark:text-primary/50",
                  fillOpacity: "0.05",
                  d: "M0,96L60,85.3C120,75,240,53,360,74.7C480,96,600,160,720,186.7C840,213,960,203,1080,170.7C1200,139,1320,85,1380,58.7L1440,32L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"
                }
              )
            }
          )
        ]
      }
    ),
    geometric: /* @__PURE__ */ p(
      Kr.div,
      {
        className: "absolute inset-0",
        initial: n ? { opacity: 0 } : !1,
        animate: n ? { opacity: 1 } : !1,
        transition: { duration: 1.5 },
        children: /* @__PURE__ */ p("div", { className: "absolute inset-0", children: /* @__PURE__ */ O("svg", { width: "100%", height: "100%", className: "absolute inset-0", children: [
          /* @__PURE__ */ p(
            "pattern",
            {
              id: "geometric",
              x: "0",
              y: "0",
              width: "50",
              height: "50",
              patternUnits: "userSpaceOnUse",
              style: { opacity: r },
              children: /* @__PURE__ */ p(
                "path",
                {
                  d: "M0 0L25 25L50 0L25 -25Z",
                  className: "text-primary dark:text-primary/50",
                  fillOpacity: "0.05"
                }
              )
            }
          ),
          /* @__PURE__ */ p(
            "rect",
            {
              x: "0",
              y: "0",
              width: "100%",
              height: "100%",
              fill: "url(#geometric)"
            }
          )
        ] }) })
      }
    ),
    circuit: /* @__PURE__ */ p(
      Kr.div,
      {
        className: "absolute inset-0",
        initial: n ? { opacity: 0 } : !1,
        animate: n ? { opacity: 1 } : !1,
        transition: { duration: 1.5 },
        children: /* @__PURE__ */ p("div", { className: "absolute inset-0", children: /* @__PURE__ */ O("svg", { width: "100%", height: "100%", className: "absolute inset-0", children: [
          /* @__PURE__ */ O(
            "pattern",
            {
              id: "circuit",
              x: "0",
              y: "0",
              width: "100",
              height: "100",
              patternUnits: "userSpaceOnUse",
              style: { opacity: r },
              children: [
                /* @__PURE__ */ p(
                  "path",
                  {
                    d: "M0 50h100M50 0v100M17 17l66 66M83 17l-66 66",
                    stroke: "currentColor",
                    strokeWidth: "1",
                    className: "text-primary dark:text-primary/50",
                    strokeOpacity: "0.05"
                  }
                ),
                /* @__PURE__ */ p(
                  "circle",
                  {
                    cx: "50",
                    cy: "50",
                    r: "3",
                    className: "fill-primary dark:fill-primary/50",
                    fillOpacity: "0.05"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ p("rect", { x: "0", y: "0", width: "100%", height: "100%", fill: "url(#circuit)" })
        ] }) })
      }
    )
  };
  return /* @__PURE__ */ p("div", { className: N("absolute inset-0 overflow-hidden", e), children: o[t] });
}
var X = function() {
  return X = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, X.apply(this, arguments);
};
function jP(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Qm(e, t, n) {
  for (var r = 0, o = t.length, s; r < o; r++)
    (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function Pr(e) {
  return e.mode === "multiple";
}
function _r(e) {
  return e.mode === "range";
}
function ss(e) {
  return e.mode === "single";
}
var KP = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function zP(e, t) {
  return be(e, "LLLL y", t);
}
function YP(e, t) {
  return be(e, "d", t);
}
function XP(e, t) {
  return be(e, "LLLL", t);
}
function qP(e) {
  return "".concat(e);
}
function ZP(e, t) {
  return be(e, "cccccc", t);
}
function JP(e, t) {
  return be(e, "yyyy", t);
}
var QP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: zP,
  formatDay: YP,
  formatMonthCaption: XP,
  formatWeekNumber: qP,
  formatWeekdayName: ZP,
  formatYearCaption: JP
}), e1 = function(e, t, n) {
  return be(e, "do MMMM (EEEE)", n);
}, t1 = function() {
  return "Month: ";
}, n1 = function() {
  return "Go to next month";
}, r1 = function() {
  return "Go to previous month";
}, o1 = function(e, t) {
  return be(e, "cccc", t);
}, s1 = function(e) {
  return "Week n. ".concat(e);
}, a1 = function() {
  return "Year: ";
}, i1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: e1,
  labelMonthDropdown: t1,
  labelNext: n1,
  labelPrevious: r1,
  labelWeekNumber: s1,
  labelWeekday: o1,
  labelYearDropdown: a1
});
function l1() {
  var e = "buttons", t = KP, n = n0, r = {}, o = {}, s = 1, a = {}, i = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: QP,
    labels: i1,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: s,
    styles: a,
    today: i,
    mode: "default"
  };
}
function c1(e) {
  var t = e.fromYear, n = e.toYear, r = e.fromMonth, o = e.toMonth, s = e.fromDate, a = e.toDate;
  return r ? s = ke(r) : t && (s = new Date(t, 0, 1)), o ? a = li(o) : n && (a = new Date(n, 11, 31)), {
    fromDate: s ? va(s) : void 0,
    toDate: a ? va(a) : void 0
  };
}
var ev = _e(void 0);
function u1(e) {
  var t, n = e.initialProps, r = l1(), o = c1(n), s = o.fromDate, a = o.toDate, i = (t = n.captionLayout) !== null && t !== void 0 ? t : r.captionLayout;
  i !== "buttons" && (!s || !a) && (i = "buttons");
  var l;
  (ss(n) || Pr(n) || _r(n)) && (l = n.onSelect);
  var c = X(X(X({}, r), n), { captionLayout: i, classNames: X(X({}, r.classNames), n.classNames), components: X({}, n.components), formatters: X(X({}, r.formatters), n.formatters), fromDate: s, labels: X(X({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: X(X({}, r.modifiers), n.modifiers), modifiersClassNames: X(X({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: X(X({}, r.styles), n.styles), toDate: a });
  return p(ev.Provider, { value: c, children: e.children });
}
function ie() {
  var e = pe(ev);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function tv(e) {
  var t = ie(), n = t.locale, r = t.classNames, o = t.styles, s = t.formatters.formatCaption;
  return p("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: s(e.displayMonth, { locale: n }) });
}
function d1(e) {
  return p("svg", X({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: p("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function nv(e) {
  var t, n, r = e.onChange, o = e.value, s = e.children, a = e.caption, i = e.className, l = e.style, c = ie(), u = (n = (t = c.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && n !== void 0 ? n : d1;
  return O("div", { className: i, style: l, children: [p("span", { className: c.classNames.vhidden, children: e["aria-label"] }), p("select", { name: e.name, "aria-label": e["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: o, onChange: r, children: s }), O("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [a, p(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function f1(e) {
  var t, n = ie(), r = n.fromDate, o = n.toDate, s = n.styles, a = n.locale, i = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return p(ge, {});
  if (!o)
    return p(ge, {});
  var f = [];
  if (ba(r, o))
    for (var h = ke(r), m = r.getMonth(); m <= o.getMonth(); m++)
      f.push(Rs(h, m));
  else
    for (var h = ke(/* @__PURE__ */ new Date()), m = 0; m <= 11; m++)
      f.push(Rs(h, m));
  var g = function(y) {
    var b = Number(y.target.value), w = Rs(ke(e.displayMonth), b);
    e.onChange(w);
  }, v = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : nv;
  return p(v, { name: "months", "aria-label": u(), className: l.dropdown_month, style: s.dropdown_month, onChange: g, value: e.displayMonth.getMonth(), caption: i(e.displayMonth, { locale: a }), children: f.map(function(y) {
    return p("option", { value: y.getMonth(), children: i(y, { locale: a }) }, y.getMonth());
  }) });
}
function p1(e) {
  var t, n = e.displayMonth, r = ie(), o = r.fromDate, s = r.toDate, a = r.locale, i = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, f = r.labels.labelYearDropdown, h = [];
  if (!o)
    return p(ge, {});
  if (!s)
    return p(ge, {});
  for (var m = o.getFullYear(), g = s.getFullYear(), v = m; v <= g; v++)
    h.push(ec(zb(/* @__PURE__ */ new Date()), v));
  var y = function(w) {
    var x = ec(ke(n), Number(w.target.value));
    e.onChange(x);
  }, b = (t = c == null ? void 0 : c.Dropdown) !== null && t !== void 0 ? t : nv;
  return p(b, { name: "years", "aria-label": f(), className: l.dropdown_year, style: i.dropdown_year, onChange: y, value: n.getFullYear(), caption: u(n, { locale: a }), children: h.map(function(w) {
    return p("option", { value: w.getFullYear(), children: u(w, { locale: a }) }, w.getFullYear());
  }) });
}
function h1(e, t) {
  var n = Ge(e), r = n[0], o = n[1], s = t === void 0 ? r : t;
  return [s, o];
}
function m1(e) {
  var t = e.month, n = e.defaultMonth, r = e.today, o = t || n || r || /* @__PURE__ */ new Date(), s = e.toDate, a = e.fromDate, i = e.numberOfMonths, l = i === void 0 ? 1 : i;
  if (s && nr(s, o) < 0) {
    var c = -1 * (l - 1);
    o = nt(s, c);
  }
  return a && nr(o, a) < 0 && (o = a), ke(o);
}
function v1() {
  var e = ie(), t = m1(e), n = h1(t, e.month), r = n[0], o = n[1], s = function(a) {
    var i;
    if (!e.disableNavigation) {
      var l = ke(a);
      o(l), (i = e.onMonthChange) === null || i === void 0 || i.call(e, l);
    }
  };
  return [r, s];
}
function g1(e, t) {
  for (var n = t.reverseMonths, r = t.numberOfMonths, o = ke(e), s = ke(nt(o, r)), a = nr(s, o), i = [], l = 0; l < a; l++) {
    var c = nt(o, l);
    i.push(c);
  }
  return n && (i = i.reverse()), i;
}
function y1(e, t) {
  if (!t.disableNavigation) {
    var n = t.toDate, r = t.pagedNavigation, o = t.numberOfMonths, s = o === void 0 ? 1 : o, a = r ? s : 1, i = ke(e);
    if (!n)
      return nt(i, a);
    var l = nr(n, e);
    if (!(l < s))
      return nt(i, a);
  }
}
function b1(e, t) {
  if (!t.disableNavigation) {
    var n = t.fromDate, r = t.pagedNavigation, o = t.numberOfMonths, s = o === void 0 ? 1 : o, a = r ? s : 1, i = ke(e);
    if (!n)
      return nt(i, -a);
    var l = nr(i, n);
    if (!(l <= 0))
      return nt(i, -a);
  }
}
var rv = _e(void 0);
function w1(e) {
  var t = ie(), n = v1(), r = n[0], o = n[1], s = g1(r, t), a = y1(r, t), i = b1(r, t), l = function(f) {
    return s.some(function(h) {
      return ci(f, h);
    });
  }, c = function(f, h) {
    l(f) || (h && wd(f, h) ? o(nt(f, 1 + t.numberOfMonths * -1)) : o(f));
  }, u = {
    currentMonth: r,
    displayMonths: s,
    goToMonth: o,
    goToDate: c,
    previousMonth: i,
    nextMonth: a,
    isDateDisplayed: l
  };
  return p(rv.Provider, { value: u, children: e.children });
}
function Mr() {
  var e = pe(rv);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function Qu(e) {
  var t, n = ie(), r = n.classNames, o = n.styles, s = n.components, a = Mr().goToMonth, i = function(u) {
    a(nt(u, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : tv, c = p(l, { id: e.id, displayMonth: e.displayMonth });
  return O("div", { className: r.caption_dropdowns, style: o.caption_dropdowns, children: [p("div", { className: r.vhidden, children: c }), p(f1, { onChange: i, displayMonth: e.displayMonth }), p(p1, { onChange: i, displayMonth: e.displayMonth })] });
}
function x1(e) {
  return p("svg", X({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: p("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function S1(e) {
  return p("svg", X({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: p("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var No = Lo(function(e, t) {
  var n = ie(), r = n.classNames, o = n.styles, s = [r.button_reset, r.button];
  e.className && s.push(e.className);
  var a = s.join(" "), i = X(X({}, o.button_reset), o.button);
  return e.style && Object.assign(i, e.style), p("button", X({}, e, { ref: t, type: "button", className: a, style: i }));
});
function C1(e) {
  var t, n, r = ie(), o = r.dir, s = r.locale, a = r.classNames, i = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, f = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return p(ge, {});
  var h = c(e.previousMonth, { locale: s }), m = [
    a.nav_button,
    a.nav_button_previous
  ].join(" "), g = u(e.nextMonth, { locale: s }), v = [
    a.nav_button,
    a.nav_button_next
  ].join(" "), y = (t = f == null ? void 0 : f.IconRight) !== null && t !== void 0 ? t : S1, b = (n = f == null ? void 0 : f.IconLeft) !== null && n !== void 0 ? n : x1;
  return O("div", { className: a.nav, style: i.nav, children: [!e.hidePrevious && p(No, { name: "previous-month", "aria-label": h, className: m, style: i.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? p(y, { className: a.nav_icon, style: i.nav_icon }) : p(b, { className: a.nav_icon, style: i.nav_icon }) }), !e.hideNext && p(No, { name: "next-month", "aria-label": g, className: v, style: i.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? p(b, { className: a.nav_icon, style: i.nav_icon }) : p(y, { className: a.nav_icon, style: i.nav_icon }) })] });
}
function ed(e) {
  var t = ie().numberOfMonths, n = Mr(), r = n.previousMonth, o = n.nextMonth, s = n.goToMonth, a = n.displayMonths, i = a.findIndex(function(g) {
    return ci(e.displayMonth, g);
  }), l = i === 0, c = i === a.length - 1, u = t > 1 && (l || !c), f = t > 1 && (c || !l), h = function() {
    r && s(r);
  }, m = function() {
    o && s(o);
  };
  return p(C1, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: f, nextMonth: o, previousMonth: r, onPreviousClick: h, onNextClick: m });
}
function A1(e) {
  var t, n = ie(), r = n.classNames, o = n.disableNavigation, s = n.styles, a = n.captionLayout, i = n.components, l = (t = i == null ? void 0 : i.CaptionLabel) !== null && t !== void 0 ? t : tv, c;
  return o ? c = p(l, { id: e.id, displayMonth: e.displayMonth }) : a === "dropdown" ? c = p(Qu, { displayMonth: e.displayMonth, id: e.id }) : a === "dropdown-buttons" ? c = O(ge, { children: [p(Qu, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), p(ed, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : c = O(ge, { children: [p(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), p(ed, { displayMonth: e.displayMonth, id: e.id })] }), p("div", { className: r.caption, style: s.caption, children: c });
}
function E1(e) {
  var t = ie(), n = t.footer, r = t.styles, o = t.classNames.tfoot;
  return n ? p("tfoot", { className: o, style: r.tfoot, children: p("tr", { children: p("td", { colSpan: 8, children: n }) }) }) : p(ge, {});
}
function N1(e, t, n) {
  for (var r = n ? ui(/* @__PURE__ */ new Date()) : di(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], s = 0; s < 7; s++) {
    var a = Ne(r, s);
    o.push(a);
  }
  return o;
}
function T1() {
  var e = ie(), t = e.classNames, n = e.styles, r = e.showWeekNumber, o = e.locale, s = e.weekStartsOn, a = e.ISOWeek, i = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, c = N1(o, s, a);
  return O("tr", { style: n.head_row, className: t.head_row, children: [r && p("td", { style: n.head_cell, className: t.head_cell }), c.map(function(u, f) {
    return p("th", { scope: "col", className: t.head_cell, style: n.head_cell, "aria-label": l(u, { locale: o }), children: i(u, { locale: o }) }, f);
  })] });
}
function R1() {
  var e, t = ie(), n = t.classNames, r = t.styles, o = t.components, s = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : T1;
  return p("thead", { style: r.head, className: n.head, children: p(s, {}) });
}
function P1(e) {
  var t = ie(), n = t.locale, r = t.formatters.formatDay;
  return p(ge, { children: r(e.date, { locale: n }) });
}
var gl = _e(void 0);
function _1(e) {
  if (!Pr(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return p(gl.Provider, { value: t, children: e.children });
  }
  return p(M1, { initialProps: e.initialProps, children: e.children });
}
function M1(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = t.min, s = t.max, a = function(c, u, f) {
    var h, m;
    (h = t.onDayClick) === null || h === void 0 || h.call(t, c, u, f);
    var g = !!(u.selected && o && (r == null ? void 0 : r.length) === o);
    if (!g) {
      var v = !!(!u.selected && s && (r == null ? void 0 : r.length) === s);
      if (!v) {
        var y = r ? Qm([], r) : [];
        if (u.selected) {
          var b = y.findIndex(function(w) {
            return Te(c, w);
          });
          y.splice(b, 1);
        } else
          y.push(c);
        (m = t.onSelect) === null || m === void 0 || m.call(t, y, c, u, f);
      }
    }
  }, i = {
    disabled: []
  };
  r && i.disabled.push(function(c) {
    var u = s && r.length > s - 1, f = r.some(function(h) {
      return Te(h, c);
    });
    return !!(u && !f);
  });
  var l = {
    selected: r,
    onDayClick: a,
    modifiers: i
  };
  return p(gl.Provider, { value: l, children: n });
}
function yl() {
  var e = pe(gl);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function I1(e, t) {
  var n = t || {}, r = n.from, o = n.to;
  return r && o ? Te(o, e) && Te(r, e) ? void 0 : Te(o, e) ? { from: o, to: void 0 } : Te(r, e) ? void 0 : ya(r, e) ? { from: e, to: o } : { from: r, to: e } : o ? ya(e, o) ? { from: o, to: e } : { from: e, to: o } : r ? wd(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var bl = _e(void 0);
function D1(e) {
  if (!_r(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return p(bl.Provider, { value: t, children: e.children });
  }
  return p(k1, { initialProps: e.initialProps, children: e.children });
}
function k1(e) {
  var t = e.initialProps, n = e.children, r = t.selected, o = r || {}, s = o.from, a = o.to, i = t.min, l = t.max, c = function(m, g, v) {
    var y, b;
    (y = t.onDayClick) === null || y === void 0 || y.call(t, m, g, v);
    var w = I1(m, r);
    (b = t.onSelect) === null || b === void 0 || b.call(t, w, m, g, v);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (s ? (u.range_start = [s], a ? (u.range_end = [a], Te(s, a) || (u.range_middle = [
    {
      after: s,
      before: a
    }
  ])) : u.range_end = [s]) : a && (u.range_start = [a], u.range_end = [a]), i && (s && !a && u.disabled.push({
    after: Ts(s, i - 1),
    before: Ne(s, i - 1)
  }), s && a && u.disabled.push({
    after: s,
    before: Ne(s, i - 1)
  }), !s && a && u.disabled.push({
    after: Ts(a, i - 1),
    before: Ne(a, i - 1)
  })), l) {
    if (s && !a && (u.disabled.push({
      before: Ne(s, -l + 1)
    }), u.disabled.push({
      after: Ne(s, l - 1)
    })), s && a) {
      var f = lt(a, s) + 1, h = l - f;
      u.disabled.push({
        before: Ts(s, h)
      }), u.disabled.push({
        after: Ne(a, h)
      });
    }
    !s && a && (u.disabled.push({
      before: Ne(a, -l + 1)
    }), u.disabled.push({
      after: Ne(a, l - 1)
    }));
  }
  return p(bl.Provider, { value: { selected: r, onDayClick: c, modifiers: u }, children: n });
}
function wl() {
  var e = pe(bl);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function so(e) {
  return Array.isArray(e) ? Qm([], e) : e !== void 0 ? [e] : [];
}
function O1(e) {
  var t = {};
  return Object.entries(e).forEach(function(n) {
    var r = n[0], o = n[1];
    t[r] = so(o);
  }), t;
}
var ze;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(ze || (ze = {}));
var L1 = ze.Selected, it = ze.Disabled, V1 = ze.Hidden, F1 = ze.Today, sa = ze.RangeEnd, aa = ze.RangeMiddle, ia = ze.RangeStart, $1 = ze.Outside;
function B1(e, t, n) {
  var r, o = (r = {}, r[L1] = so(e.selected), r[it] = so(e.disabled), r[V1] = so(e.hidden), r[F1] = [e.today], r[sa] = [], r[aa] = [], r[ia] = [], r[$1] = [], r);
  return e.fromDate && o[it].push({ before: e.fromDate }), e.toDate && o[it].push({ after: e.toDate }), Pr(e) ? o[it] = o[it].concat(t.modifiers[it]) : _r(e) && (o[it] = o[it].concat(n.modifiers[it]), o[ia] = n.modifiers[ia], o[aa] = n.modifiers[aa], o[sa] = n.modifiers[sa]), o;
}
var ov = _e(void 0);
function U1(e) {
  var t = ie(), n = yl(), r = wl(), o = B1(t, n, r), s = O1(t.modifiers), a = X(X({}, o), s);
  return p(ov.Provider, { value: a, children: e.children });
}
function sv() {
  var e = pe(ov);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function W1(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function H1(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function G1(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function j1(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function K1(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function z1(e, t) {
  var n, r = t.from, o = t.to;
  if (r && o) {
    var s = lt(o, r) < 0;
    s && (n = [o, r], r = n[0], o = n[1]);
    var a = lt(e, r) >= 0 && lt(o, e) >= 0;
    return a;
  }
  return o ? Te(o, e) : r ? Te(r, e) : !1;
}
function Y1(e) {
  return Cd(e);
}
function X1(e) {
  return Array.isArray(e) && e.every(Cd);
}
function q1(e, t) {
  return t.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (Y1(n))
      return Te(e, n);
    if (X1(n))
      return n.includes(e);
    if (H1(n))
      return z1(e, n);
    if (K1(n))
      return n.dayOfWeek.includes(e.getDay());
    if (W1(n)) {
      var r = lt(n.before, e), o = lt(n.after, e), s = r > 0, a = o < 0, i = ya(n.before, n.after);
      return i ? a && s : s || a;
    }
    return G1(n) ? lt(e, n.after) > 0 : j1(n) ? lt(n.before, e) > 0 : typeof n == "function" ? n(e) : !1;
  });
}
function xl(e, t, n) {
  var r = Object.keys(t).reduce(function(s, a) {
    var i = t[a];
    return q1(e, i) && s.push(a), s;
  }, []), o = {};
  return r.forEach(function(s) {
    return o[s] = !0;
  }), n && !ci(e, n) && (o.outside = !0), o;
}
function Z1(e, t) {
  for (var n = ke(e[0]), r = li(e[e.length - 1]), o, s, a = n; a <= r; ) {
    var i = xl(a, t), l = !i.disabled && !i.hidden;
    if (!l) {
      a = Ne(a, 1);
      continue;
    }
    if (i.selected)
      return a;
    i.today && !s && (s = a), o || (o = a), a = Ne(a, 1);
  }
  return s || o;
}
var J1 = 365;
function av(e, t) {
  var n = t.moveBy, r = t.direction, o = t.context, s = t.modifiers, a = t.retry, i = a === void 0 ? { count: 0, lastFocused: e } : a, l = o.weekStartsOn, c = o.fromDate, u = o.toDate, f = o.locale, h = {
    day: Ne,
    week: ga,
    month: nt,
    year: Gb,
    startOfWeek: function(y) {
      return o.ISOWeek ? ui(y) : di(y, { locale: f, weekStartsOn: l });
    },
    endOfWeek: function(y) {
      return o.ISOWeek ? xd(y) : Sd(y, { locale: f, weekStartsOn: l });
    }
  }, m = h[n](e, r === "after" ? 1 : -1);
  r === "before" && c ? m = jb([c, m]) : r === "after" && u && (m = Kb([u, m]));
  var g = !0;
  if (s) {
    var v = xl(m, s);
    g = !v.disabled && !v.hidden;
  }
  return g ? m : i.count > J1 ? i.lastFocused : av(m, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: s,
    retry: X(X({}, i), { count: i.count + 1 })
  });
}
var iv = _e(void 0);
function Q1(e) {
  var t = Mr(), n = sv(), r = Ge(), o = r[0], s = r[1], a = Ge(), i = a[0], l = a[1], c = Z1(t.displayMonths, n), u = o ?? (i && t.isDateDisplayed(i)) ? i : c, f = function() {
    l(o), s(void 0);
  }, h = function(y) {
    s(y);
  }, m = ie(), g = function(y, b) {
    if (o) {
      var w = av(o, {
        moveBy: y,
        direction: b,
        context: m,
        modifiers: n
      });
      Te(o, w) || (t.goToDate(w, o), h(w));
    }
  }, v = {
    focusedDay: o,
    focusTarget: u,
    blur: f,
    focus: h,
    focusDayAfter: function() {
      return g("day", "after");
    },
    focusDayBefore: function() {
      return g("day", "before");
    },
    focusWeekAfter: function() {
      return g("week", "after");
    },
    focusWeekBefore: function() {
      return g("week", "before");
    },
    focusMonthBefore: function() {
      return g("month", "before");
    },
    focusMonthAfter: function() {
      return g("month", "after");
    },
    focusYearBefore: function() {
      return g("year", "before");
    },
    focusYearAfter: function() {
      return g("year", "after");
    },
    focusStartOfWeek: function() {
      return g("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return g("endOfWeek", "after");
    }
  };
  return p(iv.Provider, { value: v, children: e.children });
}
function Sl() {
  var e = pe(iv);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function e_(e, t) {
  var n = sv(), r = xl(e, n, t);
  return r;
}
var Cl = _e(void 0);
function t_(e) {
  if (!ss(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return p(Cl.Provider, { value: t, children: e.children });
  }
  return p(n_, { initialProps: e.initialProps, children: e.children });
}
function n_(e) {
  var t = e.initialProps, n = e.children, r = function(s, a, i) {
    var l, c, u;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, s, a, i), a.selected && !t.required) {
      (c = t.onSelect) === null || c === void 0 || c.call(t, void 0, s, a, i);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, s, s, a, i);
  }, o = {
    selected: t.selected,
    onDayClick: r
  };
  return p(Cl.Provider, { value: o, children: n });
}
function lv() {
  var e = pe(Cl);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function r_(e, t) {
  var n = ie(), r = lv(), o = yl(), s = wl(), a = Sl(), i = a.focusDayAfter, l = a.focusDayBefore, c = a.focusWeekAfter, u = a.focusWeekBefore, f = a.blur, h = a.focus, m = a.focusMonthBefore, g = a.focusMonthAfter, v = a.focusYearBefore, y = a.focusYearAfter, b = a.focusStartOfWeek, w = a.focusEndOfWeek, x = function(P) {
    var R, k, Z, ne;
    ss(n) ? (R = r.onDayClick) === null || R === void 0 || R.call(r, e, t, P) : Pr(n) ? (k = o.onDayClick) === null || k === void 0 || k.call(o, e, t, P) : _r(n) ? (Z = s.onDayClick) === null || Z === void 0 || Z.call(s, e, t, P) : (ne = n.onDayClick) === null || ne === void 0 || ne.call(n, e, t, P);
  }, S = function(P) {
    var R;
    h(e), (R = n.onDayFocus) === null || R === void 0 || R.call(n, e, t, P);
  }, C = function(P) {
    var R;
    f(), (R = n.onDayBlur) === null || R === void 0 || R.call(n, e, t, P);
  }, E = function(P) {
    var R;
    (R = n.onDayMouseEnter) === null || R === void 0 || R.call(n, e, t, P);
  }, A = function(P) {
    var R;
    (R = n.onDayMouseLeave) === null || R === void 0 || R.call(n, e, t, P);
  }, T = function(P) {
    var R;
    (R = n.onDayPointerEnter) === null || R === void 0 || R.call(n, e, t, P);
  }, I = function(P) {
    var R;
    (R = n.onDayPointerLeave) === null || R === void 0 || R.call(n, e, t, P);
  }, L = function(P) {
    var R;
    (R = n.onDayTouchCancel) === null || R === void 0 || R.call(n, e, t, P);
  }, B = function(P) {
    var R;
    (R = n.onDayTouchEnd) === null || R === void 0 || R.call(n, e, t, P);
  }, V = function(P) {
    var R;
    (R = n.onDayTouchMove) === null || R === void 0 || R.call(n, e, t, P);
  }, z = function(P) {
    var R;
    (R = n.onDayTouchStart) === null || R === void 0 || R.call(n, e, t, P);
  }, D = function(P) {
    var R;
    (R = n.onDayKeyUp) === null || R === void 0 || R.call(n, e, t, P);
  }, G = function(P) {
    var R;
    switch (P.key) {
      case "ArrowLeft":
        P.preventDefault(), P.stopPropagation(), n.dir === "rtl" ? i() : l();
        break;
      case "ArrowRight":
        P.preventDefault(), P.stopPropagation(), n.dir === "rtl" ? l() : i();
        break;
      case "ArrowDown":
        P.preventDefault(), P.stopPropagation(), c();
        break;
      case "ArrowUp":
        P.preventDefault(), P.stopPropagation(), u();
        break;
      case "PageUp":
        P.preventDefault(), P.stopPropagation(), P.shiftKey ? v() : m();
        break;
      case "PageDown":
        P.preventDefault(), P.stopPropagation(), P.shiftKey ? y() : g();
        break;
      case "Home":
        P.preventDefault(), P.stopPropagation(), b();
        break;
      case "End":
        P.preventDefault(), P.stopPropagation(), w();
        break;
    }
    (R = n.onDayKeyDown) === null || R === void 0 || R.call(n, e, t, P);
  }, U = {
    onClick: x,
    onFocus: S,
    onBlur: C,
    onKeyDown: G,
    onKeyUp: D,
    onMouseEnter: E,
    onMouseLeave: A,
    onPointerEnter: T,
    onPointerLeave: I,
    onTouchCancel: L,
    onTouchEnd: B,
    onTouchMove: V,
    onTouchStart: z
  };
  return U;
}
function o_() {
  var e = ie(), t = lv(), n = yl(), r = wl(), o = ss(e) ? t.selected : Pr(e) ? n.selected : _r(e) ? r.selected : void 0;
  return o;
}
function s_(e) {
  return Object.values(ze).includes(e);
}
function a_(e, t) {
  var n = [e.classNames.day];
  return Object.keys(t).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if (s_(r)) {
      var s = e.classNames["day_".concat(r)];
      s && n.push(s);
    }
  }), n;
}
function i_(e, t) {
  var n = X({}, e.styles.day);
  return Object.keys(t).forEach(function(r) {
    var o;
    n = X(X({}, n), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function l_(e, t, n) {
  var r, o, s, a = ie(), i = Sl(), l = e_(e, t), c = r_(e, l), u = o_(), f = !!(a.onDayClick || a.mode !== "default");
  pt(function() {
    var E;
    l.outside || i.focusedDay && f && Te(i.focusedDay, e) && ((E = n.current) === null || E === void 0 || E.focus());
  }, [
    i.focusedDay,
    e,
    n,
    f,
    l.outside
  ]);
  var h = a_(a, l).join(" "), m = i_(a, l), g = !!(l.outside && !a.showOutsideDays || l.hidden), v = (s = (o = a.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && s !== void 0 ? s : P1, y = p(v, { date: e, displayMonth: t, activeModifiers: l }), b = {
    style: m,
    className: h,
    children: y,
    role: "gridcell"
  }, w = i.focusTarget && Te(i.focusTarget, e) && !l.outside, x = i.focusedDay && Te(i.focusedDay, e), S = X(X(X({}, b), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = x || w ? 0 : -1, r)), c), C = {
    isButton: f,
    isHidden: g,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: S,
    divProps: b
  };
  return C;
}
function c_(e) {
  var t = Xn(null), n = l_(e.date, e.displayMonth, t);
  return n.isHidden ? p("div", { role: "gridcell" }) : n.isButton ? p(No, X({ name: "day", ref: t }, n.buttonProps)) : p("div", X({}, n.divProps));
}
function u_(e) {
  var t = e.number, n = e.dates, r = ie(), o = r.onWeekNumberClick, s = r.styles, a = r.classNames, i = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(t), { locale: i });
  if (!o)
    return p("span", { className: a.weeknumber, style: s.weeknumber, children: u });
  var f = l(Number(t), { locale: i }), h = function(m) {
    o(t, n, m);
  };
  return p(No, { name: "week-number", "aria-label": f, className: a.weeknumber, style: s.weeknumber, onClick: h, children: u });
}
function d_(e) {
  var t, n, r = ie(), o = r.styles, s = r.classNames, a = r.showWeekNumber, i = r.components, l = (t = i == null ? void 0 : i.Day) !== null && t !== void 0 ? t : c_, c = (n = i == null ? void 0 : i.WeekNumber) !== null && n !== void 0 ? n : u_, u;
  return a && (u = p("td", { className: s.cell, style: o.cell, children: p(c, { number: e.weekNumber, dates: e.dates }) })), O("tr", { className: s.row, style: o.row, children: [u, e.dates.map(function(f) {
    return p("td", { className: s.cell, style: o.cell, role: "presentation", children: p(l, { displayMonth: e.displayMonth, date: f }) }, Hb(f));
  })] });
}
function td(e, t, n) {
  for (var r = n != null && n.ISOWeek ? xd(t) : Sd(t, n), o = n != null && n.ISOWeek ? ui(e) : di(e, n), s = lt(r, o), a = [], i = 0; i <= s; i++)
    a.push(Ne(o, i));
  var l = a.reduce(function(c, u) {
    var f = n != null && n.ISOWeek ? Yb(u) : Xb(u, n), h = c.find(function(m) {
      return m.weekNumber === f;
    });
    return h ? (h.dates.push(u), c) : (c.push({
      weekNumber: f,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function f_(e, t) {
  var n = td(ke(e), li(e), t);
  if (t != null && t.useFixedWeeks) {
    var r = Wb(e, t);
    if (r < 6) {
      var o = n[n.length - 1], s = o.dates[o.dates.length - 1], a = ga(s, 6 - r), i = td(ga(s, 1), a, t);
      n.push.apply(n, i);
    }
  }
  return n;
}
function p_(e) {
  var t, n, r, o = ie(), s = o.locale, a = o.classNames, i = o.styles, l = o.hideHead, c = o.fixedWeeks, u = o.components, f = o.weekStartsOn, h = o.firstWeekContainsDate, m = o.ISOWeek, g = f_(e.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: m,
    locale: s,
    weekStartsOn: f,
    firstWeekContainsDate: h
  }), v = (t = u == null ? void 0 : u.Head) !== null && t !== void 0 ? t : R1, y = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : d_, b = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : E1;
  return O("table", { id: e.id, className: a.table, style: i.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && p(v, {}), p("tbody", { className: a.tbody, style: i.tbody, children: g.map(function(w) {
    return p(y, { displayMonth: e.displayMonth, dates: w.dates, weekNumber: w.weekNumber }, w.weekNumber);
  }) }), p(b, { displayMonth: e.displayMonth })] });
}
function h_() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var m_ = h_() ? ai : pt, la = !1, v_ = 0;
function nd() {
  return "react-day-picker-".concat(++v_);
}
function g_(e) {
  var t, n = e ?? (la ? nd() : null), r = Ge(n), o = r[0], s = r[1];
  return m_(function() {
    o === null && s(nd());
  }, []), pt(function() {
    la === !1 && (la = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function y_(e) {
  var t, n, r = ie(), o = r.dir, s = r.classNames, a = r.styles, i = r.components, l = Mr().displayMonths, c = g_(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, f = [s.month], h = a.month, m = e.displayIndex === 0, g = e.displayIndex === l.length - 1, v = !m && !g;
  o === "rtl" && (t = [m, g], g = t[0], m = t[1]), m && (f.push(s.caption_start), h = X(X({}, h), a.caption_start)), g && (f.push(s.caption_end), h = X(X({}, h), a.caption_end)), v && (f.push(s.caption_between), h = X(X({}, h), a.caption_between));
  var y = (n = i == null ? void 0 : i.Caption) !== null && n !== void 0 ? n : A1;
  return O("div", { className: f.join(" "), style: h, children: [p(y, { id: c, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), p(p_, { id: u, "aria-labelledby": c, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function b_(e) {
  var t = ie(), n = t.classNames, r = t.styles;
  return p("div", { className: n.months, style: r.months, children: e.children });
}
function w_(e) {
  var t, n, r = e.initialProps, o = ie(), s = Sl(), a = Mr(), i = Ge(!1), l = i[0], c = i[1];
  pt(function() {
    o.initialFocus && s.focusTarget && (l || (s.focus(s.focusTarget), c(!0)));
  }, [
    o.initialFocus,
    l,
    s.focus,
    s.focusTarget,
    s
  ]);
  var u = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && u.push(o.classNames.multiple_months), o.showWeekNumber && u.push(o.classNames.with_weeknumber);
  var f = X(X({}, o.styles.root), o.style), h = Object.keys(r).filter(function(g) {
    return g.startsWith("data-");
  }).reduce(function(g, v) {
    var y;
    return X(X({}, g), (y = {}, y[v] = r[v], y));
  }, {}), m = (n = (t = r.components) === null || t === void 0 ? void 0 : t.Months) !== null && n !== void 0 ? n : b_;
  return p("div", X({ className: u.join(" "), style: f, dir: o.dir, id: o.id, nonce: r.nonce, title: r.title, lang: r.lang }, h, { children: p(m, { children: a.displayMonths.map(function(g, v) {
    return p(y_, { displayIndex: v, displayMonth: g }, v);
  }) }) }));
}
function x_(e) {
  var t = e.children, n = jP(e, ["children"]);
  return p(u1, { initialProps: n, children: p(w1, { children: p(t_, { initialProps: n, children: p(_1, { initialProps: n, children: p(D1, { initialProps: n, children: p(U1, { children: p(Q1, { children: t }) }) }) }) }) }) });
}
function S_(e) {
  return p(x_, X({}, e, { children: p(w_, { initialProps: e }) }));
}
function cv({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  locale: r,
  ...o
}) {
  const { i18n: s } = Vo(), a = r ?? Ed(s.language);
  return /* @__PURE__ */ p(
    S_,
    {
      showOutsideDays: n,
      locale: a,
      className: N("p-3", e),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: N(
          Bt({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-neutral-500 rounded-md w-9 font-normal text-xs dark:text-neutral-400",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-neutral-100/50 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20 dark:[&:has([aria-selected].day-outside)]:bg-neutral-800/50",
        day: N(
          Bt({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal rounded-full aria-selected:opacity-100"
        ),
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-white rounded-full hover:bg-primary hover:text-white focus:bg-primary focus:text-white",
        day_today: "bg-neutral-100 text-neutral-900 rounded-full dark:bg-neutral-800 dark:text-neutral-50",
        day_outside: "day-outside text-neutral-500 aria-selected:bg-neutral-100/50 aria-selected:text-neutral-500 dark:text-neutral-400 dark:aria-selected:bg-neutral-800/50 dark:aria-selected:text-neutral-400",
        day_disabled: "text-neutral-500 opacity-50 dark:text-neutral-400",
        day_range_middle: "aria-selected:bg-neutral-100 aria-selected:text-neutral-900 dark:aria-selected:bg-neutral-800 dark:aria-selected:text-neutral-50",
        day_hidden: "invisible",
        ...t
      },
      components: {
        IconLeft: ({ className: i, ...l }) => /* @__PURE__ */ p(Ap, { className: N("h-4 w-4", i), ...l }),
        IconRight: ({ className: i, ...l }) => /* @__PURE__ */ p(Ii, { className: N("h-4 w-4", i), ...l })
      },
      ...o
    }
  );
}
cv.displayName = "Calendar";
const C_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: N(
      "rounded-lg border border-border bg-card text-card-foreground shadow-sm",
      e
    ),
    ...t
  }
));
C_.displayName = "Card";
const A_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: N("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
A_.displayName = "CardHeader";
const E_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: N(
      "text-2xl font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
E_.displayName = "CardTitle";
const N_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: N("text-sm text-muted-foreground", e),
    ...t
  }
));
N_.displayName = "CardDescription";
const T_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p("div", { ref: n, className: N("p-6 pt-0", e), ...t }));
T_.displayName = "CardContent";
const R_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "div",
  {
    ref: n,
    className: N("flex items-center p-6 pt-0", e),
    ...t
  }
));
R_.displayName = "CardFooter";
function as(e) {
  const t = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var is = "Checkbox", [P_] = we(is), [__, Al] = P_(is);
function M_(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: r,
    defaultChecked: o,
    disabled: s,
    form: a,
    name: i,
    onCheckedChange: l,
    required: c,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [h, m] = Pe({
    prop: n,
    defaultProp: o ?? !1,
    onChange: l,
    caller: is
  }), [g, v] = d.useState(null), [y, b] = d.useState(null), w = d.useRef(!1), x = g ? !!a || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), S = {
    checked: h,
    disabled: s,
    setChecked: m,
    control: g,
    setControl: v,
    name: i,
    form: a,
    value: u,
    hasConsumerStoppedPropagationRef: w,
    required: c,
    defaultChecked: wt(o) ? !1 : o,
    isFormControl: x,
    bubbleInput: y,
    setBubbleInput: b
  };
  return /* @__PURE__ */ p(
    __,
    {
      scope: t,
      ...S,
      children: I_(f) ? f(S) : r
    }
  );
}
var uv = "CheckboxTrigger", dv = d.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...r }, o) => {
    const {
      control: s,
      value: a,
      disabled: i,
      checked: l,
      required: c,
      setControl: u,
      setChecked: f,
      hasConsumerStoppedPropagationRef: h,
      isFormControl: m,
      bubbleInput: g
    } = Al(uv, e), v = K(o, u), y = d.useRef(l);
    return d.useEffect(() => {
      const b = s == null ? void 0 : s.form;
      if (b) {
        const w = () => f(y.current);
        return b.addEventListener("reset", w), () => b.removeEventListener("reset", w);
      }
    }, [s, f]), /* @__PURE__ */ p(
      $.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": wt(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": vv(l),
        "data-disabled": i ? "" : void 0,
        disabled: i,
        value: a,
        ...r,
        ref: v,
        onKeyDown: M(t, (b) => {
          b.key === "Enter" && b.preventDefault();
        }),
        onClick: M(n, (b) => {
          f((w) => wt(w) ? !0 : !w), g && m && (h.current = b.isPropagationStopped(), h.current || b.stopPropagation());
        })
      }
    );
  }
);
dv.displayName = uv;
var El = d.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: s,
      required: a,
      disabled: i,
      value: l,
      onCheckedChange: c,
      form: u,
      ...f
    } = e;
    return /* @__PURE__ */ p(
      M_,
      {
        __scopeCheckbox: n,
        checked: o,
        defaultChecked: s,
        disabled: i,
        required: a,
        onCheckedChange: c,
        name: r,
        form: u,
        value: l,
        internal_do_not_use_render: ({ isFormControl: h }) => /* @__PURE__ */ O(ge, { children: [
          /* @__PURE__ */ p(
            dv,
            {
              ...f,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          h && /* @__PURE__ */ p(
            mv,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
El.displayName = is;
var fv = "CheckboxIndicator", pv = d.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, s = Al(fv, n);
    return /* @__PURE__ */ p(
      ye,
      {
        present: r || wt(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ p(
          $.span,
          {
            "data-state": vv(s.checked),
            "data-disabled": s.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
pv.displayName = fv;
var hv = "CheckboxBubbleInput", mv = d.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: o,
      checked: s,
      defaultChecked: a,
      required: i,
      disabled: l,
      name: c,
      value: u,
      form: f,
      bubbleInput: h,
      setBubbleInput: m
    } = Al(hv, e), g = K(n, m), v = as(s), y = Go(r);
    d.useEffect(() => {
      const w = h;
      if (!w) return;
      const x = window.HTMLInputElement.prototype, C = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, E = !o.current;
      if (v !== s && C) {
        const A = new Event("click", { bubbles: E });
        w.indeterminate = wt(s), C.call(w, wt(s) ? !1 : s), w.dispatchEvent(A);
      }
    }, [h, v, s, o]);
    const b = d.useRef(wt(s) ? !1 : s);
    return /* @__PURE__ */ p(
      $.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a ?? b.current,
        required: i,
        disabled: l,
        name: c,
        value: u,
        form: f,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...y,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
mv.displayName = hv;
function I_(e) {
  return typeof e == "function";
}
function wt(e) {
  return e === "indeterminate";
}
function vv(e) {
  return wt(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const D_ = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  El,
  {
    ref: n,
    className: N(
      "peer relative h-4 w-4 shrink-0 rounded-sm border border-neutral-200 border-neutral-900 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-neutral-900 data-[state=checked]:text-neutral-50 dark:border-neutral-800 dark:border-neutral-50 dark:ring-offset-neutral-950 dark:focus-visible:ring-neutral-300 dark:data-[state=checked]:bg-neutral-50 dark:data-[state=checked]:text-neutral-900 before:content-[''] before:absolute before:-inset-[14px]",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p(
      pv,
      {
        className: N("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ p(Sr, { className: "h-4 w-4" })
      }
    )
  }
));
D_.displayName = El.displayName;
var rd = 1, k_ = 0.9, O_ = 0.8, L_ = 0.17, ca = 0.1, ua = 0.999, V_ = 0.9999, F_ = 0.99, $_ = /[\\\/_+.#"@\[\(\{&]/, B_ = /[\\\/_+.#"@\[\(\{&]/g, U_ = /[\s-]/, gv = /[\s-]/g;
function Ga(e, t, n, r, o, s, a) {
  if (s === t.length) return o === e.length ? rd : F_;
  var i = `${o},${s}`;
  if (a[i] !== void 0) return a[i];
  for (var l = r.charAt(s), c = n.indexOf(l, o), u = 0, f, h, m, g; c >= 0; ) f = Ga(e, t, n, r, c + 1, s + 1, a), f > u && (c === o ? f *= rd : $_.test(e.charAt(c - 1)) ? (f *= O_, m = e.slice(o, c - 1).match(B_), m && o > 0 && (f *= Math.pow(ua, m.length))) : U_.test(e.charAt(c - 1)) ? (f *= k_, g = e.slice(o, c - 1).match(gv), g && o > 0 && (f *= Math.pow(ua, g.length))) : (f *= L_, o > 0 && (f *= Math.pow(ua, c - o))), e.charAt(c) !== t.charAt(s) && (f *= V_)), (f < ca && n.charAt(c - 1) === r.charAt(s + 1) || r.charAt(s + 1) === r.charAt(s) && n.charAt(c - 1) !== r.charAt(s)) && (h = Ga(e, t, n, r, c + 1, s + 2, a), h * ca > f && (f = h * ca)), f > u && (u = f), c = n.indexOf(l, c + 1);
  return a[i] = u, u;
}
function od(e) {
  return e.toLowerCase().replace(gv, " ");
}
function W_(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, Ga(e, t, od(e), od(t), 0, 0, {});
}
var Wn = '[cmdk-group=""]', da = '[cmdk-group-items=""]', H_ = '[cmdk-group-heading=""]', yv = '[cmdk-item=""]', sd = `${yv}:not([aria-disabled="true"])`, ja = "cmdk-item-select", Qt = "data-value", G_ = (e, t, n) => W_(e, t, n), bv = d.createContext(void 0), Ir = () => d.useContext(bv), wv = d.createContext(void 0), Nl = () => d.useContext(wv), xv = d.createContext(void 0), Sv = d.forwardRef((e, t) => {
  let n = en(() => {
    var _, H;
    return { search: "", value: (H = (_ = e.value) != null ? _ : e.defaultValue) != null ? H : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = en(() => /* @__PURE__ */ new Set()), o = en(() => /* @__PURE__ */ new Map()), s = en(() => /* @__PURE__ */ new Map()), a = en(() => /* @__PURE__ */ new Set()), i = Cv(e), { label: l, children: c, value: u, onValueChange: f, filter: h, shouldFilter: m, loop: g, disablePointerSelection: v = !1, vimBindings: y = !0, ...b } = e, w = ve(), x = ve(), S = ve(), C = d.useRef(null), E = tM();
  Gt(() => {
    if (u !== void 0) {
      let _ = u.trim();
      n.current.value = _, A.emit();
    }
  }, [u]), Gt(() => {
    E(6, z);
  }, []);
  let A = d.useMemo(() => ({ subscribe: (_) => (a.current.add(_), () => a.current.delete(_)), snapshot: () => n.current, setState: (_, H, Y) => {
    var W, ee, F, J;
    if (!Object.is(n.current[_], H)) {
      if (n.current[_] = H, _ === "search") V(), L(), E(1, B);
      else if (_ === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let Q = document.getElementById(S);
          Q ? Q.focus() : (W = document.getElementById(w)) == null || W.focus();
        }
        if (E(7, () => {
          var Q;
          n.current.selectedItemId = (Q = D()) == null ? void 0 : Q.id, A.emit();
        }), Y || E(5, z), ((ee = i.current) == null ? void 0 : ee.value) !== void 0) {
          let Q = H ?? "";
          (J = (F = i.current).onValueChange) == null || J.call(F, Q);
          return;
        }
      }
      A.emit();
    }
  }, emit: () => {
    a.current.forEach((_) => _());
  } }), []), T = d.useMemo(() => ({ value: (_, H, Y) => {
    var W;
    H !== ((W = s.current.get(_)) == null ? void 0 : W.value) && (s.current.set(_, { value: H, keywords: Y }), n.current.filtered.items.set(_, I(H, Y)), E(2, () => {
      L(), A.emit();
    }));
  }, item: (_, H) => (r.current.add(_), H && (o.current.has(H) ? o.current.get(H).add(_) : o.current.set(H, /* @__PURE__ */ new Set([_]))), E(3, () => {
    V(), L(), n.current.value || B(), A.emit();
  }), () => {
    s.current.delete(_), r.current.delete(_), n.current.filtered.items.delete(_);
    let Y = D();
    E(4, () => {
      V(), (Y == null ? void 0 : Y.getAttribute("id")) === _ && B(), A.emit();
    });
  }), group: (_) => (o.current.has(_) || o.current.set(_, /* @__PURE__ */ new Set()), () => {
    s.current.delete(_), o.current.delete(_);
  }), filter: () => i.current.shouldFilter, label: l || e["aria-label"], getDisablePointerSelection: () => i.current.disablePointerSelection, listId: w, inputId: S, labelId: x, listInnerRef: C }), []);
  function I(_, H) {
    var Y, W;
    let ee = (W = (Y = i.current) == null ? void 0 : Y.filter) != null ? W : G_;
    return _ ? ee(_, n.current.search, H) : 0;
  }
  function L() {
    if (!n.current.search || i.current.shouldFilter === !1) return;
    let _ = n.current.filtered.items, H = [];
    n.current.filtered.groups.forEach((W) => {
      let ee = o.current.get(W), F = 0;
      ee.forEach((J) => {
        let Q = _.get(J);
        F = Math.max(Q, F);
      }), H.push([W, F]);
    });
    let Y = C.current;
    G().sort((W, ee) => {
      var F, J;
      let Q = W.getAttribute("id"), re = ee.getAttribute("id");
      return ((F = _.get(re)) != null ? F : 0) - ((J = _.get(Q)) != null ? J : 0);
    }).forEach((W) => {
      let ee = W.closest(da);
      ee ? ee.appendChild(W.parentElement === ee ? W : W.closest(`${da} > *`)) : Y.appendChild(W.parentElement === Y ? W : W.closest(`${da} > *`));
    }), H.sort((W, ee) => ee[1] - W[1]).forEach((W) => {
      var ee;
      let F = (ee = C.current) == null ? void 0 : ee.querySelector(`${Wn}[${Qt}="${encodeURIComponent(W[0])}"]`);
      F == null || F.parentElement.appendChild(F);
    });
  }
  function B() {
    let _ = G().find((Y) => Y.getAttribute("aria-disabled") !== "true"), H = _ == null ? void 0 : _.getAttribute(Qt);
    A.setState("value", H || void 0);
  }
  function V() {
    var _, H, Y, W;
    if (!n.current.search || i.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let ee = 0;
    for (let F of r.current) {
      let J = (H = (_ = s.current.get(F)) == null ? void 0 : _.value) != null ? H : "", Q = (W = (Y = s.current.get(F)) == null ? void 0 : Y.keywords) != null ? W : [], re = I(J, Q);
      n.current.filtered.items.set(F, re), re > 0 && ee++;
    }
    for (let [F, J] of o.current) for (let Q of J) if (n.current.filtered.items.get(Q) > 0) {
      n.current.filtered.groups.add(F);
      break;
    }
    n.current.filtered.count = ee;
  }
  function z() {
    var _, H, Y;
    let W = D();
    W && (((_ = W.parentElement) == null ? void 0 : _.firstChild) === W && ((Y = (H = W.closest(Wn)) == null ? void 0 : H.querySelector(H_)) == null || Y.scrollIntoView({ block: "nearest" })), W.scrollIntoView({ block: "nearest" }));
  }
  function D() {
    var _;
    return (_ = C.current) == null ? void 0 : _.querySelector(`${yv}[aria-selected="true"]`);
  }
  function G() {
    var _;
    return Array.from(((_ = C.current) == null ? void 0 : _.querySelectorAll(sd)) || []);
  }
  function U(_) {
    let H = G()[_];
    H && A.setState("value", H.getAttribute(Qt));
  }
  function P(_) {
    var H;
    let Y = D(), W = G(), ee = W.findIndex((J) => J === Y), F = W[ee + _];
    (H = i.current) != null && H.loop && (F = ee + _ < 0 ? W[W.length - 1] : ee + _ === W.length ? W[0] : W[ee + _]), F && A.setState("value", F.getAttribute(Qt));
  }
  function R(_) {
    let H = D(), Y = H == null ? void 0 : H.closest(Wn), W;
    for (; Y && !W; ) Y = _ > 0 ? Q_(Y, Wn) : eM(Y, Wn), W = Y == null ? void 0 : Y.querySelector(sd);
    W ? A.setState("value", W.getAttribute(Qt)) : P(_);
  }
  let k = () => U(G().length - 1), Z = (_) => {
    _.preventDefault(), _.metaKey ? k() : _.altKey ? R(1) : P(1);
  }, ne = (_) => {
    _.preventDefault(), _.metaKey ? U(0) : _.altKey ? R(-1) : P(-1);
  };
  return d.createElement($.div, { ref: t, tabIndex: -1, ...b, "cmdk-root": "", onKeyDown: (_) => {
    var H;
    (H = b.onKeyDown) == null || H.call(b, _);
    let Y = _.nativeEvent.isComposing || _.keyCode === 229;
    if (!(_.defaultPrevented || Y)) switch (_.key) {
      case "n":
      case "j": {
        y && _.ctrlKey && Z(_);
        break;
      }
      case "ArrowDown": {
        Z(_);
        break;
      }
      case "p":
      case "k": {
        y && _.ctrlKey && ne(_);
        break;
      }
      case "ArrowUp": {
        ne(_);
        break;
      }
      case "Home": {
        _.preventDefault(), U(0);
        break;
      }
      case "End": {
        _.preventDefault(), k();
        break;
      }
      case "Enter": {
        _.preventDefault();
        let W = D();
        if (W) {
          let ee = new Event(ja);
          W.dispatchEvent(ee);
        }
      }
    }
  } }, d.createElement("label", { "cmdk-label": "", htmlFor: T.inputId, id: T.labelId, style: rM }, l), ls(e, (_) => d.createElement(wv.Provider, { value: A }, d.createElement(bv.Provider, { value: T }, _))));
}), j_ = d.forwardRef((e, t) => {
  var n, r;
  let o = ve(), s = d.useRef(null), a = d.useContext(xv), i = Ir(), l = Cv(e), c = (r = (n = l.current) == null ? void 0 : n.forceMount) != null ? r : a == null ? void 0 : a.forceMount;
  Gt(() => {
    if (!c) return i.item(o, a == null ? void 0 : a.id);
  }, [c]);
  let u = Av(o, s, [e.value, e.children, s], e.keywords), f = Nl(), h = Tt((E) => E.value && E.value === u.current), m = Tt((E) => c || i.filter() === !1 ? !0 : E.search ? E.filtered.items.get(o) > 0 : !0);
  d.useEffect(() => {
    let E = s.current;
    if (!(!E || e.disabled)) return E.addEventListener(ja, g), () => E.removeEventListener(ja, g);
  }, [m, e.onSelect, e.disabled]);
  function g() {
    var E, A;
    v(), (A = (E = l.current).onSelect) == null || A.call(E, u.current);
  }
  function v() {
    f.setState("value", u.current, !0);
  }
  if (!m) return null;
  let { disabled: y, value: b, onSelect: w, forceMount: x, keywords: S, ...C } = e;
  return d.createElement($.div, { ref: Le(s, t), ...C, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!h, "data-disabled": !!y, "data-selected": !!h, onPointerMove: y || i.getDisablePointerSelection() ? void 0 : v, onClick: y ? void 0 : g }, e.children);
}), K_ = d.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...s } = e, a = ve(), i = d.useRef(null), l = d.useRef(null), c = ve(), u = Ir(), f = Tt((m) => o || u.filter() === !1 ? !0 : m.search ? m.filtered.groups.has(a) : !0);
  Gt(() => u.group(a), []), Av(a, i, [e.value, e.heading, l]);
  let h = d.useMemo(() => ({ id: a, forceMount: o }), [o]);
  return d.createElement($.div, { ref: Le(i, t), ...s, "cmdk-group": "", role: "presentation", hidden: f ? void 0 : !0 }, n && d.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, n), ls(e, (m) => d.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? c : void 0 }, d.createElement(xv.Provider, { value: h }, m))));
}), z_ = d.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = d.useRef(null), s = Tt((a) => !a.search);
  return !n && !s ? null : d.createElement($.div, { ref: Le(o, t), ...r, "cmdk-separator": "", role: "separator" });
}), Y_ = d.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, s = Nl(), a = Tt((c) => c.search), i = Tt((c) => c.selectedItemId), l = Ir();
  return d.useEffect(() => {
    e.value != null && s.setState("search", e.value);
  }, [e.value]), d.createElement($.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": i, id: l.inputId, type: "text", value: o ? e.value : a, onChange: (c) => {
    o || s.setState("search", c.target.value), n == null || n(c.target.value);
  } });
}), X_ = d.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, s = d.useRef(null), a = d.useRef(null), i = Tt((c) => c.selectedItemId), l = Ir();
  return d.useEffect(() => {
    if (a.current && s.current) {
      let c = a.current, u = s.current, f, h = new ResizeObserver(() => {
        f = requestAnimationFrame(() => {
          let m = c.offsetHeight;
          u.style.setProperty("--cmdk-list-height", m.toFixed(1) + "px");
        });
      });
      return h.observe(c), () => {
        cancelAnimationFrame(f), h.unobserve(c);
      };
    }
  }, []), d.createElement($.div, { ref: Le(s, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": i, "aria-label": r, id: l.listId }, ls(e, (c) => d.createElement("div", { ref: Le(a, l.listInnerRef), "cmdk-list-sizer": "" }, c)));
}), q_ = d.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: s, container: a, ...i } = e;
  return d.createElement(Zo, { open: n, onOpenChange: r }, d.createElement(Jo, { container: a }, d.createElement(Rn, { "cmdk-overlay": "", className: o }), d.createElement(Pn, { "aria-label": e.label, "cmdk-dialog": "", className: s }, d.createElement(Sv, { ref: t, ...i }))));
}), Z_ = d.forwardRef((e, t) => Tt((n) => n.filtered.count === 0) ? d.createElement($.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), J_ = d.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...s } = e;
  return d.createElement($.div, { ref: t, ...s, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, ls(e, (a) => d.createElement("div", { "aria-hidden": !0 }, a)));
}), Me = Object.assign(Sv, { List: X_, Item: j_, Input: Y_, Group: K_, Separator: z_, Dialog: q_, Empty: Z_, Loading: J_ });
function Q_(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function eM(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function Cv(e) {
  let t = d.useRef(e);
  return Gt(() => {
    t.current = e;
  }), t;
}
var Gt = typeof window > "u" ? d.useEffect : d.useLayoutEffect;
function en(e) {
  let t = d.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function Tt(e) {
  let t = Nl(), n = () => e(t.snapshot());
  return d.useSyncExternalStore(t.subscribe, n, n);
}
function Av(e, t, n, r = []) {
  let o = d.useRef(), s = Ir();
  return Gt(() => {
    var a;
    let i = (() => {
      var c;
      for (let u of n) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : o.current;
      }
    })(), l = r.map((c) => c.trim());
    s.value(e, i, l), (a = t.current) == null || a.setAttribute(Qt, i), o.current = i;
  }), o;
}
var tM = () => {
  let [e, t] = d.useState(), n = en(() => /* @__PURE__ */ new Map());
  return Gt(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function nM(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function ls({ asChild: e, children: t }, n) {
  return e && d.isValidElement(t) ? d.cloneElement(nM(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var rM = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const oM = Zo, aL = Li, sM = Jo, iL = _n, Ev = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Rn,
  {
    ref: n,
    className: N(
      "fixed inset-0 z-[100] bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Ev.displayName = Rn.displayName;
const Nv = d.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ O(sM, { children: [
  /* @__PURE__ */ p(Ev, {}),
  /* @__PURE__ */ O(
    Pn,
    {
      ref: r,
      className: N(
        "fixed left-[50%] top-[50%] z-[100] grid w-[calc(100%-2rem)] max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-border bg-background p-4 sm:p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] rounded-lg max-h-[calc(100dvh-2rem)] my-4 overflow-y-auto",
        e
      ),
      ...n,
      translate: "no",
      children: [
        t,
        /* @__PURE__ */ O(_n, { className: "absolute right-4 top-4 rounded-sm p-3 opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground bg-background z-10", children: [
          /* @__PURE__ */ p(Xo, { className: "h-4 w-4" }),
          /* @__PURE__ */ p("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Nv.displayName = Pn.displayName;
const aM = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "div",
  {
    className: N(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      e
    ),
    ...t
  }
);
aM.displayName = "DialogHeader";
const iM = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "div",
  {
    className: N(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
iM.displayName = "DialogFooter";
const lM = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Cr,
  {
    ref: n,
    className: N(
      "text-lg font-semibold leading-none tracking-tight",
      e
    ),
    ...t
  }
));
lM.displayName = Cr.displayName;
const cM = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ar,
  {
    ref: n,
    className: N("text-sm text-muted-foreground", e),
    ...t
  }
));
cM.displayName = Ar.displayName;
const Tl = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Me,
  {
    ref: n,
    className: N(
      "flex h-full w-full flex-col overflow-hidden rounded-md bg-white text-neutral-950 dark:bg-neutral-950 dark:text-neutral-50",
      e
    ),
    ...t
  }
));
Tl.displayName = Me.displayName;
const lL = ({ children: e, ...t }) => /* @__PURE__ */ p(oM, { ...t, children: /* @__PURE__ */ p(Nv, { className: "overflow-hidden p-0 shadow-lg", children: /* @__PURE__ */ p(Tl, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-neutral-500 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5 dark:[&_[cmdk-group-heading]]:text-neutral-400", children: e }) }) }), Tv = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ O("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
  /* @__PURE__ */ p(rA, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
  /* @__PURE__ */ p(
    Me.Input,
    {
      ref: n,
      className: N(
        "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none placeholder:text-neutral-500 disabled:cursor-not-allowed disabled:opacity-50 dark:placeholder:text-neutral-400",
        e
      ),
      ...t
    }
  )
] }));
Tv.displayName = Me.Input.displayName;
const Rv = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Me.List,
  {
    ref: n,
    className: N("max-h-[300px] overflow-y-auto overflow-x-hidden", e),
    ...t
  }
));
Rv.displayName = Me.List.displayName;
const Pv = d.forwardRef((e, t) => /* @__PURE__ */ p(
  Me.Empty,
  {
    ref: t,
    className: "py-6 text-center text-sm",
    ...e
  }
));
Pv.displayName = Me.Empty.displayName;
const _v = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Me.Group,
  {
    ref: n,
    className: N(
      "overflow-hidden p-1 text-neutral-950 [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-neutral-500 dark:text-neutral-50 dark:[&_[cmdk-group-heading]]:text-neutral-400",
      e
    ),
    ...t
  }
));
_v.displayName = Me.Group.displayName;
const uM = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Me.Separator,
  {
    ref: n,
    className: N("-mx-1 h-px bg-neutral-200 dark:bg-neutral-800", e),
    ...t
  }
));
uM.displayName = Me.Separator.displayName;
const Mv = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Me.Item,
  {
    ref: n,
    className: N(
      "relative flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-neutral-100 data-[selected=true]:text-neutral-900 data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 dark:data-[selected='true']:bg-neutral-800 dark:data-[selected=true]:text-neutral-50",
      e
    ),
    ...t
  }
));
Mv.displayName = Me.Item.displayName;
const dM = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "span",
  {
    className: N(
      "ml-auto text-xs tracking-widest text-neutral-500 dark:text-neutral-400",
      e
    ),
    ...t
  }
);
dM.displayName = "CommandShortcut";
var fM = (e) => e.type === "checkbox", zn = (e) => e instanceof Date, Rl = (e) => e == null;
const Iv = (e) => typeof e == "object";
var jt = (e) => !Rl(e) && !Array.isArray(e) && Iv(e) && !zn(e), pM = (e) => jt(e) && e.target ? fM(e.target) ? e.target.checked : e.target.value : e, hM = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, mM = (e, t) => e.has(hM(t)), vM = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return jt(t) && t.hasOwnProperty("isPrototypeOf");
}, gM = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Dv(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (gM && (e instanceof Blob || t))
    return e;
  const n = Array.isArray(e);
  if (!n && !(jt(e) && vM(e)))
    return e;
  const r = n ? [] : Object.create(Object.getPrototypeOf(e));
  for (const o in e)
    Object.prototype.hasOwnProperty.call(e, o) && (r[o] = Dv(e[o]));
  return r;
}
var kv = (e) => /^\w*$/.test(e), Ka = (e) => e === void 0, yM = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Ov = (e) => yM(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Ee = (e, t, n) => {
  if (!t || !jt(e))
    return n;
  const r = (kv(t) ? [t] : Ov(t)).reduce((o, s) => Rl(o) ? o : o[s], e);
  return Ka(r) || r === e ? Ka(e[t]) ? n : e[t] : r;
}, fa = (e) => typeof e == "boolean", zr = (e) => typeof e == "function", ad = (e, t, n) => {
  let r = -1;
  const o = kv(t) ? [t] : Ov(t), s = o.length, a = s - 1;
  for (; ++r < s; ) {
    const i = o[r];
    let l = n;
    if (r !== a) {
      const c = e[i];
      l = jt(c) || Array.isArray(c) ? c : isNaN(+o[r + 1]) ? {} : [];
    }
    if (i === "__proto__" || i === "constructor" || i === "prototype")
      return;
    e[i] = l, e = e[i];
  }
};
const id = {
  BLUR: "blur",
  CHANGE: "change"
}, ld = {
  all: "all"
}, Pl = q.createContext(null);
Pl.displayName = "HookFormControlContext";
const _l = () => q.useContext(Pl);
var bM = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const s in e)
    Object.defineProperty(o, s, {
      get: () => {
        const a = s;
        return t._proxyFormState[a] !== ld.all && (t._proxyFormState[a] = !r || ld.all), n && (n[a] = !0), e[a];
      }
    });
  return o;
};
const Lv = typeof window < "u" ? q.useLayoutEffect : q.useEffect;
function wM(e) {
  const t = _l(), { control: n = t, disabled: r, name: o, exact: s } = e || {}, [a, i] = q.useState(n._formState), l = q.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return Lv(() => n._subscribe({
    name: o,
    formState: l.current,
    exact: s,
    callback: (c) => {
      !r && i({
        ...n._formState,
        ...c
      });
    }
  }), [o, r, s]), q.useEffect(() => {
    l.current.isValid && n._setValid(!0);
  }, [n]), q.useMemo(() => bM(a, n, l.current, !1), [a, n]);
}
var xM = (e) => typeof e == "string", cd = (e, t, n, r, o) => xM(e) ? Ee(n, e, o) : Array.isArray(e) ? e.map((s) => Ee(n, s)) : n, ud = (e) => Rl(e) || !Iv(e);
function ao(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (ud(e) || ud(t))
    return Object.is(e, t);
  if (zn(e) && zn(t))
    return Object.is(e.getTime(), t.getTime());
  const r = Object.keys(e), o = Object.keys(t);
  if (r.length !== o.length)
    return !1;
  if (n.has(e) || n.has(t))
    return !0;
  n.add(e), n.add(t);
  for (const s of r) {
    const a = e[s];
    if (!o.includes(s))
      return !1;
    if (s !== "ref") {
      const i = t[s];
      if (zn(a) && zn(i) || jt(a) && jt(i) || Array.isArray(a) && Array.isArray(i) ? !ao(a, i, n) : !Object.is(a, i))
        return !1;
    }
  }
  return !0;
}
function SM(e) {
  const t = _l(), { control: n = t, name: r, defaultValue: o, disabled: s, exact: a, compute: i } = e || {}, l = q.useRef(o), c = q.useRef(i), u = q.useRef(void 0), f = q.useRef(n), h = q.useRef(r);
  c.current = i;
  const [m, g] = q.useState(() => {
    const S = n._getWatch(r, l.current);
    return c.current ? c.current(S) : S;
  }), v = q.useCallback((S) => {
    const C = cd(r, n._names, S || n._formValues, !1, l.current);
    return c.current ? c.current(C) : C;
  }, [n._formValues, n._names, r]), y = q.useCallback((S) => {
    if (!s) {
      const C = cd(r, n._names, S || n._formValues, !1, l.current);
      if (c.current) {
        const E = c.current(C);
        ao(E, u.current) || (g(E), u.current = E);
      } else
        g(C);
    }
  }, [n._formValues, n._names, s, r]);
  Lv(() => ((f.current !== n || !ao(h.current, r)) && (f.current = n, h.current = r, y()), n._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: a,
    callback: (S) => {
      y(S.values);
    }
  })), [n, a, r, y]), q.useEffect(() => n._removeUnmounted());
  const b = f.current !== n, w = h.current, x = q.useMemo(() => {
    if (s)
      return null;
    const S = !b && !ao(w, r);
    return b || S ? v() : null;
  }, [s, b, r, w, v]);
  return x !== null ? x : m;
}
function CM(e) {
  const t = _l(), { name: n, disabled: r, control: o = t, shouldUnregister: s, defaultValue: a, exact: i = !0 } = e, l = mM(o._names.array, n), c = q.useMemo(() => Ee(o._formValues, n, Ee(o._defaultValues, n, a)), [o, n, a]), u = SM({
    control: o,
    name: n,
    defaultValue: c,
    exact: i
  }), f = wM({
    control: o,
    name: n,
    exact: i
  }), h = q.useRef(e), m = q.useRef(void 0), g = q.useRef(o.register(n, {
    ...e.rules,
    value: u,
    ...fa(e.disabled) ? { disabled: e.disabled } : {}
  }));
  h.current = e;
  const v = q.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ee(f.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ee(f.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ee(f.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ee(f.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => Ee(f.errors, n)
    }
  }), [f, n]), y = q.useCallback((S) => g.current.onChange({
    target: {
      value: pM(S),
      name: n
    },
    type: id.CHANGE
  }), [n]), b = q.useCallback(() => g.current.onBlur({
    target: {
      value: Ee(o._formValues, n),
      name: n
    },
    type: id.BLUR
  }), [n, o._formValues]), w = q.useCallback((S) => {
    const C = Ee(o._fields, n);
    C && C._f && S && (C._f.ref = {
      focus: () => zr(S.focus) && S.focus(),
      select: () => zr(S.select) && S.select(),
      setCustomValidity: (E) => zr(S.setCustomValidity) && S.setCustomValidity(E),
      reportValidity: () => zr(S.reportValidity) && S.reportValidity()
    });
  }, [o._fields, n]), x = q.useMemo(() => ({
    name: n,
    value: u,
    ...fa(r) || f.disabled ? { disabled: f.disabled || r } : {},
    onChange: y,
    onBlur: b,
    ref: w
  }), [n, r, f.disabled, y, b, w, u]);
  return q.useEffect(() => {
    const S = o._options.shouldUnregister || s, C = m.current;
    C && C !== n && !l && o.unregister(C), o.register(n, {
      ...h.current.rules,
      ...fa(h.current.disabled) ? { disabled: h.current.disabled } : {}
    });
    const E = (A, T) => {
      const I = Ee(o._fields, A);
      I && I._f && (I._f.mount = T);
    };
    if (E(n, !0), S) {
      const A = Dv(Ee(o._options.defaultValues, n, h.current.defaultValue));
      ad(o._defaultValues, n, A), Ka(Ee(o._formValues, n)) && ad(o._formValues, n, A);
    }
    return !l && o.register(n), m.current = n, () => {
      (l ? S && !o._state.action : S) ? o.unregister(n) : E(n, !1);
    };
  }, [n, o, l, s]), q.useEffect(() => {
    o._setDisabledField({
      disabled: r,
      name: n
    });
  }, [r, n, o]), q.useMemo(() => ({
    field: x,
    formState: f,
    fieldState: v
  }), [x, f, v]);
}
const AM = (e) => e.render(CM(e)), Ml = q.createContext(null);
Ml.displayName = "HookFormContext";
const EM = () => q.useContext(Ml), NM = (e) => {
  const { children: t, watch: n, getValues: r, getFieldState: o, setError: s, clearErrors: a, setValue: i, trigger: l, formState: c, resetField: u, reset: f, handleSubmit: h, unregister: m, control: g, register: v, setFocus: y, subscribe: b } = e;
  return q.createElement(
    Ml.Provider,
    { value: q.useMemo(() => ({
      watch: n,
      getValues: r,
      getFieldState: o,
      setError: s,
      clearErrors: a,
      setValue: i,
      trigger: l,
      formState: c,
      resetField: u,
      reset: f,
      handleSubmit: h,
      unregister: m,
      control: g,
      register: v,
      setFocus: y,
      subscribe: b
    }), [
      a,
      g,
      c,
      o,
      r,
      h,
      v,
      f,
      u,
      s,
      y,
      i,
      b,
      l,
      m,
      n
    ]) },
    q.createElement(Pl.Provider, { value: g }, t)
  );
};
var TM = Symbol.for("react.lazy"), To = d[" use ".trim().toString()];
function RM(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function Vv(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === TM && "_payload" in e && RM(e._payload);
}
// @__NO_SIDE_EFFECTS__
function PM(e) {
  const t = /* @__PURE__ */ _M(e), n = d.forwardRef((r, o) => {
    let { children: s, ...a } = r;
    Vv(s) && typeof To == "function" && (s = To(s._payload));
    const i = d.Children.toArray(s), l = i.find(IM);
    if (l) {
      const c = l.props.children, u = i.map((f) => f === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...a, ref: o, children: d.isValidElement(c) ? d.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ p(t, { ...a, ref: o, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function _M(e) {
  const t = d.forwardRef((n, r) => {
    let { children: o, ...s } = n;
    if (Vv(o) && typeof To == "function" && (o = To(o._payload)), d.isValidElement(o)) {
      const a = kM(o), i = DM(s, o.props);
      return o.type !== d.Fragment && (i.ref = r ? Le(r, a) : a), d.cloneElement(o, i);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var MM = Symbol("radix.slottable");
function IM(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === MM;
}
function DM(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...i) => {
      const l = s(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function kM(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var OM = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], LM = OM.reduce((e, t) => {
  const n = /* @__PURE__ */ PM(`Primitive.${t}`), r = d.forwardRef((o, s) => {
    const { asChild: a, ...i } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(l, { ...i, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), VM = "Label", Fv = d.forwardRef((e, t) => /* @__PURE__ */ p(
  LM.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Fv.displayName = VM;
var $v = Fv;
const FM = wn(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), Bv = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  $v,
  {
    ref: n,
    className: N(FM(), e),
    ...t
  }
));
Bv.displayName = $v.displayName;
const cL = NM, Uv = d.createContext(
  {}
), Wv = ({
  ...e
}) => /* @__PURE__ */ p(Uv.Provider, { value: { name: e.name }, children: /* @__PURE__ */ p(AM, { ...e }) }), cs = () => {
  const e = d.useContext(Uv), t = d.useContext(Hv), { getFieldState: n, formState: r } = EM(), o = n(e.name, r);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: s } = t;
  return {
    id: s,
    name: e.name,
    formItemId: `${s}-form-item`,
    formDescriptionId: `${s}-form-item-description`,
    formMessageId: `${s}-form-item-message`,
    ...o
  };
}, Hv = d.createContext(
  {}
), Il = d.forwardRef(({ className: e, ...t }, n) => {
  const r = d.useId();
  return /* @__PURE__ */ p(Hv.Provider, { value: { id: r }, children: /* @__PURE__ */ p("div", { ref: n, className: N("space-y-2", e), ...t }) });
});
Il.displayName = "FormItem";
const $M = d.forwardRef(({ className: e, ...t }, n) => {
  const { error: r, formItemId: o } = cs();
  return /* @__PURE__ */ p(
    Bv,
    {
      ref: n,
      className: N(r && "text-red-500 dark:text-red-900", e),
      htmlFor: o,
      ...t
    }
  );
});
$M.displayName = "FormLabel";
const Dl = d.forwardRef(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: o, formMessageId: s } = cs();
  return /* @__PURE__ */ p(
    Ld,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${o} ${s}` : `${o}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
Dl.displayName = "FormControl";
const BM = d.forwardRef(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = cs();
  return /* @__PURE__ */ p(
    "p",
    {
      ref: n,
      id: r,
      className: N("text-sm text-neutral-500 dark:text-neutral-400", e),
      ...t
    }
  );
});
BM.displayName = "FormDescription";
const kl = d.forwardRef(({ className: e, children: t, ...n }, r) => {
  const { error: o, formMessageId: s } = cs(), a = o ? String(o == null ? void 0 : o.message) : t;
  return a ? /* @__PURE__ */ p(
    "p",
    {
      ref: r,
      id: s,
      className: N("text-sm font-medium text-red-500 dark:text-red-900", e),
      ...n,
      children: a
    }
  ) : null;
});
kl.displayName = "FormMessage";
const us = d.forwardRef(
  ({ className: e, type: t, ...n }, r) => /* @__PURE__ */ p(
    "input",
    {
      type: t,
      className: N(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base text-foreground ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        e
      ),
      ref: r,
      ...n
    }
  )
);
us.displayName = "Input";
const UM = d.forwardRef(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p("div", { ref: r, className: N("relative", e), ...n, children: t })
);
UM.displayName = "Layout";
const WM = d.forwardRef(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: N("sticky top-0 z-50 w-full bg-background", e),
      ...n,
      children: t
    }
  )
);
WM.displayName = "LayoutHeader";
const HM = d.forwardRef(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: N(
        "fixed left-0 top-0 z-40 h-full w-64 -translate-x-full border-r bg-background transition-transform md:translate-x-0",
        e
      ),
      ...n,
      children: t
    }
  )
);
HM.displayName = "LayoutSidebar";
const GM = d.forwardRef(
  ({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p(
    "div",
    {
      ref: r,
      className: N("ml-0 md:ml-64 transition-[margin]", e),
      ...n,
      children: t
    }
  )
);
GM.displayName = "LayoutContent";
const jM = "_spinner_l5hs0_1", KM = "_spinnerSm_l5hs0_10", zM = "_spinnerLg_l5hs0_19", pa = {
  spinner: jM,
  spinnerSm: KM,
  spinnerLg: zM
}, uL = ({ size: e = "md" }) => {
  const t = e === "sm" ? pa.spinnerSm : e === "lg" ? pa.spinnerLg : pa.spinner;
  return /* @__PURE__ */ p("div", { className: t });
};
var ds = "Popover", [Gv] = we(ds, [
  ot
]), Dr = ot(), [YM, Mt] = Gv(ds), jv = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    modal: a = !1
  } = e, i = Dr(t), l = d.useRef(null), [c, u] = d.useState(!1), [f, h] = Pe({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: ds
  });
  return /* @__PURE__ */ p(An, { ...i, children: /* @__PURE__ */ p(
    YM,
    {
      scope: t,
      contentId: ve(),
      triggerRef: l,
      open: f,
      onOpenChange: h,
      onOpenToggle: d.useCallback(() => h((m) => !m), [h]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: d.useCallback(() => u(!0), []),
      onCustomAnchorRemove: d.useCallback(() => u(!1), []),
      modal: a,
      children: n
    }
  ) });
};
jv.displayName = ds;
var Kv = "PopoverAnchor", XM = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Mt(Kv, n), s = Dr(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: i } = o;
    return d.useEffect(() => (a(), () => i()), [a, i]), /* @__PURE__ */ p(En, { ...s, ...r, ref: t });
  }
);
XM.displayName = Kv;
var zv = "PopoverTrigger", Yv = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Mt(zv, n), s = Dr(n), a = K(t, o.triggerRef), i = /* @__PURE__ */ p(
      $.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Qv(o.open),
        ...r,
        ref: a,
        onClick: M(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? i : /* @__PURE__ */ p(En, { asChild: !0, ...s, children: i });
  }
);
Yv.displayName = zv;
var Ol = "PopoverPortal", [qM, ZM] = Gv(Ol, {
  forceMount: void 0
}), Xv = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, s = Mt(Ol, t);
  return /* @__PURE__ */ p(qM, { scope: t, forceMount: n, children: /* @__PURE__ */ p(ye, { present: n || s.open, children: /* @__PURE__ */ p(Nn, { asChild: !0, container: o, children: r }) }) });
};
Xv.displayName = Ol;
var vn = "PopoverContent", qv = d.forwardRef(
  (e, t) => {
    const n = ZM(vn, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, s = Mt(vn, e.__scopePopover);
    return /* @__PURE__ */ p(ye, { present: r || s.open, children: s.modal ? /* @__PURE__ */ p(QM, { ...o, ref: t }) : /* @__PURE__ */ p(eI, { ...o, ref: t }) });
  }
);
qv.displayName = vn;
var JM = /* @__PURE__ */ xt("PopoverContent.RemoveScroll"), QM = d.forwardRef(
  (e, t) => {
    const n = Mt(vn, e.__scopePopover), r = d.useRef(null), o = K(t, r), s = d.useRef(!1);
    return d.useEffect(() => {
      const a = r.current;
      if (a) return jo(a);
    }, []), /* @__PURE__ */ p(yr, { as: JM, allowPinchZoom: !0, children: /* @__PURE__ */ p(
      Zv,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: M(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), s.current || (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: M(
          e.onPointerDownOutside,
          (a) => {
            const i = a.detail.originalEvent, l = i.button === 0 && i.ctrlKey === !0, c = i.button === 2 || l;
            s.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: M(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), eI = d.forwardRef(
  (e, t) => {
    const n = Mt(vn, e.__scopePopover), r = d.useRef(!1), o = d.useRef(!1);
    return /* @__PURE__ */ p(
      Zv,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          var a, i;
          (a = e.onCloseAutoFocus) == null || a.call(e, s), s.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), s.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (s) => {
          var l, c;
          (l = e.onInteractOutside) == null || l.call(e, s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = s.target;
          ((c = n.triggerRef.current) == null ? void 0 : c.contains(a)) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && o.current && s.preventDefault();
        }
      }
    );
  }
), Zv = d.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: i,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: u,
      ...f
    } = e, h = Mt(vn, n), m = Dr(n);
    return $o(), /* @__PURE__ */ p(
      pr,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ p(
          Rt,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: u,
            onEscapeKeyDown: i,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => h.onOpenChange(!1),
            children: /* @__PURE__ */ p(
              mr,
              {
                "data-state": Qv(h.open),
                role: "dialog",
                id: h.contentId,
                ...m,
                ...f,
                ref: t,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Jv = "PopoverClose", tI = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Mt(Jv, n);
    return /* @__PURE__ */ p(
      $.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: M(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
tI.displayName = Jv;
var nI = "PopoverArrow", rI = d.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Dr(n);
    return /* @__PURE__ */ p(vr, { ...o, ...r, ref: t });
  }
);
rI.displayName = nI;
function Qv(e) {
  return e ? "open" : "closed";
}
var oI = jv, sI = Yv, aI = Xv, eg = qv;
const tg = oI, ng = sI, Ll = d.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ p(aI, { children: /* @__PURE__ */ p(
  eg,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: N(
      "z-[100] w-72 rounded-md border border-border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r,
    translate: "no"
  }
) }));
Ll.displayName = eg.displayName;
function iI(e, t = []) {
  let n = [];
  function r(s, a) {
    const i = d.createContext(a);
    i.displayName = s + "Context";
    const l = n.length;
    n = [...n, a];
    const c = (f) => {
      var b;
      const { scope: h, children: m, ...g } = f, v = ((b = h == null ? void 0 : h[e]) == null ? void 0 : b[l]) || i, y = d.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ p(v.Provider, { value: y, children: m });
    };
    c.displayName = s + "Provider";
    function u(f, h) {
      var v;
      const m = ((v = h == null ? void 0 : h[e]) == null ? void 0 : v[l]) || i, g = d.useContext(m);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${s}\``);
    }
    return [c, u];
  }
  const o = () => {
    const s = n.map((a) => d.createContext(a));
    return function(i) {
      const l = (i == null ? void 0 : i[e]) || s;
      return d.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: l } }),
        [i, l]
      );
    };
  };
  return o.scopeName = e, [r, lI(o, ...t)];
}
function lI(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(s) {
      const a = r.reduce((i, { useScope: l, scopeName: c }) => {
        const f = l(s)[`__scope${c}`];
        return { ...i, ...f };
      }, {});
      return d.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var cI = Symbol.for("react.lazy"), Ro = d[" use ".trim().toString()];
function uI(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function rg(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === cI && "_payload" in e && uI(e._payload);
}
// @__NO_SIDE_EFFECTS__
function dI(e) {
  const t = /* @__PURE__ */ fI(e), n = d.forwardRef((r, o) => {
    let { children: s, ...a } = r;
    rg(s) && typeof Ro == "function" && (s = Ro(s._payload));
    const i = d.Children.toArray(s), l = i.find(hI);
    if (l) {
      const c = l.props.children, u = i.map((f) => f === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...a, ref: o, children: d.isValidElement(c) ? d.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ p(t, { ...a, ref: o, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function fI(e) {
  const t = d.forwardRef((n, r) => {
    let { children: o, ...s } = n;
    if (rg(o) && typeof Ro == "function" && (o = Ro(o._payload)), d.isValidElement(o)) {
      const a = vI(o), i = mI(s, o.props);
      return o.type !== d.Fragment && (i.ref = r ? Le(r, a) : a), d.cloneElement(o, i);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var pI = Symbol("radix.slottable");
function hI(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === pI;
}
function mI(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...i) => {
      const l = s(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function vI(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var gI = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], og = gI.reduce((e, t) => {
  const n = /* @__PURE__ */ dI(`Primitive.${t}`), r = d.forwardRef((o, s) => {
    const { asChild: a, ...i } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(l, { ...i, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Vl = "Progress", Fl = 100, [yI] = iI(Vl), [bI, wI] = yI(Vl), sg = d.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: r = null,
      max: o,
      getValueLabel: s = xI,
      ...a
    } = e;
    (o || o === 0) && !dd(o) && console.error(SI(`${o}`, "Progress"));
    const i = dd(o) ? o : Fl;
    r !== null && !fd(r, i) && console.error(CI(`${r}`, "Progress"));
    const l = fd(r, i) ? r : null, c = Po(l) ? s(l, i) : void 0;
    return /* @__PURE__ */ p(bI, { scope: n, value: l, max: i, children: /* @__PURE__ */ p(
      og.div,
      {
        "aria-valuemax": i,
        "aria-valuemin": 0,
        "aria-valuenow": Po(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": lg(l, i),
        "data-value": l ?? void 0,
        "data-max": i,
        ...a,
        ref: t
      }
    ) });
  }
);
sg.displayName = Vl;
var ag = "ProgressIndicator", ig = d.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...r } = e, o = wI(ag, n);
    return /* @__PURE__ */ p(
      og.div,
      {
        "data-state": lg(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...r,
        ref: t
      }
    );
  }
);
ig.displayName = ag;
function xI(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function lg(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Po(e) {
  return typeof e == "number";
}
function dd(e) {
  return Po(e) && !isNaN(e) && e > 0;
}
function fd(e, t) {
  return Po(e) && !isNaN(e) && e <= t && e >= 0;
}
function SI(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Fl}\`.`;
}
function CI(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Fl} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var cg = sg, AI = ig;
const EI = d.forwardRef(({ className: e, value: t, indicatorClassName: n, ...r }, o) => /* @__PURE__ */ p(
  cg,
  {
    ref: o,
    className: N(
      "relative h-4 w-full overflow-hidden rounded-full bg-neutral-100 dark:bg-neutral-800",
      e
    ),
    ...r,
    children: /* @__PURE__ */ p(
      AI,
      {
        className: N(
          "h-full w-full flex-1 bg-primary transition-all",
          n
        ),
        style: { transform: `translateX(-${100 - (t || 0)}%)` }
      }
    )
  }
));
EI.displayName = cg.displayName;
var $l = "Radio", [NI, ug] = we($l), [TI, RI] = NI($l), dg = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: r,
      checked: o = !1,
      required: s,
      disabled: a,
      value: i = "on",
      onCheck: l,
      form: c,
      ...u
    } = e, [f, h] = d.useState(null), m = K(t, (y) => h(y)), g = d.useRef(!1), v = f ? c || !!f.closest("form") : !0;
    return /* @__PURE__ */ O(TI, { scope: n, checked: o, disabled: a, children: [
      /* @__PURE__ */ p(
        $.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": o,
          "data-state": mg(o),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: i,
          ...u,
          ref: m,
          onClick: M(e.onClick, (y) => {
            o || l == null || l(), v && (g.current = y.isPropagationStopped(), g.current || y.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ p(
        hg,
        {
          control: f,
          bubbles: !g.current,
          name: r,
          value: i,
          checked: o,
          required: s,
          disabled: a,
          form: c,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
dg.displayName = $l;
var fg = "RadioIndicator", pg = d.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: r, ...o } = e, s = RI(fg, n);
    return /* @__PURE__ */ p(ye, { present: r || s.checked, children: /* @__PURE__ */ p(
      $.span,
      {
        "data-state": mg(s.checked),
        "data-disabled": s.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    ) });
  }
);
pg.displayName = fg;
var PI = "RadioBubbleInput", hg = d.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, s) => {
    const a = d.useRef(null), i = K(a, s), l = as(n), c = Go(t);
    return d.useEffect(() => {
      const u = a.current;
      if (!u) return;
      const f = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== n && m) {
        const g = new Event("click", { bubbles: r });
        m.call(u, n), u.dispatchEvent(g);
      }
    }, [l, n, r]), /* @__PURE__ */ p(
      $.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: i,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
hg.displayName = PI;
function mg(e) {
  return e ? "checked" : "unchecked";
}
var _I = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], fs = "RadioGroup", [MI] = we(fs, [
  Tn,
  ug
]), vg = Tn(), gg = ug(), [II, DI] = MI(fs), yg = d.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: r,
      defaultValue: o,
      value: s,
      required: a = !1,
      disabled: i = !1,
      orientation: l,
      dir: c,
      loop: u = !0,
      onValueChange: f,
      ...h
    } = e, m = vg(n), g = xn(c), [v, y] = Pe({
      prop: s,
      defaultProp: o ?? null,
      onChange: f,
      caller: fs
    });
    return /* @__PURE__ */ p(
      II,
      {
        scope: n,
        name: r,
        required: a,
        disabled: i,
        value: v,
        onValueChange: y,
        children: /* @__PURE__ */ p(
          Si,
          {
            asChild: !0,
            ...m,
            orientation: l,
            dir: g,
            loop: u,
            children: /* @__PURE__ */ p(
              $.div,
              {
                role: "radiogroup",
                "aria-required": a,
                "aria-orientation": l,
                "data-disabled": i ? "" : void 0,
                dir: g,
                ...h,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
yg.displayName = fs;
var bg = "RadioGroupItem", wg = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: r, ...o } = e, s = DI(bg, n), a = s.disabled || r, i = vg(n), l = gg(n), c = d.useRef(null), u = K(t, c), f = s.value === o.value, h = d.useRef(!1);
    return d.useEffect(() => {
      const m = (v) => {
        _I.includes(v.key) && (h.current = !0);
      }, g = () => h.current = !1;
      return document.addEventListener("keydown", m), document.addEventListener("keyup", g), () => {
        document.removeEventListener("keydown", m), document.removeEventListener("keyup", g);
      };
    }, []), /* @__PURE__ */ p(
      Ci,
      {
        asChild: !0,
        ...i,
        focusable: !a,
        active: f,
        children: /* @__PURE__ */ p(
          dg,
          {
            disabled: a,
            required: s.required,
            checked: f,
            ...l,
            ...o,
            name: s.name,
            ref: u,
            onCheck: () => s.onValueChange(o.value),
            onKeyDown: M((m) => {
              m.key === "Enter" && m.preventDefault();
            }),
            onFocus: M(o.onFocus, () => {
              var m;
              h.current && ((m = c.current) == null || m.click());
            })
          }
        )
      }
    );
  }
);
wg.displayName = bg;
var kI = "RadioGroupIndicator", xg = d.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...r } = e, o = gg(n);
    return /* @__PURE__ */ p(pg, { ...o, ...r, ref: t });
  }
);
xg.displayName = kI;
var Sg = yg, Cg = wg, OI = xg;
const LI = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Sg,
  {
    className: N("grid gap-2", e),
    ...t,
    ref: n
  }
));
LI.displayName = Sg.displayName;
const VI = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Cg,
  {
    ref: n,
    className: N(
      "aspect-square relative h-4 w-4 rounded-full border border-neutral-200 border-neutral-900 text-neutral-900 ring-offset-white focus:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-neutral-800 dark:border-neutral-50 dark:text-neutral-50 dark:ring-offset-neutral-950 dark:focus-visible:ring-neutral-300 before:content-[''] before:absolute before:-inset-[14px]",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p(OI, { className: "flex items-center justify-center", children: /* @__PURE__ */ p(Ep, { className: "h-2.5 w-2.5 fill-current text-current" }) })
  }
));
VI.displayName = Cg.displayName;
function za(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function FI(e, t) {
  return d.useReducer((n, r) => t[n][r] ?? n, e);
}
var Bl = "ScrollArea", [Ag] = we(Bl), [$I, Ue] = Ag(Bl), Eg = d.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: r = "hover",
      dir: o,
      scrollHideDelay: s = 600,
      ...a
    } = e, [i, l] = d.useState(null), [c, u] = d.useState(null), [f, h] = d.useState(null), [m, g] = d.useState(null), [v, y] = d.useState(null), [b, w] = d.useState(0), [x, S] = d.useState(0), [C, E] = d.useState(!1), [A, T] = d.useState(!1), I = K(t, (B) => l(B)), L = xn(o);
    return /* @__PURE__ */ p(
      $I,
      {
        scope: n,
        type: r,
        dir: L,
        scrollHideDelay: s,
        scrollArea: i,
        viewport: c,
        onViewportChange: u,
        content: f,
        onContentChange: h,
        scrollbarX: m,
        onScrollbarXChange: g,
        scrollbarXEnabled: C,
        onScrollbarXEnabledChange: E,
        scrollbarY: v,
        onScrollbarYChange: y,
        scrollbarYEnabled: A,
        onScrollbarYEnabledChange: T,
        onCornerWidthChange: w,
        onCornerHeightChange: S,
        children: /* @__PURE__ */ p(
          $.div,
          {
            dir: L,
            ...a,
            ref: I,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Eg.displayName = Bl;
var Ng = "ScrollAreaViewport", Tg = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: r, nonce: o, ...s } = e, a = Ue(Ng, n), i = d.useRef(null), l = K(t, i, a.onViewportChange);
    return /* @__PURE__ */ O(ge, { children: [
      /* @__PURE__ */ p(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ p(
        $.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...s,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: a.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: a.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ p("div", { ref: a.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
Tg.displayName = Ng;
var st = "ScrollAreaScrollbar", Ul = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Ue(st, e.__scopeScrollArea), { onScrollbarXEnabledChange: s, onScrollbarYEnabledChange: a } = o, i = e.orientation === "horizontal";
    return d.useEffect(() => (i ? s(!0) : a(!0), () => {
      i ? s(!1) : a(!1);
    }), [i, s, a]), o.type === "hover" ? /* @__PURE__ */ p(BI, { ...r, ref: t, forceMount: n }) : o.type === "scroll" ? /* @__PURE__ */ p(UI, { ...r, ref: t, forceMount: n }) : o.type === "auto" ? /* @__PURE__ */ p(Rg, { ...r, ref: t, forceMount: n }) : o.type === "always" ? /* @__PURE__ */ p(Wl, { ...r, ref: t }) : null;
  }
);
Ul.displayName = st;
var BI = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Ue(st, e.__scopeScrollArea), [s, a] = d.useState(!1);
  return d.useEffect(() => {
    const i = o.scrollArea;
    let l = 0;
    if (i) {
      const c = () => {
        window.clearTimeout(l), a(!0);
      }, u = () => {
        l = window.setTimeout(() => a(!1), o.scrollHideDelay);
      };
      return i.addEventListener("pointerenter", c), i.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), i.removeEventListener("pointerenter", c), i.removeEventListener("pointerleave", u);
      };
    }
  }, [o.scrollArea, o.scrollHideDelay]), /* @__PURE__ */ p(ye, { present: n || s, children: /* @__PURE__ */ p(
    Rg,
    {
      "data-state": s ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), UI = d.forwardRef((e, t) => {
  const { forceMount: n, ...r } = e, o = Ue(st, e.__scopeScrollArea), s = e.orientation === "horizontal", a = hs(() => l("SCROLL_END"), 100), [i, l] = FI("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return d.useEffect(() => {
    if (i === "idle") {
      const c = window.setTimeout(() => l("HIDE"), o.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [i, o.scrollHideDelay, l]), d.useEffect(() => {
    const c = o.viewport, u = s ? "scrollLeft" : "scrollTop";
    if (c) {
      let f = c[u];
      const h = () => {
        const m = c[u];
        f !== m && (l("SCROLL"), a()), f = m;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [o.viewport, s, l, a]), /* @__PURE__ */ p(ye, { present: n || i !== "hidden", children: /* @__PURE__ */ p(
    Wl,
    {
      "data-state": i === "hidden" ? "hidden" : "visible",
      ...r,
      ref: t,
      onPointerEnter: M(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: M(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Rg = d.forwardRef((e, t) => {
  const n = Ue(st, e.__scopeScrollArea), { forceMount: r, ...o } = e, [s, a] = d.useState(!1), i = e.orientation === "horizontal", l = hs(() => {
    if (n.viewport) {
      const c = n.viewport.offsetWidth < n.viewport.scrollWidth, u = n.viewport.offsetHeight < n.viewport.scrollHeight;
      a(i ? c : u);
    }
  }, 10);
  return gn(n.viewport, l), gn(n.content, l), /* @__PURE__ */ p(ye, { present: r || s, children: /* @__PURE__ */ p(
    Wl,
    {
      "data-state": s ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Wl = d.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...r } = e, o = Ue(st, e.__scopeScrollArea), s = d.useRef(null), a = d.useRef(0), [i, l] = d.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Dg(i.viewport, i.content), u = {
    ...r,
    sizes: i,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => s.current = h,
    onThumbPointerUp: () => a.current = 0,
    onThumbPointerDown: (h) => a.current = h
  };
  function f(h, m) {
    return zI(h, a.current, i, m);
  }
  return n === "horizontal" ? /* @__PURE__ */ p(
    WI,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && s.current) {
          const h = o.viewport.scrollLeft, m = pd(h, i, o.dir);
          s.current.style.transform = `translate3d(${m}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        o.viewport && (o.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        o.viewport && (o.viewport.scrollLeft = f(h, o.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ p(
    HI,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (o.viewport && s.current) {
          const h = o.viewport.scrollTop, m = pd(h, i);
          s.current.style.transform = `translate3d(0, ${m}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        o.viewport && (o.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        o.viewport && (o.viewport.scrollTop = f(h));
      }
    }
  ) : null;
}), WI = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, s = Ue(st, e.__scopeScrollArea), [a, i] = d.useState(), l = d.useRef(null), c = K(t, l, s.onScrollbarXChange);
  return d.useEffect(() => {
    l.current && i(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ p(
    _g,
    {
      "data-orientation": "horizontal",
      ...o,
      ref: c,
      sizes: n,
      style: {
        bottom: 0,
        left: s.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: s.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": ps(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, f) => {
        if (s.viewport) {
          const h = s.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(h), Og(h, f) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && s.viewport && a && r({
          content: s.viewport.scrollWidth,
          viewport: s.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Mo(a.paddingLeft),
            paddingEnd: Mo(a.paddingRight)
          }
        });
      }
    }
  );
}), HI = d.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: r, ...o } = e, s = Ue(st, e.__scopeScrollArea), [a, i] = d.useState(), l = d.useRef(null), c = K(t, l, s.onScrollbarYChange);
  return d.useEffect(() => {
    l.current && i(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ p(
    _g,
    {
      "data-orientation": "vertical",
      ...o,
      ref: c,
      sizes: n,
      style: {
        top: 0,
        right: s.dir === "ltr" ? 0 : void 0,
        left: s.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": ps(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, f) => {
        if (s.viewport) {
          const h = s.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(h), Og(h, f) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && s.viewport && a && r({
          content: s.viewport.scrollHeight,
          viewport: s.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Mo(a.paddingTop),
            paddingEnd: Mo(a.paddingBottom)
          }
        });
      }
    }
  );
}), [GI, Pg] = Ag(st), _g = d.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: r,
    hasThumb: o,
    onThumbChange: s,
    onThumbPointerUp: a,
    onThumbPointerDown: i,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: f,
    ...h
  } = e, m = Ue(st, n), [g, v] = d.useState(null), y = K(t, (I) => v(I)), b = d.useRef(null), w = d.useRef(""), x = m.viewport, S = r.content - r.viewport, C = de(u), E = de(l), A = hs(f, 10);
  function T(I) {
    if (b.current) {
      const L = I.clientX - b.current.left, B = I.clientY - b.current.top;
      c({ x: L, y: B });
    }
  }
  return d.useEffect(() => {
    const I = (L) => {
      const B = L.target;
      (g == null ? void 0 : g.contains(B)) && C(L, S);
    };
    return document.addEventListener("wheel", I, { passive: !1 }), () => document.removeEventListener("wheel", I, { passive: !1 });
  }, [x, g, S, C]), d.useEffect(E, [r, E]), gn(g, A), gn(m.content, A), /* @__PURE__ */ p(
    GI,
    {
      scope: n,
      scrollbar: g,
      hasThumb: o,
      onThumbChange: de(s),
      onThumbPointerUp: de(a),
      onThumbPositionChange: E,
      onThumbPointerDown: de(i),
      children: /* @__PURE__ */ p(
        $.div,
        {
          ...h,
          ref: y,
          style: { position: "absolute", ...h.style },
          onPointerDown: M(e.onPointerDown, (I) => {
            I.button === 0 && (I.target.setPointerCapture(I.pointerId), b.current = g.getBoundingClientRect(), w.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", m.viewport && (m.viewport.style.scrollBehavior = "auto"), T(I));
          }),
          onPointerMove: M(e.onPointerMove, T),
          onPointerUp: M(e.onPointerUp, (I) => {
            const L = I.target;
            L.hasPointerCapture(I.pointerId) && L.releasePointerCapture(I.pointerId), document.body.style.webkitUserSelect = w.current, m.viewport && (m.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), _o = "ScrollAreaThumb", Mg = d.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, o = Pg(_o, e.__scopeScrollArea);
    return /* @__PURE__ */ p(ye, { present: n || o.hasThumb, children: /* @__PURE__ */ p(jI, { ref: t, ...r }) });
  }
), jI = d.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: r, ...o } = e, s = Ue(_o, n), a = Pg(_o, n), { onThumbPositionChange: i } = a, l = K(
      t,
      (f) => a.onThumbChange(f)
    ), c = d.useRef(void 0), u = hs(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return d.useEffect(() => {
      const f = s.viewport;
      if (f) {
        const h = () => {
          if (u(), !c.current) {
            const m = YI(f, i);
            c.current = m, i();
          }
        };
        return i(), f.addEventListener("scroll", h), () => f.removeEventListener("scroll", h);
      }
    }, [s.viewport, u, i]), /* @__PURE__ */ p(
      $.div,
      {
        "data-state": a.hasThumb ? "visible" : "hidden",
        ...o,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: M(e.onPointerDownCapture, (f) => {
          const m = f.target.getBoundingClientRect(), g = f.clientX - m.left, v = f.clientY - m.top;
          a.onThumbPointerDown({ x: g, y: v });
        }),
        onPointerUp: M(e.onPointerUp, a.onThumbPointerUp)
      }
    );
  }
);
Mg.displayName = _o;
var Hl = "ScrollAreaCorner", Ig = d.forwardRef(
  (e, t) => {
    const n = Ue(Hl, e.__scopeScrollArea), r = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && r ? /* @__PURE__ */ p(KI, { ...e, ref: t }) : null;
  }
);
Ig.displayName = Hl;
var KI = d.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...r } = e, o = Ue(Hl, n), [s, a] = d.useState(0), [i, l] = d.useState(0), c = !!(s && i);
  return gn(o.scrollbarX, () => {
    var f;
    const u = ((f = o.scrollbarX) == null ? void 0 : f.offsetHeight) || 0;
    o.onCornerHeightChange(u), l(u);
  }), gn(o.scrollbarY, () => {
    var f;
    const u = ((f = o.scrollbarY) == null ? void 0 : f.offsetWidth) || 0;
    o.onCornerWidthChange(u), a(u);
  }), c ? /* @__PURE__ */ p(
    $.div,
    {
      ...r,
      ref: t,
      style: {
        width: s,
        height: i,
        position: "absolute",
        right: o.dir === "ltr" ? 0 : void 0,
        left: o.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Mo(e) {
  return e ? parseInt(e, 10) : 0;
}
function Dg(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function ps(e) {
  const t = Dg(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function zI(e, t, n, r = "ltr") {
  const o = ps(n), s = o / 2, a = t || s, i = o - a, l = n.scrollbar.paddingStart + a, c = n.scrollbar.size - n.scrollbar.paddingEnd - i, u = n.content - n.viewport, f = r === "ltr" ? [0, u] : [u * -1, 0];
  return kg([l, c], f)(e);
}
function pd(e, t, n = "ltr") {
  const r = ps(t), o = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, s = t.scrollbar.size - o, a = t.content - t.viewport, i = s - r, l = n === "ltr" ? [0, a] : [a * -1, 0], c = za(e, l);
  return kg([0, a], [0, i])(c);
}
function kg(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Og(e, t) {
  return e > 0 && e < t;
}
var YI = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, r = 0;
  return (function o() {
    const s = { left: e.scrollLeft, top: e.scrollTop }, a = n.left !== s.left, i = n.top !== s.top;
    (a || i) && t(), n = s, r = window.requestAnimationFrame(o);
  })(), () => window.cancelAnimationFrame(r);
};
function hs(e, t) {
  const n = de(e), r = d.useRef(0);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), d.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [n, t]);
}
function gn(e, t) {
  const n = de(t);
  me(() => {
    let r = 0;
    if (e) {
      const o = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return o.observe(e), () => {
        window.cancelAnimationFrame(r), o.unobserve(e);
      };
    }
  }, [e, n]);
}
var Lg = Eg, XI = Tg, qI = Ig;
const ZI = d.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ O(
  Lg,
  {
    ref: r,
    className: N("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ p(XI, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ p(Vg, {}),
      /* @__PURE__ */ p(qI, {})
    ]
  }
));
ZI.displayName = Lg.displayName;
const Vg = d.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ p(
  Ul,
  {
    ref: r,
    orientation: t,
    className: N(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ p(Mg, { className: "relative flex-1 rounded-full bg-neutral-200 dark:bg-neutral-800" })
  }
));
Vg.displayName = Ul.displayName;
var Fg = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), JI = "VisuallyHidden", ms = d.forwardRef(
  (e, t) => /* @__PURE__ */ p(
    $.span,
    {
      ...e,
      ref: t,
      style: { ...Fg, ...e.style }
    }
  )
);
ms.displayName = JI;
var QI = ms, eD = [" ", "Enter", "ArrowUp", "ArrowDown"], tD = [" ", "Enter"], Kt = "Select", [vs, gs, nD] = Fo(Kt), [kn] = we(Kt, [
  nD,
  ot
]), ys = ot(), [rD, It] = kn(Kt), [oD, sD] = kn(Kt), $g = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    value: a,
    defaultValue: i,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: f,
    disabled: h,
    required: m,
    form: g
  } = e, v = ys(t), [y, b] = d.useState(null), [w, x] = d.useState(null), [S, C] = d.useState(!1), E = xn(c), [A, T] = Pe({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: Kt
  }), [I, L] = Pe({
    prop: a,
    defaultProp: i,
    onChange: l,
    caller: Kt
  }), B = d.useRef(null), V = y ? g || !!y.closest("form") : !0, [z, D] = d.useState(/* @__PURE__ */ new Set()), G = Array.from(z).map((U) => U.props.value).join(";");
  return /* @__PURE__ */ p(An, { ...v, children: /* @__PURE__ */ O(
    rD,
    {
      required: m,
      scope: t,
      trigger: y,
      onTriggerChange: b,
      valueNode: w,
      onValueNodeChange: x,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: C,
      contentId: ve(),
      value: I,
      onValueChange: L,
      open: A,
      onOpenChange: T,
      dir: E,
      triggerPointerDownPosRef: B,
      disabled: h,
      children: [
        /* @__PURE__ */ p(vs.Provider, { scope: t, children: /* @__PURE__ */ p(
          oD,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: d.useCallback((U) => {
              D((P) => new Set(P).add(U));
            }, []),
            onNativeOptionRemove: d.useCallback((U) => {
              D((P) => {
                const R = new Set(P);
                return R.delete(U), R;
              });
            }, []),
            children: n
          }
        ) }),
        V ? /* @__PURE__ */ O(
          uy,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: u,
            autoComplete: f,
            value: I,
            onChange: (U) => L(U.target.value),
            disabled: h,
            form: g,
            children: [
              I === void 0 ? /* @__PURE__ */ p("option", { value: "" }) : null,
              Array.from(z)
            ]
          },
          G
        ) : null
      ]
    }
  ) });
};
$g.displayName = Kt;
var Bg = "SelectTrigger", Ug = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...o } = e, s = ys(n), a = It(Bg, n), i = a.disabled || r, l = K(t, a.onTriggerChange), c = gs(n), u = d.useRef("touch"), [f, h, m] = fy((v) => {
      const y = c().filter((x) => !x.disabled), b = y.find((x) => x.value === a.value), w = py(y, v, b);
      w !== void 0 && a.onValueChange(w.value);
    }), g = (v) => {
      i || (a.onOpenChange(!0), m()), v && (a.triggerPointerDownPosRef.current = {
        x: Math.round(v.pageX),
        y: Math.round(v.pageY)
      });
    };
    return /* @__PURE__ */ p(En, { asChild: !0, ...s, children: /* @__PURE__ */ p(
      $.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-placeholder": dy(a.value) ? "" : void 0,
        ...o,
        ref: l,
        onClick: M(o.onClick, (v) => {
          v.currentTarget.focus(), u.current !== "mouse" && g(v);
        }),
        onPointerDown: M(o.onPointerDown, (v) => {
          u.current = v.pointerType;
          const y = v.target;
          y.hasPointerCapture(v.pointerId) && y.releasePointerCapture(v.pointerId), v.button === 0 && v.ctrlKey === !1 && v.pointerType === "mouse" && (g(v), v.preventDefault());
        }),
        onKeyDown: M(o.onKeyDown, (v) => {
          const y = f.current !== "";
          !(v.ctrlKey || v.altKey || v.metaKey) && v.key.length === 1 && h(v.key), !(y && v.key === " ") && eD.includes(v.key) && (g(), v.preventDefault());
        })
      }
    ) });
  }
);
Ug.displayName = Bg;
var Wg = "SelectValue", Hg = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, children: s, placeholder: a = "", ...i } = e, l = It(Wg, n), { onValueNodeHasChildrenChange: c } = l, u = s !== void 0, f = K(t, l.onValueNodeChange);
    return me(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ p(
      $.span,
      {
        ...i,
        ref: f,
        style: { pointerEvents: "none" },
        children: dy(l.value) ? /* @__PURE__ */ p(ge, { children: a }) : s
      }
    );
  }
);
Hg.displayName = Wg;
var aD = "SelectIcon", Gg = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...o } = e;
    return /* @__PURE__ */ p($.span, { "aria-hidden": !0, ...o, ref: t, children: r || "▼" });
  }
);
Gg.displayName = aD;
var iD = "SelectPortal", jg = (e) => /* @__PURE__ */ p(Nn, { asChild: !0, ...e });
jg.displayName = iD;
var zt = "SelectContent", Kg = d.forwardRef(
  (e, t) => {
    const n = It(zt, e.__scopeSelect), [r, o] = d.useState();
    if (me(() => {
      o(new DocumentFragment());
    }, []), !n.open) {
      const s = r;
      return s ? fr.createPortal(
        /* @__PURE__ */ p(zg, { scope: e.__scopeSelect, children: /* @__PURE__ */ p(vs.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ p("div", { children: e.children }) }) }),
        s
      ) : null;
    }
    return /* @__PURE__ */ p(Yg, { ...e, ref: t });
  }
);
Kg.displayName = zt;
var He = 10, [zg, Dt] = kn(zt), lD = "SelectContentImpl", cD = /* @__PURE__ */ xt("SelectContent.RemoveScroll"), Yg = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: i,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: y,
      //
      ...b
    } = e, w = It(zt, n), [x, S] = d.useState(null), [C, E] = d.useState(null), A = K(t, (F) => S(F)), [T, I] = d.useState(null), [L, B] = d.useState(
      null
    ), V = gs(n), [z, D] = d.useState(!1), G = d.useRef(!1);
    d.useEffect(() => {
      if (x) return jo(x);
    }, [x]), $o();
    const U = d.useCallback(
      (F) => {
        const [J, ...Q] = V().map((se) => se.ref.current), [re] = Q.slice(-1), oe = document.activeElement;
        for (const se of F)
          if (se === oe || (se == null || se.scrollIntoView({ block: "nearest" }), se === J && C && (C.scrollTop = 0), se === re && C && (C.scrollTop = C.scrollHeight), se == null || se.focus(), document.activeElement !== oe)) return;
      },
      [V, C]
    ), P = d.useCallback(
      () => U([T, x]),
      [U, T, x]
    );
    d.useEffect(() => {
      z && P();
    }, [z, P]);
    const { onOpenChange: R, triggerPointerDownPosRef: k } = w;
    d.useEffect(() => {
      if (x) {
        let F = { x: 0, y: 0 };
        const J = (re) => {
          var oe, se;
          F = {
            x: Math.abs(Math.round(re.pageX) - (((oe = k.current) == null ? void 0 : oe.x) ?? 0)),
            y: Math.abs(Math.round(re.pageY) - (((se = k.current) == null ? void 0 : se.y) ?? 0))
          };
        }, Q = (re) => {
          F.x <= 10 && F.y <= 10 ? re.preventDefault() : x.contains(re.target) || R(!1), document.removeEventListener("pointermove", J), k.current = null;
        };
        return k.current !== null && (document.addEventListener("pointermove", J), document.addEventListener("pointerup", Q, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", J), document.removeEventListener("pointerup", Q, { capture: !0 });
        };
      }
    }, [x, R, k]), d.useEffect(() => {
      const F = () => R(!1);
      return window.addEventListener("blur", F), window.addEventListener("resize", F), () => {
        window.removeEventListener("blur", F), window.removeEventListener("resize", F);
      };
    }, [R]);
    const [Z, ne] = fy((F) => {
      const J = V().filter((oe) => !oe.disabled), Q = J.find((oe) => oe.ref.current === document.activeElement), re = py(J, F, Q);
      re && setTimeout(() => re.ref.current.focus());
    }), _ = d.useCallback(
      (F, J, Q) => {
        const re = !G.current && !Q;
        (w.value !== void 0 && w.value === J || re) && (I(F), re && (G.current = !0));
      },
      [w.value]
    ), H = d.useCallback(() => x == null ? void 0 : x.focus(), [x]), Y = d.useCallback(
      (F, J, Q) => {
        const re = !G.current && !Q;
        (w.value !== void 0 && w.value === J || re) && B(F);
      },
      [w.value]
    ), W = r === "popper" ? Ya : Xg, ee = W === Ya ? {
      side: i,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: h,
      collisionPadding: m,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ p(
      zg,
      {
        scope: n,
        content: x,
        viewport: C,
        onViewportChange: E,
        itemRefCallback: _,
        selectedItem: T,
        onItemLeave: H,
        itemTextRefCallback: Y,
        focusSelectedItem: P,
        selectedItemText: L,
        position: r,
        isPositioned: z,
        searchRef: Z,
        children: /* @__PURE__ */ p(yr, { as: cD, allowPinchZoom: !0, children: /* @__PURE__ */ p(
          pr,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (F) => {
              F.preventDefault();
            },
            onUnmountAutoFocus: M(o, (F) => {
              var J;
              (J = w.trigger) == null || J.focus({ preventScroll: !0 }), F.preventDefault();
            }),
            children: /* @__PURE__ */ p(
              Rt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: a,
                onFocusOutside: (F) => F.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ p(
                  W,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (F) => F.preventDefault(),
                    ...b,
                    ...ee,
                    onPlaced: () => D(!0),
                    ref: A,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: M(b.onKeyDown, (F) => {
                      const J = F.ctrlKey || F.altKey || F.metaKey;
                      if (F.key === "Tab" && F.preventDefault(), !J && F.key.length === 1 && ne(F.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(F.key)) {
                        let re = V().filter((oe) => !oe.disabled).map((oe) => oe.ref.current);
                        if (["ArrowUp", "End"].includes(F.key) && (re = re.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(F.key)) {
                          const oe = F.target, se = re.indexOf(oe);
                          re = re.slice(se + 1);
                        }
                        setTimeout(() => U(re)), F.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Yg.displayName = lD;
var uD = "SelectItemAlignedPosition", Xg = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...o } = e, s = It(zt, n), a = Dt(zt, n), [i, l] = d.useState(null), [c, u] = d.useState(null), f = K(t, (A) => u(A)), h = gs(n), m = d.useRef(!1), g = d.useRef(!0), { viewport: v, selectedItem: y, selectedItemText: b, focusSelectedItem: w } = a, x = d.useCallback(() => {
    if (s.trigger && s.valueNode && i && c && v && y && b) {
      const A = s.trigger.getBoundingClientRect(), T = c.getBoundingClientRect(), I = s.valueNode.getBoundingClientRect(), L = b.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const oe = L.left - T.left, se = I.left - oe, Ie = A.left - se, Xe = A.width + Ie, On = Math.max(Xe, T.width), Ln = window.innerWidth - He, Vn = za(se, [
          He,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(He, Ln - On)
        ]);
        i.style.minWidth = Xe + "px", i.style.left = Vn + "px";
      } else {
        const oe = T.right - L.right, se = window.innerWidth - I.right - oe, Ie = window.innerWidth - A.right - se, Xe = A.width + Ie, On = Math.max(Xe, T.width), Ln = window.innerWidth - He, Vn = za(se, [
          He,
          Math.max(He, Ln - On)
        ]);
        i.style.minWidth = Xe + "px", i.style.right = Vn + "px";
      }
      const B = h(), V = window.innerHeight - He * 2, z = v.scrollHeight, D = window.getComputedStyle(c), G = parseInt(D.borderTopWidth, 10), U = parseInt(D.paddingTop, 10), P = parseInt(D.borderBottomWidth, 10), R = parseInt(D.paddingBottom, 10), k = G + U + z + R + P, Z = Math.min(y.offsetHeight * 5, k), ne = window.getComputedStyle(v), _ = parseInt(ne.paddingTop, 10), H = parseInt(ne.paddingBottom, 10), Y = A.top + A.height / 2 - He, W = V - Y, ee = y.offsetHeight / 2, F = y.offsetTop + ee, J = G + U + F, Q = k - J;
      if (J <= Y) {
        const oe = B.length > 0 && y === B[B.length - 1].ref.current;
        i.style.bottom = "0px";
        const se = c.clientHeight - v.offsetTop - v.offsetHeight, Ie = Math.max(
          W,
          ee + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (oe ? H : 0) + se + P
        ), Xe = J + Ie;
        i.style.height = Xe + "px";
      } else {
        const oe = B.length > 0 && y === B[0].ref.current;
        i.style.top = "0px";
        const Ie = Math.max(
          Y,
          G + v.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (oe ? _ : 0) + ee
        ) + Q;
        i.style.height = Ie + "px", v.scrollTop = J - Y + v.offsetTop;
      }
      i.style.margin = `${He}px 0`, i.style.minHeight = Z + "px", i.style.maxHeight = V + "px", r == null || r(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    h,
    s.trigger,
    s.valueNode,
    i,
    c,
    v,
    y,
    b,
    s.dir,
    r
  ]);
  me(() => x(), [x]);
  const [S, C] = d.useState();
  me(() => {
    c && C(window.getComputedStyle(c).zIndex);
  }, [c]);
  const E = d.useCallback(
    (A) => {
      A && g.current === !0 && (x(), w == null || w(), g.current = !1);
    },
    [x, w]
  );
  return /* @__PURE__ */ p(
    fD,
    {
      scope: n,
      contentWrapper: i,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: E,
      children: /* @__PURE__ */ p(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ p(
            $.div,
            {
              ...o,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
Xg.displayName = uD;
var dD = "SelectPopperPosition", Ya = d.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: o = He,
    ...s
  } = e, a = ys(n);
  return /* @__PURE__ */ p(
    mr,
    {
      ...a,
      ...s,
      ref: t,
      align: r,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Ya.displayName = dD;
var [fD, Gl] = kn(zt, {}), Xa = "SelectViewport", qg = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...o } = e, s = Dt(Xa, n), a = Gl(Xa, n), i = K(t, s.onViewportChange), l = d.useRef(0);
    return /* @__PURE__ */ O(ge, { children: [
      /* @__PURE__ */ p(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ p(vs.Slot, { scope: n, children: /* @__PURE__ */ p(
        $.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: i,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: M(o.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: h } = a;
            if (h != null && h.current && f) {
              const m = Math.abs(l.current - u.scrollTop);
              if (m > 0) {
                const g = window.innerHeight - He * 2, v = parseFloat(f.style.minHeight), y = parseFloat(f.style.height), b = Math.max(v, y);
                if (b < g) {
                  const w = b + m, x = Math.min(g, w), S = w - x;
                  f.style.height = x + "px", f.style.bottom === "0px" && (u.scrollTop = S > 0 ? S : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
qg.displayName = Xa;
var Zg = "SelectGroup", [pD, hD] = kn(Zg), Jg = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = ve();
    return /* @__PURE__ */ p(pD, { scope: n, id: o, children: /* @__PURE__ */ p($.div, { role: "group", "aria-labelledby": o, ...r, ref: t }) });
  }
);
Jg.displayName = Zg;
var Qg = "SelectLabel", ey = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = hD(Qg, n);
    return /* @__PURE__ */ p($.div, { id: o.id, ...r, ref: t });
  }
);
ey.displayName = Qg;
var Io = "SelectItem", [mD, ty] = kn(Io), ny = d.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: o = !1,
      textValue: s,
      ...a
    } = e, i = It(Io, n), l = Dt(Io, n), c = i.value === r, [u, f] = d.useState(s ?? ""), [h, m] = d.useState(!1), g = K(
      t,
      (w) => {
        var x;
        return (x = l.itemRefCallback) == null ? void 0 : x.call(l, w, r, o);
      }
    ), v = ve(), y = d.useRef("touch"), b = () => {
      o || (i.onValueChange(r), i.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ p(
      mD,
      {
        scope: n,
        value: r,
        disabled: o,
        textId: v,
        isSelected: c,
        onItemTextChange: d.useCallback((w) => {
          f((x) => x || ((w == null ? void 0 : w.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ p(
          vs.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ p(
              $.div,
              {
                role: "option",
                "aria-labelledby": v,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": c && h,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...a,
                ref: g,
                onFocus: M(a.onFocus, () => m(!0)),
                onBlur: M(a.onBlur, () => m(!1)),
                onClick: M(a.onClick, () => {
                  y.current !== "mouse" && b();
                }),
                onPointerUp: M(a.onPointerUp, () => {
                  y.current === "mouse" && b();
                }),
                onPointerDown: M(a.onPointerDown, (w) => {
                  y.current = w.pointerType;
                }),
                onPointerMove: M(a.onPointerMove, (w) => {
                  var x;
                  y.current = w.pointerType, o ? (x = l.onItemLeave) == null || x.call(l) : y.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: M(a.onPointerLeave, (w) => {
                  var x;
                  w.currentTarget === document.activeElement && ((x = l.onItemLeave) == null || x.call(l));
                }),
                onKeyDown: M(a.onKeyDown, (w) => {
                  var S;
                  ((S = l.searchRef) == null ? void 0 : S.current) !== "" && w.key === " " || (tD.includes(w.key) && b(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
ny.displayName = Io;
var Yn = "SelectItemText", ry = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: o, ...s } = e, a = It(Yn, n), i = Dt(Yn, n), l = ty(Yn, n), c = sD(Yn, n), [u, f] = d.useState(null), h = K(
      t,
      (b) => f(b),
      l.onItemTextChange,
      (b) => {
        var w;
        return (w = i.itemTextRefCallback) == null ? void 0 : w.call(i, b, l.value, l.disabled);
      }
    ), m = u == null ? void 0 : u.textContent, g = d.useMemo(
      () => /* @__PURE__ */ p("option", { value: l.value, disabled: l.disabled, children: m }, l.value),
      [l.disabled, l.value, m]
    ), { onNativeOptionAdd: v, onNativeOptionRemove: y } = c;
    return me(() => (v(g), () => y(g)), [v, y, g]), /* @__PURE__ */ O(ge, { children: [
      /* @__PURE__ */ p($.span, { id: l.textId, ...s, ref: h }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? fr.createPortal(s.children, a.valueNode) : null
    ] });
  }
);
ry.displayName = Yn;
var oy = "SelectItemIndicator", sy = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return ty(oy, n).isSelected ? /* @__PURE__ */ p($.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
sy.displayName = oy;
var qa = "SelectScrollUpButton", ay = d.forwardRef((e, t) => {
  const n = Dt(qa, e.__scopeSelect), r = Gl(qa, e.__scopeSelect), [o, s] = d.useState(!1), a = K(t, r.onScrollButtonChange);
  return me(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const c = l.scrollTop > 0;
        s(c);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ p(
    ly,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
ay.displayName = qa;
var Za = "SelectScrollDownButton", iy = d.forwardRef((e, t) => {
  const n = Dt(Za, e.__scopeSelect), r = Gl(Za, e.__scopeSelect), [o, s] = d.useState(!1), a = K(t, r.onScrollButtonChange);
  return me(() => {
    if (n.viewport && n.isPositioned) {
      let i = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        s(u);
      };
      const l = n.viewport;
      return i(), l.addEventListener("scroll", i), () => l.removeEventListener("scroll", i);
    }
  }, [n.viewport, n.isPositioned]), o ? /* @__PURE__ */ p(
    ly,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: i, selectedItem: l } = n;
        i && l && (i.scrollTop = i.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
iy.displayName = Za;
var ly = d.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...o } = e, s = Dt("SelectScrollButton", n), a = d.useRef(null), i = gs(n), l = d.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return d.useEffect(() => () => l(), [l]), me(() => {
    var u;
    const c = i().find((f) => f.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [i]), /* @__PURE__ */ p(
    $.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: M(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: M(o.onPointerMove, () => {
        var c;
        (c = s.onItemLeave) == null || c.call(s), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: M(o.onPointerLeave, () => {
        l();
      })
    }
  );
}), vD = "SelectSeparator", cy = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ p($.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
cy.displayName = vD;
var Ja = "SelectArrow", gD = d.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, o = ys(n), s = It(Ja, n), a = Dt(Ja, n);
    return s.open && a.position === "popper" ? /* @__PURE__ */ p(vr, { ...o, ...r, ref: t }) : null;
  }
);
gD.displayName = Ja;
var yD = "SelectBubbleInput", uy = d.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const o = d.useRef(null), s = K(r, o), a = as(t);
    return d.useEffect(() => {
      const i = o.current;
      if (!i) return;
      const l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== t && u) {
        const f = new Event("change", { bubbles: !0 });
        u.call(i, t), i.dispatchEvent(f);
      }
    }, [a, t]), /* @__PURE__ */ p(
      $.select,
      {
        ...n,
        style: { ...Fg, ...n.style },
        ref: s,
        defaultValue: t
      }
    );
  }
);
uy.displayName = yD;
function dy(e) {
  return e === "" || e === void 0;
}
function fy(e) {
  const t = de(e), n = d.useRef(""), r = d.useRef(0), o = d.useCallback(
    (a) => {
      const i = n.current + a;
      t(i), (function l(c) {
        n.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      })(i);
    },
    [t]
  ), s = d.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return d.useEffect(() => () => window.clearTimeout(r.current), []), [n, o, s];
}
function py(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((c) => c === t[0]) ? t[0] : t, s = n ? e.indexOf(n) : -1;
  let a = bD(e, Math.max(s, 0));
  o.length === 1 && (a = a.filter((c) => c !== n));
  const l = a.find(
    (c) => c.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function bD(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var wD = $g, hy = Ug, xD = Hg, SD = Gg, CD = jg, my = Kg, AD = qg, ED = Jg, vy = ey, gy = ny, ND = ry, TD = sy, yy = ay, by = iy, wy = cy;
const dL = wD, fL = ED, pL = xD, RD = d.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ O(
  hy,
  {
    ref: r,
    className: N(
      "flex min-h-10 w-full items-center justify-between gap-2 rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm text-foreground ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:break-words [&>span]:text-left",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ p(SD, { asChild: !0, children: /* @__PURE__ */ p(Cp, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
RD.displayName = hy.displayName;
const xy = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  yy,
  {
    ref: n,
    className: N(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p(zC, { className: "h-4 w-4" })
  }
));
xy.displayName = yy.displayName;
const Sy = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  by,
  {
    ref: n,
    className: N(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ p(Cp, { className: "h-4 w-4" })
  }
));
Sy.displayName = by.displayName;
const PD = d.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, o) => /* @__PURE__ */ p(CD, { children: /* @__PURE__ */ O(
  my,
  {
    ref: o,
    className: N(
      "relative z-[100] max-h-96 min-w-[8rem] overflow-hidden rounded-md border border-input bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...r,
    translate: "no",
    children: [
      /* @__PURE__ */ p(xy, {}),
      /* @__PURE__ */ p(
        AD,
        {
          className: N(
            "p-1",
            n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
          ),
          children: t
        }
      ),
      /* @__PURE__ */ p(Sy, {})
    ]
  }
) }));
PD.displayName = my.displayName;
const _D = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  vy,
  {
    ref: n,
    className: N("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
_D.displayName = vy.displayName;
const MD = d.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ O(
  gy,
  {
    ref: r,
    className: N(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ p("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ p(TD, { children: /* @__PURE__ */ p(Sr, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ p(ND, { children: /* @__PURE__ */ p("span", { children: t }) })
    ]
  }
));
MD.displayName = gy.displayName;
const ID = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  wy,
  {
    ref: n,
    className: N("-mx-1 my-1 h-px bg-border", e),
    ...t
  }
));
ID.displayName = wy.displayName;
var DD = Symbol.for("react.lazy"), Do = d[" use ".trim().toString()];
function kD(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function Cy(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === DD && "_payload" in e && kD(e._payload);
}
// @__NO_SIDE_EFFECTS__
function OD(e) {
  const t = /* @__PURE__ */ LD(e), n = d.forwardRef((r, o) => {
    let { children: s, ...a } = r;
    Cy(s) && typeof Do == "function" && (s = Do(s._payload));
    const i = d.Children.toArray(s), l = i.find(FD);
    if (l) {
      const c = l.props.children, u = i.map((f) => f === l ? d.Children.count(c) > 1 ? d.Children.only(null) : d.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...a, ref: o, children: d.isValidElement(c) ? d.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ p(t, { ...a, ref: o, children: s });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function LD(e) {
  const t = d.forwardRef((n, r) => {
    let { children: o, ...s } = n;
    if (Cy(o) && typeof Do == "function" && (o = Do(o._payload)), d.isValidElement(o)) {
      const a = BD(o), i = $D(s, o.props);
      return o.type !== d.Fragment && (i.ref = r ? Le(r, a) : a), d.cloneElement(o, i);
    }
    return d.Children.count(o) > 1 ? d.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var VD = Symbol("radix.slottable");
function FD(e) {
  return d.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === VD;
}
function $D(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...i) => {
      const l = s(...i);
      return o(...i), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function BD(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var UD = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], WD = UD.reduce((e, t) => {
  const n = /* @__PURE__ */ OD(`Primitive.${t}`), r = d.forwardRef((o, s) => {
    const { asChild: a, ...i } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(l, { ...i, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), HD = "Separator", hd = "horizontal", GD = ["horizontal", "vertical"], Ay = d.forwardRef((e, t) => {
  const { decorative: n, orientation: r = hd, ...o } = e, s = jD(r) ? r : hd, i = n ? { role: "none" } : { "aria-orientation": s === "vertical" ? s : void 0, role: "separator" };
  return /* @__PURE__ */ p(
    WD.div,
    {
      "data-orientation": s,
      ...i,
      ...o,
      ref: t
    }
  );
});
Ay.displayName = HD;
function jD(e) {
  return GD.includes(e);
}
var Ey = Ay;
const KD = d.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, o) => /* @__PURE__ */ p(
    Ey,
    {
      ref: o,
      decorative: n,
      orientation: t,
      className: N(
        "shrink-0 bg-neutral-200 dark:bg-neutral-800",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...r
    }
  )
);
KD.displayName = Ey.displayName;
const hL = Zo, mL = Li, vL = _n, zD = Jo, Ny = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Rn,
  {
    className: N(
      "fixed inset-0 z-[100] bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
Ny.displayName = Rn.displayName;
const YD = wn(
  "fixed z-[100] gap-4 bg-background p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), XD = d.forwardRef(({ side: e = "right", className: t, children: n, closeLabel: r = "Close", ...o }, s) => /* @__PURE__ */ O(zD, { children: [
  /* @__PURE__ */ p(Ny, {}),
  /* @__PURE__ */ O(
    Pn,
    {
      ref: s,
      className: N(YD({ side: e }), t),
      ...o,
      translate: "no",
      children: [
        n,
        /* @__PURE__ */ O(_n, { className: "absolute right-4 top-4 rounded-sm p-3 opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-neutral-950 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-neutral-100 dark:ring-offset-neutral-950 dark:focus:ring-neutral-300 dark:data-[state=open]:bg-neutral-800", children: [
          /* @__PURE__ */ p(Xo, { className: "h-4 w-4" }),
          /* @__PURE__ */ p("span", { className: "sr-only", children: r })
        ] })
      ]
    }
  )
] }));
XD.displayName = Pn.displayName;
const qD = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "div",
  {
    className: N(
      "flex flex-col space-y-2 text-center sm:text-left",
      e
    ),
    ...t
  }
);
qD.displayName = "SheetHeader";
const ZD = ({
  className: e,
  ...t
}) => /* @__PURE__ */ p(
  "div",
  {
    className: N(
      "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
      e
    ),
    ...t
  }
);
ZD.displayName = "SheetFooter";
const JD = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Cr,
  {
    ref: n,
    className: N("text-lg font-semibold text-neutral-950 dark:text-neutral-50", e),
    ...t
  }
));
JD.displayName = Cr.displayName;
const QD = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ar,
  {
    ref: n,
    className: N("text-sm text-neutral-500 dark:text-neutral-400", e),
    ...t
  }
));
QD.displayName = Ar.displayName;
function gL({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      className: N("animate-pulse rounded-md bg-neutral-100 dark:bg-neutral-800", e),
      ...t
    }
  );
}
var bs = "Switch", [ek] = we(bs), [tk, nk] = ek(bs), Ty = d.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: o,
      defaultChecked: s,
      required: a,
      disabled: i,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...f
    } = e, [h, m] = d.useState(null), g = K(t, (x) => m(x)), v = d.useRef(!1), y = h ? u || !!h.closest("form") : !0, [b, w] = Pe({
      prop: o,
      defaultProp: s ?? !1,
      onChange: c,
      caller: bs
    });
    return /* @__PURE__ */ O(tk, { scope: n, checked: b, disabled: i, children: [
      /* @__PURE__ */ p(
        $.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": a,
          "data-state": My(b),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: l,
          ...f,
          ref: g,
          onClick: M(e.onClick, (x) => {
            w((S) => !S), y && (v.current = x.isPropagationStopped(), v.current || x.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ p(
        _y,
        {
          control: h,
          bubbles: !v.current,
          name: r,
          value: l,
          checked: b,
          required: a,
          disabled: i,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Ty.displayName = bs;
var Ry = "SwitchThumb", Py = d.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, o = nk(Ry, n);
    return /* @__PURE__ */ p(
      $.span,
      {
        "data-state": My(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
Py.displayName = Ry;
var rk = "SwitchBubbleInput", _y = d.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    ...o
  }, s) => {
    const a = d.useRef(null), i = K(a, s), l = as(n), c = Go(t);
    return d.useEffect(() => {
      const u = a.current;
      if (!u) return;
      const f = window.HTMLInputElement.prototype, m = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== n && m) {
        const g = new Event("click", { bubbles: r });
        m.call(u, n), u.dispatchEvent(g);
      }
    }, [l, n, r]), /* @__PURE__ */ p(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...o,
        tabIndex: -1,
        ref: i,
        style: {
          ...o.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
_y.displayName = rk;
function My(e) {
  return e ? "checked" : "unchecked";
}
var Iy = Ty, ok = Py;
const sk = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Iy,
  {
    className: N(
      "peer relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-neutral-900 data-[state=unchecked]:bg-neutral-200 dark:focus-visible:ring-neutral-300 dark:focus-visible:ring-offset-neutral-950 dark:data-[state=checked]:bg-neutral-50 dark:data-[state=unchecked]:bg-neutral-800 before:content-[''] before:absolute before:-inset-y-[10px] before:inset-x-0",
      e
    ),
    ...t,
    ref: n,
    children: /* @__PURE__ */ p(
      ok,
      {
        className: N(
          "pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 dark:bg-neutral-950"
        )
      }
    )
  }
));
sk.displayName = Iy.displayName;
const ak = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "textarea",
  {
    className: N(
      "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-base text-foreground ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
      e
    ),
    ref: n,
    ...t
  }
));
ak.displayName = "Textarea";
var jl = "ToastProvider", [Kl, ik, lk] = Fo("Toast"), [Dy] = we("Toast", [lk]), [ck, ws] = Dy(jl), ky = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: s = 50,
    children: a
  } = e, [i, l] = d.useState(null), [c, u] = d.useState(0), f = d.useRef(!1), h = d.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${jl}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ p(Kl.Provider, { scope: t, children: /* @__PURE__ */ p(
    ck,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: s,
      toastCount: c,
      viewport: i,
      onViewportChange: l,
      onToastAdd: d.useCallback(() => u((m) => m + 1), []),
      onToastRemove: d.useCallback(() => u((m) => m - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: h,
      children: a
    }
  ) });
};
ky.displayName = jl;
var Oy = "ToastViewport", uk = ["F8"], Qa = "toast.viewportPause", ei = "toast.viewportResume", Ly = d.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = uk,
      label: o = "Notifications ({hotkey})",
      ...s
    } = e, a = ws(Oy, n), i = ik(n), l = d.useRef(null), c = d.useRef(null), u = d.useRef(null), f = d.useRef(null), h = K(t, f, a.onViewportChange), m = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = a.toastCount > 0;
    d.useEffect(() => {
      const y = (b) => {
        var x;
        r.length !== 0 && r.every((S) => b[S] || b.code === S) && ((x = f.current) == null || x.focus());
      };
      return document.addEventListener("keydown", y), () => document.removeEventListener("keydown", y);
    }, [r]), d.useEffect(() => {
      const y = l.current, b = f.current;
      if (g && y && b) {
        const w = () => {
          if (!a.isClosePausedRef.current) {
            const E = new CustomEvent(Qa);
            b.dispatchEvent(E), a.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (a.isClosePausedRef.current) {
            const E = new CustomEvent(ei);
            b.dispatchEvent(E), a.isClosePausedRef.current = !1;
          }
        }, S = (E) => {
          !y.contains(E.relatedTarget) && x();
        }, C = () => {
          y.contains(document.activeElement) || x();
        };
        return y.addEventListener("focusin", w), y.addEventListener("focusout", S), y.addEventListener("pointermove", w), y.addEventListener("pointerleave", C), window.addEventListener("blur", w), window.addEventListener("focus", x), () => {
          y.removeEventListener("focusin", w), y.removeEventListener("focusout", S), y.removeEventListener("pointermove", w), y.removeEventListener("pointerleave", C), window.removeEventListener("blur", w), window.removeEventListener("focus", x);
        };
      }
    }, [g, a.isClosePausedRef]);
    const v = d.useCallback(
      ({ tabbingDirection: y }) => {
        const w = i().map((x) => {
          const S = x.ref.current, C = [S, ...Ck(S)];
          return y === "forwards" ? C : C.reverse();
        });
        return (y === "forwards" ? w.reverse() : w).flat();
      },
      [i]
    );
    return d.useEffect(() => {
      const y = f.current;
      if (y) {
        const b = (w) => {
          var C, E, A;
          const x = w.altKey || w.ctrlKey || w.metaKey;
          if (w.key === "Tab" && !x) {
            const T = document.activeElement, I = w.shiftKey;
            if (w.target === y && I) {
              (C = c.current) == null || C.focus();
              return;
            }
            const V = v({ tabbingDirection: I ? "backwards" : "forwards" }), z = V.findIndex((D) => D === T);
            ha(V.slice(z + 1)) ? w.preventDefault() : I ? (E = c.current) == null || E.focus() : (A = u.current) == null || A.focus();
          }
        };
        return y.addEventListener("keydown", b), () => y.removeEventListener("keydown", b);
      }
    }, [i, v]), /* @__PURE__ */ O(
      pw,
      {
        ref: l,
        role: "region",
        "aria-label": o.replace("{hotkey}", m),
        tabIndex: -1,
        style: { pointerEvents: g ? void 0 : "none" },
        children: [
          g && /* @__PURE__ */ p(
            ti,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const y = v({
                  tabbingDirection: "forwards"
                });
                ha(y);
              }
            }
          ),
          /* @__PURE__ */ p(Kl.Slot, { scope: n, children: /* @__PURE__ */ p($.ol, { tabIndex: -1, ...s, ref: h }) }),
          g && /* @__PURE__ */ p(
            ti,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const y = v({
                  tabbingDirection: "backwards"
                });
                ha(y);
              }
            }
          )
        ]
      }
    );
  }
);
Ly.displayName = Oy;
var Vy = "ToastFocusProxy", ti = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, s = ws(Vy, n);
    return /* @__PURE__ */ p(
      ms,
      {
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (a) => {
          var c;
          const i = a.relatedTarget;
          !((c = s.viewport) != null && c.contains(i)) && r();
        }
      }
    );
  }
);
ti.displayName = Vy;
var kr = "Toast", dk = "toast.swipeStart", fk = "toast.swipeMove", pk = "toast.swipeCancel", hk = "toast.swipeEnd", Fy = d.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: s, ...a } = e, [i, l] = Pe({
      prop: r,
      defaultProp: o ?? !0,
      onChange: s,
      caller: kr
    });
    return /* @__PURE__ */ p(ye, { present: n || i, children: /* @__PURE__ */ p(
      gk,
      {
        open: i,
        ...a,
        ref: t,
        onClose: () => l(!1),
        onPause: de(e.onPause),
        onResume: de(e.onResume),
        onSwipeStart: M(e.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: M(e.onSwipeMove, (c) => {
          const { x: u, y: f } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: M(e.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: M(e.onSwipeEnd, (c) => {
          const { x: u, y: f } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), l(!1);
        })
      }
    ) });
  }
);
Fy.displayName = kr;
var [mk, vk] = Dy(kr, {
  onClose() {
  }
}), gk = d.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: s,
      onClose: a,
      onEscapeKeyDown: i,
      onPause: l,
      onResume: c,
      onSwipeStart: u,
      onSwipeMove: f,
      onSwipeCancel: h,
      onSwipeEnd: m,
      ...g
    } = e, v = ws(kr, n), [y, b] = d.useState(null), w = K(t, (D) => b(D)), x = d.useRef(null), S = d.useRef(null), C = o || v.duration, E = d.useRef(0), A = d.useRef(C), T = d.useRef(0), { onToastAdd: I, onToastRemove: L } = v, B = de(() => {
      var G;
      (y == null ? void 0 : y.contains(document.activeElement)) && ((G = v.viewport) == null || G.focus()), a();
    }), V = d.useCallback(
      (D) => {
        !D || D === 1 / 0 || (window.clearTimeout(T.current), E.current = (/* @__PURE__ */ new Date()).getTime(), T.current = window.setTimeout(B, D));
      },
      [B]
    );
    d.useEffect(() => {
      const D = v.viewport;
      if (D) {
        const G = () => {
          V(A.current), c == null || c();
        }, U = () => {
          const P = (/* @__PURE__ */ new Date()).getTime() - E.current;
          A.current = A.current - P, window.clearTimeout(T.current), l == null || l();
        };
        return D.addEventListener(Qa, U), D.addEventListener(ei, G), () => {
          D.removeEventListener(Qa, U), D.removeEventListener(ei, G);
        };
      }
    }, [v.viewport, C, l, c, V]), d.useEffect(() => {
      s && !v.isClosePausedRef.current && V(C);
    }, [s, C, v.isClosePausedRef, V]), d.useEffect(() => (I(), () => L()), [I, L]);
    const z = d.useMemo(() => y ? jy(y) : null, [y]);
    return v.viewport ? /* @__PURE__ */ O(ge, { children: [
      z && /* @__PURE__ */ p(
        yk,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          children: z
        }
      ),
      /* @__PURE__ */ p(mk, { scope: n, onClose: B, children: fr.createPortal(
        /* @__PURE__ */ p(Kl.ItemSlot, { scope: n, children: /* @__PURE__ */ p(
          fw,
          {
            asChild: !0,
            onEscapeKeyDown: M(i, () => {
              v.isFocusedToastEscapeKeyDownRef.current || B(), v.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ p(
              $.li,
              {
                tabIndex: 0,
                "data-state": s ? "open" : "closed",
                "data-swipe-direction": v.swipeDirection,
                ...g,
                ref: w,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: M(e.onKeyDown, (D) => {
                  D.key === "Escape" && (i == null || i(D.nativeEvent), D.nativeEvent.defaultPrevented || (v.isFocusedToastEscapeKeyDownRef.current = !0, B()));
                }),
                onPointerDown: M(e.onPointerDown, (D) => {
                  D.button === 0 && (x.current = { x: D.clientX, y: D.clientY });
                }),
                onPointerMove: M(e.onPointerMove, (D) => {
                  if (!x.current) return;
                  const G = D.clientX - x.current.x, U = D.clientY - x.current.y, P = !!S.current, R = ["left", "right"].includes(v.swipeDirection), k = ["left", "up"].includes(v.swipeDirection) ? Math.min : Math.max, Z = R ? k(0, G) : 0, ne = R ? 0 : k(0, U), _ = D.pointerType === "touch" ? 10 : 2, H = { x: Z, y: ne }, Y = { originalEvent: D, delta: H };
                  P ? (S.current = H, Yr(fk, f, Y, {
                    discrete: !1
                  })) : md(H, v.swipeDirection, _) ? (S.current = H, Yr(dk, u, Y, {
                    discrete: !1
                  }), D.target.setPointerCapture(D.pointerId)) : (Math.abs(G) > _ || Math.abs(U) > _) && (x.current = null);
                }),
                onPointerUp: M(e.onPointerUp, (D) => {
                  const G = S.current, U = D.target;
                  if (U.hasPointerCapture(D.pointerId) && U.releasePointerCapture(D.pointerId), S.current = null, x.current = null, G) {
                    const P = D.currentTarget, R = { originalEvent: D, delta: G };
                    md(G, v.swipeDirection, v.swipeThreshold) ? Yr(hk, m, R, {
                      discrete: !0
                    }) : Yr(
                      pk,
                      h,
                      R,
                      {
                        discrete: !0
                      }
                    ), P.addEventListener("click", (k) => k.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        v.viewport
      ) })
    ] }) : null;
  }
), yk = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = ws(kr, t), [s, a] = d.useState(!1), [i, l] = d.useState(!1);
  return xk(() => a(!0)), d.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), i ? null : /* @__PURE__ */ p(Nn, { asChild: !0, children: /* @__PURE__ */ p(ms, { ...r, children: s && /* @__PURE__ */ O(ge, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, bk = "ToastTitle", $y = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ p($.div, { ...r, ref: t });
  }
);
$y.displayName = bk;
var wk = "ToastDescription", By = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ p($.div, { ...r, ref: t });
  }
);
By.displayName = wk;
var Uy = "ToastAction", Wy = d.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ p(Gy, { altText: n, asChild: !0, children: /* @__PURE__ */ p(zl, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Uy}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Wy.displayName = Uy;
var Hy = "ToastClose", zl = d.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = vk(Hy, n);
    return /* @__PURE__ */ p(Gy, { asChild: !0, children: /* @__PURE__ */ p(
      $.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: M(e.onClick, o.onClose)
      }
    ) });
  }
);
zl.displayName = Hy;
var Gy = d.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ p(
    $.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function jy(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), Sk(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", s = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (s) {
          const a = r.dataset.radixToastAnnounceAlt;
          a && t.push(a);
        } else
          t.push(...jy(r));
    }
  }), t;
}
function Yr(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, s = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? pi(o, s) : o.dispatchEvent(s);
}
var md = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), s = r > o;
  return t === "left" || t === "right" ? s && r > n : !s && o > n;
};
function xk(e = () => {
}) {
  const t = de(e);
  me(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function Sk(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Ck(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ha(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var Ak = ky, Ky = Ly, zy = Fy, Yy = $y, Xy = By, qy = Wy, Zy = zl;
const Ek = Ak, Jy = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ky,
  {
    ref: n,
    className: N(
      "fixed top-0 z-[9999] flex max-h-dvh w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px] safe-top sm:safe-bottom",
      e
    ),
    ...t,
    translate: "no"
  }
));
Jy.displayName = Ky.displayName;
const Nk = wn(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border border-border bg-background text-foreground",
        destructive: "border border-red-500/50 bg-red-50 text-red-800 dark:border-red-800/20 dark:bg-red-950/50 dark:text-red-200",
        success: "border border-green-500/50 bg-green-50 text-green-800 dark:border-green-800/20 dark:bg-green-950/50 dark:text-green-200",
        warning: "border border-amber-500/50 bg-amber-50 text-amber-800 dark:border-amber-800/20 dark:bg-amber-950/50 dark:text-amber-200",
        info: "border border-blue-500/50 bg-blue-50 text-blue-800 dark:border-blue-800/20 dark:bg-blue-950/50 dark:text-blue-200",
        primary: "border border-primary/50 bg-primary/10 text-primary dark:border-primary/20 dark:bg-primary/20 dark:text-primary-foreground",
        secondary: "border border-secondary/50 bg-secondary/10 text-secondary dark:border-secondary/20 dark:bg-secondary/20 dark:text-secondary-foreground",
        muted: "border border-border bg-muted text-muted-foreground",
        accent: "border border-accent/50 bg-accent/10 text-accent-foreground dark:border-accent/20 dark:bg-accent/20",
        highlight: "border-l-4 border-l-blue-500 border-y border-r border-border bg-background text-foreground pl-5"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Qy = d.forwardRef(({ className: e, variant: t, ...n }, r) => /* @__PURE__ */ p(
  zy,
  {
    ref: r,
    className: N(Nk({ variant: t }), e),
    ...n
  }
));
Qy.displayName = zy.displayName;
const Tk = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  qy,
  {
    ref: n,
    className: N(
      "inline-flex h-11 shrink-0 items-center justify-center rounded-md border border-border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-accent focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-destructive/40 group-[.destructive]:hover:border-red-500/30 group-[.destructive]:hover:bg-red-500 group-[.destructive]:hover:text-white group-[.destructive]:focus:ring-red-500",
      e
    ),
    ...t
  }
));
Tk.displayName = qy.displayName;
const eb = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Zy,
  {
    ref: n,
    className: N(
      "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
      e
    ),
    "toast-close": "",
    ...t,
    children: /* @__PURE__ */ p(Xo, { className: "h-4 w-4" })
  }
));
eb.displayName = Zy.displayName;
const tb = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Yy,
  {
    ref: n,
    className: N("text-sm font-semibold", e),
    ...t
  }
));
tb.displayName = Yy.displayName;
const nb = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Xy,
  {
    ref: n,
    className: N("text-sm opacity-90", e),
    ...t
  }
));
nb.displayName = Xy.displayName;
function yL() {
  const { toasts: e } = G0();
  return /* @__PURE__ */ O(Ek, { duration: 3e3, children: [
    e.map(function({ id: t, title: n, description: r, action: o, icon: s, ...a }) {
      return /* @__PURE__ */ O(Qy, { ...a, children: [
        /* @__PURE__ */ O("div", { className: "flex gap-3", children: [
          s && /* @__PURE__ */ p("div", { className: "flex-shrink-0 self-start mt-1", children: s }),
          /* @__PURE__ */ O("div", { className: "grid gap-1", children: [
            n && /* @__PURE__ */ p(tb, { children: n }),
            r && /* @__PURE__ */ p(nb, { children: r })
          ] })
        ] }),
        o,
        /* @__PURE__ */ p(eb, {})
      ] }, t);
    }),
    /* @__PURE__ */ p(Jy, {})
  ] });
}
var [xs] = we("Tooltip", [
  ot
]), Ss = ot(), rb = "TooltipProvider", Rk = 700, ni = "tooltip.open", [Pk, Yl] = xs(rb), ob = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: n = Rk,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: s
  } = e, a = d.useRef(!0), i = d.useRef(!1), l = d.useRef(0);
  return d.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ p(
    Pk,
    {
      scope: t,
      isOpenDelayedRef: a,
      delayDuration: n,
      onOpen: d.useCallback(() => {
        window.clearTimeout(l.current), a.current = !1;
      }, []),
      onClose: d.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => a.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: i,
      onPointerInTransitChange: d.useCallback((c) => {
        i.current = c;
      }, []),
      disableHoverableContent: o,
      children: s
    }
  );
};
ob.displayName = rb;
var dr = "Tooltip", [_k, Cs] = xs(dr), sb = (e) => {
  const {
    __scopeTooltip: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    disableHoverableContent: a,
    delayDuration: i
  } = e, l = Yl(dr, e.__scopeTooltip), c = Ss(t), [u, f] = d.useState(null), h = ve(), m = d.useRef(0), g = a ?? l.disableHoverableContent, v = i ?? l.delayDuration, y = d.useRef(!1), [b, w] = Pe({
    prop: r,
    defaultProp: o ?? !1,
    onChange: (A) => {
      A ? (l.onOpen(), document.dispatchEvent(new CustomEvent(ni))) : l.onClose(), s == null || s(A);
    },
    caller: dr
  }), x = d.useMemo(() => b ? y.current ? "delayed-open" : "instant-open" : "closed", [b]), S = d.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, y.current = !1, w(!0);
  }, [w]), C = d.useCallback(() => {
    window.clearTimeout(m.current), m.current = 0, w(!1);
  }, [w]), E = d.useCallback(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      y.current = !0, w(!0), m.current = 0;
    }, v);
  }, [v, w]);
  return d.useEffect(() => () => {
    m.current && (window.clearTimeout(m.current), m.current = 0);
  }, []), /* @__PURE__ */ p(An, { ...c, children: /* @__PURE__ */ p(
    _k,
    {
      scope: t,
      contentId: h,
      open: b,
      stateAttribute: x,
      trigger: u,
      onTriggerChange: f,
      onTriggerEnter: d.useCallback(() => {
        l.isOpenDelayedRef.current ? E() : S();
      }, [l.isOpenDelayedRef, E, S]),
      onTriggerLeave: d.useCallback(() => {
        g ? C() : (window.clearTimeout(m.current), m.current = 0);
      }, [C, g]),
      onOpen: S,
      onClose: C,
      disableHoverableContent: g,
      children: n
    }
  ) });
};
sb.displayName = dr;
var ri = "TooltipTrigger", ab = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Cs(ri, n), s = Yl(ri, n), a = Ss(n), i = d.useRef(null), l = K(t, i, o.onTriggerChange), c = d.useRef(!1), u = d.useRef(!1), f = d.useCallback(() => c.current = !1, []);
    return d.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ p(En, { asChild: !0, ...a, children: /* @__PURE__ */ p(
      $.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: M(e.onPointerMove, (h) => {
          h.pointerType !== "touch" && !u.current && !s.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: M(e.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: M(e.onPointerDown, () => {
          o.open && o.onClose(), c.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: M(e.onFocus, () => {
          c.current || o.onOpen();
        }),
        onBlur: M(e.onBlur, o.onClose),
        onClick: M(e.onClick, o.onClose)
      }
    ) });
  }
);
ab.displayName = ri;
var Mk = "TooltipPortal", [bL, Ik] = xs(Mk, {
  forceMount: void 0
}), yn = "TooltipContent", ib = d.forwardRef(
  (e, t) => {
    const n = Ik(yn, e.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...s } = e, a = Cs(yn, e.__scopeTooltip);
    return /* @__PURE__ */ p(ye, { present: r || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ p(lb, { side: o, ...s, ref: t }) : /* @__PURE__ */ p(Dk, { side: o, ...s, ref: t }) });
  }
), Dk = d.forwardRef((e, t) => {
  const n = Cs(yn, e.__scopeTooltip), r = Yl(yn, e.__scopeTooltip), o = d.useRef(null), s = K(t, o), [a, i] = d.useState(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: f } = r, h = d.useCallback(() => {
    i(null), f(!1);
  }, [f]), m = d.useCallback(
    (g, v) => {
      const y = g.currentTarget, b = { x: g.clientX, y: g.clientY }, w = Fk(b, y.getBoundingClientRect()), x = $k(b, w), S = Bk(v.getBoundingClientRect()), C = Wk([...x, ...S]);
      i(C), f(!0);
    },
    [f]
  );
  return d.useEffect(() => () => h(), [h]), d.useEffect(() => {
    if (l && u) {
      const g = (y) => m(y, u), v = (y) => m(y, l);
      return l.addEventListener("pointerleave", g), u.addEventListener("pointerleave", v), () => {
        l.removeEventListener("pointerleave", g), u.removeEventListener("pointerleave", v);
      };
    }
  }, [l, u, m, h]), d.useEffect(() => {
    if (a) {
      const g = (v) => {
        const y = v.target, b = { x: v.clientX, y: v.clientY }, w = (l == null ? void 0 : l.contains(y)) || (u == null ? void 0 : u.contains(y)), x = !Uk(b, a);
        w ? h() : x && (h(), c());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [l, u, a, c, h]), /* @__PURE__ */ p(lb, { ...e, ref: s });
}), [kk, Ok] = xs(dr, { isInside: !1 }), Lk = /* @__PURE__ */ Fd("TooltipContent"), lb = d.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: n,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      ...i
    } = e, l = Cs(yn, n), c = Ss(n), { onClose: u } = l;
    return d.useEffect(() => (document.addEventListener(ni, u), () => document.removeEventListener(ni, u)), [u]), d.useEffect(() => {
      if (l.trigger) {
        const f = (h) => {
          const m = h.target;
          m != null && m.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ p(
      Rt,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: s,
        onPointerDownOutside: a,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ O(
          mr,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...i,
            ref: t,
            style: {
              ...i.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ p(Lk, { children: r }),
              /* @__PURE__ */ p(kk, { scope: n, isInside: !0, children: /* @__PURE__ */ p(QI, { id: l.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
ib.displayName = yn;
var cb = "TooltipArrow", Vk = d.forwardRef(
  (e, t) => {
    const { __scopeTooltip: n, ...r } = e, o = Ss(n);
    return Ok(
      cb,
      n
    ).isInside ? null : /* @__PURE__ */ p(vr, { ...o, ...r, ref: t });
  }
);
Vk.displayName = cb;
function Fk(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), s = Math.abs(t.left - e.x);
  switch (Math.min(n, r, o, s)) {
    case s:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function $k(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push(
        { x: e.x - n, y: e.y + n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x + n, y: e.y - n }
      );
      break;
    case "left":
      r.push(
        { x: e.x + n, y: e.y - n },
        { x: e.x + n, y: e.y + n }
      );
      break;
    case "right":
      r.push(
        { x: e.x - n, y: e.y - n },
        { x: e.x - n, y: e.y + n }
      );
      break;
  }
  return r;
}
function Bk(e) {
  const { top: t, right: n, bottom: r, left: o } = e;
  return [
    { x: o, y: t },
    { x: n, y: t },
    { x: n, y: r },
    { x: o, y: r }
  ];
}
function Uk(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let s = 0, a = t.length - 1; s < t.length; a = s++) {
    const i = t[s], l = t[a], c = i.x, u = i.y, f = l.x, h = l.y;
    u > r != h > r && n < (f - c) * (r - u) / (h - u) + c && (o = !o);
  }
  return o;
}
function Wk(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), Hk(t);
}
function Hk(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const s = t[t.length - 1], a = t[t.length - 2];
      if ((s.x - a.x) * (o.y - a.y) >= (s.y - a.y) * (o.x - a.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const s = n[n.length - 1], a = n[n.length - 2];
      if ((s.x - a.x) * (o.y - a.y) >= (s.y - a.y) * (o.x - a.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
var Gk = ob, jk = sb, Kk = ab, ub = ib;
const db = Gk, fb = jk, pb = Kk, Xl = d.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ p(
  ub,
  {
    ref: r,
    sideOffset: t,
    className: N(
      "z-[100] overflow-hidden rounded-md border border-border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n,
    translate: "no"
  }
));
Xl.displayName = ub.displayName;
const wL = ({
  children: e,
  content: t,
  side: n = "top",
  align: r = "center",
  delayDuration: o = 300,
  className: s
}) => /* @__PURE__ */ p(db, { children: /* @__PURE__ */ O(fb, { delayDuration: o, children: [
  /* @__PURE__ */ p(pb, { asChild: !0, children: e }),
  /* @__PURE__ */ p(Xl, { side: n, align: r, className: s, children: t })
] }) });
function xL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p(
    "h1",
    {
      className: N("font-nexa text-h1 tracking-tight", t),
      ...n,
      children: e
    }
  );
}
function SL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p(
    "h2",
    {
      className: N("font-nexa text-h2 tracking-tight", t),
      ...n,
      children: e
    }
  );
}
function CL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p(
    "h3",
    {
      className: N("font-nexa text-h3 tracking-tight", t),
      ...n,
      children: e
    }
  );
}
function AL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p(
    "h4",
    {
      className: N("font-nexa text-h4 tracking-tight", t),
      ...n,
      children: e
    }
  );
}
function EL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p("p", { className: N("font-poppins text-base leading-7", t), ...n, children: e });
}
function NL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p(
    "p",
    {
      className: N("font-poppins text-xl text-muted-foreground", t),
      ...n,
      children: e
    }
  );
}
function TL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p(
    "p",
    {
      className: N("font-poppins text-lg font-semibold", t),
      ...n,
      children: e
    }
  );
}
function RL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p(
    "p",
    {
      className: N("font-poppins text-sm font-medium leading-none", t),
      ...n,
      children: e
    }
  );
}
function PL({ children: e, className: t, ...n }) {
  return /* @__PURE__ */ p(
    "p",
    {
      className: N("font-poppins text-sm text-muted-foreground", t),
      ...n,
      children: e
    }
  );
}
var ma, As = "HoverCard", [hb] = we(As, [
  ot
]), Es = ot(), [zk, ql] = hb(As), mb = (e) => {
  const {
    __scopeHoverCard: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    openDelay: a = 700,
    closeDelay: i = 300
  } = e, l = Es(t), c = d.useRef(0), u = d.useRef(0), f = d.useRef(!1), h = d.useRef(!1), [m, g] = Pe({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: As
  }), v = d.useCallback(() => {
    clearTimeout(u.current), c.current = window.setTimeout(() => g(!0), a);
  }, [a, g]), y = d.useCallback(() => {
    clearTimeout(c.current), !f.current && !h.current && (u.current = window.setTimeout(() => g(!1), i));
  }, [i, g]), b = d.useCallback(() => g(!1), [g]);
  return d.useEffect(() => () => {
    clearTimeout(c.current), clearTimeout(u.current);
  }, []), /* @__PURE__ */ p(
    zk,
    {
      scope: t,
      open: m,
      onOpenChange: g,
      onOpen: v,
      onClose: y,
      onDismiss: b,
      hasSelectionRef: f,
      isPointerDownOnContentRef: h,
      children: /* @__PURE__ */ p(An, { ...l, children: n })
    }
  );
};
mb.displayName = As;
var vb = "HoverCardTrigger", gb = d.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = ql(vb, n), s = Es(n);
    return /* @__PURE__ */ p(En, { asChild: !0, ...s, children: /* @__PURE__ */ p(
      $.a,
      {
        "data-state": o.open ? "open" : "closed",
        ...r,
        ref: t,
        onPointerEnter: M(e.onPointerEnter, Oo(o.onOpen)),
        onPointerLeave: M(e.onPointerLeave, Oo(o.onClose)),
        onFocus: M(e.onFocus, o.onOpen),
        onBlur: M(e.onBlur, o.onClose),
        onTouchStart: M(e.onTouchStart, (a) => a.preventDefault())
      }
    ) });
  }
);
gb.displayName = vb;
var Yk = "HoverCardPortal", [_L, Xk] = hb(Yk, {
  forceMount: void 0
}), ko = "HoverCardContent", yb = d.forwardRef(
  (e, t) => {
    const n = Xk(ko, e.__scopeHoverCard), { forceMount: r = n.forceMount, ...o } = e, s = ql(ko, e.__scopeHoverCard);
    return /* @__PURE__ */ p(ye, { present: r || s.open, children: /* @__PURE__ */ p(
      qk,
      {
        "data-state": s.open ? "open" : "closed",
        ...o,
        onPointerEnter: M(e.onPointerEnter, Oo(s.onOpen)),
        onPointerLeave: M(e.onPointerLeave, Oo(s.onClose)),
        ref: t
      }
    ) });
  }
);
yb.displayName = ko;
var qk = d.forwardRef((e, t) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: r,
    onPointerDownOutside: o,
    onFocusOutside: s,
    onInteractOutside: a,
    ...i
  } = e, l = ql(ko, n), c = Es(n), u = d.useRef(null), f = K(t, u), [h, m] = d.useState(!1);
  return d.useEffect(() => {
    if (h) {
      const g = document.body;
      return ma = g.style.userSelect || g.style.webkitUserSelect, g.style.userSelect = "none", g.style.webkitUserSelect = "none", () => {
        g.style.userSelect = ma, g.style.webkitUserSelect = ma;
      };
    }
  }, [h]), d.useEffect(() => {
    if (u.current) {
      const g = () => {
        m(!1), l.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var y;
          ((y = document.getSelection()) == null ? void 0 : y.toString()) !== "" && (l.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", g), () => {
        document.removeEventListener("pointerup", g), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [l.isPointerDownOnContentRef, l.hasSelectionRef]), d.useEffect(() => {
    u.current && Qk(u.current).forEach((v) => v.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ p(
    Rt,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: a,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: M(s, (g) => {
        g.preventDefault();
      }),
      onDismiss: l.onDismiss,
      children: /* @__PURE__ */ p(
        mr,
        {
          ...c,
          ...i,
          onPointerDown: M(i.onPointerDown, (g) => {
            g.currentTarget.contains(g.target) && m(!0), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !0;
          }),
          ref: f,
          style: {
            ...i.style,
            userSelect: h ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: h ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), Zk = "HoverCardArrow", Jk = d.forwardRef(
  (e, t) => {
    const { __scopeHoverCard: n, ...r } = e, o = Es(n);
    return /* @__PURE__ */ p(vr, { ...o, ...r, ref: t });
  }
);
Jk.displayName = Zk;
function Oo(e) {
  return (t) => t.pointerType === "touch" ? void 0 : e();
}
function Qk(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
var eO = mb, tO = gb, bb = yb;
const ML = eO, IL = tO, nO = d.forwardRef(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ p(
  bb,
  {
    ref: o,
    align: t,
    sideOffset: n,
    className: N(
      "z-[100] w-64 rounded-md border border-border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...r,
    translate: "no"
  }
));
nO.displayName = bb.displayName;
var Ns = "Tabs", [rO] = we(Ns, [
  Tn
]), wb = Tn(), [oO, Zl] = rO(Ns), xb = d.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: r,
      onValueChange: o,
      defaultValue: s,
      orientation: a = "horizontal",
      dir: i,
      activationMode: l = "automatic",
      ...c
    } = e, u = xn(i), [f, h] = Pe({
      prop: r,
      onChange: o,
      defaultProp: s ?? "",
      caller: Ns
    });
    return /* @__PURE__ */ p(
      oO,
      {
        scope: n,
        baseId: ve(),
        value: f,
        onValueChange: h,
        orientation: a,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ p(
          $.div,
          {
            dir: u,
            "data-orientation": a,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
xb.displayName = Ns;
var Sb = "TabsList", Cb = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: r = !0, ...o } = e, s = Zl(Sb, n), a = wb(n);
    return /* @__PURE__ */ p(
      Si,
      {
        asChild: !0,
        ...a,
        orientation: s.orientation,
        dir: s.dir,
        loop: r,
        children: /* @__PURE__ */ p(
          $.div,
          {
            role: "tablist",
            "aria-orientation": s.orientation,
            ...o,
            ref: t
          }
        )
      }
    );
  }
);
Cb.displayName = Sb;
var Ab = "TabsTrigger", Eb = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, disabled: o = !1, ...s } = e, a = Zl(Ab, n), i = wb(n), l = Rb(a.baseId, r), c = Pb(a.baseId, r), u = r === a.value;
    return /* @__PURE__ */ p(
      Ci,
      {
        asChild: !0,
        ...i,
        focusable: !o,
        active: u,
        children: /* @__PURE__ */ p(
          $.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: l,
            ...s,
            ref: t,
            onMouseDown: M(e.onMouseDown, (f) => {
              !o && f.button === 0 && f.ctrlKey === !1 ? a.onValueChange(r) : f.preventDefault();
            }),
            onKeyDown: M(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && a.onValueChange(r);
            }),
            onFocus: M(e.onFocus, () => {
              const f = a.activationMode !== "manual";
              !u && !o && f && a.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
Eb.displayName = Ab;
var Nb = "TabsContent", Tb = d.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: r, forceMount: o, children: s, ...a } = e, i = Zl(Nb, n), l = Rb(i.baseId, r), c = Pb(i.baseId, r), u = r === i.value, f = d.useRef(u);
    return d.useEffect(() => {
      const h = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ p(ye, { present: o || u, children: ({ present: h }) => /* @__PURE__ */ p(
      $.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": i.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: c,
        tabIndex: 0,
        ...a,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: h && s
      }
    ) });
  }
);
Tb.displayName = Nb;
function Rb(e, t) {
  return `${e}-trigger-${t}`;
}
function Pb(e, t) {
  return `${e}-content-${t}`;
}
var sO = xb, _b = Cb, Mb = Eb, Ib = Tb;
const DL = sO, aO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  _b,
  {
    ref: n,
    className: N(
      "inline-flex h-10 items-center justify-center rounded-md bg-neutral-100 p-1 text-neutral-500 dark:bg-neutral-800 dark:text-neutral-400",
      e
    ),
    ...t
  }
));
aO.displayName = _b.displayName;
const iO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Mb,
  {
    ref: n,
    className: N(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white data-[state=active]:text-neutral-950 data-[state=active]:shadow-sm dark:ring-offset-neutral-950 dark:focus-visible:ring-neutral-300 dark:data-[state=active]:bg-neutral-950 dark:data-[state=active]:text-neutral-50",
      e
    ),
    ...t
  }
));
iO.displayName = Mb.displayName;
const lO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ib,
  {
    ref: n,
    className: N(
      "mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neutral-950 focus-visible:ring-offset-2 dark:ring-offset-neutral-950 dark:focus-visible:ring-neutral-300",
      e
    ),
    ...t
  }
));
lO.displayName = Ib.displayName;
const cO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ p(
  "table",
  {
    ref: n,
    className: N("w-full caption-bottom text-sm", e),
    ...t
  }
) }));
cO.displayName = "Table";
const uO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p("thead", { ref: n, className: N("[&_tr]:border-b", e), ...t }));
uO.displayName = "TableHeader";
const dO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "tbody",
  {
    ref: n,
    className: N("[&_tr:last-child]:border-0", e),
    ...t
  }
));
dO.displayName = "TableBody";
const fO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "tfoot",
  {
    ref: n,
    className: N(
      "border-t bg-neutral-100/50 font-medium [&>tr]:last:border-b-0 dark:bg-neutral-800/50",
      e
    ),
    ...t
  }
));
fO.displayName = "TableFooter";
const pO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "tr",
  {
    ref: n,
    className: N(
      "border-b transition-colors hover:bg-neutral-100/50 data-[state=selected]:bg-neutral-100 dark:hover:bg-neutral-800/50 dark:data-[state=selected]:bg-neutral-800",
      e
    ),
    ...t
  }
));
pO.displayName = "TableRow";
const hO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "th",
  {
    ref: n,
    className: N(
      "h-12 px-4 text-left align-middle font-medium text-neutral-500 [&:has([role=checkbox])]:pr-0 dark:text-neutral-400",
      e
    ),
    ...t
  }
));
hO.displayName = "TableHead";
const mO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "td",
  {
    ref: n,
    className: N("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
    ...t
  }
));
mO.displayName = "TableCell";
const vO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "caption",
  {
    ref: n,
    className: N("mt-4 text-sm text-neutral-500 dark:text-neutral-400", e),
    ...t
  }
));
vO.displayName = "TableCaption";
const gO = ({ className: e, ...t }) => /* @__PURE__ */ p(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: N("mx-auto flex w-full justify-center", e),
    ...t
  }
);
gO.displayName = "Pagination";
const yO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  "ul",
  {
    ref: n,
    className: N("flex flex-row items-center gap-1", e),
    ...t
  }
));
yO.displayName = "PaginationContent";
const bO = d.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p("li", { ref: n, className: N("", e), ...t }));
bO.displayName = "PaginationItem";
const Jl = ({
  className: e,
  isActive: t,
  disabled: n,
  size: r = "icon",
  ...o
}) => n ? /* @__PURE__ */ p(
  "div",
  {
    className: N(
      Bt({
        variant: "ghost",
        size: r
      }),
      "pointer-events-none opacity-50",
      e
    ),
    children: o.children
  }
) : /* @__PURE__ */ p(
  "a",
  {
    "aria-current": t ? "page" : void 0,
    className: N(
      Bt({
        variant: t ? "outline" : "ghost",
        size: r
      }),
      e
    ),
    ...o
  }
);
Jl.displayName = "PaginationLink";
const wO = ({
  className: e,
  label: t = "Previous",
  ...n
}) => /* @__PURE__ */ O(
  Jl,
  {
    "aria-label": "Go to previous page",
    size: "default",
    className: N("gap-1 pl-2.5", e),
    ...n,
    children: [
      /* @__PURE__ */ p(Ap, { className: "h-4 w-4" }),
      /* @__PURE__ */ p("span", { children: t })
    ]
  }
);
wO.displayName = "PaginationPrevious";
const xO = ({
  className: e,
  label: t = "Next",
  ...n
}) => /* @__PURE__ */ O(
  Jl,
  {
    "aria-label": "Go to next page",
    size: "default",
    className: N("gap-1 pr-2.5", e),
    ...n,
    children: [
      /* @__PURE__ */ p("span", { children: t }),
      /* @__PURE__ */ p(Ii, { className: "h-4 w-4" })
    ]
  }
);
xO.displayName = "PaginationNext";
const SO = ({
  className: e,
  ...t
}) => /* @__PURE__ */ O(
  "span",
  {
    "aria-hidden": !0,
    className: N("flex h-9 w-9 items-center justify-center", e),
    ...t,
    children: [
      /* @__PURE__ */ p(JC, { className: "h-4 w-4" }),
      /* @__PURE__ */ p("span", { className: "sr-only", children: "More pages" })
    ]
  }
);
SO.displayName = "PaginationEllipsis";
const kL = ({
  status: e,
  className: t,
  showIcon: n = !0,
  showTooltip: r = !0,
  size: o = "md"
}) => {
  const { t: s } = Vo(), a = (m) => ({
    SENT: {
      color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
      icon: oA,
      label: s("forms.status.sent.label")
    },
    ACCEPTED: {
      color: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200",
      icon: qC,
      label: s("forms.status.accepted.label")
    },
    REJECTED: {
      color: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
      icon: ZC,
      label: s("forms.status.rejected.label")
    },
    COMPLETED: {
      color: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
      icon: vo,
      label: s("forms.status.completed.label")
    },
    // Waiting on the community administration. A "waiting" look on purpose — never the
    // colour of ACCEPTED: the booking is not cleared for the gate yet.
    PENDING_COMMUNITY: {
      color: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200",
      icon: QC,
      label: s("forms.status.pending_community.label")
    },
    VALIDATED: {
      color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
      icon: sA,
      label: s("forms.status.validated.label")
    },
    INVALIDATED: {
      color: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
      icon: aA,
      label: s("forms.status.invalidated.label")
    },
    CHECKED_OUT: {
      color: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
      icon: tA,
      label: s("forms.status.checked_out.label")
    }
  })[m], i = {
    sm: "text-xs px-2 py-1",
    md: "text-sm px-2.5 py-1.5",
    lg: "text-base px-3 py-2"
  }, l = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5"
  }, c = a(e), u = c ?? {
    color: "bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200",
    icon: vo,
    label: String(e)
  }, f = u.icon, h = /* @__PURE__ */ O(
    "div",
    {
      className: N(
        "inline-flex items-center gap-1.5 rounded-full font-medium",
        i[o],
        u.color,
        t
      ),
      children: [
        n && /* @__PURE__ */ p(f, { className: N(l[o], "flex-shrink-0") }),
        /* @__PURE__ */ p("span", { className: "truncate", children: u.label })
      ]
    }
  );
  return r && c ? /* @__PURE__ */ p(db, { delayDuration: 300, children: /* @__PURE__ */ O(fb, { children: [
    /* @__PURE__ */ p(pb, { asChild: !0, children: h }),
    /* @__PURE__ */ p(Xl, { children: /* @__PURE__ */ p("p", { children: s(`forms.status.${e.toLowerCase()}.description`) }) })
  ] }) }) : h;
};
function CO(e) {
  const t = Zb(e, "yyyy-MM-dd", /* @__PURE__ */ new Date());
  return Ad(t) ? t : null;
}
const AO = ({
  value: e,
  onChange: t,
  placeholder: n = "yyyy-MM-dd",
  minYear: r = (/* @__PURE__ */ new Date()).getFullYear() - 5,
  maxYear: o = (/* @__PURE__ */ new Date()).getFullYear() + 5,
  maxDate: s,
  minDate: a,
  disabled: i = !1,
  className: l
}) => {
  const c = dn(() => CO(e), [e]), [u, f] = Ge(!1), h = (g) => {
    t(g ? be(g, "yyyy-MM-dd") : ""), f(!1);
  }, m = dn(() => {
    const g = [];
    if (a) {
      const v = va(a);
      g.push((y) => y < v);
    }
    if (s) {
      const v = qb(s);
      g.push((y) => y > v);
    }
    if (g.length !== 0)
      return g.length === 1 ? g[0] : (v) => g.some((y) => y(v));
  }, [a, s]);
  return /* @__PURE__ */ p("div", { className: N("relative", l), children: /* @__PURE__ */ O(tg, { open: i ? !1 : u, onOpenChange: i ? void 0 : f, children: [
    /* @__PURE__ */ p(ng, { asChild: !0, children: /* @__PURE__ */ O(
      "button",
      {
        type: "button",
        disabled: i,
        className: N(
          "relative flex items-center w-full",
          "rounded-md border border-input bg-background font-poppins",
          "pl-9 pr-3 py-2 text-base md:text-sm text-left",
          "shadow-sm focus:outline-none focus:ring-1 focus:ring-primary",
          "focus:border-primary transition-colors duration-200 ease-in-out",
          "dark:text-foreground",
          i ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        ),
        children: [
          /* @__PURE__ */ p("div", { className: "absolute left-3 pointer-events-none text-primary", children: /* @__PURE__ */ p(mo, { className: "h-4 w-4" }) }),
          /* @__PURE__ */ p("span", { className: N(!c && "text-muted-foreground"), children: c ? be(c, "yyyy-MM-dd") : n })
        ]
      }
    ) }),
    /* @__PURE__ */ p(Ll, { className: "w-auto p-0 z-[200]", align: "start", children: /* @__PURE__ */ p("div", { onPointerDown: (g) => g.stopPropagation(), children: /* @__PURE__ */ p(
      cv,
      {
        mode: "single",
        selected: c ?? void 0,
        onSelect: h,
        disabled: m,
        defaultMonth: c ?? void 0,
        fromYear: r,
        toYear: o,
        captionLayout: "dropdown-buttons",
        classNames: {
          caption_label: "sr-only",
          caption_dropdowns: "flex items-center gap-1",
          vhidden: "sr-only",
          dropdown: "bg-background border border-input rounded-md text-sm px-2 py-1 focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer"
        },
        initialFocus: !0
      }
    ) }) })
  ] }) });
}, OL = ({
  value: e,
  onChange: t,
  placeholder: n = Fn.DISPLAY,
  disabled: r = !1,
  minDate: o,
  maxDate: s,
  className: a
}) => {
  if (r0("(max-width: 639px)")) {
    const l = Ps.parseAnyFormat(e), c = l ? be(l, Fn.API) : "";
    return /* @__PURE__ */ O("div", { className: N("relative", a), children: [
      /* @__PURE__ */ p("div", { className: "absolute left-3 top-1/2 -translate-y-1/2 text-primary pointer-events-none", children: /* @__PURE__ */ p(mo, { className: "h-4 w-4" }) }),
      /* @__PURE__ */ p(
        "input",
        {
          type: "date",
          className: N(
            "block w-full rounded-md",
            "border border-input",
            "bg-background font-poppins",
            "pl-9 pr-3 py-2 text-base md:text-sm",
            "shadow-sm focus:outline-none",
            "focus:ring-1 focus:ring-primary",
            "focus:border-primary transition-colors",
            "duration-200 ease-in-out",
            "dark:text-foreground",
            r && "opacity-50 cursor-not-allowed"
          ),
          min: o ? be(o, Fn.API) : void 0,
          max: s ? be(s, Fn.API) : void 0,
          value: c,
          onChange: (u) => {
            const f = u.target.value;
            if (!f) {
              t("");
              return;
            }
            const h = Jb(f);
            Ad(h) && t(be(h, Fn.API));
          },
          disabled: r
        }
      )
    ] });
  }
  return /* @__PURE__ */ p("div", { className: N("relative", a), children: /* @__PURE__ */ p(
    AO,
    {
      value: Ps.toDisplayFormat(e),
      onChange: (l) => t(Ps.toAPIFormat(l)),
      placeholder: n,
      disabled: r,
      minDate: o,
      maxDate: s
    }
  ) });
}, LL = ({
  value: e,
  onChange: t,
  placeholder: n = "HH:mm",
  disabled: r = !1
}) => /* @__PURE__ */ p(
  us,
  {
    type: "time",
    value: e,
    onChange: (o) => t(o.target.value),
    placeholder: n,
    disabled: r,
    className: "w-full rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm focus:outline-none focus:ring-2 focus:ring-primary"
  }
), EO = d.forwardRef(
  ({
    value: e,
    onChange: t,
    onBlur: n,
    min: r = 1,
    max: o,
    disabled: s = !1,
    name: a,
    className: i,
    inputClassName: l,
    "aria-label": c,
    decreaseLabel: u = "Decrease",
    increaseLabel: f = "Increase"
  }, h) => {
    const m = Number.isFinite(e) ? e : r, [g, v] = d.useState(String(m)), y = d.useRef(!1);
    d.useEffect(() => {
      y.current || v(String(Number.isFinite(e) ? e : r));
    }, [e, r]);
    const b = (A) => Math.min(o, Math.max(r, A)), w = (A) => {
      const T = A.target.value;
      if (v(T), T === "") return;
      const I = parseInt(T, 10);
      Number.isNaN(I) || t(I);
    }, x = () => {
      y.current = !0;
    }, S = () => {
      y.current = !1;
      const A = parseInt(g, 10), T = Number.isNaN(A) ? r : b(A);
      v(String(T)), T !== e && t(T), n == null || n();
    }, C = () => {
      const A = b(m - 1);
      v(String(A)), A !== e && t(A);
    }, E = () => {
      const A = b(m + 1);
      v(String(A)), A !== e && t(A);
    };
    return /* @__PURE__ */ O("div", { className: N("flex items-center space-x-1 sm:space-x-2", i), children: [
      /* @__PURE__ */ p(
        Ut,
        {
          type: "button",
          variant: "outline",
          size: "icon",
          className: "h-8 w-8 sm:h-10 sm:w-10 flex-shrink-0",
          disabled: s || m <= r,
          onClick: C,
          "aria-label": u,
          children: "-"
        }
      ),
      /* @__PURE__ */ p("div", { className: "relative w-14 sm:w-20", children: /* @__PURE__ */ p(
        us,
        {
          ref: h,
          type: "number",
          inputMode: "numeric",
          name: a,
          value: g,
          onChange: w,
          onFocus: x,
          onBlur: S,
          min: r,
          max: o,
          disabled: s,
          "aria-label": c,
          className: N("text-center", l)
        }
      ) }),
      /* @__PURE__ */ p(
        Ut,
        {
          type: "button",
          variant: "outline",
          size: "icon",
          className: "h-8 w-8 sm:h-10 sm:w-10 flex-shrink-0",
          disabled: s || m >= o,
          onClick: E,
          "aria-label": f,
          children: "+"
        }
      )
    ] });
  }
);
EO.displayName = "GuestCountStepper";
const VL = ({
  date: e,
  showRelative: t = !0,
  className: n,
  iconSize: r = 14,
  stacked: o = !1
}) => {
  const { i18n: s, t: a } = Vo(), i = Ed(s.language);
  if (!e) return null;
  const l = typeof e == "string" ? o0(e) : e, c = /* @__PURE__ */ new Date(), u = (g) => g.charAt(0).toUpperCase() + g.slice(1), f = be(l, "h:mm a", { locale: i });
  let h, m = !1;
  return t ? Qb(l) ? (h = a("calendar.today"), m = !0) : e0(l) ? (h = a("calendar.tomorrow"), m = !0) : t0(l) ? (h = a("calendar.yesterday"), m = !0) : l > c && l < Ne(c, 7) ? (h = u(be(l, "EEEE", { locale: i })), m = !0) : ba(l, c) ? h = u(be(l, "MMM d", { locale: i })) : h = u(be(l, "MMM d, yyyy", { locale: i })) : h = ba(l, c) ? u(be(l, "MMM d", { locale: i })) : u(be(l, "MMM d, yyyy", { locale: i })), o ? /* @__PURE__ */ O("div", { className: N("flex flex-col", n), children: [
    /* @__PURE__ */ O("div", { className: "flex items-center text-foreground font-medium", children: [
      /* @__PURE__ */ p(mo, { className: "mr-1 opacity-70", size: r }),
      /* @__PURE__ */ p("span", { className: N(m && "text-primary font-semibold"), children: h })
    ] }),
    /* @__PURE__ */ O("div", { className: "flex items-center text-muted-foreground ml-5", children: [
      /* @__PURE__ */ p(vo, { className: "mr-1 opacity-70", size: r - 2 }),
      /* @__PURE__ */ p("span", { children: f })
    ] })
  ] }) : /* @__PURE__ */ O("div", { className: N("flex items-center gap-1.5", n), children: [
    /* @__PURE__ */ O("div", { className: "flex items-center", children: [
      /* @__PURE__ */ p(mo, { className: "mr-1 opacity-70", size: r }),
      /* @__PURE__ */ p("span", { className: N("font-medium", m && "text-primary font-semibold"), children: h })
    ] }),
    /* @__PURE__ */ p("span", { className: "text-muted-foreground", children: "•" }),
    /* @__PURE__ */ O("div", { className: "flex items-center text-muted-foreground", children: [
      /* @__PURE__ */ p(vo, { className: "mr-1 opacity-70", size: r - 2 }),
      /* @__PURE__ */ p("span", { children: f })
    ] })
  ] });
};
function NO({ label: e, name: t, form: n, className: r, type: o = "text", readOnly: s = !1, ...a }, i) {
  const [l, c] = Ge(!1);
  return /* @__PURE__ */ p(
    Wv,
    {
      control: n.control,
      name: t,
      render: ({ field: u }) => /* @__PURE__ */ O(Il, { className: "relative", children: [
        /* @__PURE__ */ p(Dl, { children: /* @__PURE__ */ O("div", { className: "relative", children: [
          /* @__PURE__ */ p(
            "input",
            {
              ...u,
              ...a,
              id: t,
              type: o,
              readOnly: s,
              className: N(
                "block w-full px-0 py-4 text-base bg-transparent border-0 border-b-2",
                "border-gray-300 dark:border-gray-600",
                "appearance-none focus:outline-none focus:ring-0",
                "focus:border-primary dark:focus:border-primary",
                "peer",
                s && "cursor-not-allowed bg-muted/20 text-muted-foreground",
                r
              ),
              placeholder: " ",
              onFocus: (f) => {
                s || c(!0);
              },
              onBlur: (f) => {
                s || (c(!1), u.onBlur());
              },
              ref: i
            }
          ),
          /* @__PURE__ */ p(
            "label",
            {
              htmlFor: t,
              className: N(
                "absolute text-base duration-200 transform -translate-y-4",
                "top-3 origin-[0] peer-focus:text-primary",
                "peer-placeholder-shown:translate-y-0",
                "peer-focus:-translate-y-4",
                "peer-focus:scale-85",
                "text-gray-500 dark:text-gray-400",
                "peer-focus:text-primary dark:peer-focus:text-primary",
                u.value || l ? "-translate-y-4 scale-85" : "",
                s ? "cursor-not-allowed text-muted-foreground" : "cursor-text"
              ),
              children: e
            }
          )
        ] }) }),
        /* @__PURE__ */ p(kl, { className: "text-xs mt-1 absolute" })
      ] })
    }
  );
}
const FL = q.forwardRef(NO), TO = q.forwardRef(({ label: e, name: t, form: n, className: r, ...o }, s) => /* @__PURE__ */ p(
  Wv,
  {
    control: n.control,
    name: t,
    render: ({ field: a }) => /* @__PURE__ */ O(Il, { className: "relative", children: [
      /* @__PURE__ */ p(Dl, { children: /* @__PURE__ */ O("div", { className: "relative", children: [
        /* @__PURE__ */ p(
          us,
          {
            ...a,
            ...o,
            ref: s,
            placeholder: " ",
            className: N(
              // Use a dark bottom border (2px for emphasis) plus smooth focus
              "peer border-0 border-b-2 border-gray-900 bg-transparent px-0 py-2 focus:outline-none focus:border-primary",
              r
            )
          }
        ),
        /* @__PURE__ */ p(
          "label",
          {
            className: `
                  absolute left-0 top-2
                  text-gray-500 transition-all duration-200 pointer-events-none
                  peer-placeholder-shown:top-2 peer-placeholder-shown:text-base
                  peer-focus:top-0 peer-focus:text-xs peer-focus:text-gray-900
                `,
            children: e
          }
        )
      ] }) }),
      /* @__PURE__ */ p(kl, { className: "text-xs mt-1" })
    ] })
  }
));
TO.displayName = "UnderlineInput";
function $L({
  currentImageUrl: e,
  onImageUpload: t,
  onImageRemove: n,
  isLoading: r = !1,
  error: o = null,
  maxSizeMB: s = 5,
  acceptedFileTypes: a = ["image/jpeg", "image/png"],
  className: i,
  imageClassName: l
}) {
  const { t: c } = Vo(), [u, f] = Ge(null), h = s * 1024 * 1024;
  pt(() => () => {
    u && URL.revokeObjectURL(u);
  }, [u]);
  const m = ii(
    (A) => {
      if ((A == null ? void 0 : A.length) > 0) {
        const T = A[0];
        if (!T) return;
        t(T);
        const I = URL.createObjectURL(T);
        f(I);
      }
    },
    [t]
  ), { getRootProps: g, getInputProps: v, isDragActive: y, isDragReject: b, fileRejections: w } = s0({
    onDrop: m,
    accept: a.reduce((A, T) => ({ ...A, [T]: [] }), {}),
    maxSize: h,
    multiple: !1
  }), x = u || e, C = o || (() => {
    if (w.length === 0) return null;
    const A = w[0];
    return A ? A.errors.some((T) => T.code === "file-too-large") ? c("listing.update.image.errorFileSize", { size: s }) : A.errors.some((T) => T.code === "file-invalid-type") ? c("listing.update.image.errorFileType", { types: a.join(", ") }) : c("listing.update.image.errorGeneric") : null;
  })(), E = () => {
    f(null), n && n();
  };
  return /* @__PURE__ */ O("div", { className: N("space-y-4", i), children: [
    C && /* @__PURE__ */ O(_p, { variant: "destructive", className: "text-sm font-poppins", children: [
      /* @__PURE__ */ p(XC, { className: "h-4 w-4 mr-2" }),
      /* @__PURE__ */ p(Mp, { children: C })
    ] }),
    x ? /* @__PURE__ */ O("div", { className: "relative rounded-md overflow-hidden group", children: [
      /* @__PURE__ */ p(
        "img",
        {
          src: x,
          alt: c("listing.update.image.preview"),
          className: N(
            "w-full h-64 object-cover transition-opacity",
            r ? "opacity-50" : "opacity-100",
            l
          )
        }
      ),
      r && /* @__PURE__ */ p("div", { className: "absolute inset-0 flex items-center justify-center bg-black/20", children: /* @__PURE__ */ p(Mc, { className: "h-8 w-8 animate-spin text-white" }) }),
      !r && /* @__PURE__ */ O("div", { className: "absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center gap-4", children: [
        /* @__PURE__ */ O("div", { ...g(), className: "cursor-pointer", children: [
          /* @__PURE__ */ p("input", { ...v() }),
          /* @__PURE__ */ O(Ut, { variant: "outline", size: "sm", className: "bg-white/90 hover:bg-white", children: [
            /* @__PURE__ */ p(iA, { className: "h-4 w-4 mr-2" }),
            c("listing.update.image.change")
          ] })
        ] }),
        /* @__PURE__ */ O(
          Ut,
          {
            variant: "outline",
            size: "sm",
            className: "bg-white/90 hover:bg-white text-destructive hover:text-destructive",
            onClick: E,
            children: [
              /* @__PURE__ */ p(Xo, { className: "h-4 w-4 mr-2" }),
              c("listing.update.image.remove")
            ]
          }
        )
      ] })
    ] }) : /* @__PURE__ */ O(
      "div",
      {
        ...g(),
        className: N(
          "border-2 border-dashed rounded-md p-8 flex flex-col items-center justify-center h-64 cursor-pointer transition-colors",
          y ? "border-primary bg-primary/5" : "border-neutral-300 dark:border-neutral-700",
          b ? "border-destructive bg-destructive/5" : "",
          r ? "opacity-50 cursor-not-allowed" : "",
          "hover:bg-neutral-50 dark:hover:bg-neutral-900"
        ),
        children: [
          /* @__PURE__ */ p("input", { ...v(), disabled: r }),
          r ? /* @__PURE__ */ p(Mc, { className: "h-10 w-10 text-primary animate-spin" }) : /* @__PURE__ */ O(ge, { children: [
            /* @__PURE__ */ p("div", { className: "p-4 rounded-full bg-primary/10 mb-4", children: /* @__PURE__ */ p(eA, { className: "h-8 w-8 text-primary" }) }),
            /* @__PURE__ */ O("div", { className: "text-center space-y-1", children: [
              /* @__PURE__ */ p("p", { className: "font-nexa-heavy text-lg", children: c(y ? "listing.update.image.dropHere" : "listing.update.image.dragDrop") }),
              /* @__PURE__ */ p("p", { className: "text-sm text-muted-foreground font-poppins", children: c("listing.update.image.maxSize", { size: s }) }),
              /* @__PURE__ */ p("p", { className: "text-sm text-primary font-poppins-medium", children: c("listing.update.image.browse") })
            ] })
          ] })
        ]
      }
    )
  ] });
}
const RO = [
  "AFGHANISTAN",
  "ALBANIA",
  "ALGERIA",
  "ANDORRA",
  "ANGOLA",
  "ANTIGUA_AND_BARBUDA",
  "ARGENTINA",
  "ARMENIA",
  "AUSTRALIA",
  "AUSTRIA",
  "AZERBAIJAN",
  "BAHAMAS",
  "BAHRAIN",
  "BANGLADESH",
  "BARBADOS",
  "BELARUS",
  "BELGIUM",
  "BELIZE",
  "BENIN",
  "BHUTAN",
  "BOLIVIA",
  "BOSNIA_AND_HERZEGOVINA",
  "BOTSWANA",
  "BRAZIL",
  "BRUNEI",
  "BULGARIA",
  "BURKINA_FASO",
  "BURUNDI",
  "CAPE_VERDE",
  "CAMBODIA",
  "CAMEROON",
  "CANADA",
  "CENTRAL_AFRICAN_REPUBLIC",
  "CHAD",
  "CHILE",
  "CHINA",
  "COLOMBIA",
  "COMOROS",
  "CONGO",
  "COSTA_RICA",
  "CROATIA",
  "CUBA",
  "CYPRUS",
  "CZECH_REPUBLIC",
  "DENMARK",
  "DJIBOUTI",
  "DOMINICA",
  "DOMINICAN_REPUBLIC",
  "ECUADOR",
  "EGYPT",
  "EL_SALVADOR",
  "EQUATORIAL_GUINEA",
  "ERITREA",
  "ESTONIA",
  "ESWATINI",
  "ETHIOPIA",
  "FIJI",
  "FINLAND",
  "FRANCE",
  "GABON",
  "GAMBIA",
  "GEORGIA",
  "GERMANY",
  "GHANA",
  "GREECE",
  "GRENADA",
  "GUATEMALA",
  "GUINEA",
  "GUINEA_BISSAU",
  "GUYANA",
  "HAITI",
  "HONDURAS",
  "HUNGARY",
  "ICELAND",
  "INDIA",
  "INDONESIA",
  "IRAN",
  "IRAQ",
  "IRELAND",
  "ISRAEL",
  "ITALY",
  "IVORY_COAST",
  "JAMAICA",
  "JAPAN",
  "JORDAN",
  "KAZAKHSTAN",
  "KENYA",
  "KIRIBATI",
  "KUWAIT",
  "KYRGYZSTAN",
  "LAOS",
  "LATVIA",
  "LEBANON",
  "LESOTHO",
  "LIBERIA",
  "LIBYA",
  "LIECHTENSTEIN",
  "LITHUANIA",
  "LUXEMBOURG",
  "MADAGASCAR",
  "MALAWI",
  "MALAYSIA",
  "MALDIVES",
  "MALI",
  "MALTA",
  "MARSHALL_ISLANDS",
  "MAURITANIA",
  "MAURITIUS",
  "MEXICO",
  "MICRONESIA",
  "MOLDOVA",
  "MONACO",
  "MONGOLIA",
  "MONTENEGRO",
  "MOROCCO",
  "MOZAMBIQUE",
  "MYANMAR",
  "NAMIBIA",
  "NAURU",
  "NEPAL",
  "NETHERLANDS",
  "NEW_ZEALAND",
  "NICARAGUA",
  "NIGER",
  "NIGERIA",
  "NORTH_KOREA",
  "NORTH_MACEDONIA",
  "NORWAY",
  "OMAN",
  "PAKISTAN",
  "PALAU",
  "PALESTINE",
  "PANAMA",
  "PAPUA_NEW_GUINEA",
  "PARAGUAY",
  "PERU",
  "PHILIPPINES",
  "POLAND",
  "PORTUGAL",
  "QATAR",
  "ROMANIA",
  "RUSSIA",
  "RWANDA",
  "SAINT_KITTS_AND_NEVIS",
  "SAINT_LUCIA",
  "SAINT_VINCENT_AND_THE_GRENADINES",
  "SAMOA",
  "SAN_MARINO",
  "SAO_TOME_AND_PRINCIPE",
  "SAUDI_ARABIA",
  "SENEGAL",
  "SERBIA",
  "SEYCHELLES",
  "SIERRA_LEONE",
  "SINGAPORE",
  "SLOVAKIA",
  "SLOVENIA",
  "SOLOMON_ISLANDS",
  "SOMALIA",
  "SOUTH_AFRICA",
  "SOUTH_KOREA",
  "SOUTH_SUDAN",
  "SPAIN",
  "SRI_LANKA",
  "SUDAN",
  "SURINAME",
  "SWEDEN",
  "SWITZERLAND",
  "SYRIA",
  "TAJIKISTAN",
  "TANZANIA",
  "THAILAND",
  "TIMOR_LESTE",
  "TOGO",
  "TONGA",
  "TRINIDAD_AND_TOBAGO",
  "TUNISIA",
  "TURKEY",
  "TURKMENISTAN",
  "TUVALU",
  "UGANDA",
  "UKRAINE",
  "UNITED_ARAB_EMIRATES",
  "UNITED_KINGDOM",
  "UNITED_STATES",
  "URUGUAY",
  "UZBEKISTAN",
  "VANUATU",
  "VATICAN_CITY",
  "VENEZUELA",
  "VIETNAM",
  "YEMEN",
  "ZAMBIA",
  "ZIMBABWE"
], PO = RO.filter((e) => e !== "ECUADOR").sort(), Db = ["ECUADOR", ...PO], _O = {
  AFGHANISTAN: "AF",
  ALBANIA: "AL",
  ALGERIA: "DZ",
  ANDORRA: "AD",
  ANGOLA: "AO",
  ANTIGUA_AND_BARBUDA: "AG",
  ARGENTINA: "AR",
  ARMENIA: "AM",
  AUSTRALIA: "AU",
  AUSTRIA: "AT",
  AZERBAIJAN: "AZ",
  BAHAMAS: "BS",
  BAHRAIN: "BH",
  BANGLADESH: "BD",
  BARBADOS: "BB",
  BELARUS: "BY",
  BELGIUM: "BE",
  BELIZE: "BZ",
  BENIN: "BJ",
  BHUTAN: "BT",
  BOLIVIA: "BO",
  BOSNIA_AND_HERZEGOVINA: "BA",
  BOTSWANA: "BW",
  BRAZIL: "BR",
  BRUNEI: "BN",
  BULGARIA: "BG",
  BURKINA_FASO: "BF",
  BURUNDI: "BI",
  CAPE_VERDE: "CV",
  CAMBODIA: "KH",
  CAMEROON: "CM",
  CANADA: "CA",
  CENTRAL_AFRICAN_REPUBLIC: "CF",
  CHAD: "TD",
  CHILE: "CL",
  CHINA: "CN",
  COLOMBIA: "CO",
  COMOROS: "KM",
  CONGO: "CG",
  COSTA_RICA: "CR",
  CROATIA: "HR",
  CUBA: "CU",
  CYPRUS: "CY",
  CZECH_REPUBLIC: "CZ",
  DENMARK: "DK",
  DJIBOUTI: "DJ",
  DOMINICA: "DM",
  DOMINICAN_REPUBLIC: "DO",
  ECUADOR: "EC",
  EGYPT: "EG",
  EL_SALVADOR: "SV",
  EQUATORIAL_GUINEA: "GQ",
  ERITREA: "ER",
  ESTONIA: "EE",
  ESWATINI: "SZ",
  ETHIOPIA: "ET",
  FIJI: "FJ",
  FINLAND: "FI",
  FRANCE: "FR",
  GABON: "GA",
  GAMBIA: "GM",
  GEORGIA: "GE",
  GERMANY: "DE",
  GHANA: "GH",
  GREECE: "GR",
  GRENADA: "GD",
  GUATEMALA: "GT",
  GUINEA: "GN",
  GUINEA_BISSAU: "GW",
  GUYANA: "GY",
  HAITI: "HT",
  HONDURAS: "HN",
  HUNGARY: "HU",
  ICELAND: "IS",
  INDIA: "IN",
  INDONESIA: "ID",
  IRAN: "IR",
  IRAQ: "IQ",
  IRELAND: "IE",
  ISRAEL: "IL",
  ITALY: "IT",
  IVORY_COAST: "CI",
  JAMAICA: "JM",
  JAPAN: "JP",
  JORDAN: "JO",
  KAZAKHSTAN: "KZ",
  KENYA: "KE",
  KIRIBATI: "KI",
  KUWAIT: "KW",
  KYRGYZSTAN: "KG",
  LAOS: "LA",
  LATVIA: "LV",
  LEBANON: "LB",
  LESOTHO: "LS",
  LIBERIA: "LR",
  LIBYA: "LY",
  LIECHTENSTEIN: "LI",
  LITHUANIA: "LT",
  LUXEMBOURG: "LU",
  MADAGASCAR: "MG",
  MALAWI: "MW",
  MALAYSIA: "MY",
  MALDIVES: "MV",
  MALI: "ML",
  MALTA: "MT",
  MARSHALL_ISLANDS: "MH",
  MAURITANIA: "MR",
  MAURITIUS: "MU",
  MEXICO: "MX",
  MICRONESIA: "FM",
  MOLDOVA: "MD",
  MONACO: "MC",
  MONGOLIA: "MN",
  MONTENEGRO: "ME",
  MOROCCO: "MA",
  MOZAMBIQUE: "MZ",
  MYANMAR: "MM",
  NAMIBIA: "NA",
  NAURU: "NR",
  NEPAL: "NP",
  NETHERLANDS: "NL",
  NEW_ZEALAND: "NZ",
  NICARAGUA: "NI",
  NIGER: "NE",
  NIGERIA: "NG",
  NORTH_KOREA: "KP",
  NORTH_MACEDONIA: "MK",
  NORWAY: "NO",
  OMAN: "OM",
  PAKISTAN: "PK",
  PALAU: "PW",
  PALESTINE: "PS",
  PANAMA: "PA",
  PAPUA_NEW_GUINEA: "PG",
  PARAGUAY: "PY",
  PERU: "PE",
  PHILIPPINES: "PH",
  POLAND: "PL",
  PORTUGAL: "PT",
  QATAR: "QA",
  ROMANIA: "RO",
  RUSSIA: "RU",
  RWANDA: "RW",
  SAINT_KITTS_AND_NEVIS: "KN",
  SAINT_LUCIA: "LC",
  SAINT_VINCENT_AND_THE_GRENADINES: "VC",
  SAMOA: "WS",
  SAN_MARINO: "SM",
  SAO_TOME_AND_PRINCIPE: "ST",
  SAUDI_ARABIA: "SA",
  SENEGAL: "SN",
  SERBIA: "RS",
  SEYCHELLES: "SC",
  SIERRA_LEONE: "SL",
  SINGAPORE: "SG",
  SLOVAKIA: "SK",
  SLOVENIA: "SI",
  SOLOMON_ISLANDS: "SB",
  SOMALIA: "SO",
  SOUTH_AFRICA: "ZA",
  SOUTH_KOREA: "KR",
  SOUTH_SUDAN: "SS",
  SPAIN: "ES",
  SRI_LANKA: "LK",
  SUDAN: "SD",
  SURINAME: "SR",
  SWEDEN: "SE",
  SWITZERLAND: "CH",
  SYRIA: "SY",
  TAJIKISTAN: "TJ",
  TANZANIA: "TZ",
  THAILAND: "TH",
  TIMOR_LESTE: "TL",
  TOGO: "TG",
  TONGA: "TO",
  TRINIDAD_AND_TOBAGO: "TT",
  TUNISIA: "TN",
  TURKEY: "TR",
  TURKMENISTAN: "TM",
  TUVALU: "TV",
  UGANDA: "UG",
  UKRAINE: "UA",
  UNITED_ARAB_EMIRATES: "AE",
  UNITED_KINGDOM: "GB",
  UNITED_STATES: "US",
  URUGUAY: "UY",
  UZBEKISTAN: "UZ",
  VANUATU: "VU",
  VATICAN_CITY: "VA",
  VENEZUELA: "VE",
  VIETNAM: "VN",
  YEMEN: "YE",
  ZAMBIA: "ZM",
  ZIMBABWE: "ZW",
  // CountryApiEnum aliases: a returning originator's `nationality` is seeded from
  // idIssuingCountry (a CountryApiEnum: ECUADOR/USA/CANADA/UK/GERMANY), so the short
  // forms "USA"/"UK" reach nameToIso and must resolve. The COUNTRIES list itself
  // uses UNITED_STATES/UNITED_KINGDOM.
  USA: "US",
  UK: "GB"
}, Ql = (e) => {
  if (e)
    return _O[e.toUpperCase()];
};
function oi(e) {
  return e ? e.split("_").map((t) => t.charAt(0) + t.slice(1).toLowerCase()).join(" ") : "";
}
const MO = ["en", "es", "fr", "de", "it"], IO = {
  // Demonyms and cities, because a guest answering "which country issued your ID?" types what
  // they read off the document: the nationality line, or the place of issue printed on it
  // (Quito, Guayaquil). Without these, "ecuatoriana" finds only Guinea Ecuatorial. "Equador"
  // is the Portuguese/Catalan spelling, common among visitors.
  ECUADOR: ["Ecuatoriano", "Ecuatoriana", "Ecuadorian", "Equador", "Quito", "Guayaquil"],
  UNITED_STATES: ["USA", "EEUU", "EE UU", "America", "Norteamerica"],
  UNITED_KINGDOM: ["UK", "Great Britain", "Gran Bretana", "England", "Inglaterra"],
  UNITED_ARAB_EMIRATES: ["UAE", "EAU", "Emirates"],
  NETHERLANDS: ["Holland", "Holanda"],
  SOUTH_KOREA: ["Korea", "Corea"],
  NORTH_KOREA: ["Korea", "Corea"],
  RUSSIA: ["Russian Federation"],
  VATICAN_CITY: ["Holy See", "Santa Sede"],
  TIMOR_LESTE: ["East Timor", "Timor Oriental"],
  ESWATINI: ["Swaziland"],
  CAPE_VERDE: ["Cabo Verde"],
  IVORY_COAST: ["Cote d Ivoire"],
  MYANMAR: ["Burma", "Birmania"],
  CZECH_REPUBLIC: ["Czechia", "Chequia"],
  TURKEY: ["Turkiye"]
}, Xr = /* @__PURE__ */ new Map();
function kb(e) {
  if (!Xr.has(e))
    try {
      Xr.set(
        e,
        new Intl.DisplayNames([e, "en"], { type: "region" })
      );
    } catch {
      Xr.set(e, null);
    }
  return Xr.get(e) ?? null;
}
function tr(e, t = "en") {
  var o;
  if (!e) return "";
  const n = Ql(e);
  if (!n) return oi(e);
  const r = (o = kb(t)) == null ? void 0 : o.of(n);
  return r && r !== n ? r : oi(e);
}
function Ob(e) {
  var o;
  const t = /* @__PURE__ */ new Set(), n = (s) => {
    s && t.add(s);
  };
  n(oi(e)), n(e), n(e.replace(/_/g, " "));
  const r = Ql(e);
  if (n(r), r)
    for (const s of MO) {
      const a = (o = kb(s)) == null ? void 0 : o.of(r);
      a && a !== r && n(a);
    }
  for (const s of IO[e] ?? []) n(s);
  return [...t];
}
const vd = /* @__PURE__ */ new Map();
function DO(e) {
  try {
    return new Intl.Collator([e, "en"], { sensitivity: "base" });
  } catch {
    return new Intl.Collator("en", { sensitivity: "base" });
  }
}
function BL(e = "en") {
  let t = vd.get(e);
  if (!t) {
    const n = DO(e);
    t = Object.freeze(
      Db.map((r) => ({ code: r, label: tr(r, e) })).sort((r, o) => n.compare(r.label, o.label) || r.code.localeCompare(o.code)).map(({ code: r }) => r)
    ), vd.set(e, t);
  }
  return t;
}
function si(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{M}", "gu"), "").toLowerCase().replace(/[^\p{L}\p{N}]+/gu, " ").trim();
}
const kO = /^(?:el|la|the|republica del?|republic of)\s+/;
function Lb(e) {
  let t = e;
  for (; ; ) {
    const n = t.replace(kO, "");
    if (n === t) return t;
    t = n;
  }
}
const OO = 4, gd = 3, LO = 2, VO = 1, FO = 3, yd = /* @__PURE__ */ new Map();
function $O(e, t) {
  let n = yd.get(t);
  n || (n = /* @__PURE__ */ new Map(), yd.set(t, n));
  let r = n.get(e);
  if (!r) {
    const o = Ql(e), s = /* @__PURE__ */ new Set();
    for (const i of [tr(e, t), ...Ob(e)]) {
      if (i === o) continue;
      const l = si(i);
      l && (s.add(l), s.add(Lb(l)));
    }
    const a = o ? si(o) : void 0;
    r = { names: [...s], isoCode: a && !s.has(a) ? a : void 0 }, n.set(e, r);
  }
  return r;
}
function UL(e, t, n = "en") {
  const r = Lb(si(t));
  if (!r) return 0;
  const { names: o, isoCode: s } = $O(e, n);
  let a = s != null && s.startsWith(r) ? gd : 0;
  for (const i of o) {
    if (i === r) return OO;
    let l = 0;
    i.startsWith(r) ? l = gd : (" " + i).includes(" " + r) ? l = LO : r.length >= FO && i.includes(r) && (l = VO), l > a && (a = l);
  }
  return a;
}
const WL = ({
  value: e,
  onChange: t,
  disabled: n,
  placeholder: r = "Select a country",
  searchPlaceholder: o = "Search country...",
  noResultsText: s = "No country found.",
  locale: a = "en",
  className: i
}) => {
  const [l, c] = q.useState(!1);
  return /* @__PURE__ */ p("div", { translate: "no", className: i, children: /* @__PURE__ */ O(tg, { open: l, onOpenChange: c, modal: !0, children: [
    /* @__PURE__ */ p(ng, { asChild: !0, children: /* @__PURE__ */ O(
      Ut,
      {
        variant: "outline",
        role: "combobox",
        "aria-expanded": l,
        disabled: n,
        className: "w-full justify-between border border-input bg-background dark:bg-muted px-3 py-2 rounded-md shadow-none text-left h-10",
        children: [
          /* @__PURE__ */ p("span", { children: e ? tr(e, a) : r }),
          /* @__PURE__ */ p(YC, { className: "ml-2 h-4 w-4 shrink-0 opacity-50" })
        ]
      }
    ) }),
    /* @__PURE__ */ p(Ll, { className: "w-[--radix-popover-trigger-width] p-0", children: /* @__PURE__ */ O(Tl, { children: [
      /* @__PURE__ */ p(Tv, { placeholder: o }),
      /* @__PURE__ */ O(Rv, { children: [
        /* @__PURE__ */ p(Pv, { children: s }),
        /* @__PURE__ */ p(_v, { children: Db.map((u) => /* @__PURE__ */ O(
          Mv,
          {
            value: tr(u, a),
            keywords: Ob(u),
            "data-country": u,
            onSelect: () => {
              t(u), c(!1);
            },
            children: [
              /* @__PURE__ */ p(Sr, { className: N("mr-2 h-4 w-4", e === u ? "opacity-100" : "opacity-0") }),
              tr(u, a)
            ]
          },
          u
        )) })
      ] })
    ] }) })
  ] }) });
};
export {
  _p as Alert,
  Mp as AlertDescription,
  tL as AlertDialog,
  YA as AlertDialogAction,
  XA as AlertDialogCancel,
  HA as AlertDialogContent,
  zA as AlertDialogDescription,
  jA as AlertDialogFooter,
  GA as AlertDialogHeader,
  hh as AlertDialogOverlay,
  WA as AlertDialogPortal,
  KA as AlertDialogTitle,
  nL as AlertDialogTrigger,
  bA as AlertTitle,
  vE as Avatar,
  yE as AvatarFallback,
  gE as AvatarImage,
  sL as BackgroundPattern,
  rL as Badge,
  Ut as Button,
  Db as COUNTRIES,
  _O as COUNTRY_NAME_TO_ISO,
  MO as COUNTRY_SEARCH_LOCALES,
  cv as Calendar,
  C_ as Card,
  T_ as CardContent,
  N_ as CardDescription,
  R_ as CardFooter,
  A_ as CardHeader,
  E_ as CardTitle,
  D_ as Checkbox,
  Tl as Command,
  lL as CommandDialog,
  Pv as CommandEmpty,
  _v as CommandGroup,
  Tv as CommandInput,
  Mv as CommandItem,
  Rv as CommandList,
  uM as CommandSeparator,
  dM as CommandShortcut,
  OL as CustomDateInput,
  AO as CustomDesktopDatePicker,
  LL as CustomTimeInput,
  oM as Dialog,
  iL as DialogClose,
  Nv as DialogContent,
  cM as DialogDescription,
  iM as DialogFooter,
  aM as DialogHeader,
  Ev as DialogOverlay,
  sM as DialogPortal,
  lM as DialogTitle,
  aL as DialogTrigger,
  lA as DropdownMenu,
  fA as DropdownMenuCheckboxItem,
  Rp as DropdownMenuContent,
  qO as DropdownMenuGroup,
  Pp as DropdownMenuItem,
  hA as DropdownMenuLabel,
  ZO as DropdownMenuPortal,
  QO as DropdownMenuRadioGroup,
  pA as DropdownMenuRadioItem,
  mA as DropdownMenuSeparator,
  vA as DropdownMenuShortcut,
  JO as DropdownMenuSub,
  dA as DropdownMenuSubContent,
  uA as DropdownMenuSubTrigger,
  cA as DropdownMenuTrigger,
  FL as FloatingLabelInput,
  cL as Form,
  Dl as FormControl,
  BM as FormDescription,
  Wv as FormField,
  Il as FormItem,
  $M as FormLabel,
  kl as FormMessage,
  VL as FormattedDateTime,
  EO as GuestCountStepper,
  xL as H1,
  SL as H2,
  CL as H3,
  AL as H4,
  ML as HoverCard,
  nO as HoverCardContent,
  IL as HoverCardTrigger,
  $L as ImageDropzone,
  us as Input,
  Bv as Label,
  TL as Large,
  UM as Layout,
  GM as LayoutContent,
  WM as LayoutHeader,
  HM as LayoutSidebar,
  NL as Lead,
  uL as LoadingSpinner,
  gO as Pagination,
  yO as PaginationContent,
  SO as PaginationEllipsis,
  bO as PaginationItem,
  Jl as PaginationLink,
  xO as PaginationNext,
  wO as PaginationPrevious,
  tg as Popover,
  Ll as PopoverContent,
  ng as PopoverTrigger,
  EI as Progress,
  LI as RadioGroup,
  VI as RadioGroupItem,
  ZI as ScrollArea,
  Vg as ScrollBar,
  WL as SearchableCountrySelect,
  dL as Select,
  PD as SelectContent,
  fL as SelectGroup,
  MD as SelectItem,
  _D as SelectLabel,
  Sy as SelectScrollDownButton,
  xy as SelectScrollUpButton,
  ID as SelectSeparator,
  RD as SelectTrigger,
  pL as SelectValue,
  KD as Separator,
  hL as Sheet,
  vL as SheetClose,
  XD as SheetContent,
  QD as SheetDescription,
  ZD as SheetFooter,
  qD as SheetHeader,
  Ny as SheetOverlay,
  zD as SheetPortal,
  JD as SheetTitle,
  mL as SheetTrigger,
  wL as SimpleTooltip,
  gL as Skeleton,
  RL as Small,
  kL as StatusChip,
  PL as Subtle,
  sk as Switch,
  cO as Table,
  dO as TableBody,
  vO as TableCaption,
  mO as TableCell,
  fO as TableFooter,
  hO as TableHead,
  uO as TableHeader,
  pO as TableRow,
  DL as Tabs,
  lO as TabsContent,
  aO as TabsList,
  iO as TabsTrigger,
  EL as Text,
  ak as Textarea,
  XO as ThemeProvider,
  eL as ThemeSwitcher,
  Qy as Toast,
  Tk as ToastAction,
  eb as ToastClose,
  nb as ToastDescription,
  Ek as ToastProvider,
  tb as ToastTitle,
  Jy as ToastViewport,
  yL as Toaster,
  fb as Tooltip,
  Xl as TooltipContent,
  db as TooltipProvider,
  pb as TooltipTrigger,
  TO as UnderlineInput,
  bE as badgeVariants,
  Bt as buttonVariants,
  N as cn,
  YO as configureToast,
  BL as countriesSortedByName,
  tr as countryDisplayName,
  UL as countryMatchScore,
  Ob as countrySearchKeywords,
  oi as formatCountryName,
  Ql as nameToIso,
  H0 as toast,
  cs as useFormField,
  z0 as useTheme,
  G0 as useToast
};
